/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 48);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(61));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_554932f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__(55);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_554932f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tour__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_tour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__params__ = __webpack_require__(104);








__webpack_require__(105);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_tour___default.a);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        params: __WEBPACK_IMPORTED_MODULE_5__params__["a" /* params */]
    },
    strict: true,
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
    mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__,
    state: {
        prod: true,
        auth: null,
        loading: false,
        pdfloading: false,
        csvloading: false,
        fileuploading: false,
        projects: null,
        project: null,
        windows: null,
        window: null,
        bom: null,
        handles: null,
        motors: null,
        profiles: null,
        invisitopprofiles: null,
        users: null,
        windowCreateResponse: null,
        translations: null,
        versions: null,
        version: null,
        latestversion: 0,
        errorlist: null,
        invalidfile: false,
        language: null,
        sharedusers: null,
        sharedprojects: null,
        genericDownloads: null,
        windowsortoptions: 'newold',
        projectsortoptions: 'newold',
        countries: null,
        languages: null,
        syscos: null
    },
    getters: {
        getAddress: function getAddress(state) {
            var url = "";
            if (state.prod == true) {
                url = 'https://classic-api.chronologiconline.com/api/';
            } else {
                url = 'https://classic-dev-api.chronologiconline.com/api/';
                //url = 'https://localhost:44393/api/'
            }
            return url;
        },
        isAuthenticated: function isAuthenticated(state) {
            return state.auth !== null && state.auth.access_token !== null;
        },

        getProjectById: function getProjectById(state) {
            return function (id) {
                var prj = state.projects.find(function (project) {
                    return project.id == id;
                });
                if (prj == null) return null;else return prj;
            };
        },
        getWindowById: function getWindowById(state) {
            return function (id) {
                var win = state.windows.find(function (window) {
                    return window.id == id;
                });
                if (win == null) return null;else return win;
            };
        },
        getCurrentProject: function getCurrentProject(state) {
            return state.project;
        },
        getProjects: function getProjects(state) {
            return state.projects;
        },
        getWindows: function getWindows(state) {
            return state.windows;
        },
        getCountries: function getCountries(state) {
            return state.countries;
        },
        getLanguages: function getLanguages(state) {
            return state.languages;
        },
        getSysCos: function getSysCos(state) {
            return state.syscos;
        },
        getHandleByAN: function getHandleByAN(state) {
            return function (anr) {
                return state.handles.find(function (handle) {
                    return handle.anr == anr;
                });
            };
        },
        getTranslationByTerm: function getTranslationByTerm(state) {
            return function (term) {
                if (term != null && state.translations != null) {
                    var retval = state.translations.find(function (caption) {
                        return caption.term == term;
                    });
                } else {
                    var retval = '';
                }
                return retval;
            };
        },
        getTypes: function getTypes(state) {
            if (state.auth != null) return state.params.type.filter(function (f) {
                return f.sysco == 0 || f.sysco == state.auth.systemCompany;
            });else return null;
        },
        getProfiles: function getProfiles(state) {
            if (state.auth != null) return state.profiles;else return null;
        },
        getInvisitopProfilesForWindow: function getInvisitopProfilesForWindow(state) {
            return function (hinge, chrono) {
                return state.invisitopprofiles.filter(function (p) {
                    return p.hin == hinge && p.chr == chrono;
                });
            };
        },
        getAuth: function getAuth(state) {
            if (state.auth != null) return state.auth;else return null;
        },
        getUserlist: function getUserlist(state) {
            var s = state.users;
            return s;
        },
        getLanguage: function getLanguage(state) {
            if (state.language != null) {
                if (state.language == "Nederlands") return "NED";else return "ENG";
            }
        },
        getUserById: function getUserById(state) {
            return function (id) {
                var usr = state.users.find(function (user) {
                    return user.userId == id;
                });
                if (usr == null) return null;else return usr;
            };
        },
        getshareduser: function getshareduser(state) {
            return function (id) {
                var usr = state.sharedusers.find(function (user) {
                    return user.userId == id;
                });
                if (usr == null) return null;else return usr;
            };
        },
        getshareduserinfo: function getshareduserinfo(state) {
            return function (id, ro) {
                var usr = state.sharedusers.find(function (user) {
                    return user.userId == id;
                });
                if (usr == null) return null;else return usr;
            };
        },
        getVNList: function getVNList(state) {
            var vn = 0;
            var vnlist = [];
            for (var i = 0, len = state.versions.length; i < len; i++) {
                if (state.versions[i].vn != vn) {
                    vnlist.push(state.versions[i].vn);
                    vn = state.versions[i].vn;
                }
            }
            return vnlist;
        },
        getVersion: function getVersion(state) {
            return state.version;
        },
        getWindowSortOptions: function getWindowSortOptions(state) {
            return state.windowsortoptions;
        },
        getProjectSortOptions: function getProjectSortOptions(state) {
            return state.projectsortoptions;
        },
        getprojro: function getprojro(state) {
            return function (id) {
                var proj = state.sharedprojects.find(function (pr) {
                    return pr.projectId == id && pr.ownerId == state.auth.userId;
                });
                if (proj != null) return 0;
                if (proj == null) proj = state.sharedprojects.find(function (pr) {
                    return pr.projectId == id && pr.userId == state.auth.userId;
                });
                if (proj == null) return 0;
                return proj.readonly;
            };
        },

        getLatestVN: function getLatestVN(state) {
            var vn = 0;
            if (state.versions != null) {
                for (var i = 0, len = state.versions.length; i < len; i++) {
                    if (state.versions[i].vn > vn) {
                        vn = state.versions[i].vn;
                    }
                }
                return vn;
            } else return null;
        },
        getGenericDownloads: function getGenericDownloads(state) {
            return state.genericDownloads;
        },
        getMotors: function getMotors(state) {
            return state.motors;
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(107)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(23);
var isBuffer = __webpack_require__(86);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(60));

var _alphaNum = _interopRequireDefault(__webpack_require__(63));

var _numeric = _interopRequireDefault(__webpack_require__(64));

var _between = _interopRequireDefault(__webpack_require__(65));

var _email = _interopRequireDefault(__webpack_require__(66));

var _ipAddress = _interopRequireDefault(__webpack_require__(67));

var _macAddress = _interopRequireDefault(__webpack_require__(68));

var _maxLength = _interopRequireDefault(__webpack_require__(69));

var _minLength = _interopRequireDefault(__webpack_require__(70));

var _required = _interopRequireDefault(__webpack_require__(71));

var _requiredIf = _interopRequireDefault(__webpack_require__(72));

var _requiredUnless = _interopRequireDefault(__webpack_require__(73));

var _sameAs = _interopRequireDefault(__webpack_require__(74));

var _url = _interopRequireDefault(__webpack_require__(75));

var _or = _interopRequireDefault(__webpack_require__(76));

var _and = _interopRequireDefault(__webpack_require__(77));

var _not = _interopRequireDefault(__webpack_require__(78));

var _minValue = _interopRequireDefault(__webpack_require__(79));

var _maxValue = _interopRequireDefault(__webpack_require__(80));

var _integer = _interopRequireDefault(__webpack_require__(81));

var _decimal = _interopRequireDefault(__webpack_require__(82));

var helpers = _interopRequireWildcard(__webpack_require__(1));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapActions; });
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.0.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (true) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (true) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (true) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (true) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (true) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (true) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    "staging" !== 'production' &&
    options && options.silent
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (true) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (true) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (true) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (true) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if ("staging" !== 'production' && !store._actions[type]) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if ("staging" !== 'production' && !store._mutations[type]) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (true) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (true) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (true) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (true) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if ("staging" !== 'production' && !(val in this.$store.getters)) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if ("staging" !== 'production' && !module) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.0.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),
/* 9 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var projectsteps = {
    stepswithoutENG: [{
        target: '.v-step-0',
        content: 'Click to see the latest updates. When a new update is available, this button will be red.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-1',
        content: 'Click to edit the list of shared users.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-2',
        content: 'Click to change the language.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-3',
        content: 'Click to create a new project.',
        params: {
            placement: 'left'
        }
    }, {
        target: '.v-step-4',
        content: 'Enter text here to filter the project list.',
        params: {
            placement: 'left'
        }
    }],
    stepswithENG: [{
        target: '.v-step-0',
        content: 'Click to see the latest updates. When a new update is available, this button will be red.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-1',
        content: 'Click to edit the list of shared users.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-2',
        content: 'Click to change the language.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-3',
        content: 'Click to create a new project.',
        params: {
            placement: 'left'
        }
    }, {
        target: '.v-step-4',
        content: 'Enter text here to filter the project list.',
        params: {
            placement: 'left'
        }
    }, {
        target: '.v-step-5',
        content: 'This is the number of windows in a project.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-6',
        content: 'Click to generate a .CSV file with the BOM for the complete project. The .CSV file is stored in your Downloads folder.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-7',
        content: 'Click to generate a .PDF file with the mounting instructions for all windows in this project. The .PDF file is stored in your Downloads folder.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-8',
        content: 'Click to show the list of windows in a project.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-9',
        content: 'Click to select the users that will share this project.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-10',
        content: 'Click to edit the project data.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-11',
        content: 'Click to make a copy of a project including all windows.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-12',
        content: 'Click to delete a project.',
        params: {
            placement: 'top'
        }
    }],
    stepswithoutNED: [{
        target: '.v-step-0',
        content: 'Klik om de laatste updates te bekijken. Deze knop kleurt rood wanneer een nieuwe update beschikbaar is.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-1',
        content: 'Klik om de lijst van gedeelde gebruikers te bekijken of aan te passen',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-2',
        content: 'Klik om de taal te kiezen.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-3',
        content: 'Klik om een nieuw project aan te maken.',
        params: {
            placement: 'left'
        }
    }, {
        target: '.v-step-4',
        content: 'Typ tekst in deze balk om de projectlijst te filteren.',
        params: {
            placement: 'left'
        }
    }],
    stepswithNED: [{
        target: '.v-step-0',
        content: 'Klik om de laatste updates te bekijken. Deze knop kleurt rood wanneer een nieuwe update beschikbaar is.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-1',
        content: 'Klik om de lijst van gedeelde gebruikers te bekijken of aan te passen',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-2',
        content: 'Klik om de taal te kiezen.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-3',
        content: 'Klik om een nieuw project aan te maken.',
        params: {
            placement: 'left'
        }
    }, {
        target: '.v-step-4',
        content: 'Typ tekst in deze balk om de projectlijst te filteren.',
        params: {
            placement: 'left'
        }
    }, {
        target: '.v-step-5',
        content: 'Dit is het aantal ramen in een project. Als een project gedeeld wordt dan wordt dit hier aangeduid.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-6',
        content: 'Klik om een .CSV bestand te genereren met de BOM voor het hele project. Het .CSV bestand wordt in uw Downloads folder bewaard.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-7',
        content: 'Klik om een gebundeld .PDF bestand aan te maken met de montage instructies voor alle ramen in een project. Het .PDF bestand wordt in uw Downloads folder bewaard.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-8',
        content: 'Klik om de ramenlijst van een project te tonen.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-9',
        content: 'Klik om gebruikers te selecteren die dit project delen.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-10',
        content: 'Klik om de projectgegevens te wijzigen.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-11',
        content: 'Klik om een kopie te maken van een project incl. alle ramen.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-12',
        content: 'Klik om een project te verwijderen.',
        params: {
            placement: 'top'
        }
    }],
    stepswithoutCHI: [{
        target: '.v-step-0',
        content: '单击此按钮可查看最新升级。当软件有新的升级时，此按钮为红色。',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-1',
        content: '\u70B9\u51FB\u7F16\u8F91\u5171\u4EAB\u7528\u6237\u5217\u8868',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-2',
        content: '点击更改语言',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-3',
        content: '\u5355\u51FB\u6B64\u6309\u94AE\u521B\u5EFA\u65B0\u7684\u9879\u76EE',
        params: {
            placement: 'left'
        }
    }, {
        target: '.v-step-4',
        content: '在此输入文本可筛选项目列表',
        params: {
            placement: 'left'
        }
    }],
    stepswithCHI: [{
        target: '.v-step-0',
        content: '单击此按钮可查看最新升级。当软件有新的升级时，此按钮为红色。',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-1',
        content: '\u70B9\u51FB\u7F16\u8F91\u5171\u4EAB\u7528\u6237\u5217\u8868',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-2',
        content: '点击更改语言',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-3',
        content: '\u5355\u51FB\u6B64\u6309\u94AE\u521B\u5EFA\u65B0\u7684\u9879\u76EE',
        params: {
            placement: 'left'
        }
    }, {
        target: '.v-step-4',
        content: '在此输入文本可筛选项目列表',
        params: {
            placement: 'left'
        }
    }, {
        target: '.v-step-5',
        content: '项目中窗型的数量',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-6',
        content: '单击此按钮生成一个.CSV文件，其中包含完整项目的物料清单。.CSV文件存储在下载文件夹中。',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-7',
        content: '单击此按钮生成一个 .PDF文件，其中包含此项目中所有窗型的安装说明。.PDF文件存储在下载文件夹中',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-8',
        content: '单击此按钮显示项目中的窗型列表',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-9',
        content: '点击选择用户，将此项目共享给该用户',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-10',
        content: '单击此按钮可编辑项目参数',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-11',
        content: '单击此按钮可复制项目全部窗型',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-12',
        content: '单击此按钮可删除项目',
        params: {
            placement: 'top'
        }
    }],
    stepswithoutPOR: [{
        target: '.v-step-0',
        content: 'Carregue para ver as últimas atualizações. Quando uma nova atualização é colocada, este botão fica vermelho.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-1',
        content: '– Carregue para editar a listagem de utilizadores partilhados.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-2',
        content: 'Carregue para alterar o idioma.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-3',
        content: 'Carregue para criar um novo projeto.',
        params: {
            placement: 'left'
        }
    }, {
        target: '.v-step-4',
        content: 'Insira o texto a pesquisar na lista de projetos.',
        params: {
            placement: 'left'
        }
    }],
    stepswithPOR: [{
        target: '.v-step-0',
        content: 'Carregue para ver as últimas atualizações. Quando uma nova atualização é colocada, este botão fica vermelho.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-1',
        content: 'Carregue para editar a listagem de utilizadores partilhados.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-2',
        content: 'Carregue para alterar o idioma.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-3',
        content: 'Carregue para criar um novo projeto.',
        params: {
            placement: 'left'
        }
    }, {
        target: '.v-step-4',
        content: 'Insira o texto a pesquisar na lista de projetos.',
        params: {
            placement: 'left'
        }
    }, {
        target: '.v-step-5',
        content: 'Número de janelas configuradas no projeto.',
        params: {
            placement: 'bottom'
        }
    }, {
        target: '.v-step-6',
        content: 'Carregue para gerar um ficheiro .CSV com a BOM da totalidade do projeto. O ficheiro .CSV será guardado na pasta de Transferências.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-7',
        content: 'Carregue para gerar um ficheiro .PDF com as instruções de montagem para todas as janelas do projeto. O ficheiro .PDF será guardado na pasta de Transferências.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-8',
        content: 'Carregue para ver a listagem de janelas do projeto.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-9',
        content: 'Carregue para selecionar os utilizadores que irão partilhar este projeto.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-10',
        content: 'Carregue para editar as características de um projeto.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-11',
        content: 'Carregue para criar uma cópia de um projeto com a totalidade das janelas.',
        params: {
            placement: 'top'
        }
    }, {
        target: '.v-step-12',
        content: 'Carregue para eliminar um projeto.',
        params: {
            placement: 'top'
        }
    }]
};

/* harmony default export */ __webpack_exports__["a"] = (projectsteps);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.17
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "staging" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "staging" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
})

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (true) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if ("staging" !== 'production' && customSetter) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if ("staging" !== 'production' &&
    (isUndef(target) || isPrimitive(target))
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "staging" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if ("staging" !== 'production' &&
    (isUndef(target) || isPrimitive(target))
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "staging" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (true) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "staging" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "staging" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (true) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "staging" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (true) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (true) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (true) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (true) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if ("staging" !== 'production' && warnMissing && !res) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    true
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if ("staging" !== 'production' && isObject(def)) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (true) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (true) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (true) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "staging" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (true) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "staging" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 true
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (true) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (true) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if ("staging" !== 'production' && config.performance && mark) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (true) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (true) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (true) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if ("staging" !== 'production' && has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  true
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "staging" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (true) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "staging" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (true) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "staging" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if ("staging" !== 'production' && getter == null) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (true) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if ("staging" !== 'production' &&
      sharedPropertyDefinition.set === noop) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (true) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (true) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (true) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (true) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if ("staging" !== 'production' && !isObject(bindObject)) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if ("staging" !== 'production' && slotNodes._rendered) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "staging" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "staging" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (true) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "staging" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if ("staging" !== 'production' &&
    isDef(data) && isDef(data.key) && !isPrimitive(data.key)
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (true) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (true) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (true) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if ("staging" !== 'production' && Array.isArray(vnode)) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if ("staging" !== 'production' && config.performance && mark) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (true) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if ("staging" !== 'production' && config.performance && mark) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue (options) {
  if ("staging" !== 'production' &&
    !(this instanceof Vue)
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if ("staging" !== 'production' && name) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if ("staging" !== 'production' && type === 'component') {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
}

var builtInComponents = {
  KeepAlive: KeepAlive
}

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (true) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.17';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "staging" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
}

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (true) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if ("staging" !== 'production' && data && data.pre) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (true) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (true) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (true) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if ("staging" !== 'production' &&
                typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if ("staging" !== 'production' &&
                typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (true) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
}

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
]

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
}

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
}

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    "staging" !== 'production' && warn &&
    modifiers.prevent && modifiers.passive
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = {
    value: value.trim()
  };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (true) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (true) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (true) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
}

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
}

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
}

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if ("staging" !== 'production' && explicitEnterDuration != null) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if ("staging" !== 'production' && isDef(explicitLeaveDuration)) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {}

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
]

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "staging" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
}

var platformDirectives = {
  model: directive,
  show: show
}

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if ("staging" !== 'production' && children.length > 1) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if ("staging" !== 'production' &&
      mode && mode !== 'in-out' && mode !== 'out-in'
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
}

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (true) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
}

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
}

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        "staging" !== 'production' &&
        "staging" !== 'test' &&
        isChrome
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if ("staging" !== 'production' &&
      "staging" !== 'test' &&
      config.productionTip !== false &&
      typeof console !== 'undefined'
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if ("staging" !== 'production' && staticClass) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
}

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (true) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
}

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
}

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if ("staging" !== 'production' && !stack.length && options.warn) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if ("staging" !== 'production' &&
          (i > pos || !tagName) &&
          options.warn
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "staging" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (true) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (true) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (true) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if ("staging" !== 'production' && el.tag === 'template') {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (true) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (true) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if ("staging" !== 'production' && children[i].text !== ' ') {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if ("staging" !== 'production' && el.key) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if ("staging" !== 'production' && slotScope) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if ("staging" !== 'production' && el.attrsMap['v-for']) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if ("staging" !== 'production' && name === 'model') {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (true) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      "staging" !== 'production' &&
      map[attrs[i].name] && !isIE && !isEdge
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
}

var modules$1 = [
  klass$1,
  style$1,
  model$2
]

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
}

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  'delete': ['Backspace', 'Delete']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if ("staging" !== 'production' && dir.modifiers) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
}

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "staging" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if ("staging" !== 'production' &&
    state.maybeComponent(el) &&
    el.tag !== 'slot' &&
    el.tag !== 'template' &&
    !el.key
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if ("staging" !== 'production' && (
    el.children.length !== 1 || ast.type !== 1
  )) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (true) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (true) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (true) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (true) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "staging" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if ("staging" !== 'production' && !template) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (true) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if ("staging" !== 'production' && config.performance && mark) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if ("staging" !== 'production' && config.performance && mark) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(9), __webpack_require__(49).setImmediate))

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86ce7f60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__(56);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86ce7f60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(6);
var normalizeHeaderName = __webpack_require__(88);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(24);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(24);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WindowGraph_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_261e051e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WindowGraph_vue__ = __webpack_require__(126);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WindowGraph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_261e051e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WindowGraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app"
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_intro_AppIntro__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_intro_Login__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_intro_RegisterForm__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_projects_ProjectList__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_projects_ProjectEdit__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_projects_ProjectCreate__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_windows_WindowList__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_windows_WindowEdit__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_windows_WindowBom__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_users_UserList__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_users_UserEdit__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_users_SharedUserList__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_versions_VersionList__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_intro_PasswordReset__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_intro_PasswordInput__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_cilinders_CilinderIntro__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_cilinders_Cilinder880__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_cilinders_Config880__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_downloads_DownloadList__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_intro_TermsAndConditions__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_intro_PrivacyPolicy__ = __webpack_require__(176);

























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_2__components_intro_AppIntro__["a" /* default */]
  }, {
    path: "/login",
    component: __WEBPACK_IMPORTED_MODULE_3__components_intro_Login__["a" /* default */]
  }, {
    path: "/terms-and-conditions",
    component: __WEBPACK_IMPORTED_MODULE_21__components_intro_TermsAndConditions__["a" /* default */]
  }, {
    path: "/privacy-policy",
    component: __WEBPACK_IMPORTED_MODULE_22__components_intro_PrivacyPolicy__["a" /* default */]
  }, {
    path: "/register",
    component: __WEBPACK_IMPORTED_MODULE_4__components_intro_RegisterForm__["a" /* default */]
  }, {
    path: "/projects/:id",
    component: __WEBPACK_IMPORTED_MODULE_5__components_projects_ProjectList__["a" /* default */]
  }, {
    path: "/projectedit/:id",
    component: __WEBPACK_IMPORTED_MODULE_6__components_projects_ProjectEdit__["a" /* default */]
  }, {
    path: "/projectcreate",
    component: __WEBPACK_IMPORTED_MODULE_7__components_projects_ProjectCreate__["a" /* default */]
  }, {
    path: "/projectwindows/:id",
    component: __WEBPACK_IMPORTED_MODULE_8__components_windows_WindowList__["a" /* default */]
  }, {
    path: "/windowedit/:id",
    component: __WEBPACK_IMPORTED_MODULE_9__components_windows_WindowEdit__["a" /* default */]
  }, {
    path: "/bom/:id",
    component: __WEBPACK_IMPORTED_MODULE_10__components_windows_WindowBom__["a" /* default */]
  }, {
    path: "/users",
    component: __WEBPACK_IMPORTED_MODULE_11__components_users_UserList__["a" /* default */]
  }, {
    path: "/edituser/:id",
    component: __WEBPACK_IMPORTED_MODULE_12__components_users_UserEdit__["a" /* default */]
  }, {
    path: "/versions",
    component: __WEBPACK_IMPORTED_MODULE_14__components_versions_VersionList__["a" /* default */]
  }, {
    path: "/sharedusers",
    component: __WEBPACK_IMPORTED_MODULE_13__components_users_SharedUserList__["a" /* default */]
  }, {
    path: "/pwreset",
    component: __WEBPACK_IMPORTED_MODULE_15__components_intro_PasswordReset__["a" /* default */]
  }, {
    path: "/pw/:id",
    component: __WEBPACK_IMPORTED_MODULE_16__components_intro_PasswordInput__["a" /* default */]
  }, {
    path: "/cilinders",
    component: __WEBPACK_IMPORTED_MODULE_17__components_cilinders_CilinderIntro__["a" /* default */]
  }, {
    path: "/cilinder880",
    component: __WEBPACK_IMPORTED_MODULE_18__components_cilinders_Cilinder880__["a" /* default */]
  }, {
    path: "/config880",
    component: __WEBPACK_IMPORTED_MODULE_19__components_cilinders_Config880__["a" /* default */]
  }, {
    path: "/downloads",
    component: __WEBPACK_IMPORTED_MODULE_20__components_downloads_DownloadList__["a" /* default */]
  }, {
    path: "*",
    redirect: "/"
  }]
}));

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppFooter__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__AppHeader__["a" /* default */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__AppFooter__["a" /* default */]
  },
  methods: {
    openLoginPage: function openLoginPage() {
      this.$router.push("/login");
    },
    openTCPage: function openTCPage() {
      this.$router.push("/terms-and-conditions");
    },
    openPPPage: function openPPPage() {
      this.$router.push("/privacy-policy");
    }
  },
  created: function created() {
    if (this.$route.query.pwr == 1) this.$router.push("/pw/" + this.$route.query.id + "?token=" + this.$route.query.token);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["sysco"],
  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    fullName: function fullName() {
      return this.$store.getters.getAuth.firstName + " " + this.$store.getters.getAuth.lastName;
    },
    version: function version() {
      return this.$store.getters.getVersion;
    }
  },
  methods: {
    logout: function logout() {
      var _this = this;

      this.$store.dispatch("logout").then(function () {
        _this.$router.push("/login");
      });
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientApp_store__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__AppHeader__["a" /* default */]
  },
  data: function data() {
    return {
      form: {
        email: "",
        password: ""
      },
      error: null
    };
  },
  validations: {
    form: {
      email: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    login: function login() {
      var _this = this;

      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      var payload = {
        email: this.form.email,
        password: this.form.password
      };
      this.$store.dispatch("login", payload).then(function () {
        _this.error = null;
        _this.form.email = "";
        _this.form.password = "";
        _this.$store.dispatch("getTranslations");
        _this.$store.dispatch("getHandles");
        _this.$store.dispatch("getProfiles");
        _this.$store.dispatch("getMotors");
        _this.$store.dispatch("getInvisitopProfiles");
        _this.$store.dispatch("getVersion");
        _this.$router.push("/projects/0");
      }).catch(function (error) {
        _this.error = error.data;
      });
    }
  },
  computed: {
    loading: function loading() {
      return this.$store.state.loading;
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushParams = pushParams;
exports.popParams = popParams;
exports.withParams = withParams;
exports._setTarget = exports.target = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var stack = [];
var target = null;
exports.target = target;

var _setTarget = function _setTarget(x) {
  exports.target = target = x;
};

exports._setTarget = _setTarget;

function pushParams() {
  if (target !== null) {
    stack.push(target);
  }

  exports.target = target = {};
}

function popParams() {
  var lastTarget = target;
  var newTarget = exports.target = target = stack.pop() || null;

  if (newTarget) {
    if (!Array.isArray(newTarget.$sub)) {
      newTarget.$sub = [];
    }

    newTarget.$sub.push(lastTarget);
  }

  return lastTarget;
}

function addParams(params) {
  if (_typeof(params) === 'object' && !Array.isArray(params)) {
    exports.target = target = _objectSpread({}, target, params);
  } else {
    throw new Error('params must be an object');
  }
}

function withParamsDirect(params, validator) {
  return withParamsClosure(function (add) {
    return function () {
      add(params);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return validator.apply(this, args);
    };
  });
}

function withParamsClosure(closure) {
  var validator = closure(addParams);
  return function () {
    pushParams();

    try {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return validator.apply(this, args);
    } finally {
      popParams();
    }
  };
}

function withParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return withParamsDirect(paramsOrClosure, maybeValidator);
  }

  return withParamsClosure(paramsOrClosure);
}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(85);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var settle = __webpack_require__(89);
var buildURL = __webpack_require__(91);
var parseHeaders = __webpack_require__(92);
var isURLSameOrigin = __webpack_require__(93);
var createError = __webpack_require__(25);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(94);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("staging" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(95);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(90);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientApp_store__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GDPRnotTrue = function GDPRnotTrue(value) {
  return value == true;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__AppHeader__["a" /* default */]
  },
  data: function data() {
    return {
      form: {
        email: '',
        company: '',
        sysco: 1,
        country: 3,
        language: 1,
        firstname: '',
        lastname: '',
        password: '',
        confirmpassword: '',
        gdprok: false
      },
      errors: null,
      countriesloaded: false,
      languagesloaded: false,
      syscosloaded: false
    };
  },
  validations: {
    form: {
      email: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
      },
      company: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      sysco: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      country: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      language: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      firstname: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      lastname: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      confirmpassword: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        sameAsPassword: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('password')
      },
      gdprok: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        GDPRnotTrue: GDPRnotTrue
      }
    }
  },
  methods: {
    register: function register() {
      var _this = this;

      this.errors = null;
      this.$v.form.$touch();
      if (this.$v.form.$error) return;
      $('#MyModal').modal('show');
      var payload = {
        FirstName: this.form.firstname,
        LastName: this.form.lastname,
        CompanyName: this.form.company,
        SysCo: this.form.sysco,
        Country: this.form.country,
        Language: this.form.language,
        Email: this.form.email,
        Password: this.form.password,
        ConfirmPassword: this.form.confirmpassword,
        GDPROK: this.form.gdprok
      };

      this.$store.dispatch("register", payload).then(function (response) {
        _this.error = null;
        $('#myModal').modal('show');
      }).catch(function (error) {
        if (typeof error.data === "string" || error.data instanceof String) {
          _this.errors = {
            error: [error.data]
          };
        } else {
          _this.errors = error.data;
        }
      });
    },
    backToLogin: function backToLogin() {
      this.$router.push("/login");
    },
    showGDPR: function showGDPR() {
      $('#GDPR_Ned').modal('show');
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.dispatch("getCountries").then(function (response) {
      _this2.countriesloaded = true;
    });
    this.$store.dispatch("getLanguages").then(function (response) {
      _this2.languagesloaded = true;
    });
    this.$store.dispatch("getSysCos").then(function (response) {
      _this2.syscosloaded = true;
    });
  },


  computed: {
    loading: function loading() {
      return this.$store.state.loading;
    },
    countries: function countries() {
      return this.$store.getters.getCountries;
    },
    languages: function languages() {
      return this.$store.getters.getLanguages;
    },
    syscos: function syscos() {
      return this.$store.getters.getSysCos;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientApp_helpers_project_steps__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//Test

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        custName: "",
        projName: ""
      },
      error: null,
      projectsloaded: false,
      translationsloaded: false,
      versionsloaded: false,
      searchproj: "",
      selProj: 0,
      stepswithoutENG: __WEBPACK_IMPORTED_MODULE_2__ClientApp_helpers_project_steps__["a" /* default */].stepswithoutENG,
      stepswithENG: __WEBPACK_IMPORTED_MODULE_2__ClientApp_helpers_project_steps__["a" /* default */].stepswithENG,
      stepswithoutCHI: __WEBPACK_IMPORTED_MODULE_2__ClientApp_helpers_project_steps__["a" /* default */].stepswithoutCHI,
      stepswithCHI: __WEBPACK_IMPORTED_MODULE_2__ClientApp_helpers_project_steps__["a" /* default */].stepswithCHI,
      stepswithoutNED: __WEBPACK_IMPORTED_MODULE_2__ClientApp_helpers_project_steps__["a" /* default */].stepswithoutNED,
      stepswithNED: __WEBPACK_IMPORTED_MODULE_2__ClientApp_helpers_project_steps__["a" /* default */].stepswithNED,
      stepswithoutPOR: __WEBPACK_IMPORTED_MODULE_2__ClientApp_helpers_project_steps__["a" /* default */].stepswithoutPOR,
      stepswithPOR: __WEBPACK_IMPORTED_MODULE_2__ClientApp_helpers_project_steps__["a" /* default */].stepswithPOR,
      tour: false,
      myCallbacks: {
        onStart: this.myTourStart,
        onStop: this.myTourStop
      },
      myOptionsNED: {
        labels: {
          buttonSkip: "Verlaat tour",
          buttonPrevious: "Vorige",
          buttonNext: "Volgende",
          buttonStop: "Einde"
        }
      },
      myOptionsENG: {
        labels: {
          buttonSkip: "Skip tour",
          buttonPrevious: "Previous",
          buttonNext: "Next",
          buttonStop: "Finish"
        }
      },
      myOptionsCHI: {
        labels: {
          buttonSkip: "跳过演示说明",
          buttonPrevious: "上一步",
          buttonNext: "下一步",
          buttonStop: "演示结束"
        }
      },
      myOptionsPOR: {
        labels: {
          buttonSkip: "Skip tour",
          buttonPrevious: "Previous",
          buttonNext: "Next",
          buttonStop: "Finish"
        }
      },
      projtodelete: 0,
      bomprojid: null,
      pdfcaption: "PDF",
      pdfproj: null,
      projName: null,
      projId: null,
      projNumWin: null,
      projectNameEmpty: false,
      projusers: [],
      sortoptions: this.$store.getters.getProjectSortOptions,
      firstpage: "1",
      sashpage: "1",
      framepage: "1",
      shulist: null,
      sharedusersloaded: false,
      sharedprojectsloaded: false
    };
  },
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__["a" /* default */]
  },
  computed: {
    projects: function projects() {
      var _this = this;

      var p = this.$store.getters.getProjects;
      var so = this.$store.getters.getProjectSortOptions;
      if (p != null) {
        var projs = p.filter(function (p) {
          return p.customerName.toUpperCase().concat(p.projectName.toUpperCase()).includes(_this.searchproj.toUpperCase());
        });
        if (so == "newold") {
          projs.sort(function (a, b) {
            if (a.id > b.id) return -1;
            if (a.id < b.id) return 1;
            return 0;
          });
        }
        if (so == "lstmod") {
          projs.sort(function (a, b) {
            if (a.lastModifiedDate > b.lastModifiedDate) return -1;
            if (a.lastModifiedDate < b.lastModifiedDate) return 1;
            return 0;
          });
        }

        if (so == "oldnew") {
          projs.sort(function (a, b) {
            if (a.id < b.id) return -1;
            if (a.id > b.id) return 1;
            return 0;
          });
        }
        if (so == "byName") {
          projs.sort(function (a, b) {
            var nameA = a.customerName.toLowerCase() + a.projectName.toLowerCase(),
                nameB = b.customerName.toLowerCase() + b.projectName.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
        }

        if (this.tour == false) return projs;else return projs.slice(0, 1);
      } else return p;
    },
    role: function role() {
      return this.$store.state.auth.role;
    },
    companyName: function companyName() {
      return this.$store.state.auth.companyName;
    },
    sysco: function sysco() {
      return this.$store.getters.getAuth.systemCompany;
    },
    usersVN: function usersVN() {
      return this.$store.getters.getAuth.latestVersion;
    },
    latestVN: function latestVN() {
      return this.$store.getters.getLatestVN;
    },
    csvloading: function csvloading() {
      return this.$store.state.csvloading;
    },
    pdfloading: function pdfloading() {
      return this.$store.state.pdfloading;
    },
    language: function language() {
      return this.$store.state.language;
    },
    projEmpty: function projEmpty() {
      if (this.projectNameEmpty) return true;else return false;
    },
    shusers: function shusers() {
      var selusers = null;
      return this.$store.state.sharedusers;
    },
    shprojects: function shprojects() {
      return this.$store.state.sharedprojects;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.$route.params.id > 0) {
      this.$store.dispatch("getProjectsPerUser", this.$route.params.id).then(function (response) {
        _this2.projectsloaded = true;
      });
    } else {
      this.$store.dispatch("getProjects").then(function (response) {
        _this2.projectsloaded = true;
      });
    }
    this.$store.dispatch("getVersions").then(function (response) {
      _this2.versionsloaded = true;
    });
    this.$store.dispatch("getSharedUsers").then(function (response) {
      _this2.sharedusersloaded = true;
    });
    this.$store.dispatch("getSharedProjects").then(function (response) {
      _this2.sharedprojectsloaded = true;
    });

    $(document).ready(function () {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
          $("#back-to-top").show();
        } else {
          $("#back-to-top").hide();
        }
      });
      // scroll body to 0px on click
      $("#back-to-top").click(function () {
        $("#back-to-top").tooltip("hide");
        $("body,html").animate({
          scrollTop: 0
        }, 800);
        return false;
      });

      $("#back-to-top").tooltip("show");
    });
  },

  methods: {
    projectCreate: function projectCreate() {
      this.$router.push("/projectcreate");
    },
    projectEdit: function projectEdit(id) {
      this.$router.push("/projectedit/" + id);
    },
    projectCopy: function projectCopy(id, pname) {
      this.projName = pname;
      this.projId = id;
      this.projectNameEmpty = false;
      $("#CopyProjectName").modal("show");
    },
    projCopySend: function projCopySend() {
      var _this3 = this;

      if (this.projName != "") {
        $("#CopyProjectName").modal("hide");
        var payload = { Id: this.projId, ProjectName: this.projName };
        this.$store.dispatch("projectcopy", payload).then(function (response) {
          _this3.$store.dispatch("getProjects");
        });
      } else {
        this.projectNameEmpty = true;
      }
    },
    projectDelete: function projectDelete(id) {
      var _this4 = this;

      var payload = {
        Id: id
      };
      this.$store.dispatch("projectdelete", payload).then(function (response) {
        _this4.$store.dispatch("getProjects");
      }).catch(function (error) {
        if (typeof error.data === "string" || error.data instanceof String) {
          _this4.errors = {
            error: [error.data]
          };
        } else {
          _this4.errors = error.data;
        }
      });
    },
    projectWindows: function projectWindows(proj) {
      this.$store.commit("setProject", proj);
      this.$router.push("/projectwindows/" + proj.id);
    },
    projectBOM: function projectBOM(proj) {
      this.bomprojid = proj;
      $("#BomSelection").modal("show");
    },
    projectCSV: function projectCSV(proj) {
      $("#BomSelection").modal("hide");
      this.selProj = proj.id;
      this.$store.dispatch("projectcsv", proj.id);
    },
    projectXL: function projectXL(proj) {
      $("#BomSelection").modal("hide");
      this.selProj = proj.id;
      this.$store.dispatch("projectxl", proj.id);
    },
    bommodalhide: function bommodalhide() {
      $("#BomSelection").modal("hide");
    },
    projectPDF: function projectPDF(proj) {
      this.pdfproj = proj;
      $("#PDFSelection").modal("show");
    },
    projectcopyModalHide: function projectcopyModalHide() {
      $("#CopyProjectName").modal("hide");
    },
    pdfmodalhide: function pdfmodalhide() {
      $("#PDFSelection").modal("hide");
    },
    selectusershide: function selectusershide() {
      var _this5 = this;

      $("#SharedUsersSelection").modal("hide");
      var pu = { projectId: this.selProj, users: this.projusers };
      this.$store.dispatch("selectusers", pu).then(function (response) {
        _this5.$store.dispatch("getProjects").then(function (response) {
          _this5.$store.dispatch("getSharedProjects");
        });
      });
    },
    projectPdfSeparate: function projectPdfSeparate() {
      var _this6 = this;

      this.$store.commit("setProject", this.pdfproj);
      this.selProj = this.pdfproj.id;
      $("#PDFSelection").modal("hide");
      if (this.firstpage != "0" || this.sashpage != "0" || this.framepage != "0") {
        this.$store.commit("projectPDFRequest");
        var counter = 1;
        this.pdfcaption = "PDF";
        this.$store.dispatch("getwindows", this.pdfproj.id).then(function (response) {
          var numwin = response.length;
          response.forEach(function (a) {
            var winname = a.name;
            _this6.$store.dispatch("projectwindowpdf", {
              id: a.id,
              pages: _this6.firstpage + _this6.sashpage + _this6.framepage
            }).then(function (response) {
              _this6.pdfcaption = counter + " / " + numwin;
              if (counter == numwin) {
                _this6.$store.commit("projectPDFSuccess");
              }
              counter = counter + 1;
            });
          });
        });
      }
    },
    projectPdfBundled: function projectPdfBundled() {
      var _this7 = this;

      $("#PDFSelection").modal("hide");
      if (this.firstpage != "0" || this.sashpage != "0" || this.framepage != "0") {
        this.$store.commit("projectPDFRequest");
        this.$store.dispatch("projectpdf", {
          proj: this.pdfproj,
          pages: this.firstpage + this.sashpage + this.framepage
        }).then(function (response) {
          _this7.$store.commit("projectPDFSuccess");
        });
      }
    },
    exportOrgaData: function exportOrgaData() {
      this.$store.dispatch("exportOrgaData");
    },
    users: function users() {
      this.$router.push("/users");
    },
    caption: function caption(term) {
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
    },

    versions: function versions() {
      this.$store.dispatch("setversion");
      this.$router.push("/versions");
    },
    sharedusers: function sharedusers() {
      this.$router.push("/sharedusers");
    },
    downloads: function downloads() {
      this.$router.push("/downloads");
    },
    starttour: function starttour() {
      this.$tours["ProjectTour"].start();
    },
    cilinder: function cilinder() {
      this.$router.push("/cilinders");
    },
    myTourStart: function myTourStart() {
      this.tour = true;
    },
    myTourStop: function myTourStop() {
      this.tour = false;
    },
    showConfirmDelete: function showConfirmDelete(proj) {
      this.projtodelete = proj;
      $("#ConfirmDelete").modal("show");
    },
    refresh: function refresh() {
      var _this8 = this;

      this.$store.dispatch("getProjects").then(function (response) {
        _this8.projectsloaded = true;
      });
    },

    changelanguage: function changelanguage(lang) {
      var _this9 = this;

      this.$store.dispatch("changeLanguage", { l: lang }).then(function (response) {
        _this9.$store.dispatch("userLanguage").then(function (response) {
          _this9.$store.dispatch("getTranslations");
        });
      });
    },
    showSharedUsers: function showSharedUsers(proj) {
      var _this10 = this;

      var pu = [];
      this.$store.dispatch("getProjUsers", proj).then(function (response) {
        response.data.forEach(function (item) {
          var ro = item.readonly;
          if (ro == 0) pu.push(item.userId + "W");
          if (ro == 1) pu.push(item.userId + "R");
        });
        _this10.projusers = pu;
        _this10.selProj = proj.id;
        $("#SharedUsersSelection").modal("show");
      });
    },
    getuserinfo: function getuserinfo(id) {
      var usr = this.$store.getters.getshareduser(id);
      return usr.firstName + " " + usr.lastName + ", " + usr.companyName;
    },
    getshareduserinfo: function getshareduserinfo(id, ro) {
      var usr = this.$store.getters.getshareduserinfo(id, ro);
      if (usr != null) {
        return usr.firstName + " " + usr.lastName + ", " + usr.companyName;
      }
      return "";
    },
    usrinlist: function usrinlist(id) {
      if (this.projusers.includes(id + "W") || this.projusers.includes(id + "R")) {
        return true;
      } else {
        return false;
      }
    },
    readonly: function readonly(id) {
      if (this.projusers.includes(id + "R")) return 1;else if (this.projusers.includes(id + "W")) return 2;else return 0;
    },
    setUser: function setUser(id) {
      if (this.projusers.includes(id + "R")) {
        var i = this.projusers.indexOf(id + "R");
        this.projusers.splice(i, 1);
      } else if (this.projusers.includes(id + "W")) {
        var i = this.projusers.indexOf(id + "W");
        this.projusers.splice(i, 1);
        this.projusers.push(id + "R");
      } else {
        this.projusers.push(id + "W");
      }
    },
    setSort: function setSort(so) {
      this.sortoptions = so;
      this.$store.commit("setProjectSortOptions", so);
    },
    setfirstpage: function setfirstpage() {
      if (this.firstpage == "1") {
        this.firstpage = "0";
      } else {
        this.firstpage = "1";
      }
    },
    setsashpage: function setsashpage() {
      if (this.sashpage == "1") {
        this.sashpage = "0";
      } else {
        this.sashpage = "1";
      }
    },
    setframepage: function setframepage() {
      if (this.framepage == "1") {
        this.framepage = "0";
      } else {
        this.framepage = "1";
      }
    },
    getDate: function getDate(dt) {
      var fulldate = JSON.stringify(dt);
      var timeindex = fulldate.indexOf("T");
      var date = fulldate.substring(1, timeindex);

      return date;
    },
    getDateTime: function getDateTime(dt) {
      var fulldate = JSON.stringify(dt);
      var timeindex = fulldate.indexOf("T");
      var date = fulldate.substring(1, timeindex);
      var time = fulldate.substring(timeindex + 1, timeindex + 6);
      return date + " " + time;
    },
    getprojreadonly: function getprojreadonly(pid) {
      return this.$store.getters.getprojro(pid);
    }
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  validations: {
    form: {
      custName: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      projName: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      }
    }
  },
  data: function data() {
    return {
      form: {
        custName: "",
        projName: ""
      },
      error: null
    };
  },
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__["a" /* default */]
  },
  computed: {
    proj: function proj() {
      return this.$store.getters.getProjectById(this.prid);
    },
    prid: function prid() {
      return this.$route.params.id;
    },
    sysco: function sysco() {
      return this.$store.getters.getAuth.systemCompany;
    }
  },
  mounted: function mounted() {
    this.form.custName = this.proj.customerName;
    this.form.projName = this.proj.projectName;
  },

  methods: {
    projectedit: function projectedit() {
      var _this = this;

      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      var payload = {
        Id: this.proj.id,
        CustomerName: this.form.custName,
        ProjectName: this.form.projName,
        NumWindows: 0
      };

      this.$store.dispatch("projectedit", payload).then(function (response) {
        _this.$router.push("/projects/0");
      }).catch(function (error) {
        if (typeof error.data === "string" || error.data instanceof String) {
          _this.errors = {
            error: [error.data]
          };
        } else {
          _this.errors = error.data;
        }
      });
    },
    cancel: function cancel() {
      this.$router.push("/projects/0");
    },
    caption: function caption(term) {
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  validations: {
    form: {
      custName: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      projName: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      }
    }
  },
  data: function data() {
    return {
      form: {
        custName: "",
        projName: ""
      },
      error: null
    };
  },
  computed: {
    sysco: function sysco() {
      return this.$store.getters.getAuth.systemCompany;
    }
  },
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__["a" /* default */]
  },
  methods: {
    projectcreate: function projectcreate() {
      var _this = this;

      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      var payload = {
        CustomerName: this.form.custName,
        ProjectName: this.form.projName
      };

      this.$store.dispatch("projectcreate", payload).then(function (response) {
        _this.$router.push("/projects/0");
      }).catch(function (error) {
        if (typeof error.data === "string" || error.data instanceof String) {
          _this.errors = {
            error: [error.data]
          };
        } else {
          _this.errors = error.data;
        }
      });
    },
    cancel: function cancel() {
      this.$router.push("/projects/0");
    },
    caption: function caption(term) {
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
    }
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WindowGraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClientApp_helpers_window_steps__ = __webpack_require__(127);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dimension: true,
      scale: 10,
      projectId: 0,
      selWin: 0,
      searchwin: "",
      file: '',
      uploadcaption: '',
      stepswithoutENG: __WEBPACK_IMPORTED_MODULE_4__ClientApp_helpers_window_steps__["a" /* default */].stepswithoutENG,
      stepswithENG: __WEBPACK_IMPORTED_MODULE_4__ClientApp_helpers_window_steps__["a" /* default */].stepswithENG,
      stepswithoutCHI: __WEBPACK_IMPORTED_MODULE_4__ClientApp_helpers_window_steps__["a" /* default */].stepswithoutCHI,
      stepswithCHI: __WEBPACK_IMPORTED_MODULE_4__ClientApp_helpers_window_steps__["a" /* default */].stepswithCHI,
      stepswithoutNED: __WEBPACK_IMPORTED_MODULE_4__ClientApp_helpers_window_steps__["a" /* default */].stepswithoutNED,
      stepswithNED: __WEBPACK_IMPORTED_MODULE_4__ClientApp_helpers_window_steps__["a" /* default */].stepswithNED,
      stepswithoutPOR: __WEBPACK_IMPORTED_MODULE_4__ClientApp_helpers_window_steps__["a" /* default */].stepswithoutPOR,
      stepswithPOR: __WEBPACK_IMPORTED_MODULE_4__ClientApp_helpers_window_steps__["a" /* default */].stepswithPOR,
      tour: false,
      winName: null,
      winNameEmpty: false,
      winId: null,
      copywindow: null,
      myCallbacks: {
        onStart: this.myTourStart,
        onStop: this.myTourStop
      },
      myOptionsNED: {
        labels: {
          buttonSkip: 'Verlaat tour',
          buttonPrevious: 'Vorige',
          buttonNext: 'Volgende',
          buttonStop: 'Einde'
        }
      },
      myOptionsENG: {
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      myOptionsCHI: {
        labels: {
          buttonSkip: '跳过演示说明',
          buttonPrevious: '上一步',
          buttonNext: '下一步',
          buttonStop: '演示结束'
        }
      },
      myOptionsPOR: {
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      wintodelete: 0,
      sortoptions: this.$store.getters.getWindowSortOptions,
      firstpage: '1',
      sashpage: '1',
      framepage: '1'
    };
  },
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__["a" /* default */],
    WindowGraph: __WEBPACK_IMPORTED_MODULE_1__WindowGraph__["a" /* default */]
  },
  computed: _extends({
    windows: function windows() {
      var _this = this;

      var w = this.$store.getters.getWindows;
      var so = this.$store.getters.getWindowSortOptions;
      if (w != null) {
        var wins = w.filter(function (w) {
          return w.name.toUpperCase().includes(_this.searchwin.toUpperCase());
        });
        if (so == 'newold') {
          wins.sort(function (a, b) {
            if (a.id > b.id) return -1;
            if (a.id < b.id) return 1;
            return 0;
          });
        }
        if (so == 'oldnew') {
          wins.sort(function (a, b) {
            if (a.id < b.id) return -1;
            if (a.id > b.id) return 1;
            return 0;
          });
        }
        if (so == 'byName') {
          wins.sort(function (a, b) {
            var nameA = a.name.toLowerCase(),
                nameB = b.name.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
        }
        if (this.tour == false) return wins;else return wins.slice(0, 1);
      } else return w;
    },
    proj: function proj() {
      var p = this.$store.getters.getProjectById(this.pid);
      return p;
    },
    pid: function pid() {
      return this.$route.params.id;
    },
    bom: function bom() {
      return this.$store.state.bom;
    },
    loading: function loading() {
      return this.$store.state.loading;
    },
    sysco: function sysco() {
      return this.$store.getters.getAuth.systemCompany;
    },
    fileuploading: function fileuploading() {
      return this.$store.state.fileuploading;
    },
    errorlist: function errorlist() {
      return this.$store.state.errorlist;
    },
    invalidfile: function invalidfile() {
      return this.$store.state.invalidfile;
    },
    language: function language() {
      return this.$store.state.auth.language;
    },
    setgroove: function setgroove() {
      return this.$store.getters.getAuth.setGroove;
    },
    winEmpty: function winEmpty() {
      if (this.winNameEmpty) return true;else return false;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getChrono', 'getOpDir', 'getHinge', 'getHandle', 'getGroove', 'getErrorList'])),

  methods: {
    windowCreate: function windowCreate() {
      this.$store.commit("getProject", this.proj);
      this.$router.push("/windowedit/0");
    },
    windowEdit: function windowEdit(id) {
      this.$store.commit("getProject", this.proj);
      this.$router.push("/windowedit/" + id);
    },
    windowDelete: function windowDelete(win) {
      var _this2 = this;

      this.$store.dispatch("windowdelete", win).then(function (response) {
        _this2.$store.dispatch("getwindows", _this2.projectId);
      }).catch(function (error) {
        if (typeof error.data === "string" || error.data instanceof String) {
          _this2.errors = {
            error: [error.data]
          };
        } else {
          _this2.errors = error.data;
        }
      });
    },
    windowCopy: function windowCopy(win) {
      this.copywindow = win;
      this.winName = win.name;
      this.winNameEmpty = false;
      $('#CopyWindowName').modal('show');
    },
    winCopySend: function winCopySend() {
      var _this3 = this;

      if (this.winName != "") {
        $('#CopyWindowName').modal('hide');
        var newwin = this.copywindow;
        newwin.Name = this.winName;
        this.$store.dispatch("windowpost", newwin).then(function (response) {
          _this3.$store.dispatch("getwindows", _this3.projectId);
        }).catch(function (error) {
          if (typeof error.data === "string" || error.data instanceof String) {
            _this3.errors = {
              error: [error.data]
            };
          } else {
            _this3.errors = error.data;
          }
        });
      } else {
        this.winNameEmpty = true;
      }
    },
    windowBom: function windowBom(win) {
      this.$store.commit("setWindow", win);
      this.$router.push("/bom/" + win.id);
    },
    windowPdf: function windowPdf(win) {
      $('#PDFPagesSelection').modal('show');
      this.selWin = win.id;
    },
    genericPdf: function genericPdf(win) {
      this.selWin = win.id;
      this.$store.dispatch("genericpdf", win.id);
    },

    chrono: function chrono(c) {
      var chr = this.getChrono.find(function (o) {
        return o.chronoId == c;
      });
      return chr.chronoDesc;
    },
    type: function type(w) {
      return this.$store.state.type[w];
    },
    handle: function handle(h) {
      var han = this.getHandle.find(function (o) {
        return o.handleId == h;
      });
      return han.handleDesc;
    },
    hinge: function hinge(h) {
      var hin = this.getHinge.find(function (o) {
        return o.hingeId == h;
      });
      return hin.hingeDesc;
    },
    opdir: function opdir(o) {
      var opd = this.getOpDir.find(function (d) {
        return d.openId == o;
      });
      return opd.openDesc;
    },
    groove: function groove(g) {
      var gro = this.getGroove.find(function (e) {
        return e.grooveId == g;
      });
      return gro.grooveDesc;
    },
    showProjectlist: function showProjectlist() {
      this.$store.commit("resetProject");
      this.$router.push("/projects/0");
    },
    handleBMP: function handleBMP(anr) {
      var han = this.$store.getters.getHandleByAN(anr);
      if (han != null) return han.bmp;else return null;
    },
    handleAN: function handleAN(anr) {
      var han = this.$store.getters.getHandleByAN(anr);
      if (han != null) return han.ext;else return null;
    },
    caption: function caption(term) {
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
    },
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadcaption = this.file.name;
    },
    submitFile: function submitFile() {
      var _this4 = this;

      var formdata = new FormData();
      this.$store.commit("resetErrors");
      formdata.append('file', this.file);
      this.$store.dispatch("uploadfile", formdata).then(function (response) {
        $('#UploadModal').modal('show');
        var payload = _this4.$route.params.id;
        _this4.projectId = payload;
        _this4.$store.dispatch("getwindows", payload);
      });
    },
    closeModal: function closeModal() {
      $('#UploadModal').modal('hide');
      this.$store.commit("resetInvalidFile");
    },

    starttour: function starttour() {
      this.$tours['WindowTour'].start();
    },
    myTourStart: function myTourStart() {
      this.tour = true;
    },
    myTourStop: function myTourStop() {
      this.tour = false;
    },
    showConfirmDelete: function showConfirmDelete(win) {
      this.wintodelete = win;
      $('#ConfirmDelete').modal('show');
    },
    setSort: function setSort(so) {
      this.sortoptions = so;
      this.$store.commit('setWindowSortOptions', so);
    },
    setfirstpage: function setfirstpage() {
      if (this.firstpage == '1') {
        this.firstpage = '0';
      } else {
        this.firstpage = '1';
      };
    },
    setsashpage: function setsashpage() {
      if (this.sashpage == '1') {
        this.sashpage = '0';
      } else {
        this.sashpage = '1';
      };
    },
    setframepage: function setframepage() {
      if (this.framepage == '1') {
        this.framepage = '0';
      } else {
        this.framepage = '1';
      };
    },
    pdfpageshide: function pdfpageshide() {
      $('#PDFPagesSelection').modal('hide');
      if (this.firstpage != '0' || this.sashpage != '0' || this.framepage != '0') this.$store.dispatch("windowpdf", { id: this.selWin, pages: this.firstpage + this.sashpage + this.framepage });
    },
    wincopyModalHide: function wincopyModalHide() {
      $("#CopyWindowName").modal("hide");
    },
    pdfpagesmodalhide: function pdfpagesmodalhide() {
      $('#PDFPagesSelection').modal('hide');
    },
    getprojreadonly: function getprojreadonly(pid) {
      return this.$store.getters.getprojro(pid);
    }
  },
  beforeMount: function beforeMount() {
    this.uploadcaption = this.caption("upload_select");
  },
  mounted: function mounted() {
    var payload = this.$route.params.id;
    this.projectId = payload;
    this.$store.dispatch("getwindows", payload);
    $(document).ready(function () {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
          $('#back-to-top').show();
        } else {
          $('#back-to-top').hide();
        }
      });
      // scroll body to 0px on click
      $('#back-to-top').click(function () {
        $('#back-to-top').tooltip('hide');
        $('body,html').animate({
          scrollTop: 0
        }, 800);
        return false;
      });

      $('#back-to-top').tooltip('show');
    });
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            picH: 50,
            picW: 50
        };
    },
    props: ['type', 'dir', 'hinge', 'handle', 'Fb1', 'Fb2', 'Fh', 'A', 'W1', 'W2', 'dim', 'scale', 'profile', 'config'],
    methods: {
        caption: function caption(term) {
            var cpt = this.$store.getters.getTranslationByTerm(term);
            return cpt.caption;
        }
    },
    computed: {
        rotFh90: function rotFh90() {
            return 'rotate(90 ' + (this.SFb1 + 27) + ', ' + (this.SFh / 2 + 23) + ')';
        },
        rotFh270: function rotFh270() {
            return 'rotate(270 15, ' + (this.SFh / 2 + 23) + ')';
        },
        rotSFh90: function rotSFh90() {
            return 'rotate(90 ' + (this.SFb1 + this.SFb2 + 27) + ', ' + (this.SFh / 2 + 23) + ')';
        },
        rotSFh270: function rotSFh270() {
            return 'rotate(270 15, ' + (this.SFh / 2 + 23) + ')';
        },
        rotA90: function rotA90() {
            return 'rotate(90 ' + (this.SFb1 + 27) + ', ' + (this.SFh - this.SA / 2 + 25) + ')';
        },
        rotA270: function rotA270() {
            return 'rotate(270 15,' + (this.SFh - this.SA / 2 + 21) + ')';
        },
        rotSA90: function rotSA90() {
            return 'rotate(90 ' + (this.SFb1 + this.SFb2 + 27) + ', ' + (this.SFh - this.SA / 2 + 25) + ')';
        },
        rotSA270: function rotSA270() {
            return 'rotate(270 15,' + (this.SFh - this.SA / 2 + 21) + ')';
        },
        SFb1: function SFb1() {
            return this.Fb1 / this.scale;
        },
        SFb2: function SFb2() {
            return this.Fb2 / this.scale;
        },
        SFh: function SFh() {
            return this.Fh / this.scale;
        },
        SA: function SA() {
            return this.A / this.scale;
        }
    }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WindowGraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientApp_helpers_windowedit_steps__ = __webpack_require__(132);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dimension: true,
      scale: 11,
      setOrBulk: this.caption("Set"),
      groove: "14-18",
      direction: this.caption("addwin_Right"),
      nightvent: this.caption("addwin_No"),
      magnet: this.caption("addwin_No"),
      stay: this.caption("addwin_No"),
      snapper: this.caption("addwin_No"),
      fclockcase: this.caption("addwin_No"),
      handlereinforcement: this.caption("addwin_No"),
      drillingprotection: this.caption("addwin_No"),
      adjustablefckeeps: this.caption("addwin_No"),
      handle90block: this.caption("addwin_No"),
      stype: this.caption("addwin_No"),
      linkarm: this.caption("addwin_No"),
      Stype: 0,
      form: {
        windowName: "",
        windowType: 1,
        windowQuantity: 1,
        windowChrono: 10,
        windowHinge: 1,
        windowHandle: 1,
        windowFb1: 1000,
        windowFb2: 1000,
        windowFh: 2000,
        windowA: 1000.0,
        windowWeight1: 10,
        windowWeight2: 10,
        windowColor: "CN",
        windowScrew: "6",
        windowDepth: 30,
        windowBulk: false,
        windowK12: false,
        windowMAC: false,
        windowRAB: 0,
        windowSNP: false,
        windowXVS: false,
        windowOpenDir: 1,
        windowGroove: 14,
        windowHandleAN: null,
        windowMotorAN: null,
        fcLockcase: false,
        handleReinforcement: false,
        drillingProtection: false,
        adjustableFCKeeps: false,
        handle90Block: false,
        windowSType: 0,
        profile: null
      },
      showFb2: false,
      showWeight2: false,
      weightLabel: this.caption("addwin_Weight") + "(kg)",
      error: null,
      tour: false,
      myCallbacks: {
        onStart: this.myTourStart,
        onStop: this.myTourStop
      },
      myOptionsNED: {
        labels: {
          buttonSkip: 'Verlaat tour',
          buttonPrevious: 'Vorige',
          buttonNext: 'Volgende',
          buttonStop: 'Einde'
        }
      },
      myOptionsENG: {
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      myOptionsCHI: {
        labels: {
          buttonSkip: '跳过演示说明',
          buttonPrevious: '上一步',
          buttonNext: '下一步',
          buttonStop: '演示结束'
        }
      },
      myOptionsPOR: {
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      stepsENG: __WEBPACK_IMPORTED_MODULE_5__ClientApp_helpers_windowedit_steps__["a" /* default */].stepsENG,
      stepsCHI: __WEBPACK_IMPORTED_MODULE_5__ClientApp_helpers_windowedit_steps__["a" /* default */].stepsCHI,
      stepsNED: __WEBPACK_IMPORTED_MODULE_5__ClientApp_helpers_windowedit_steps__["a" /* default */].stepsNED,
      stepsPOR: __WEBPACK_IMPORTED_MODULE_5__ClientApp_helpers_windowedit_steps__["a" /* default */].stepsPOR
    };
  },
  validations: {
    form: {
      windowName: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowType: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowQuantity: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowChrono: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowHinge: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowHandle: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowFb1: {
        minValue: 1,
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowFb2: {
        minValue: 0,
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowFh: {
        minValue: 1,
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowA: {
        minValue: 1.0,
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowWeight1: {
        minValue: 1,
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowWeight2: {
        minValue: 1,
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowColor: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowScrew: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowDepth: {
        minValue: 30,
        maxValue: 60,
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      },
      windowHandleAN: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      }
      // windowMotorAN: {
      //   required
      // },
      // windowInvisitopProfile: {
      //   required
      // }
    }
  },
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__["a" /* default */],
    WindowGraph: __WEBPACK_IMPORTED_MODULE_1__WindowGraph__["a" /* default */]
  },
  computed: {
    window: function window() {
      if (this.wid != 0) return this.$store.getters.getWindowById(this.wid);
    },
    wid: function wid() {
      return this.$route.params.id;
    },
    proj: function proj() {
      return this.$store.getters.getCurrentProject;
    },
    types: function types() {
      return this.$store.getters.getTypes;
    },
    profiles: function profiles() {
      return this.$store.getters.getProfiles;
    },
    invisitopprofiles: function invisitopprofiles() {
      return this.$store.getters.getInvisitopProfilesForWindow(this.form.windowHinge, this.form.windowChrono);
    },
    chrono: function chrono() {
      return this.$store.getters.getChrono;
    },
    hinge: function hinge() {
      return this.$store.getters.getHinge;
    },
    handles: function handles() {
      var _this = this;

      if (this.form.windowType == 1 || this.form.windowType == 2 || this.form.windowType == 21 || this.form.windowType == 22) {
        this.filteredHandles = this.$store.state.handles.filter(function (t) {
          return t.drk === 1;
        }).filter(function (t) {
          return t.rct == _this.form.windowOpenDir || t.rct == null;
        }).filter(function (c) {
          return c.col === _this.form.windowColor || c.col == null;
        }).filter(function (d) {
          return _this.form.windowChrono == 40 || _this.form.windowChrono == 50 ? d.cyl == 1 : d;
        }).filter(function (e) {
          return _this.Stype == 0 ? e.sty == 0 || e.sty == 1 || e.sty == null : _this.Stype == 1 ? e.sty == 0 : _this.Stype == 2 ? e.sty == 1 : _this.Stype == 3 ? e.sty == null : e.sty == 0 || e.sty == 1 || e.sty == null;
        });
      }
      if (this.form.windowType == 3 || this.form.windowType == 4 || this.form.windowType == 23) {
        this.filteredHandles = this.$store.state.handles.filter(function (t) {
          return t.kdr === 1;
        }).filter(function (t) {
          return t.rct == _this.form.windowOpenDir || t.rct == null;
        }).filter(function (c) {
          return c.col === _this.form.windowColor || c.col == null;
        }).filter(function (d) {
          return _this.form.windowChrono == 40 || _this.form.windowChrono == 50 ? d.cyl == 1 : d;
        }).filter(function (e) {
          return _this.Stype == 0 ? e.sty == 0 || e.sty == 1 || e.sty == null : _this.Stype == 1 ? e.sty == 0 : _this.Stype == 2 ? e.sty == 1 : _this.Stype == 3 ? e.sty == null : e.sty == 0 || e.sty == 1 || e.sty == null;
        });
      }
      if (this.form.windowType == 6 || this.form.windowType == 60 || this.form.windowType == 7 || this.form.windowType == 8 || this.form.windowType == 26 || this.form.windowType == 27) {
        this.filteredHandles = this.$store.state.handles.filter(function (t) {
          return t.drr === 1;
        }).filter(function (t) {
          return t.rct == _this.form.windowOpenDir || t.rct == null;
        }).filter(function (c) {
          return c.col === _this.form.windowColor || c.col == null;
        }).filter(function (d) {
          return _this.form.windowChrono == 40 || _this.form.windowChrono == 50 ? d.cyl == 1 : d;
        }).filter(function (e) {
          return _this.Stype == 0 ? e.sty == 0 || e.sty == 1 || e.sty == null : _this.Stype == 1 ? e.sty == 0 : _this.Stype == 2 ? e.sty == 1 : _this.Stype == 3 ? e.sty == null : e.sty == 0 || e.sty == 1 || e.sty == null;
        });
      }
      if (this.form.windowType == 30 || this.form.windowType == 31) {
        this.filteredHandles = this.$store.state.handles.filter(function (t) {
          return t.oo === 1;
        }).filter(function (t) {
          return t.rct == _this.form.windowOpenDir || t.rct == null;
        }).filter(function (c) {
          return c.col === _this.form.windowColor || c.col == null;
        }).filter(function (d) {
          return _this.form.windowChrono == 40 || _this.form.windowChrono == 50 ? d.cyl == 1 : d;
        });
      }
      var flag = 0;

      this.filteredHandles.forEach(function (element) {
        if (element.anr == _this.form.windowHandleAN) {
          flag = 1;
        }
      });
      if (flag == 0) this.form.windowHandleAN = null;

      return this.filteredHandles;
    },
    motor: function motor() {
      return this.$store.getters.getMotors;
    },
    color: function color() {
      return this.$store.getters.getColor;
    },
    screw: function screw() {
      return this.$store.getters.getScrew;
    },
    selectedHandle: function selectedHandle() {
      return this.$store.getters.getHandleByAN(this.form.windowHandleAN);
    },
    selHandle: function selHandle() {
      var sh = this.$store.getters.getHandleByAN(this.form.windowHandleAN);
      if (sh != null) return sh.bmp;else return '';
    },
    Error: function Error() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = this.caption("addwin_Error");
      return msg;
    },
    Fb1Error: function Fb1Error() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.fb1Error;
      return msg;
    },
    Fb2Error: function Fb2Error() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.fb2Error;
      return msg;
    },
    FhError: function FhError() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.fhError;
      return msg;
    },
    AError: function AError() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.aError;
      return msg;
    },
    W1Error: function W1Error() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.w1Error;
      return msg;
    },
    W2Error: function W2Error() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.w2Error;
      return msg;
    },
    HingeError: function HingeError() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.hingeError;
      return msg;
    },
    HandleError: function HandleError() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.handleError;
      return msg;
    },
    MotorError: function MotorError() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.motorError;
      return msg;
    },
    VentError: function VentError() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.ventError;
      return msg;
    },
    MagnetError: function MagnetError() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.magnetError;
      return msg;
    },
    SnapperError: function SnapperError() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.snapperError;
      return msg;
    },
    ChronoError: function ChronoError() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.chronoError;
      return msg;
    },
    XVSError: function XVSError() {
      var errormsg = this.$store.state.windowCreateResponse;
      var msg = "";
      if (errormsg != null && errormsg.err == 1) msg = errormsg.xvserror;
      return msg;
    },
    sysco: function sysco() {
      return this.$store.getters.getAuth.systemCompany;
    },
    setgroove: function setgroove() {
      return this.$store.getters.getAuth.setGroove;
    },
    getgroove: function getgroove() {
      return this.$store.getters.getAuth.groove;
    },
    setpackaging: function setpackaging() {
      return this.$store.getters.getAuth.setPackaging;
    },
    getpackaging: function getpackaging() {
      return this.$store.getters.getAuth.packaging;
    },
    sethandleplate: function sethandleplate() {
      return this.$store.getters.getAuth.setHandlePlate;
    },
    gethandleplate: function gethandleplate() {
      return this.$store.getters.getAuth.handlePlate;
    },
    setblock90: function setblock90() {
      return this.$store.getters.getAuth.setBlock90;
    },
    getblock90: function getblock90() {
      return this.$store.getters.getAuth.block90;
    },

    // setdrillingprotection() {
    //   return this.$store.getters.getAuth.setDrillingProtection;
    // },
    // getdrillingprotection() {
    //   return this.$store.getters.getAuth.drillingProtection;
    // },
    setfcscrew: function setfcscrew() {
      return this.$store.getters.getAuth.setFCScrew;
    },
    getfcscrew: function getfcscrew() {
      return this.$store.getters.getAuth.fcScrew;
    },
    setfcprofile: function setfcprofile() {
      return this.$store.getters.getAuth.setFCProfile;
    },
    getfcprofile: function getfcprofile() {
      return this.$store.getters.getAuth.fcProfile;
    },
    setfccentral: function setfccentral() {
      return this.$store.getters.getAuth.setFCCentral;
    },
    getfccentral: function getfccentral() {
      return this.$store.getters.getAuth.fcCentral;
    },
    setfcadjkeeps: function setfcadjkeeps() {
      return this.$store.getters.getAuth.setFCAdjKeeps;
    },
    getfcadjkeeps: function getfcadjkeeps() {
      return this.$store.getters.getAuth.fcAdjKeeps;
    },
    setfcmagnet: function setfcmagnet() {
      return this.$store.getters.getAuth.setFCMagnet;
    },
    getfcmagnet: function getfcmagnet() {
      return this.$store.getters.getAuth.fcMagnet;
    },
    language: function language() {
      return this.$store.state.auth.language;
    }
  },
  mounted: function mounted() {
    if (this.wid != 0) {
      this.form.windowName = this.window.name;
      this.form.windowType = this.window.windowType;
      this.form.windowQuantity = this.window.quantity;
      this.form.windowChrono = this.window.chrono;
      this.form.windowHinge = this.window.hingeType;
      this.form.windowHandle = this.window.handleType;
      this.form.windowFb1 = this.window.fb1;
      this.form.windowFb2 = this.window.fb2;
      if (this.window.fb2 == 0) {
        this.form.windowFb2 = 1000;
        this.form.windowWeight2 = 10;
        this.showFb2 = false;
        this.showWeight2 = false;
        this.widthLabel = this.caption("addwin_Fb");
        this.weightLabel = this.caption("addwin_Weight") + "(kg)";
      }
      if (this.window.fb2 != 0) {
        this.showFb2 = true;
        this.showWeight2 = true;
        this.widthLabel = this.caption("addwin_Fb1");
        this.weightLabel = this.caption("addwin_Weight") + "(kg)";
      }
      this.form.windowFh = this.window.fh;
      this.form.windowA = this.window.a;
      this.form.windowWeight1 = this.window.weight1;
      this.form.windowWeight2 = this.window.weight2;
      this.form.windowColor = this.window.colorCode;
      this.form.windowScrew = this.window.screwLength;
      this.form.windowDepth = this.window.profileDepth;
      this.form.windowBulk = this.window.bulk;
      this.form.windowK12 = this.window.k12;
      this.form.windowMAC = this.window.mac;
      this.form.windowRAB = this.window.rab;
      this.form.windowSNP = this.window.snp;
      this.form.windowXVS = this.window.xvs;
      this.form.windowOpenDir = this.window.openDir;
      this.form.windowGroove = this.window.groove;
      this.form.windowHandleAN = this.window.handleAN;
      this.form.windowMotorAN = this.window.motorAN;
      this.form.fcLockcase = this.window.fcLockcase;
      this.form.handleReinforcement = this.window.handleReinforcement;
      this.form.drillingProtection = this.window.drillingProtection;
      this.form.adjustableFCKeeps = this.window.adjustableFCKeeps;
      this.form.handle90Block = this.window.handle90Block;
      this.setOrBulk = this.form.windowBulk != true ? this.caption("Set") : this.caption("Bulk");
      this.groove = this.form.windowGroove == 14 ? "14-18" : "10-14";
      this.direction = this.form.windowOpenDir == 1 ? this.caption("addwin_Right") : this.caption("addwin_Left");
      this.nightvent = this.form.windowK12 == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes");
      this.magnet = this.form.windowMAC == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes");
      this.linkarm = this.form.windowXVS == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes");
      if (this.form.windowHinge != 5) {
        this.stay = this.form.windowRAB == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes");
      }
      if (this.form.windowHinge == 5) {
        if (this.form.windowRAB == 0) this.stay = this.caption("addwin_No");
        if (this.form.windowRAB == 1) this.stay = "= 90°";
        if (this.form.windowRAB == 2) this.stay = "< 90°";
      }
      this.snapper = this.form.windowSNP == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes");
      this.fclockcase = this.form.fcLockcase == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes");
      this.handlereinforcement = this.form.handleReinforcement == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes");
      this.drillingprotection = this.form.drillingProtection == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes");
      this.adjustablefckeeps = this.form.adjustableFCKeeps == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes");
      this.handle90block = this.form.handle90Block == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes");
      this.form.profile = this.window.profile;
    }
    this.$store.commit("resetError");
  },

  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['windowedit', 'windowpost', 'getwindows']), {
    setFb2: function setFb2(wt) {
      if (wt == 2 || wt == 4 || wt == 60 || wt == 22 || wt == 24 || wt == 27 || wt == 31) {
        this.showFb2 = true;
        this.showWeight2 = true;
        if (this.form.weight2 == 0) this.form.weight2 = 1;
        this.weightLabel = this.caption("addwin_Weight") + "(kg)";
        this.form.windowMotorAN = "";
      } else {
        this.showFb2 = false;
        this.showWeight2 = false;
        if (this.form.weight2 != 0) this.form.weight2 = 0;
        this.weightLabel = this.caption("addwin_Weight") + "(kg)";
      }
      if (wt == 4 && this.form.windowChrono == 10) {
        this.form.fcLockcase = 1;
        this.fclockcase = this.caption("addwin_Yes");
        this.form.windowMotorAN = "";
      }
      if (wt == 50 || wt == 55) {
        this.form.windowA = this.form.windowFh / 2;

        this.form.windowSNP = 0;
        this.snapper = this.caption("addwin_No");

        this.form.windowRAB = 0;
        this.stay = this.caption("addwin_No");

        this.form.windowK12 = 0;
        this.nightvent = this.caption("addwin_No");

        this.form.windowMAC = 0;
        this.magnet = this.caption("addwin_No");

        this.form.windowHandle = 0;
        this.form.windowHandleAN = 'ENVI NO HANDLE';

        this.form.windowFb2 = 0;
        this.form.windowWeight2 = 0;
        this.showFb2 = false;
        this.showWeight2 = false;

        if (this.motor.length > 0) {
          this.form.windowMotorAN = this.motor[0].ext;
        }

        if (this.invisitopprofiles.length > 0) {
          this.form.profile = this.invisitopprofiles[0].prf;
        }
      }
      if (wt != 55) {
        this.form.windowMotorAN = "";
        this.form.profile = "";
      }
    },
    setA: function setA(wt) {
      if (wt != 8) this.form.windowA = this.form.windowFh / 2;else this.form.windowA = this.form.windowFb1 / 2;
    },
    SetPackaging: function SetPackaging() {
      this.form.windowBulk = !this.form.windowBulk;
      if (this.form.windowBulk == true) {
        this.setOrBulk = this.caption("Bulk");
      } else {
        this.setOrBulk = this.caption("Set");
      }
    },
    SetGroove: function SetGroove() {
      if (this.form.windowGroove == 14) {
        this.form.windowGroove = 10;
        this.groove = "10-14";
      } else {
        this.form.windowGroove = 14;
        this.groove = "14-18";
      }
    },
    SetDirection: function SetDirection() {
      if (this.form.windowOpenDir == 1) {
        this.form.windowOpenDir = 2;
        this.direction = this.caption("addwin_Left");
      } else {
        this.form.windowOpenDir = 1;
        this.direction = this.caption("addwin_Right");
      }
    },
    SetNightvent: function SetNightvent() {
      if (this.form.windowK12 == 1) {
        this.form.windowK12 = 0;
        this.nightvent = this.caption("addwin_No");
      } else {
        this.form.windowK12 = 1;
        this.nightvent = this.caption("addwin_Yes");
      }
    },
    SetMagnet: function SetMagnet() {
      if (this.form.windowMAC == 1) {
        this.form.windowMAC = 0;
        this.magnet = this.caption("addwin_No");
      } else {
        this.form.windowMAC = 1;
        this.magnet = this.caption("addwin_Yes");
      }
    },
    SetStay: function SetStay() {
      if (this.form.windowHinge != 5) {
        if (this.form.windowRAB == 1) {
          this.form.windowRAB = 0;
          this.stay = this.caption("addwin_No");
        } else {
          this.form.windowRAB = 1;
          this.stay = this.caption("addwin_Yes");
        }
      } else if (this.form.windowHinge == 5 && this.form.windowType != 30 && this.form.windowType != 31) {
        var rab = this.form.windowRAB;
        switch (rab) {
          case 1:
            this.form.windowRAB = 2;
            this.stay = "< 90°";
            break;
          case 2:
            this.form.windowRAB = 0;
            this.stay = this.caption("addwin_No");
            break;
          case 0:
            this.form.windowRAB = 1;
            this.stay = "= 90°";
            break;
          default:
        }
      } else if (this.form.windowHinge == 5 && (this.form.windowType == 30 || this.form.windowType == 31)) {
        if (this.form.windowRAB == 1) {
          this.form.windowRAB = 0;
          this.stay = this.caption("addwin_No");
        } else {
          this.form.windowRAB = 1;
          this.stay = this.caption("addwin_Yes");
        }
      }
    },
    SetSnapper: function SetSnapper() {
      if (this.form.windowSNP == 1) {
        this.form.windowSNP = 0;
        this.snapper = this.caption("addwin_No");
      } else {
        this.form.windowSNP = 1;
        this.snapper = this.caption("addwin_Yes");
      }
    },
    SetFCLockcase: function SetFCLockcase() {
      if (this.form.fcLockcase == 1) {
        this.form.fcLockcase = 0;
        this.fclockcase = this.caption("addwin_No");
      } else {
        this.form.fcLockcase = 1;
        this.fclockcase = this.caption("addwin_Yes");
      }
    },
    SetLinkArm: function SetLinkArm() {
      if (this.form.windowXVS == 1) {
        this.form.windowXVS = 0;
        this.linkarm = this.caption("addwin_No");
      } else {
        this.form.windowXVS = 1;
        this.linkarm = this.caption("addwin_Yes");
      }
    },
    SetChrono: function SetChrono() {
      if (this.form.windowChrono != 40) {
        this.form.drillingProtection = 0;
        this.drillingprotection = this.caption("addwin_No");
      }
      if (this.form.windowChrono == 10 && this.form.windowType == 4) {
        this.form.fcLockcase = 1;
        this.fclockcase = this.caption("addwin_Yes");
      }
    },
    SetHandleReinforcement: function SetHandleReinforcement() {
      if (this.form.handleReinforcement == 1) {
        this.form.handleReinforcement = 0;
        this.handlereinforcement = this.caption("addwin_No");
      } else {
        this.form.handleReinforcement = 1;
        this.handlereinforcement = this.caption("addwin_Yes");
      }
    },
    SetDrillingProtection: function SetDrillingProtection() {
      if (this.form.drillingProtection == 1) {
        this.form.drillingProtection = 0;
        this.drillingprotection = this.caption("addwin_No");
      } else {
        this.form.drillingProtection = 1;
        this.drillingprotection = this.caption("addwin_Yes");
      }
    },
    SetAdjustableFCKeeps: function SetAdjustableFCKeeps() {
      if (this.form.adjustableFCKeeps == 1) {
        this.form.adjustableFCKeeps = 0;
        this.adjustablefckeeps = this.caption("addwin_No");
      } else {
        this.form.adjustableFCKeeps = 1;
        this.adjustablefckeeps = this.caption("addwin_Yes");
      }
    },
    SetHandle90Block: function SetHandle90Block() {
      if (this.form.handle90Block == 1) {
        this.form.handle90Block = 0;
        this.handle90block = this.caption("addwin_No");
      } else {
        this.form.handle90Block = 1;
        this.handle90block = this.caption("addwin_Yes");
      }
    },
    checkHandlePosition: function checkHandlePosition() {
      if (this.form.windowA > this.form.windowFh / 2 && this.form.windowType != 8) $('#HandlePosition').modal('show');else this.edit();
    },

    hideModal: function hideModal() {
      $('#HandlePosition').modal('hide');
      this.edit();
    },
    isFCLockCaseAvailable: function isFCLockCaseAvailable() {
      return showFb2 && !(form.windowType == 4 && form.windowChrono == 10) && form.windowType != 22 && form.windowType != 27 && form.windowType != 31 && (form.windowChrono == 10 || form.windowChrono == 20) && setfccentral == false;
    },
    edit: function edit() {
      var _this2 = this;

      this.$v.form.$touch();
      if (this.$v.form.$error) return;
      if (this.form.windowType == 1 || this.form.windowType == 3 || this.form.windowType == 6 || this.form.windowType == 7 || this.form.windowType == 8 || this.form.WindowType == 16 || this.form.WindowType == 46 || this.form.windowType == 30 || this.form.windowType == 21 || this.form.windowType == 23 || this.form.windowType == 26 || this.form.windowType == 50 || this.form.WindowType == 55) {
        this.form.windowFb2 = 0;
        this.form.windowWeight2 = 1;
      }
      if (this.selectedHandle != null && this.selectedHandle.vrk != 1) this.form.handleReinforcement = 0;
      if (this.form.fcLockcase == 1) this.form.adjustableFCKeeps = 0;

      var editPayload = {
        Id: this.wid,
        ProjectId: this.proj.id,
        Name: this.form.windowName,
        Quantity: this.form.windowQuantity,
        Chrono: this.form.windowChrono,
        HingeType: this.form.windowHinge,
        HandleType: this.selectedHandle.vrk,
        OpenDir: Number(this.form.windowOpenDir),
        Fb1: this.form.windowFb1,
        Fb2: this.form.windowFb2,
        Fh: this.form.windowFh,
        A: this.form.windowA,
        RAB: this.form.windowRAB,
        MAC: this.form.windowMAC ? 1 : 0,
        K12: this.form.windowK12 ? 1 : 0,
        SNP: this.form.windowSNP ? 1 : 0,
        XVS: this.form.windowXVS ? 1 : 0,
        HandleAN: this.selectedHandle.anr,
        MotorAN: this.form.windowMotorAN,
        ColorCode: this.form.windowColor,
        WindowType: this.form.windowType,
        Weight1: this.form.windowWeight1,
        Weight2: this.form.windowWeight2,
        Groove: this.setgroove ? this.getgroove : Number(this.form.windowGroove),
        ScrewLength: this.setfcscrew ? this.getfcscrew : Number(this.form.windowScrew),
        ProfileDepth: this.setfcprofile ? this.getfcprofile : this.form.windowDepth,
        Bulk: this.setpackaging ? this.getpackaging : this.form.windowBulk ? 1 : 0,
        HandleSType: this.selectedHandle.sty != null ? this.selectedHandle.sty : 0,
        FCLockcase: this.isFCLockCaseAvailable ? this.setfccentral ? this.getfccentral : this.form.fcLockcase ? 1 : 0 : 1,
        HandleReinforcement: this.sethandleplate ? this.gethandleplate : this.form.handleReinforcement ? 1 : 0,
        DrillingProtection: this.form.drillingProtection ? 1 : 0,
        AdjustableFCKeeps: this.setfcadjkeeps ? this.getfcadjkeeps : this.form.adjustableFCKeeps ? 1 : 0,
        Magnet: this.setfcmagnet ? this.getfcmagnet : this.form.magnet ? 1 : 0,
        Handle90Block: this.setblock90 ? this.getblock90 : this.form.handle90Block ? 1 : 0,
        Profile: this.form.profile
      };

      var createPayload = {
        ProjectId: this.proj.id,
        Name: this.form.windowName,
        Quantity: this.form.windowQuantity,
        Chrono: this.form.windowChrono,
        HingeType: this.form.windowHinge,
        HandleType: this.selectedHandle.vrk,
        OpenDir: Number(this.form.windowOpenDir),
        Fb1: this.form.windowFb1,
        Fb2: this.form.windowFb2,
        Fh: this.form.windowFh,
        A: this.form.windowA,
        RAB: this.form.windowRAB,
        MAC: this.form.windowMAC ? 1 : 0,
        K12: this.form.windowK12 ? 1 : 0,
        SNP: this.form.windowSNP ? 1 : 0,
        XVS: this.form.windowXVS ? 1 : 0,
        HandleAN: this.selectedHandle.anr,
        MotorAN: this.form.windowMotorAN,
        ColorCode: this.form.windowColor,
        WindowType: this.form.windowType,
        Weight1: this.form.windowWeight1,
        Weight2: this.form.windowWeight2,
        Groove: this.setgroove ? this.getgroove : Number(this.form.windowGroove),
        ScrewLength: this.setfcscrew ? this.getfcscrew : Number(this.form.windowScrew),
        ProfileDepth: this.setfcprofile ? this.getfcprofile : this.form.windowDepth,
        Bulk: this.setpackaging ? this.getpackaging : this.form.windowBulk ? 1 : 0,
        HandleSType: this.selectedHandle.sty != null ? this.selectedHandle.sty : 0,
        FCLockcase: this.isFCLockCaseAvailable ? this.setfccentral ? this.getfccentral : this.form.fcLockcase ? 1 : 0 : 1,
        HandleReinforcement: this.sethandleplate ? this.gethandleplate : this.form.handleReinforcement ? 1 : 0,
        DrillingProtection: this.form.drillingProtection ? 1 : 0,
        AdjustableFCKeeps: this.setfcadjkeeps ? this.getfcadjkeeps : this.form.adjustableFCKeeps ? 1 : 0,
        Magnet: this.setfcmagnet ? this.getfcmagnet : this.form.magnet ? 1 : 0,
        Handle90Block: this.setblock90 ? this.getblock90 : this.form.handle90Block ? 1 : 0,
        Profile: this.form.profile
      };
      if (this.wid != 0) {
        this.windowedit(editPayload).then(function () {
          if (_this2.$store.state.windowCreateResponse.err == 0) {
            _this2.getwindows(_this2.proj.id);
            _this2.$router.go(-1);
          }
        });
      }
      if (this.wid == 0) {
        this.windowpost(createPayload).then(function () {
          if (_this2.$store.state.windowCreateResponse.err == 0) {
            _this2.getwindows(_this2.proj.id);
            _this2.$router.push("/projectwindows/" + _this2.proj.id);
          }
        });
      }
    },
    cancel: function cancel() {
      this.$router.push("/projectwindows/" + this.proj.id);
    },
    caption: function caption(term) {
      var cpt = this.$store.getters.getTranslationByTerm(term);
      if (cpt === undefined) {
        return "";
      }

      return cpt.caption;
    },

    starttour: function starttour() {
      this.$tours['WindowEditTour'].start();
    },
    myTourStart: function myTourStart() {
      this.tour = true;
    },
    myTourStop: function myTourStop() {
      this.tour = false;
    },
    changehinge: function changehinge() {
      var _this3 = this;

      this.form.windowRAB = 0;
      this.stay = this.caption("addwin_No");

      if (this.form.windowType == 50 || this.form.windowType == 55) {
        if (this.invisitopprofiles.length > 0) {
          if (this.invisitopprofiles.filter(function (x) {
            return x.prf == _this3.form.profile;
          }) == null) {
            this.form.profile = this.invisitopprofiles[0].prf;
          }
        }
      } else {
        this.form.profile = "";
      }
    }
  })
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WindowGraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dimension: true,
      scale: 10
    };
  },
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__["a" /* default */],
    WindowGraph: __WEBPACK_IMPORTED_MODULE_1__WindowGraph__["a" /* default */]
  },
  computed: _extends({
    proj: function proj() {
      return this.$store.state.project;
    },
    win: function win() {
      return this.$store.state.window;
    },
    bom: function bom() {
      return this.$store.state.bom;
    },
    sysco: function sysco() {
      return this.$store.getters.getAuth.systemCompany;
    },
    language: function language() {
      return this.$store.state.auth.language;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getChrono', 'getHinge', 'getHandle', 'getGroove'])),
  mounted: function mounted() {
    this.$store.dispatch("windowbom", this.win.id);
  },

  methods: {
    showProjectlist: function showProjectlist() {
      this.$router.push("/projects");
    },
    showWindowlist: function showWindowlist() {
      this.$router.push("/projectwindows/" + this.proj.id);
    },
    chrono: function chrono(c) {
      var chr = this.getChrono.find(function (o) {
        return o.chronoId == c;
      });
      return chr.chronoDesc;
    },
    handle: function handle(h) {
      var han = this.getHandle.find(function (o) {
        return o.handleId == h;
      });
      return han.handleDesc;
    },
    hinge: function hinge(h) {
      var hin = this.getHinge.find(function (o) {
        return o.hingeId == h;
      });
      return hin.hingeDesc;
    },
    groove: function groove(g) {
      var gro = this.getGroove.find(function (e) {
        return e.grooveId == g;
      });
      return gro.grooveDesc;
    },
    handleAN: function handleAN(anr) {
      var han = this.$store.getters.getHandleByAN(anr);
      return han.bmp;
    },
    getCsv: function getCsv() {
      this.$store.dispatch("windowcsv", this.win.id);
    },
    getXl: function getXl() {
      this.$store.dispatch("windowxl", this.win.id);
    },
    caption: function caption(term) {
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      error: null,
      usersloaded: false,
      searchuser: "",
      users: null
    };
  },
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__["a" /* default */]
  },
  computed: _extends({
    role: function role() {
      return this.$store.state.auth.role;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getSysco'])),
  methods: {
    EditUser: function EditUser(id) {
      this.$router.push("/edituser/" + id);
    },
    sysco: function sysco(s) {
      var sc = this.getSysco.find(function (o) {
        return o.code == s;
      });
      return sc.desc;
    },
    backToProjects: function backToProjects() {
      this.$router.push("/projects/0");
    },
    userlist: function userlist() {
      var _this = this;

      var u = this.$store.getters.getUserlist;
      if (u != null) {
        return u.filter(function (f) {
          return f.firstName.toUpperCase().concat(f.lastName.toUpperCase()).concat(f.companyName.toUpperCase()).concat(f.role.toString()).includes(_this.searchuser.toUpperCase());
        });
      } else return u;
    },
    ProjectList: function ProjectList(id) {
      this.$router.push("/projects/" + id);
    }
  },

  beforeCreate: function beforeCreate() {
    var _this2 = this;

    this.$store.dispatch("getUsers").then(function (response) {
      _this2.usersloaded = true;
    });
  },
  mounted: function mounted() {
    $(document).ready(function () {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
          $('#back-to-top').show();
        } else {
          $('#back-to-top').hide();
        }
      });
      // scroll body to 0px on click
      $('#back-to-top').click(function () {
        $('#back-to-top').tooltip('hide');
        $('body,html').animate({
          scrollTop: 0
        }, 800);
        return false;
      });

      $('#back-to-top').tooltip('show');
    });
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientApp_store__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        userId: null,
        userCompanyName: "",
        userLanguage: "",
        userCountry: "",
        userFirstName: "",
        userLastName: "",
        userSystemCompany: null,
        userRole: null,
        userSetPackaging: null,
        userPackaging: null,
        userSetGroove: null,
        userGroove: null,
        userSetHandlePlate: null,
        userHandlePlate: null,
        userSetBlock90: null,
        userBlock90: null,
        userSetFCScrew: null,
        userFCScrew: null,
        userSetFCProfile: null,
        userFCProfile: null,
        userSetFCCentral: null,
        userFCCentral: null,
        userSetFCAdjKeeps: null,
        userFCAdjKeeps: null,
        userSetFCMagnet: null,
        userFCMagnet: null
      }
    };
  },
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__["a" /* default */]
  },
  computed: {
    usersettings: function usersettings() {
      return this.$store.getters.getUserById(this.userid);
    },
    userid: function userid() {
      return this.$route.params.id;
    },
    packagingCaption: function packagingCaption() {
      return this.form.userSetPackaging ? 'Packaging On' : 'Packaging Off';
    },
    grooveCaption: function grooveCaption() {
      return this.form.userSetGroove ? 'Groove On' : 'Groove Off';
    },
    handleplateCaption: function handleplateCaption() {
      return this.form.userSetHandlePlate ? 'Handle Reinforce On' : 'Handle Reinforce Off';
    },
    block90Caption: function block90Caption() {
      return this.form.userSetBlock90 ? '90° Block On' : '90° Block Off';
    },
    fcScrewCaption: function fcScrewCaption() {
      return this.form.userSetFCScrew ? 'FC Bolt Screw On' : 'FC Bolt Screw Off';
    },
    fcProfileCaption: function fcProfileCaption() {
      return this.form.userSetFCProfile ? 'FC Profile Depth On' : 'FC Profile Depth Off';
    },
    fcCentralCaption: function fcCentralCaption() {
      return this.form.userSetFCCentral ? 'FC Central Lock On' : 'FC Central Lock Off';
    },
    fcAdjKeepsCaption: function fcAdjKeepsCaption() {
      return this.form.userSetFCAdjKeeps ? 'FC Adjustable Keeps On' : 'FC Adjustable Keeps Off';
    },
    fcMagnetCaption: function fcMagnetCaption() {
      return this.form.userSetFCMagnet ? 'FC Magnet Show' : 'FC Magnet Hide';
    },
    role: function role() {
      return this.$store.state.auth.role;
    }
  },
  methods: {
    useredit: function useredit() {
      var _this = this;

      var payload = {
        UserId: this.userid,
        CompanyName: this.form.userCompanyName,
        SystemCompany: this.form.userSystemCompany,
        Language: this.form.userLanguage,
        FirstName: this.form.userFirstName,
        LastName: this.form.userLastName,
        Country: this.form.userCountry,
        Role: this.form.userRole,
        SetPackaging: this.form.userSetPackaging,
        Packaging: this.form.userPackaging,
        SetGroove: this.form.userSetGroove,
        Groove: this.form.userGroove,
        SetHandlePlate: this.form.userSetHandlePlate,
        HandlePlate: this.form.userHandlePlate,
        SetBlock90: this.form.userSetBlock90,
        Block90: this.form.userBlock90,
        SetFCScrew: this.form.userSetFCScrew,
        FCScrew: this.form.userFCScrew,
        SetFCProfile: this.form.userSetFCProfile,
        FCProfile: this.form.userFCProfile,
        SetFCCentral: this.form.userSetFCCentral,
        FCCentral: this.form.userFCCentral,
        SetFCAdjKeeps: this.form.userSetFCAdjKeeps,
        FCAdjKeeps: this.form.userFCAdjKeeps,
        SetFCMagnet: this.form.userSetFCMagnet,
        FCMagnet: this.form.userFCMagnet
      };

      this.$store.dispatch("useredit", payload).then(function (response) {
        _this.$store.dispatch("userLanguage").then(function (response) {
          _this.$router.push("/users");
        });
      }).catch(function (error) {
        _this.errors = error.data;
      });
    },
    cancel: function cancel() {
      this.$router.push("/users");
    },
    togglePackaging: function togglePackaging() {
      this.form.userSetPackaging = !this.form.userSetPackaging;
    },
    toggleGroove: function toggleGroove() {
      this.form.userSetGroove = !this.form.userSetGroove;
    },
    toggleHandleplate: function toggleHandleplate() {
      this.form.userSetHandlePlate = !this.form.userSetHandlePlate;
    },
    toggleBlock90: function toggleBlock90() {
      this.form.userSetBlock90 = !this.form.userSetBlock90;
    },
    toggleFCScrew: function toggleFCScrew() {
      this.form.userSetFCScrew = !this.form.userSetFCScrew;
    },
    toggleFCProfile: function toggleFCProfile() {
      this.form.userSetFCProfile = !this.form.userSetFCProfile;
    },
    toggleFCCentral: function toggleFCCentral() {
      this.form.userSetFCCentral = !this.form.userSetFCCentral;
    },
    toggleFCAdjKeeps: function toggleFCAdjKeeps() {
      this.form.userSetFCAdjKeeps = !this.form.userSetFCAdjKeeps;
    },
    toggleFCMagnet: function toggleFCMagnet() {
      this.form.userSetFCMagnet = !this.form.userSetFCMagnet;
    }
  },

  mounted: function mounted() {
    this.form.userCompanyName = this.usersettings.companyName;
    this.form.userLanguage = this.usersettings.language;
    this.form.userSystemCompany = this.usersettings.systemCompany;
    this.form.userFirstName = this.usersettings.firstName;
    this.form.userLastName = this.usersettings.lastName;
    this.form.userRole = this.usersettings.role;
    this.form.userCountry = this.usersettings.country;
    this.form.userSetPackaging = this.usersettings.setPackaging;
    this.form.userPackaging = this.usersettings.packaging;
    this.form.userSetGroove = this.usersettings.setGroove;
    this.form.userGroove = this.usersettings.groove;
    this.form.userSetHandlePlate = this.usersettings.setHandlePlate;
    this.form.userHandlePlate = this.usersettings.handlePlate;
    this.form.userSetBlock90 = this.usersettings.setBlock90;
    this.form.userBlock90 = this.usersettings.block90;
    this.form.userSetFCScrew = this.usersettings.setFCScrew;
    this.form.userFCScrew = this.usersettings.fcScrew;
    this.form.userSetFCProfile = this.usersettings.setFCProfile;
    this.form.userFCProfile = this.usersettings.fcProfile;
    this.form.userSetFCCentral = this.usersettings.setFCCentral;
    this.form.userFCCentral = this.usersettings.fcCentral;
    this.form.userSetFCAdjKeeps = this.usersettings.setFCAdjKeeps;
    this.form.userFCAdjKeeps = this.usersettings.fcAdjKeeps;
    this.form.userSetFCMagnet = this.usersettings.setFCMagnet;
    this.form.userFCMagnet = this.usersettings.fcMagnet;
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      error: null,
      sharedusersloaded: false,
      userEmail: null,
      emailEmpty: true
    };
  },
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__["a" /* default */]
  },
  computed: _extends({
    sharedusers: function sharedusers() {
      var u = this.$store.state.sharedusers;
      return u;
    },
    lang: function lang() {
      var l = this.$store.getters.getLanguage;
      return l;
    },
    projEmpty: function projEmpty() {
      if (this.emailEmpty) return true;else return false;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getSysco', 'getVNList'])),
  methods: {
    backToProjects: function backToProjects() {
      this.$router.push("/projects/0");
    },
    caption: function caption(term) {
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
    },
    addUser: function addUser() {
      $('#AddUser').modal('show');
    },
    deleteuser: function deleteuser(payload) {
      var _this = this;

      this.$store.dispatch("deleteUser", payload).then(function (response) {
        _this.$store.dispatch("getSharedUsers");
      });
    },
    userModalHide: function userModalHide() {
      $('#AddUser').modal('hide');
    },
    notFoundHide: function notFoundHide() {
      $('#NotFound').modal('hide');
    },
    userSend: function userSend() {
      var _this2 = this;

      if (this.userEmail != "") {
        $('#AddUser').modal('hide');
        var payload = this.userEmail;
        this.$store.dispatch("getUser", payload).then(function (response) {
          _this2.$store.dispatch("getSharedUsers");
        }).catch(function (error) {
          $('#NotFound').modal('show');
        });
      } else {
        this.emailEmpty = true;
      }
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$store.dispatch("getSharedUsers").then(function (response) {
      _this3.sharedusersloaded = true;
    });
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      error: null,
      versionsloaded: false
    };
  },
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__["a" /* default */]
  },
  computed: _extends({
    versions: function versions() {
      var u = this.$store.state.versions;
      return u;
    },
    lang: function lang() {
      var l = this.$store.getters.getLanguage;
      return l;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getSysco', 'getVNList'])),
  methods: {
    backToProjects: function backToProjects() {
      this.$router.push("/projects/0");
    },
    caption: function caption(term) {
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch("getVersions").then(function (response) {
      _this.versionsloaded = true;
    });
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientApp_store__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__AppHeader__["a" /* default */]
  },
  data: function data() {
    return {
      form: {
        email: ''
      },
      error: null
    };
  },
  validations: {
    form: {
      email: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
      }
    }
  },
  methods: {
    changed: function changed() {
      this.$v.form.email.$touch();
      this.error = null;
    },
    pwreset: function pwreset() {
      var _this = this;

      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      var payload = {
        Email: this.form.email
      };
      this.$store.dispatch("pwreset", payload).then(function () {
        _this.error = null;
        _this.form.email = "";
        _this.$router.push("/login");
      }).catch(function (error) {
        _this.error = error.data;
      });
    }
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientApp_store__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__AppHeader__["a" /* default */]
  },
  data: function data() {
    return {
      form: {
        password: '',
        confirmpassword: '',
        id: '',
        token: ''
      },
      errors: null
    };
  },
  validations: {
    form: {
      password: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      confirmpassword: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        sameAsPassword: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('password')
      }
    }
  },
  methods: {
    pwreset: function pwreset() {
      var _this = this;

      this.$v.form.$touch();
      if (this.$v.form.$error) return;
      var payload = {
        NewPassword: this.form.password,
        ConfirmPassword: this.form.confirmpassword,
        Id: this.$route.params.id,
        Token: this.$route.query.token
      };
      this.$store.dispatch("pwchange", payload).then(function () {
        _this.error = null;
        _this.form.password = "";
        _this.form.confirmpassword = "";
        _this.$router.push("/login");
      }).catch(function (error) {
        _this.errors = error.data;
      });
    }
  },
  computed: {
    loading: function loading() {
      return this.$store.state.loading;
    },
    id: function id() {
      return this.$route.params.id;
    },
    token: function token() {
      return this.$route.query.token;
    }
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientApp_helpers_project_steps__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    goto880: function goto880() {
      this.$router.push("/cilinder880");
    }
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientApp_helpers_project_steps__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    config880: function config880() {
      this.$router.push('/config880');
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientApp_helpers_project_steps__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: 1,
      bdim: 30,
      cdim: 30,
      aantal: 1,
      winkelmand: [],
      gs: false
    };
  },

  computed: {
    cyl880b: function cyl880b() {
      var bvalues = this.$store.getters.getcyl880b;
      return bvalues;
    },
    cyl880c: function cyl880c() {
      var _this = this;

      var cylvalues = this.$store.getters.getcyl880;
      var cvalues = cylvalues.filter(function (a) {
        return a.b == _this.bdim;
      });
      console.log(cvalues);
      if (!cvalues.find(function (a) {
        return a.c == _this.cdim;
      })) this.cdim = cvalues[0].c;
      return cvalues;
    }
  },
  methods: {
    verzend: function verzend() {
      if (this.aantal != 0) {
        if (this.gs == false) this.winkelmand.push({ id: this.id, artnummer: '880-' + this.bdim + "-" + this.cdim, bdim: this.bdim, cdim: this.cdim, aantal: this.aantal });
        if (this.gs == true) this.winkelmand.push({ id: this.id, artnummer: '880A-' + this.bdim + "-" + this.cdim, bdim: this.bdim, cdim: this.cdim, aantal: this.aantal });
        this.id++;
      }
    },
    reset: function reset() {
      this.winkelmand = [];
      this.gs = false;
    },
    setgs: function setgs() {
      console.log("gs: " + this.gs);
      this.gs = !this.gs;
      if (this.gs == true) {
        this.winkelmand.forEach(function (b) {
          return b.artnummer = '880A-' + b.bdim + '-' + b.cdim;
        });
      } else {
        this.winkelmand.forEach(function (b) {
          return b.artnummer = '880-' + b.bdim + '-' + b.cdim;
        });
      }
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientApp_store__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      genericdownloadsloaded: false
    };
  },
  methods: {
    downloadsList: function downloadsList() {
      this.$router.push("/downloads");
    }
  },
  computed: {
    downloads: function downloads() {
      return this.$store.getters.getGenericDownloads;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch("getGenericDownloads").then(function (response) {
      _this.genericdownloadsloaded = true;
    });
  },

  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__intro_AppHeader__["a" /* default */]
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppFooter__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__AppHeader__["a" /* default */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__AppFooter__["a" /* default */]
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppHeader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppFooter__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__AppHeader__["a" /* default */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__AppFooter__["a" /* default */]
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClientApp_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientApp_helpers_interceptors__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_autofocus_directive__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_autofocus_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_autofocus_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_css_bootstrap_min_css__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('autofocus', __WEBPACK_IMPORTED_MODULE_6_vue_autofocus_directive___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__ClientApp_store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(50);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(15)))

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb46966_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(52);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb46966_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"padding":"0","margin":"0"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v3.0.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if ("staging" !== 'production' && !condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (true) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "staging" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (true) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (true) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (true) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if ("staging" !== 'production' && !matchAs) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (true) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (true) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (true) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (true) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (true) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (true) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (true) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (true) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "staging" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (true) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "staging" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppIntro_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1452fa14_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppIntro_vue__ = __webpack_require__(58);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppIntro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1452fa14_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppIntro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-dark sticky-top bg-primary"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-header"},[(_vm.sysco == 2)?_c('span',[_c('img',{staticClass:"img mr-2",staticStyle:{"width":"10%"},attrs:{"src":"/src/assets/ReynaersLogo.jpg"}})]):_vm._e(),_vm._v(" "),(_vm.sysco == 4)?_c('span',[_c('img',{staticClass:"img mr-2",staticStyle:{"width":"10%"},attrs:{"src":"/src/assets/VBHLogo.png"}})]):_vm._e(),_vm._v(" "),(_vm.sysco == 5)?_c('span',[_c('img',{staticClass:"img mr-2",staticStyle:{"width":"20%"},attrs:{"src":"/src/assets/AlukLogo.png"}})]):_vm._e(),_vm._v(" "),(_vm.sysco == 7)?_c('span',[_c('img',{staticClass:"img mr-2",staticStyle:{"width":"15%"},attrs:{"src":"/src/assets/SapaLogo.jpg"}})]):_vm._e(),_vm._v(" "),(_vm.sysco == 8)?_c('span',[_c('img',{staticClass:"img mr-2 pb-2",staticStyle:{"width":"25%"},attrs:{"src":"/src/assets/TitonLogo.svg"}})]):_vm._e(),_vm._v(" "),(_vm.sysco == 9)?_c('span',[_c('img',{staticClass:"img mr-2 pb-2",staticStyle:{"width":"15%"},attrs:{"src":"/src/assets/AliplastLogo.png"}})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"navbar-brand",attrs:{"href":"/"}},[_vm._v("\n        Chrono Logic\n        "),_c('strong',[_vm._v("Online")]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.version))])])]),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav navbar-right",staticStyle:{"color":"white"}},[(_vm.isAuthenticated)?_c('li',[_c('button',{staticClass:"btn btn-outline-light btn-sm mr-3",attrs:{"type":"button"},on:{"click":_vm.logout}},[_vm._v("Logout")]),_vm._v("\n        "+_vm._s(_vm.fullName)+"\n      ")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"page-footer font-small pt-2"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center mb-2"},[_c('img',{attrs:{"src":__webpack_require__(57),"width":"200"}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 text-center text-sm-right"},[_c('div',[_vm._v("Waregemstraat 5")]),_vm._v(" "),_c('div',[_vm._v("B-9870 Zulte, Belgium")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-center text-sm-left"},[_c('div',[_vm._v("Tel +32 (0)9 388 88 81")]),_vm._v(" "),_c('div',[_vm._v("Fax +32 (0)9 388 88 21")])])]),_vm._v(" "),_c('div',{staticClass:"row m-2"},[_c('div',{staticClass:"col text-center"},[_vm._v("\n        E-mail\n        "),_c('a',{attrs:{"href":"mailto://logic@sobinco.com"}},[_vm._v("logic@sobinco.com")])])])]),_vm._v(" "),_c('div',{staticClass:"footer-copyright text-center"},[_vm._v("\n    © 2020\n    "),_c('a',{attrs:{"href":"https://www.sobinco.com/"}},[_vm._v("www.sobinco.com")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo.png?57817059fdc7171e53be53879ce4f978";

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"jumbotron jumbotron-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._m(1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center mt-5"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.openLoginPage}},[_vm._v("Get Started")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.openTCPage}},[_vm._v("Terms & Conditions")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.openPPPage}},[_vm._v("Privacy Policy")])])])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-center pb-5"},[_c('h1',{staticClass:"display-4"},[_vm._v("\n        Chrono Logic\n        "),_c('strong',[_vm._v("Online")])]),_vm._v(" "),_c('p',{staticClass:"lead"},[_c('strong',[_vm._v("Calculate")]),_vm._v(" &\n        "),_c('strong',[_vm._v("visualize")]),_vm._v(" the\n        "),_c('strong',[_vm._v("Chrono")]),_vm._v(" window\n        hardware system\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h2',[_vm._v("Calculate")]),_vm._v(" "),_c('p',[_vm._v("\n            With Chrono Logic Online you can easily calculate the hardware parts and sets needed for each type of\n            window. The bill of materials is generated automaticaly based on the chosen options. The output is\n            formatted as .CSV.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h2',[_vm._v("Visualize")]),_vm._v(" "),_c('p',[_vm._v("\n            Chrono Logic Online generates PDF files with detailed visual information for easy mounting of our Chrono\n            window hardware. The length and position of the rods in the vent and the position of the frame parts are\n            shown on a dedicated drawing for each window.\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bf4310e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(108);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bf4310e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"staging"}).BUILD === 'web' ? __webpack_require__(62).withParams : __webpack_require__(21).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-tour"] = factory();
	else
		root["vue-tour"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "1eb2":
/***/ (function(module, exports, __webpack_require__) {

// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "5b1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VStep_vue_vue_type_style_index_0_id_aa0cbe42_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ae07");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VStep_vue_vue_type_style_index_0_id_aa0cbe42_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VStep_vue_vue_type_style_index_0_id_aa0cbe42_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VStep_vue_vue_type_style_index_0_id_aa0cbe42_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f7f":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("9e1e") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "8634":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function pad (hash, len) {
  while (hash.length < len) {
    hash = '0' + hash;
  }
  return hash;
}

function fold (hash, text) {
  var i;
  var chr;
  var len;
  if (text.length === 0) {
    return hash;
  }
  for (i = 0, len = text.length; i < len; i++) {
    chr = text.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0;
  }
  return hash < 0 ? hash * -2 : hash;
}

function foldObject (hash, o, seen) {
  return Object.keys(o).sort().reduce(foldKey, hash);
  function foldKey (hash, key) {
    return foldValue(hash, o[key], key, seen);
  }
}

function foldValue (input, value, key, seen) {
  var hash = fold(fold(fold(input, key), toString(value)), typeof value);
  if (value === null) {
    return fold(hash, 'null');
  }
  if (value === undefined) {
    return fold(hash, 'undefined');
  }
  if (typeof value === 'object') {
    if (seen.indexOf(value) !== -1) {
      return fold(hash, '[Circular]' + key);
    }
    seen.push(value);
    return foldObject(hash, value, seen);
  }
  return fold(hash, value.toString());
}

function toString (o) {
  return Object.prototype.toString.call(o);
}

function sum (o) {
  return pad(foldValue(0, o, '', []).toString(16), 8);
}

module.exports = sum;


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "ae07":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "f0bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.4
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
var setPublicPath = __webpack_require__("1eb2");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules//.cache//vue-loader","cacheIdentifier":"0595ba96-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/VTour.vue?vue&type=template&id=50006eb3&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-tour"},[_vm._t("default",_vm._l((_vm.steps),function(step,index){return (_vm.currentStep === index)?_c('v-step',{key:index,attrs:{"step":step,"previous-step":_vm.previousStep,"next-step":_vm.nextStep,"stop":_vm.stop,"is-first":_vm.isFirst,"is-last":_vm.isLast,"labels":_vm.customOptions.labels}}):_vm._e()}),{currentStep:_vm.currentStep,steps:_vm.steps,previousStep:_vm.previousStep,nextStep:_vm.nextStep,stop:_vm.stop,isFirst:_vm.isFirst,isLast:_vm.isLast,labels:_vm.customOptions.labels})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/VTour.vue?vue&type=template&id=50006eb3&

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/builtin/es6/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/builtin/es6/objectSpread.js

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}
// CONCATENATED MODULE: ./src/shared/constants.js
var DEFAULT_CALLBACKS = {
  onStart: function onStart() {},
  onPreviousStep: function onPreviousStep(currentStep) {},
  onNextStep: function onNextStep(currentStep) {},
  onStop: function onStop() {}
};
var DEFAULT_OPTIONS = {
  useKeyboardNavigation: true,
  startTimeout: 0,
  labels: {
    buttonSkip: 'Skip tour',
    buttonPrevious: 'Previous',
    buttonNext: 'Next',
    buttonStop: 'Finish'
  }
};
var DEFAULT_STEP_OPTIONS = {
  placement: 'bottom',
  enableScrolling: true,
  modifiers: {
    arrow: {
      element: '.v-step__arrow'
    }
  }
};
var KEYS = {
  ARROW_RIGHT: 39,
  ARROW_LEFT: 37,
  ESCAPE: 27
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/VTour.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VTourvue_type_script_lang_js_ = ({
  name: 'v-tour',
  props: {
    steps: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    name: {
      type: String
    },
    options: {
      type: Object,
      default: function _default() {
        return DEFAULT_OPTIONS;
      }
    },
    callbacks: {
      type: Object,
      default: function _default() {
        return DEFAULT_CALLBACKS;
      }
    }
  },
  data: function data() {
    return {
      currentStep: -1
    };
  },
  mounted: function mounted() {
    this.$tours[this.name] = this;

    if (this.customOptions.useKeyboardNavigation) {
      window.addEventListener('keyup', this.handleKeyup);
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Remove the keyup listener if it has been defined
    if (this.customOptions.useKeyboardNavigation) {
      window.removeEventListener('keyup', this.handleKeyup);
    }
  },
  computed: {
    // Allow us to define custom options and merge them with the default options.
    // Since options is a computed property, it is reactive and can be updated during runtime.
    customOptions: function customOptions() {
      return _objectSpread({}, DEFAULT_OPTIONS, this.options);
    },
    customCallbacks: function customCallbacks() {
      return _objectSpread({}, DEFAULT_CALLBACKS, this.callbacks);
    },
    // Return true if the tour is active, which means that there's a VStep displayed
    isRunning: function isRunning() {
      return this.currentStep > -1 && this.currentStep < this.numberOfSteps;
    },
    isFirst: function isFirst() {
      return this.currentStep === 0;
    },
    isLast: function isLast() {
      return this.currentStep === this.steps.length - 1;
    },
    numberOfSteps: function numberOfSteps() {
      return this.steps.length;
    }
  },
  methods: {
    start: function start(startStep) {
      var _this = this;

      // Wait for the DOM to be loaded, then start the tour
      setTimeout(function () {
        _this.customCallbacks.onStart();

        _this.currentStep = typeof startStep !== 'undefined' ? parseInt(startStep, 10) : 0;
      }, this.customOptions.startTimeout);
    },
    previousStep: function previousStep() {
      if (this.currentStep > 0) {
        this.customCallbacks.onPreviousStep(this.currentStep);
        this.currentStep--;
      }
    },
    nextStep: function nextStep() {
      if (this.currentStep < this.numberOfSteps - 1 && this.currentStep !== -1) {
        this.customCallbacks.onNextStep(this.currentStep);
        this.currentStep++;
      }
    },
    stop: function stop() {
      this.customCallbacks.onStop();
      this.currentStep = -1;
    },
    handleKeyup: function handleKeyup(e) {
      // TODO: debug mode
      // console.log('[Vue Tour] A keyup event occured:', e)
      switch (e.keyCode) {
        case KEYS.ARROW_RIGHT:
          this.nextStep();
          break;

        case KEYS.ARROW_LEFT:
          this.previousStep();
          break;

        case KEYS.ESCAPE:
          this.stop();
          break;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/VTour.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VTourvue_type_script_lang_js_ = (VTourvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/VTour.vue





/* normalize component */

var component = normalizeComponent(
  components_VTourvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VTour.vue"
/* harmony default export */ var VTour = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules//.cache//vue-loader","cacheIdentifier":"0595ba96-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/VStep.vue?vue&type=template&id=aa0cbe42&scoped=true&
var VStepvue_type_template_id_aa0cbe42_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:'v-step-' + _vm.hash,staticClass:"v-step",attrs:{"id":'v-step-' + _vm.hash}},[_vm._t("header",[(_vm.step.header)?_c('div',{staticClass:"v-step__header"},[(_vm.step.header.title)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.step.header.title)}}):_vm._e()]):_vm._e()]),_vm._t("content",[_c('div',{staticClass:"v-step__content"},[(_vm.step.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.step.content)}}):_c('div',[_vm._v("This is a demo step! The id of this step is "+_vm._s(_vm.hash)+" and it targets "+_vm._s(_vm.step.target)+".")])])]),_vm._t("actions",[_c('div',{staticClass:"v-step__buttons"},[(!_vm.isLast)?_c('button',{staticClass:"v-step__button",on:{"click":function($event){$event.preventDefault();return _vm.stop($event)}}},[_vm._v(_vm._s(_vm.labels.buttonSkip))]):_vm._e(),(!_vm.isFirst)?_c('button',{staticClass:"v-step__button",on:{"click":function($event){$event.preventDefault();return _vm.previousStep($event)}}},[_vm._v(_vm._s(_vm.labels.buttonPrevious))]):_vm._e(),(!_vm.isLast)?_c('button',{staticClass:"v-step__button",on:{"click":function($event){$event.preventDefault();return _vm.nextStep($event)}}},[_vm._v(_vm._s(_vm.labels.buttonNext))]):_vm._e(),(_vm.isLast)?_c('button',{staticClass:"v-step__button",on:{"click":function($event){$event.preventDefault();return _vm.stop($event)}}},[_vm._v(_vm._s(_vm.labels.buttonStop))]):_vm._e()])]),_c('div',{staticClass:"v-step__arrow",class:{ 'v-step__arrow--dark': _vm.step.header && _vm.step.header.title }})],2)}
var VStepvue_type_template_id_aa0cbe42_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/VStep.vue?vue&type=template&id=aa0cbe42&scoped=true&

// EXTERNAL MODULE: ./node_modules/popper.js/dist/esm/popper.js
var popper = __webpack_require__("f0bd");

// CONCATENATED MODULE: ./node_modules/jump.js/dist/jump.module.js
// Robert Penner's easeInOutQuad

// find the rest of his easing functions here: http://robertpenner.com/easing/
// find them exported for ES6 consumption here: https://github.com/jaxgeller/ez.js

var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var jumper = function jumper() {
  // private variable cache
  // no variables are created during a jump, preventing memory leaks

  var element = void 0; // element to scroll to                   (node)

  var start = void 0; // where scroll starts                    (px)
  var stop = void 0; // where scroll stops                     (px)

  var offset = void 0; // adjustment from the stop position      (px)
  var easing = void 0; // easing function                        (function)
  var a11y = void 0; // accessibility support flag             (boolean)

  var distance = void 0; // distance of scroll                     (px)
  var duration = void 0; // scroll duration                        (ms)

  var timeStart = void 0; // time scroll started                    (ms)
  var timeElapsed = void 0; // time spent scrolling thus far          (ms)

  var next = void 0; // next scroll position                   (px)

  var callback = void 0; // to call when done scrolling            (function)

  // scroll position helper

  function location() {
    return window.scrollY || window.pageYOffset;
  }

  // element offset helper

  function top(element) {
    return element.getBoundingClientRect().top + start;
  }

  // rAF loop helper

  function loop(timeCurrent) {
    // store time scroll started, if not started already
    if (!timeStart) {
      timeStart = timeCurrent;
    }

    // determine time spent scrolling so far
    timeElapsed = timeCurrent - timeStart;

    // calculate next scroll position
    next = easing(timeElapsed, start, distance, duration);

    // scroll to it
    window.scrollTo(0, next);

    // check progress
    timeElapsed < duration ? window.requestAnimationFrame(loop) // continue scroll loop
    : done(); // scrolling is done
  }

  // scroll finished helper

  function done() {
    // account for rAF time rounding inaccuracies
    window.scrollTo(0, start + distance);

    // if scrolling to an element, and accessibility is enabled
    if (element && a11y) {
      // add tabindex indicating programmatic focus
      element.setAttribute('tabindex', '-1');

      // focus the element
      element.focus();
    }

    // if it exists, fire the callback
    if (typeof callback === 'function') {
      callback();
    }

    // reset time for next jump
    timeStart = false;
  }

  // API

  function jump(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // resolve options, or use defaults
    duration = options.duration || 1000;
    offset = options.offset || 0;
    callback = options.callback; // "undefined" is a suitable default, and won't be called
    easing = options.easing || easeInOutQuad;
    a11y = options.a11y || false;

    // cache starting position
    start = location();

    // resolve target
    switch (typeof target === 'undefined' ? 'undefined' : _typeof(target)) {
      // scroll from current position
      case 'number':
        element = undefined; // no element to scroll to
        a11y = false; // make sure accessibility is off
        stop = start + target;
        break;

      // scroll to element (node)
      // bounding rect is relative to the viewport
      case 'object':
        element = target;
        stop = top(element);
        break;

      // scroll to element (selector)
      // bounding rect is relative to the viewport
      case 'string':
        element = document.querySelector(target);
        stop = top(element);
        break;
    }

    // resolve scroll distance, accounting for offset
    distance = stop - start + offset;

    // resolve duration
    switch (_typeof(options.duration)) {
      // number in ms
      case 'number':
        duration = options.duration;
        break;

      // function passed the distance of the scroll
      case 'function':
        duration = options.duration(distance);
        break;
    }

    // start the loop
    window.requestAnimationFrame(loop);
  }

  // expose only the jump method
  return jump;
};

// export singleton

var singleton = jumper();

/* harmony default export */ var jump_module = (singleton);

// EXTERNAL MODULE: ./node_modules/hash-sum/hash-sum.js
var hash_sum = __webpack_require__("8634");
var hash_sum_default = /*#__PURE__*/__webpack_require__.n(hash_sum);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/VStep.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VStepvue_type_script_lang_js_ = ({
  name: 'v-step',
  props: {
    step: {
      type: Object
    },
    previousStep: {
      type: Function
    },
    nextStep: {
      type: Function
    },
    stop: {
      type: Function
    },
    isFirst: {
      type: Boolean
    },
    isLast: {
      type: Boolean
    },
    labels: {
      type: Object
    }
  },
  data: function data() {
    return {
      hash: hash_sum_default()(this.step.target)
    };
  },
  computed: {
    params: function params() {
      return _objectSpread({}, DEFAULT_STEP_OPTIONS, this.step.params);
    }
  },
  methods: {
    createStep: function createStep() {
      var targetElement = document.querySelector(this.step.target); // TODO: debug mode
      // console.log('[Vue Tour] The target element ' + this.step.target + ' of .v-step[id="' + this.hash + '"] is:', targetElement)

      if (targetElement) {
        if (this.params.enableScrolling) {
          if (this.step.duration || this.step.offset) {
            var jumpOptions = {
              duration: this.step.duration || 1000,
              offset: this.step.offset || 0,
              callback: undefined,
              a11y: false
            };
            jump_module(targetElement, jumpOptions);
          } else {
            // Use the native scroll by default if no scroll options has been defined
            targetElement.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }
        /* eslint-disable no-new */


        new popper["a" /* default */](targetElement, this.$refs['v-step-' + this.hash], this.params);
      } else {
        console.error('[Vue Tour] The target element ' + this.step.target + ' of .v-step[id="' + this.hash + '"] does not exist!');
        this.$emit('targetNotFound', this.step);
      }
    }
  },
  mounted: function mounted() {
    this.createStep();
  }
});
// CONCATENATED MODULE: ./src/components/VStep.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VStepvue_type_script_lang_js_ = (VStepvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/VStep.vue?vue&type=style&index=0&id=aa0cbe42&lang=scss&scoped=true&
var VStepvue_type_style_index_0_id_aa0cbe42_lang_scss_scoped_true_ = __webpack_require__("5b1b");

// CONCATENATED MODULE: ./src/components/VStep.vue






/* normalize component */

var VStep_component = normalizeComponent(
  components_VStepvue_type_script_lang_js_,
  VStepvue_type_template_id_aa0cbe42_scoped_true_render,
  VStepvue_type_template_id_aa0cbe42_scoped_true_staticRenderFns,
  false,
  null,
  "aa0cbe42",
  null
  
)

VStep_component.options.__file = "VStep.vue"
/* harmony default export */ var VStep = (VStep_component.exports);
// CONCATENATED MODULE: ./src/main.js



var VueTour = {
  install: function install(Vue, options) {
    Vue.component(VTour.name, VTour);
    Vue.component(VStep.name, VStep); // Object containing Tour objects (see VTour.vue) where the tour name is used as key

    Vue.prototype.$tours = {};
  }
};
/* harmony default export */ var main = (VueTour);

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueTour);
}
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (main);



/***/ })

/******/ });
});
//# sourceMappingURL=vue-tour.umd.js.map

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "register", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUsers", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useredit", function() { return useredit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userLanguage", function() { return userLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjects", function() { return getProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectsPerUser", function() { return getProjectsPerUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectedit", function() { return projectedit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectcreate", function() { return projectcreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectcopy", function() { return projectcopy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectdelete", function() { return projectdelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectusers", function() { return selectusers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getwindows", function() { return getwindows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowpost", function() { return windowpost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowedit", function() { return windowedit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowdelete", function() { return windowdelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowbom", function() { return windowbom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHandles", function() { return getHandles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMotors", function() { return getMotors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProfiles", function() { return getProfiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvisitopProfiles", function() { return getInvisitopProfiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTranslations", function() { return getTranslations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVersions", function() { return getVersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSharedUsers", function() { return getSharedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSharedProjects", function() { return getSharedProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjUsers", function() { return getProjUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteUser", function() { return deleteUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVersion", function() { return getVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setversion", function() { return setversion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectcsv", function() { return projectcsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectxl", function() { return projectxl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowcsv", function() { return windowcsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowxl", function() { return windowxl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowpdf_ORIGINAL", function() { return windowpdf_ORIGINAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowpdf", function() { return windowpdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectwindowpdf", function() { return projectwindowpdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genericpdf", function() { return genericpdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectpdf", function() { return projectpdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportOrgaData", function() { return exportOrgaData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadfile", function() { return uploadfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGenericDownloads", function() { return getGenericDownloads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pwreset", function() { return pwreset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pwchange", function() { return pwchange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCountries", function() { return getCountries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLanguages", function() { return getLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSysCos", function() { return getSysCos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(3);



// POST LOGIN => API/TOKEN
var login = function login(_ref, payload) {
  var commit = _ref.commit;

  return new Promise(function (resolve, reject) {
    commit("loginRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "token", payload).then(function (response) {
      var auth = response.data;
      commit("setLanguage", response.data.language);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + auth.access_token;
      commit("loginSuccess", auth);
      resolve(response);
    }).catch(function (error) {
      commit("loginError");
      delete __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['Authorization'];
      reject(error.response);
    });
  });
};

// POST REGISTER => API/ACCOUNT
var register = function register(_ref2, payload) {
  var commit = _ref2.commit;

  return new Promise(function (resolve, reject) {
    commit("registerRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "account", payload).then(function (response) {
      commit("registerSuccess");
      resolve(response);
    }).catch(function (error) {
      commit("registerError");
      reject(error.response);
    });
  });
};

// LOGOUT
var logout = function logout(_ref3) {
  var commit = _ref3.commit;

  commit("logout");
  delete __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common["Authorization"];
};

// GET USERS=> API/USERS
var getUsers = function getUsers(_ref4) {
  var commit = _ref4.commit;

  return new Promise(function (reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "users").then(function (response) {
      commit("getUsers", response.data);
      resolve(response.data);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

// EDIT USER SETTINGS
var useredit = function useredit(_ref5, payload) {
  var commit = _ref5.commit;

  return new Promise(function (resolve, reject) {
    commit("registerRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "user/settings", payload).then(function (response) {
      commit("registerSuccess");
      resolve(response);
    }).catch(function (error) {
      commit("registerError");
      reject(error.response);
    });
  });
};

// GET USER LANGUAGE
var userLanguage = function userLanguage(_ref6, payload) {
  var commit = _ref6.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "user/getlanguage").then(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.language = response.data;
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

// CHANGE USERS LANGUAGE
var changeLanguage = function changeLanguage(_ref7, payload) {
  var commit = _ref7.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "user/language/" + payload.l).then(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.language = payload.l;
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

// GET PROJECTS=> API/PROJECT/ALL
var getProjects = function getProjects(_ref8, payload) {
  var commit = _ref8.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "project/all").then(function (response) {
      commit("getProjects", response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

// GET PROJECTS PER USER => API/PROJECT/ALL/id
var getProjectsPerUser = function getProjectsPerUser(_ref9, payload) {
  var commit = _ref9.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "project/all/" + payload).then(function (response) {
      commit("getProjects", response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

// PUT PROJECT => API/PROJECT
var projectedit = function projectedit(_ref10, payload) {
  var commit = _ref10.commit;

  return new Promise(function (resolve, reject) {
    commit("registerRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "project", payload).then(function (response) {
      commit("registerSuccess");
      resolve(response);
    }).catch(function (error) {
      commit("registerError");
      reject(error.response);
    });
  });
};

// POST PROJECT => API/PROJECT
var projectcreate = function projectcreate(_ref11, payload) {
  var commit = _ref11.commit;

  return new Promise(function (resolve, reject) {
    commit("registerRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "project", payload).then(function (response) {
      commit("registerSuccess");
      resolve(response);
    }).catch(function (error) {
      commit("registerError");
      reject(error.response);
    });
  });
};

// COPY PROJECT => API/PROJECT/COPY
var projectcopy = function projectcopy(_ref12, payload) {
  var commit = _ref12.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "project/copy", payload).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

// DELETE PROJECT => API/PROJECT/id
var projectdelete = function projectdelete(_ref13, payload) {
  var commit = _ref13.commit;

  return new Promise(function (resolve, reject) {
    commit("registerRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "project/" + payload.Id).then(function (response) {
      commit("registerSuccess");
      resolve(response);
    }).catch(function (error) {
      commit("registerError");
      reject(error.response);
    });
  });
};

// POST SELUSERS
var selectusers = function selectusers(_ref14, payload) {
  var commit = _ref14.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "sharedprojects", payload).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

// GET WINDOWS=> API/WINDOW/ALL
var getwindows = function getwindows(_ref15, payload) {
  var commit = _ref15.commit;

  return new Promise(function (resolve, reject) {
    commit("registerRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "window/all/" + payload).then(function (response) {
      commit("getWindows", response.data);
      commit("registerSuccess");
      resolve(response.data);
    }).catch(function (error) {
      commit("noWindowsFound");
      commit("registerError");
      reject(error.response);
    });
  });
};

// POST WINDOW => API/WINDOW
var windowpost = function windowpost(_ref16, payload) {
  var commit = _ref16.commit;

  return new Promise(function (resolve, reject) {
    commit("registerRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "window", payload).then(function (response) {
      commit("windowCreateResponse", response.data);
      resolve(response);
    }).catch(function (error) {
      commit("registerError");
      reject(error.response);
    });
  });
};

// PUT WINDOW => API/WINDOW
var windowedit = function windowedit(_ref17, payload) {
  var commit = _ref17.commit;

  return new Promise(function (resolve, reject) {
    commit("registerRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "window", payload).then(function (response) {
      commit("windowCreateResponse", response.data);
      resolve(response);
    }).catch(function (error) {
      commit("registerError");
      reject(error.response);
    });
  });
};

// DELETE WINDOW => API/WINDOW/id
var windowdelete = function windowdelete(_ref18, payload) {
  var commit = _ref18.commit,
      state = _ref18.state;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "window/" + payload).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      commit("registerError");
      reject(error.response);
    });
  });
};

// GET BOM => API/BOM/id
var windowbom = function windowbom(_ref19, payload) {
  var commit = _ref19.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "BOM/" + payload).then(function (response) {
      commit("getBom", response.data);
      resolve(response);
    }).catch(function (error) {
      commit("noWindowsFound");
      reject(error.response);
    });
  });
};

var getHandles = function getHandles(_ref20) {
  var commit = _ref20.commit;

  return new Promise(function (reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "handle").then(function (response) {
      commit("getHandles", response.data);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var getMotors = function getMotors(_ref21) {
  var commit = _ref21.commit;

  return new Promise(function (reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "motor").then(function (response) {
      commit("getMotors", response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var getProfiles = function getProfiles(_ref22) {
  var commit = _ref22.commit;

  return new Promise(function (reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "profile").then(function (response) {
      commit("getProfiles", response.data);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var getInvisitopProfiles = function getInvisitopProfiles(_ref23) {
  var commit = _ref23.commit;

  return new Promise(function (reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "invisitopprofile").then(function (response) {
      commit("getInvisitopProfiles", response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var getTranslations = function getTranslations(_ref24) {
  var commit = _ref24.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "translation").then(function (response) {
      commit("getTranslations", response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var getVersions = function getVersions(_ref25) {
  var commit = _ref25.commit;

  return new Promise(function (reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "version/list").then(function (response) {
      commit("getVersions", response.data);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var getSharedUsers = function getSharedUsers(_ref26) {
  var commit = _ref26.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "sharedusers").then(function (response) {
      commit("setSharedUsers", response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var getSharedProjects = function getSharedProjects(_ref27) {
  var commit = _ref27.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "sharedprojects").then(function (response) {
      commit("setSharedProjects", response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var getProjUsers = function getProjUsers(_ref28, payload) {
  var commit = _ref28.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "sharedprojects/" + payload.id).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var getUser = function getUser(_ref29, payload) {
  var commit = _ref29.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "sharedusers/getuser/" + payload).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var deleteUser = function deleteUser(_ref30, payload) {
  var commit = _ref30.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "sharedusers/" + payload).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var getVersion = function getVersion(_ref31) {
  var commit = _ref31.commit;

  return new Promise(function (reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "version").then(function (response) {
      commit("setVersion", response.data.version);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var setversion = function setversion(_ref32) {
  var commit = _ref32.commit;

  return new Promise(function (reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "version/setversion").then(function (response) {
      commit("setVersions", response.data);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var projectcsv = function projectcsv(_ref33, payload) {
  var state = _ref33.state,
      getters = _ref33.getters,
      commit = _ref33.commit;

  return new Promise(function (resolve, reject) {
    commit("projectCSVRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      url: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + 'project/bom/' + payload,
      method: 'GET',
      responseType: 'blob'
    }).then(function (response) {
      commit("projectCSVSuccess");
      var url = window.URL.createObjectURL(response.data);
      var a = document.createElement('a');
      var prj = getters.getProjectById(payload);
      a.href = url;
      a.download = prj.customerName + " - " + prj.projectName + '.csv';
      a.click();
      a.remove();
      setTimeout(function () {
        return window.URL.revokeObjectURL(url);
      }, 100);
    });
  });
};

var projectxl = function projectxl(_ref34, payload) {
  var state = _ref34.state,
      getters = _ref34.getters,
      commit = _ref34.commit;

  return new Promise(function (resolve, reject) {
    commit("projectCSVRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      url: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + 'project/bom/xl/' + payload,
      method: 'GET',
      responseType: 'blob'
    }).then(function (response) {
      commit("projectCSVSuccess");
      var url = window.URL.createObjectURL(response.data);
      var a = document.createElement('a');
      var prj = getters.getProjectById(payload);
      a.href = url;
      a.download = prj.customerName + " - " + prj.projectName + '.xlsx';
      a.click();
      a.remove();
      setTimeout(function () {
        return window.URL.revokeObjectURL(url);
      }, 100);
    });
  });
};

var windowcsv = function windowcsv(_ref35, payload) {
  var state = _ref35.state,
      getters = _ref35.getters;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      url: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + 'bom/csv/' + payload,
      method: 'GET',
      responseType: 'blob'
    }).then(function (response) {
      var url = window.URL.createObjectURL(response.data);
      var a = document.createElement('a');
      var win = getters.getWindowById(payload);
      a.href = url;
      a.download = state.project.customerName + " - " + state.project.projectName + " [" + win.name + '].csv';
      a.click();
      a.remove();
      setTimeout(function () {
        return window.URL.revokeObjectURL(url);
      }, 100);
    });
  });
};

var windowxl = function windowxl(_ref36, payload) {
  var state = _ref36.state,
      getters = _ref36.getters;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      url: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + 'bom/xl/' + payload,
      method: 'GET',
      responseType: 'blob'
    }).then(function (response) {
      var url = window.URL.createObjectURL(response.data);
      var a = document.createElement('a');
      var win = getters.getWindowById(payload);
      a.href = url;
      a.download = state.project.customerName + " - " + state.project.projectName + " [" + win.name + '].xlsx';
      a.click();
      a.remove();
      setTimeout(function () {
        return window.URL.revokeObjectURL(url);
      }, 100);
    });
  });
};

var windowpdf_ORIGINAL = function windowpdf_ORIGINAL(_ref37, payload) {
  var state = _ref37.state,
      getters = _ref37.getters,
      commit = _ref37.commit;

  return new Promise(function (resolve, reject) {
    commit("pdfRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      url: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + 'window/pdf/' + payload,
      method: 'GET',
      responseType: 'arraybuffer'
    }).then(function (response) {
      commit("pdfSuccess");
      var contentDisposition = response.request.getResponseHeader('Content-Disposition');

      var fileName = 'unknown';
      var fn = contentDisposition.split(";");
      var file = fn[1];
      file = file.trim();
      file = file.replace(/"/g, '');
      file = file.replace(/filename=/, '');

      var blob = new File([response.data], file);
      var url = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;

      link.download = file;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    });
  });
};

var windowpdf = function windowpdf(_ref38, payload) {
  var state = _ref38.state,
      getters = _ref38.getters,
      commit = _ref38.commit;

  return new Promise(function (resolve, reject) {
    commit("pdfRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      url: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + 'window/pdf/' + payload.id + '/' + payload.pages,
      method: 'GET',
      responseType: 'blob' // important
    }).then(function (response) {
      commit("pdfSuccess");
      var url = window.URL.createObjectURL(new Blob([response.data]));
      var win = getters.getWindowById(payload.id);
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', state.project.customerName + " - " + state.project.projectName + " [" + win.name + '].pdf');
      document.body.appendChild(link);
      link.click();
      resolve(response);
    });
  });
};

var projectwindowpdf = function projectwindowpdf(_ref39, payload) {
  var state = _ref39.state,
      getters = _ref39.getters,
      commit = _ref39.commit;

  return new Promise(function (resolve, reject) {

    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      url: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + 'window/pdf/' + payload.id + '/' + payload.pages,
      method: 'GET',
      responseType: 'blob' // important
    }).then(function (response) {

      var url = window.URL.createObjectURL(new Blob([response.data]));
      var win = getters.getWindowById(payload.id);
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', state.project.customerName + " - " + state.project.projectName + " [" + win.name + '].pdf');
      document.body.appendChild(link);
      link.click();
      resolve(response);
    });
  });
};

var genericpdf = function genericpdf(_ref40, payload) {
  var state = _ref40.state,
      getters = _ref40.getters,
      commit = _ref40.commit;

  return new Promise(function (resolve, reject) {
    commit("pdfRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      url: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + 'genericdrawing/pdf/' + payload,
      method: 'GET',
      responseType: 'blob'
    }).then(function (response) {
      commit("pdfSuccess");
      var url = window.URL.createObjectURL(new Blob([response.data]));
      var win = getters.getWindowById(payload);
      var link = document.createElement('a');
      link.href = url;
      link.download = 'GENERIC_' + state.project.customerName + " - " + state.project.projectName + " [" + win.name + '].pdf';
      link.setAttribute('download', 'GENERIC_' + state.project.customerName + " - " + state.project.projectName + " [" + win.name + '].pdf');
      document.body.appendChild(link);
      link.click();
    });
  });
};

var projectpdf = function projectpdf(_ref41, payload) {
  var state = _ref41.state,
      getters = _ref41.getters,
      commit = _ref41.commit;

  return new Promise(function (resolve, reject) {
    commit("projectPDFRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      url: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + 'project/pdf/' + payload.proj.id + '/' + payload.pages,
      method: 'GET',
      responseType: 'blob' // important
    }).then(function (response) {
      commit("projectPDFSuccess");
      var url = window.URL.createObjectURL(new Blob([response.data]));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', payload.proj.customerName + " - " + payload.proj.projectName + ".pdf");
      document.body.appendChild(link);
      link.click();
    });
  });
};

var exportOrgaData = function exportOrgaData(_ref42) {
  var state = _ref42.state,
      getters = _ref42.getters;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      url: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + 'system/export/orgadata/',
      method: 'GET',
      responseType: 'blob'
    }).then(function (response) {
      var url = window.URL.createObjectURL(response.data);
      var a = document.createElement('a');
      a.href = url;
      a.download = "export.xlsx";
      a.click();
      a.remove();
      setTimeout(function () {
        return window.URL.revokeObjectURL(url);
      }, 100);
    });
  });
};

var uploadfile = function uploadfile(_ref43, payload) {
  var state = _ref43.state,
      getters = _ref43.getters,
      commit = _ref43.commit,
      resolve = _ref43.resolve;

  return new Promise(function (resolve, reject) {
    commit("fileUploadRequest");
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + 'window/upload/' + state.project.id, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      commit("setErrorList", response);
      commit("fileUploadSuccess");
      resolve(response);
    }).catch(function () {
      console.log('Invalid file');
    });
  });
};

var getGenericDownloads = function getGenericDownloads(_ref44) {
  var commit = _ref44.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "genericdownloads/all").then(function (response) {
      commit("getGenericDownloads", response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

// Password reset
var pwreset = function pwreset(_ref45, payload) {
  var commit = _ref45.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "token/pwreset/", payload).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

// Password change
var pwchange = function pwchange(_ref46, payload) {
  var commit = _ref46.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "token/pwchange/", payload).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

// GET COUNTRIES=> API/COUNTRIES
var getCountries = function getCountries(_ref47) {
  var commit = _ref47.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "countries").then(function (response) {
      commit("setCountries", response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

// GET LANGUAGES=> API/LANGUAGES
var getLanguages = function getLanguages(_ref48) {
  var commit = _ref48.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "languages").then(function (response) {
      commit("setLanguages", response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

// GET SYSCOS=> API/SYSCOS
var getSysCos = function getSysCos(_ref49) {
  var commit = _ref49.commit;

  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + "syscos").then(function (response) {
      commit("setSysCos", response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var bind = __webpack_require__(23);
var Axios = __webpack_require__(87);
var defaults = __webpack_require__(13);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(27);
axios.CancelToken = __webpack_require__(101);
axios.isCancel = __webpack_require__(26);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(102);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(13);
var utils = __webpack_require__(6);
var InterceptorManager = __webpack_require__(96);
var dispatchRequest = __webpack_require__(97);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(25);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var transformData = __webpack_require__(98);
var isCancel = __webpack_require__(26);
var defaults = __webpack_require__(13);
var isAbsoluteURL = __webpack_require__(99);
var combineURLs = __webpack_require__(100);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(27);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loginRequest", function() { return loginRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loginSuccess", function() { return loginSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loginError", function() { return loginError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerRequest", function() { return registerRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerSuccess", function() { return registerSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerError", function() { return registerError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pdfRequest", function() { return pdfRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pdfSuccess", function() { return pdfSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectPDFRequest", function() { return projectPDFRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectPDFSuccess", function() { return projectPDFSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectCSVRequest", function() { return projectCSVRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectCSVSuccess", function() { return projectCSVSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fileUploadRequest", function() { return fileUploadRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fileUploadSuccess", function() { return fileUploadSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pdfError", function() { return pdfError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowCreateResponse", function() { return windowCreateResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjects", function() { return getProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUsers", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProject", function() { return getProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWindows", function() { return getWindows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noWindowsFound", function() { return noWindowsFound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBom", function() { return getBom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProject", function() { return setProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProjectNumWindows", function() { return setProjectNumWindows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWindow", function() { return setWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProject", function() { return resetProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHandles", function() { return getHandles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMotors", function() { return getMotors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProfiles", function() { return getProfiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvisitopProfiles", function() { return getInvisitopProfiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTranslations", function() { return getTranslations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVersions", function() { return getVersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVersion", function() { return setVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSharedUsers", function() { return setSharedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSharedProjects", function() { return setSharedProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGenericDownloads", function() { return getGenericDownloads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVersions", function() { return setVersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetError", function() { return resetError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setErrorList", function() { return setErrorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetErrors", function() { return resetErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetInvalidFile", function() { return resetInvalidFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLanguage", function() { return setLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWindowSortOptions", function() { return setWindowSortOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProjectSortOptions", function() { return setProjectSortOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCountries", function() { return setCountries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLanguages", function() { return setLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSysCos", function() { return setSysCos; });
var loginRequest = function loginRequest(state) {
  state.loading = true;
};

var loginSuccess = function loginSuccess(state, payload) {
  state.auth = payload;
  state.language = payload.language;
  state.loading = false;
};

var loginError = function loginError(state) {
  state.loading = false;
};

var registerRequest = function registerRequest(state) {
  state.loading = true;
};

var registerSuccess = function registerSuccess(state) {
  state.loading = false;
};

var registerError = function registerError(state) {
  state.loading = false;
};

var pdfRequest = function pdfRequest(state) {
  state.loading = true;
};

var pdfSuccess = function pdfSuccess(state) {
  state.loading = false;
};

var projectPDFRequest = function projectPDFRequest(state) {
  state.pdfloading = true;
};

var projectPDFSuccess = function projectPDFSuccess(state) {
  state.pdfloading = false;
};

var projectCSVRequest = function projectCSVRequest(state) {
  state.csvloading = true;
};

var projectCSVSuccess = function projectCSVSuccess(state) {
  state.csvloading = false;
};

var fileUploadRequest = function fileUploadRequest(state) {
  state.fileuploading = true;
};

var fileUploadSuccess = function fileUploadSuccess(state) {
  state.fileuploading = false;
};

var pdfError = function pdfError(state) {
  state.loading = false;
};

var logout = function logout(state) {
  state.auth = null;
  state.project = null;
};

var windowCreateResponse = function windowCreateResponse(state, payload) {
  state.loading = false;
  state.windowCreateResponse = payload;
};

var getProjects = function getProjects(state, payload) {
  state.projects = payload;
};

var getUsers = function getUsers(state, payload) {
  state.users = payload;
};

var getProject = function getProject(state, payload) {
  state.project = payload;
};

var getWindows = function getWindows(state, payload) {
  state.windows = payload;
};

var noWindowsFound = function noWindowsFound(state) {
  state.windows = null;
};

var getBom = function getBom(state, payload) {
  state.bom = payload;
};

var setProject = function setProject(state, payload) {
  state.project = payload;
};

var setProjectNumWindows = function setProjectNumWindows(state, payload) {
  state.project.numWindows = payload;
};

var setWindow = function setWindow(state, payload) {
  state.window = payload;
};

var resetProject = function resetProject(state) {
  state.project = null;
};

var getHandles = function getHandles(state, payload) {
  state.handles = payload;
};

var getMotors = function getMotors(state, payload) {
  state.motors = payload;
};

var getProfiles = function getProfiles(state, payload) {
  state.profiles = payload;
};

var getInvisitopProfiles = function getInvisitopProfiles(state, payload) {
  state.invisitopprofiles = payload;
};

var getTranslations = function getTranslations(state, payload) {
  state.translations = payload;
};

var getVersions = function getVersions(state, payload) {
  state.versions = payload;
};

var setVersion = function setVersion(state, payload) {
  state.version = payload;
};

var setSharedUsers = function setSharedUsers(state, payload) {
  state.sharedusers = payload;
};

var setSharedProjects = function setSharedProjects(state, payload) {
  state.sharedprojects = payload;
};

var getGenericDownloads = function getGenericDownloads(state, payload) {
  state.genericDownloads = payload;
};

var setVersions = function setVersions(state) {};

var resetError = function resetError(state) {
  state.windowCreateResponse = null;
};

var setErrorList = function setErrorList(state, payload) {
  if (Object.keys(payload.data)[0] == "NoErrors") state.errorlist = null;else if (Object.keys(payload.data)[0] == "InvalidFile") state.invalidfile = true;else state.errorlist = payload.data;
};

var resetErrors = function resetErrors(state) {
  state.errorlist = null;
};

var resetInvalidFile = function resetInvalidFile(state) {
  state.invalidfile = false;
};

var setLanguage = function setLanguage(state, payload) {
  state.language = payload;
};

var setWindowSortOptions = function setWindowSortOptions(state, payload) {
  state.windowsortoptions = payload;
};

var setProjectSortOptions = function setProjectSortOptions(state, payload) {
  state.projectsortoptions = payload;
};

var setCountries = function setCountries(state, payload) {
  state.countries = payload;
};

var setLanguages = function setLanguages(state, payload) {
  state.languages = payload;
};

var setSysCos = function setSysCos(state, payload) {
  state.syscos = payload;
};

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return params; });
var params = {
    state: {
        chrono: [{ chronoId: 10, chronoDesc: "Standard" }, { chronoId: 20, chronoDesc: "Plus" }, { chronoId: 50, chronoDesc: "SKG**" }, { chronoId: 40, chronoDesc: "RC2" }, { chronoId: 60, chronoDesc: "RC3" }, { chronoId: 80, chronoDesc: "Hurricane" }, { chronoId: 90, chronoDesc: "Fireproof" }],
        hinge: [{ hingeId: 1, hingeDesc: "winlist_VisibleHinges", hingePng: "/src/assets/35140_760_1.png" }, { hingeId: 2, hingeDesc: "winlist_PRO", hingePng: "/src/assets/32114_780.png" }, { hingeId: 4, hingeDesc: "winlist_VisibleNAHinges", hingePng: "/src/assets/35140_760_1.png" }, { hingeId: 5, hingeDesc: "winlist_GO", hingePng: "/src/assets/32107_780_1.png" }],
        type: [{ typeId: 1, sysco: 0, typeDesc: "addwin_TurnTilt" }, { typeId: 2, sysco: 0, typeDesc: "addwin_TurnTiltFC" }, { typeId: 3, sysco: 0, typeDesc: "addwin_TiltTurn" }, { typeId: 4, sysco: 0, typeDesc: "addwin_TiltTurnFC" }, { typeId: 6, sysco: 0, typeDesc: "addwin_SideHung" }, { typeId: 60, sysco: 0, typeDesc: "addwin_SideHungFC" }, { typeId: 7, sysco: 0, typeDesc: "addwin_VBottomHung" }, { typeId: 8, sysco: 0, typeDesc: "addwin_HBottomHung" }, { typeId: 30, sysco: 0, typeDesc: "addwin_OpenOut" }, { typeId: 31, sysco: 0, typeDesc: "addwin_OpenOutFrenchCasement" }, { typeId: 16, sysco: 0, typeDesc: "addwin_VentilationVent" }, { typeId: 21, sysco: 0, typeDesc: "addwin_BalconyTUTI" }, { typeId: 22, sysco: 0, typeDesc: "addwin_BalconyTUTIFC" }, { typeId: 23, sysco: 0, typeDesc: "addwin_BalconyTITU" }, { typeId: 26, sysco: 0, typeDesc: "addwin_BalconySIHU" }, { typeId: 27, sysco: 0, typeDesc: "addwin_BalconySIHUFC" }, { typeId: 46, sysco: 0, typeDesc: "addwin_HandleAtCill" }, { typeId: 55, sysco: 0, typeDesc: "addwin_EInvisitop" }],
        handle: [{ handleId: 1, handleDesc: "winlist_ForkHandle" }, { handleId: 3, handleDesc: "winlist_SquareSpindleHandle" }, { handleId: 4, handleDesc: "winlist_BaselessHandle" }, { handleId: 5, handleDesc: "winlist_SpecialSquareHandle" }],
        opdir: [{ openId: 1, openDesc: "R" }, { openId: 2, openDesc: "L" }],
        groove: [{ grooveId: 10, grooveDesc: "10-14" }, { grooveId: 14, grooveDesc: "14-18" }],
        color: [{ code: "C1", desc: "addwin_C1" }, { code: "C3", desc: "addwin_C3" }, { code: "C4", desc: "addwin_C4" }, { code: "C5", desc: "addwin_C5" }, { code: "C6", desc: "addwin_C6" }, { code: "CN", desc: "addwin_CN" }],
        screw: ["6", "12", "16"],
        sysco: [{ code: "1", desc: "SOB" }, { code: "2", desc: "REY" }, { code: "4", desc: "VBH" }, { code: "5", desc: "ALK" }, { code: "6", desc: "SMT" }, { code: "7", desc: "SAP" }, { code: "8", desc: "TIT" }, { code: "9", desc: "ALI" }],
        cyl880: [{ b: 30, c: 30 }, { b: 30, c: 35 }, { b: 30, c: 40 }, { b: 30, c: 45 }, { b: 30, c: 50 }, { b: 30, c: 55 }, { b: 30, c: 60 }, { b: 30, c: 65 }, { b: 30, c: 70 }, { b: 30, c: 75 }, { b: 30, c: 80 }, { b: 30, c: 90 }, { b: 35, c: 35 }, { b: 35, c: 40 }, { b: 35, c: 45 }, { b: 35, c: 50 }, { b: 35, c: 55 }, { b: 35, c: 60 }, { b: 35, c: 65 }, { b: 35, c: 70 }, { b: 35, c: 75 }, { b: 35, c: 80 }, { b: 35, c: 85 }, { b: 40, c: 40 }, { b: 40, c: 45 }, { b: 40, c: 50 }, { b: 40, c: 55 }, { b: 40, c: 60 }, { b: 40, c: 65 }, { b: 40, c: 70 }, { b: 40, c: 75 }, { b: 40, c: 80 }, { b: 40, c: 85 }, { b: 40, c: 90 }, { b: 45, c: 45 }, { b: 45, c: 50 }, { b: 45, c: 55 }, { b: 45, c: 60 }, { b: 45, c: 65 }, { b: 50, c: 50 }, { b: 50, c: 55 }, { b: 50, c: 60 }, { b: 50, c: 65 }, { b: 60, c: 60 }],
        cyl880b: [30, 35, 40, 45, 50, 60]
    },
    getters: {
        getChrono: function getChrono(state) {
            return state.chrono;
        },
        getHinge: function getHinge(state) {
            return state.hinge;
        },
        getHandle: function getHandle(state) {
            return state.handle;
        },
        getMotor: function getMotor(state) {
            return state.motor;
        },
        getColor: function getColor(state) {
            return state.color;
        },
        getScrew: function getScrew(state) {
            return state.screw;
        },
        getOpDir: function getOpDir(state) {
            return state.opdir;
        },
        getGroove: function getGroove(state) {
            return state.groove;
        },
        getSysco: function getSysco(state) {
            return state.sysco;
        },
        getErrorList: function getErrorList(state) {
            return state.errorlist;
        },
        getcyl880b: function getcyl880b(state) {
            return state.cyl880b;
        },
        getcyl880: function getcyl880(state) {
            return state.cyl880;
        }
    }
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(106);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("6341e812", content, true, {});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".v-step[data-v-aa0cbe42]{-webkit-filter:drop-shadow(0 0 2px rgba(0,0,0,.5));background:#50596c;border-radius:3px;color:#fff;filter:drop-shadow(0 0 2px rgba(0,0,0,.5));max-width:320px;padding:1rem;text-align:center}.v-step .v-step__arrow[data-v-aa0cbe42]{border-color:#50596c;border-style:solid;height:0;margin:.5rem;position:absolute;width:0}.v-step .v-step__arrow--dark[data-v-aa0cbe42]{border-color:#454d5d}.v-step[x-placement^=top][data-v-aa0cbe42]{margin-bottom:.5rem}.v-step[x-placement^=top] .v-step__arrow[data-v-aa0cbe42]{border-bottom-color:transparent;border-left-color:transparent;border-right-color:transparent;border-width:.5rem .5rem 0;bottom:-.5rem;left:calc(50% - 1rem);margin-bottom:0;margin-top:0}.v-step[x-placement^=bottom][data-v-aa0cbe42]{margin-top:.5rem}.v-step[x-placement^=bottom] .v-step__arrow[data-v-aa0cbe42]{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent;border-width:0 .5rem .5rem;left:calc(50% - 1rem);margin-bottom:0;margin-top:0;top:-.5rem}.v-step[x-placement^=right][data-v-aa0cbe42]{margin-left:.5rem}.v-step[x-placement^=right] .v-step__arrow[data-v-aa0cbe42]{border-bottom-color:transparent;border-left-color:transparent;border-top-color:transparent;border-width:.5rem .5rem .5rem 0;left:-.5rem;margin-left:0;margin-right:0;top:calc(50% - 1rem)}.v-step[x-placement^=left][data-v-aa0cbe42]{margin-right:.5rem}.v-step[x-placement^=left] .v-step__arrow[data-v-aa0cbe42]{border-bottom-color:transparent;border-right-color:transparent;border-top-color:transparent;border-width:.5rem 0 .5rem .5rem;margin-left:0;margin-right:0;right:-.5rem;top:calc(50% - 1rem)}.v-step__header[data-v-aa0cbe42]{background-color:#454d5d;border-top-left-radius:3px;border-top-right-radius:3px;margin:-1rem -1rem .5rem;padding:.5rem}.v-step__content[data-v-aa0cbe42]{margin:0 0 1rem}.v-step__button[data-v-aa0cbe42]{-webkit-transition:all .2s ease;background:transparent;border:.05rem solid #fff;border-radius:.1rem;color:#fff;cursor:pointer;display:inline-block;font-size:.8rem;height:1.8rem;line-height:1rem;margin:0 .2rem;outline:none;padding:.35rem .4rem;text-align:center;text-decoration:none;transition:all .2s ease;vertical-align:middle;white-space:nowrap}.v-step__button[data-v-aa0cbe42]:hover{background-color:hsla(0,0%,100%,.95);color:#50596c}", ""]);

// exports


/***/ }),
/* 107 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('h1',{staticClass:"display-4 text-center"},[_vm._v("User Login")]),_vm._v(" "),_c('div',{staticClass:"container-fluid w-50 mt-5 bg-light"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error !== null),expression:"error !== null"}],staticClass:"btn-danger text-center mb-3"},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.email),expression:"form.email",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value.trim())},function($event){_vm.$v.form.email.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.email.$dirty)?_c('div',[(!_vm.$v.form.email.required)?_c('div',{staticClass:"text-danger"},[_vm._v("Email is required!")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.email.email)?_c('div',{staticClass:"text-danger"},[_vm._v("Email is not valid!")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.password),expression:"form.password",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"password"},domProps:{"value":(_vm.form.password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value.trim())},function($event){_vm.$v.form.password.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.password.dirty)?_c('div',[(!_vm.$v.form.password.required)?_c('div',{staticClass:"text-danger"},[_vm._v("Password required!")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary mb-3",attrs:{"disabled":_vm.loading,"type":"submit"}},[_vm._v("\n          Login\n          "),(_vm.loading)?_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.loading)?_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")]):_vm._e()])])]),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":"/register"}},[_vm._v("No login? Register here.")])],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":"/pwreset"}},[_vm._v("Password reset")])],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"text-center mt-3 pb-3"},[_c('router-link',{attrs:{"to":"/terms-and-conditions"}},[_vm._v("Terms & Conditions")]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/privacy-policy"}},[_vm._v("Privacy Policy")])],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f91bdf0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__ = __webpack_require__(110);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f91bdf0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('h1',{staticClass:"display-4 text-center"},[_vm._v("Register for Chrono Logic")]),_vm._v(" "),_c('div',{staticClass:"container-fluid w-50 mt-5 bg-light"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors !== null),expression:"errors !== null"}],staticClass:"btn-danger text-center mb-3",attrs:{"dismissible":""},on:{"dismissed":function($event){_vm.errors = null}}},_vm._l((_vm.errors),function(error,index){return _c('div',{key:index},[_vm._v("\n        "+_vm._s(error[0])+"\n      ")])})),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.register($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy.trim",value:(_vm.form.email),expression:"form.email",modifiers:{"lazy":true,"trim":true}}],staticClass:"input form-control",attrs:{"placeholder":"Enter your e-mail address","type":"text"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){_vm.$v.form.email.$touch()},"change":function($event){_vm.$set(_vm.form, "email", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.email.$touch)?_c('div',[(!_vm.$v.form.email.required)?_c('div',{staticClass:"text-danger"},[_vm._v("Email is required!")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.email.email)?_c('div',{staticClass:"text-danger"},[_vm._v("Email is not valid!")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Company name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.company),expression:"form.company",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"placeholder":"Enter your company name","type":"text"},domProps:{"value":(_vm.form.company)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "company", $event.target.value.trim())},function($event){_vm.$v.form.company.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.company.$dirty)?_c('div',[(!_vm.$v.form.company.required)?_c('div',{staticClass:"text-danger"},[_vm._v("Company name is required!")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("System Company")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.sysco),expression:"form.sysco"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "sysco", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.$v.form.sysco.$touch()}]}},_vm._l((_vm.syscos),function(s){return _c('option',{key:s.sysCoId,domProps:{"value":s.sysCoId}},[_vm._v(_vm._s(s.sysCoName))])})),_vm._v(" "),(_vm.$v.form.sysco.$dirty)?_c('div',[(!_vm.$v.form.sysco.required)?_c('div',{staticClass:"text-danger"},[_vm._v("System Company is required")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.country),expression:"form.country"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.$v.form.country.$touch()}]}},_vm._l((_vm.countries),function(c){return _c('option',{key:c.countryId,domProps:{"value":c.countryId}},[_vm._v(_vm._s(c.countryName))])})),_vm._v(" "),(_vm.$v.form.country.$dirty)?_c('div',[(!_vm.$v.form.country.required)?_c('div',{staticClass:"text-danger"},[_vm._v("Country name is required")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Language")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.language),expression:"form.language"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.$v.form.language.$touch()}]}},_vm._l((_vm.languages),function(l){return _c('option',{key:l.languageId,domProps:{"value":l.languageId}},[_vm._v(_vm._s(l.languageName))])})),_vm._v(" "),(_vm.$v.form.language.$dirty)?_c('div',[(!_vm.$v.form.language.required)?_c('div',{staticClass:"text-danger"},[_vm._v("Language is required!")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("First name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.firstname),expression:"form.firstname",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.firstname)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "firstname", $event.target.value.trim())},function($event){_vm.$v.form.firstname.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.firstname.$dirty)?_c('div',[(!_vm.$v.form.firstname.required)?_c('div',{staticClass:"text-danger"},[_vm._v("First name is required!")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Last name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.lastname),expression:"form.lastname",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.lastname)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "lastname", $event.target.value.trim())},function($event){_vm.$v.form.lastname.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.lastname.$dirty)?_c('div',[(!_vm.$v.form.lastname.required)?_c('div',{staticClass:"text-danger"},[_vm._v("Last name is required!")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.password),expression:"form.password",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"password"},domProps:{"value":(_vm.form.password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value.trim())},function($event){_vm.$v.form.password.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.password.$dirty)?_c('div',[(!_vm.$v.form.password.required)?_c('div',{staticClass:"text-danger"},[_vm._v("Password is required!")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.errors != null)?_c('div',_vm._l((_vm.errors),function(e){return _c('div',{key:e.code,staticClass:"text-danger"},[_vm._v(_vm._s(e.description))])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Confirm password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.confirmpassword),expression:"form.confirmpassword",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"password"},domProps:{"value":(_vm.form.confirmpassword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "confirmpassword", $event.target.value.trim())},function($event){_vm.$v.form.confirmpassword.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.confirmpassword.$dirty)?_c('div',[(!_vm.$v.form.confirmpassword.required)?_c('div',{staticClass:"text-danger"},[_vm._v("Password is required!")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.confirmpassword.sameAsPassword)?_c('div',{staticClass:"text-danger"},[_vm._v("Passwords don't match")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.gdprok),expression:"form.gdprok"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"gdprCheck"},domProps:{"checked":Array.isArray(_vm.form.gdprok)?_vm._i(_vm.form.gdprok,null)>-1:(_vm.form.gdprok)},on:{"input":function($event){_vm.$v.form.gdprok.$touch()},"change":function($event){var $$a=_vm.form.gdprok,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "gdprok", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "gdprok", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "gdprok", $$c)}}}}),_vm._v(" "),(_vm.form.language == 'Nederlands')?_c('label',{staticClass:"form-check-label",attrs:{"for":"gdprCheck"}},[_vm._v("\n            Ik accepteer de Chrono Logic Online "),_c('a',{attrs:{"href":"/terms-and-conditions","target":"_blank"}},[_vm._v("Gebruiksvoorwaarden")]),_vm._v(" en "),_c('a',{attrs:{"href":"/privacy-policy","target":"_blank"}},[_vm._v("Privacyverklaring")])]):_vm._e(),_vm._v(" "),(_vm.form.language == 'Français')?_c('label',{staticClass:"form-check-label",attrs:{"for":"gdprCheck"}},[_vm._v("\n            J'accepte les "),_c('a',{attrs:{"href":"/terms-and-conditions","target":"_blank"}},[_vm._v("Conditions d'utilisation")]),_vm._v(" et  la "),_c('a',{attrs:{"href":"/privacy-policy","target":"_blank"}},[_vm._v("Déclaration de confidentialité")]),_vm._v(" pour Chrono Logic Online.\n          ")]):_vm._e(),_vm._v(" "),(_vm.form.language != 'Nederlands' && _vm.form.language != 'Français')?_c('label',{staticClass:"form-check-label",attrs:{"for":"gdprCheck"}},[_vm._v("\n            I agree with the Chrono Logic Online "),_c('a',{attrs:{"href":"/terms-and-conditions","target":"_blank"}},[_vm._v("Terms and Conditions")]),_vm._v(" and "),_c('a',{attrs:{"href":"/privacy-policy","target":"_blank"}},[_vm._v("Privacy Policy")])]):_vm._e()]),_vm._v(" "),(_vm.$v.form.gdprok.$dirty)?_c('div',[(!_vm.$v.form.gdprok.GDPRnotTrue)?_c('div',{staticClass:"text-danger"},[_vm._v("Must be checked!")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary mb-3",attrs:{"disabled":_vm.loading,"type":"submit"}},[_vm._v("Register")])])])]),_vm._v(" "),(_vm.form.language == 'Nederlands')?_c('div',{staticClass:"modal fade",attrs:{"id":"myModal","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.backToLogin}},[_vm._v("Sluiten")])])])])]):_c('div',{staticClass:"modal fade",attrs:{"id":"myModal","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.backToLogin}},[_vm._v("Close")])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Registratie ontvangen")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Bedankt voor uw registratie!")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p',[_vm._v("Gelieve te wachten op een validatie e-mail alvorens in te loggen.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Registration received")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Thank you for your registration!")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p',[_vm._v("Please wait for a validation e-mail before attempting to log in.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectList_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71d9058d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectList_vue__ = __webpack_require__(114);
function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71d9058d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71d9058d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(113);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("404b033c", content, true, {});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:1500px){.container-fluid[data-v-71d9058d]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-71d9058d]{width:60%}}.lnk[data-v-71d9058d]{cursor:pointer}.back-to-top[data-v-71d9058d]{cursor:pointer;position:fixed;bottom:20px;right:20px;display:none}", ""]);

// exports


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.language == 'Nederlands')?_c('v-tour',{attrs:{"name":"ProjectTour","steps":_vm.projects != null ? _vm.stepswithNED : _vm.stepswithoutNED,"callbacks":_vm.myCallbacks,"options":_vm.myOptionsNED}}):(_vm.language == 'Chinese')?_c('v-tour',{attrs:{"name":"ProjectTour","steps":_vm.projects != null ? _vm.stepswithCHI : _vm.stepswithoutCHI,"callbacks":_vm.myCallbacks,"options":_vm.myOptionsCHI}}):(_vm.language == 'Portugues')?_c('v-tour',{attrs:{"name":"ProjectTour","steps":_vm.projects != null ? _vm.stepswithPOR : _vm.stepswithoutPOR,"callbacks":_vm.myCallbacks,"options":_vm.myOptionsPOR}}):_c('v-tour',{attrs:{"name":"ProjectTour","steps":_vm.projects != null ? _vm.stepswithENG : _vm.stepswithoutENG,"callbacks":_vm.myCallbacks,"options":_vm.myOptionsENG}}),_vm._v(" "),_c('app-header',{attrs:{"sysco":_vm.sysco}}),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"ConfirmDelete","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.caption("delete_warning")))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.projtodelete.customerName)+" - "+_vm._s(_vm.projtodelete.projectName))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.caption("delete_project_sure")))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.projectDelete(_vm.projtodelete.id)}}},[_vm._v(_vm._s(_vm.caption("addwin_Yes")))]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.caption("addwin_No")))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"BomSelection","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content centered"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.caption("bom_chooseformat")))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('span',[_c('button',{staticClass:"btn btn-small btn-outline-primary",on:{"click":function($event){_vm.projectCSV(_vm.bomprojid)}}},[_vm._v(_vm._s(_vm.caption("bom_csv")))])]),_vm._v(" "),_c('span',[_c('button',{staticClass:"btn btn-small btn-outline-primary",on:{"click":function($event){_vm.projectXL(_vm.bomprojid)}}},[_vm._v(_vm._s(_vm.caption("bom_xlsx")))])]),_vm._v(" "),_c('span',[_c('button',{staticClass:"btn btn-small btn-danger",on:{"click":function($event){_vm.bommodalhide()}}},[_vm._v(_vm._s(_vm.caption("Cancel")))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"PDFSelection","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content centered"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.caption("pdf_chooseformat")))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{attrs:{"align":"middle"}},[_c('button',{class:_vm.firstpage == '1' ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2',staticStyle:{"width":"400px"},on:{"click":function($event){_vm.setfirstpage()}}},[_vm._v(_vm._s(_vm.caption("pdf_firstpage")))])]),_vm._v(" "),_c('div',{attrs:{"align":"middle"}},[_c('button',{class:_vm.sashpage == '1' ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2',staticStyle:{"width":"400px"},on:{"click":function($event){_vm.setsashpage()}}},[_vm._v(_vm._s(_vm.caption("pdf_sashpage")))])]),_vm._v(" "),_c('div',{attrs:{"align":"middle"}},[_c('button',{class:_vm.framepage == '1' ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2',staticStyle:{"width":"400px"},on:{"click":function($event){_vm.setframepage()}}},[_vm._v(_vm._s(_vm.caption("pdf_framepage")))])]),_vm._v(" "),_c('div',{staticClass:"mt-3",attrs:{"align":"middle"}},[_c('span',[_c('button',{staticClass:"btn btn-small btn-outline-primary",on:{"click":function($event){_vm.projectPdfSeparate()}}},[_vm._v(_vm._s(_vm.caption("pdf_separate")))])]),_vm._v(" "),_c('span',[_c('button',{staticClass:"btn btn-small btn-outline-primary",on:{"click":function($event){_vm.projectPdfBundled()}}},[_vm._v(_vm._s(_vm.caption("pdf_bundled")))])]),_vm._v(" "),_c('span',[_c('button',{staticClass:"btn btn-small btn-danger",on:{"click":function($event){_vm.pdfmodalhide()}}},[_vm._v(_vm._s(_vm.caption("Cancel")))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"CopyProjectName","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content centered"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.caption("addproj_EnterProjectName")))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.caption("addproj_ProjectName")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.projName),expression:"projName",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.projName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.projName=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.projEmpty)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.caption("addwin_Required")))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('span',[_c('button',{staticClass:"btn btn-small btn-primary",on:{"click":function($event){_vm.projCopySend()}}},[_vm._v(_vm._s(_vm.caption("Submit")))])]),_vm._v(" "),_c('span',[_c('button',{staticClass:"btn btn-small btn-danger",on:{"click":function($event){_vm.projectcopyModalHide()}}},[_vm._v(_vm._s(_vm.caption("Cancel")))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"SharedUsersSelection","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content centered"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.caption("shared_selectusers")))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._l((_vm.shusers),function(usr){return _c('div',{key:usr.userId,attrs:{"align":"middle"}},[_c('div',[_c('button',{class:_vm.usrinlist(usr.userId) ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2',staticStyle:{"width":"400px"},on:{"click":function($event){_vm.setUser(usr.userId)}}},[(_vm.readonly(usr.userId) == 1)?_c('i',{staticClass:"fas fa-lock mr-3"}):_vm._e(),_vm._v(" "),(_vm.readonly(usr.userId) == 2)?_c('i',{staticClass:"fas fa-lock-open mr-3"}):_vm._e(),_vm._v("\n                "+_vm._s(usr.firstName)+" "+_vm._s(usr.lastName)+", "+_vm._s(usr.companyName)+"\n              ")])])])}),_vm._v(" "),_c('div',{staticClass:"mt-4",attrs:{"align":"middle"}},[_c('span',[_c('button',{staticClass:"btn btn-small btn-primary",on:{"click":function($event){_vm.selectusershide()}}},[_vm._v(_vm._s(_vm.caption("Submit")))])])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid",staticStyle:{"background-color":"white"}},[_c('div',[(_vm.role == 1 || _vm.role == 4 || _vm.role == 5 || _vm.role == 6)?_c('span',[_c('button',{staticClass:"btn btn-primary btn-sm my-2",attrs:{"type":"button"},on:{"click":function($event){_vm.users()}}},[_vm._v("Users")])]):_vm._e(),_vm._v(" "),(_vm.versionsloaded = true && (_vm.usersVN < _vm.latestVN))?_c('span',[_c('button',{staticClass:"btn btn-danger btn-sm my-2 v-step-0",attrs:{"type":"button"},on:{"click":function($event){_vm.versions()}}},[_vm._v(_vm._s(_vm.caption("update_new")))])]):_vm._e(),_vm._v(" "),(_vm.versionsloaded = true && (_vm.usersVN >= _vm.latestVN))?_c('span',[_c('button',{staticClass:"btn btn-primary btn-sm my-2 v-step-0",attrs:{"type":"button"},on:{"click":function($event){_vm.versions()}}},[_vm._v(_vm._s(_vm.caption("update_updates")))])]):_vm._e(),_vm._v(" "),_c('span',[_c('button',{staticClass:"btn btn-info btn-sm my-2",attrs:{"type":"button"},on:{"click":_vm.starttour}},[_vm._v(_vm._s(_vm.caption("tour_tour")))])]),_vm._v(" "),_c('span',[_c('button',{staticClass:"btn btn-primary btn-sm my-2 v-step-1",attrs:{"type":"button"},on:{"click":function($event){_vm.sharedusers()}}},[_vm._v(_vm._s(_vm.caption("users_sharedusers")))])]),_vm._v(" "),_c('span',[_c('button',{staticClass:"btn btn-primary btn-sm my-2",attrs:{"type":"button"},on:{"click":function($event){_vm.downloads()}}},[_vm._v("Downloads")])]),_vm._v(" "),(_vm.role == 1 || _vm.role == 4 || _vm.role == 5 || _vm.role == 6)?_c('span',[_c('button',{staticClass:"btn btn-primary btn-sm my-2",attrs:{"type":"button"},on:{"click":function($event){_vm.exportOrgaData()}}},[_vm._v("Export")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"dropdown float-right"},[_c('button',{staticClass:"btn btn-secondary btn-sm dropdown-toggle my-2 v-step-2",attrs:{"type":"button","id":"dropdownMenuButton","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(_vm._s(_vm.language))]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.changelanguage('Nederlands')}}},[_vm._v("Nederlands")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.changelanguage('English')}}},[_vm._v("English")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.changelanguage('Français')}}},[_vm._v("Français")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.changelanguage('Deutsch')}}},[_vm._v("Deutsch")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.changelanguage('Chinese')}}},[_vm._v("Chinese")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.changelanguage('Portugues')}}},[_vm._v("Portugues")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.changelanguage('Espanol')}}},[_vm._v("Espanol")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.changelanguage('Czech')}}},[_vm._v("Czech")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.changelanguage('Polski')}}},[_vm._v("Polski")])])])]),_vm._v(" "),_c('div',{staticClass:"display-4"},[_vm._v(_vm._s(_vm.caption("projlist_Projects")))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm mb-2 v-step-3",staticStyle:{"font-size":"20px"},attrs:{"type":"button"},on:{"click":function($event){_vm.projectCreate()}}},[_c('i',{staticClass:"fas fa-plus-square mr-2"}),_vm._v("\n      "+_vm._s(_vm.caption("projlist_AddProject"))+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm mb-2",staticStyle:{"font-size":"20px"},attrs:{"type":"button"},on:{"click":function($event){_vm.refresh()}}},[_c('i',{staticClass:"fas fa-sync"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchproj),expression:"searchproj"}],staticClass:"input form-control mb-2 v-step-4",staticStyle:{"font-size":"16px"},attrs:{"type":"text"},domProps:{"value":(_vm.searchproj)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchproj=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"dropdown"},[_c('button',{staticClass:"btn btn-secondary btn-sm dropdown-toggle my-2",attrs:{"type":"button","id":"dropdownMenuButton","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(_vm._s(_vm.caption(_vm.sortoptions)))]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.setSort('byName')}}},[_vm._v(_vm._s(_vm.caption('byName')))]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.setSort('oldnew')}}},[_vm._v(_vm._s(_vm.caption('oldnew')))]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.setSort('newold')}}},[_vm._v(_vm._s(_vm.caption('newold')))]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.setSort('lstmod')}}},[_vm._v(_vm._s(_vm.caption('lstmod')))])])])]),_vm._v(" "),(_vm.projectsloaded = true)?_c('div',{staticClass:"container-fluid"},_vm._l((_vm.projects),function(p){return _c('div',{key:p.Id,staticClass:"card",style:(_vm.tour == true ? 'z-index:-1; position:relative' : '')},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-subtitle mt-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-5"},[_c('div',{staticClass:"row"},[(p.sharedCount == null)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"row"},[_c('div',[_c('span',{class:p.numWindows > 0 ? 'badge badge-primary v-step-5 ml-4' : 'badge badge-danger ml-4 v-step-5'},[_vm._v(_vm._s(p.numWindows))]),_vm._v(" "),_c('span',{staticClass:"ml-3",staticStyle:{"color":"blue"}},[_c('small',[_vm._v(_vm._s(p.customerName))])]),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_c('strong',[_vm._v(_vm._s(p.projectName))])]),_vm._v(" "),_c('div',{staticClass:"my-1 ml-4 small"},[_c('i',{staticClass:"far fa-plus-square mr-1"}),_vm._v("\n                        "+_vm._s(_vm.getDateTime(p.createdDate))+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"my-1 ml-4 small"},[_c('i',{staticClass:"far fa-edit mr-1"}),_vm._v("\n                        "+_vm._s(_vm.getDateTime(p.lastModifiedDate))+_vm._s(p.lastModifiedUser != p.userId && p.lastModifiedUser != 0 ? ' (' + _vm.getuserinfo(p.lastModifiedUser) + ')' : '')+"\n                        "),(p.lastModifiedUser == p.userId)?_c('i',{staticClass:"far fa-user ml-1 mr-1"}):_vm._e()])])])]):_vm._e(),_vm._v(" "),(p.sharedCount == 0)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"row"},[_c('div',[_c('span',{class:p.numWindows > 0 ? 'badge badge-primary v-step-5 ml-4' : 'badge badge-danger ml-4 v-step-5'},[_vm._v(_vm._s(p.numWindows))]),_vm._v(" "),_c('span',{staticClass:"ml-3",staticStyle:{"color":"blue"}},[_c('small',[_vm._v(_vm._s(p.customerName))])]),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_c('strong',[_vm._v(_vm._s(p.projectName))])]),_vm._v(" "),_c('div',{staticClass:"my-1 ml-4 small"},[_c('i',{staticClass:"far fa-plus-square mr-1"}),_vm._v("\n                        "+_vm._s(_vm.getDateTime(p.createdDate))+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"my-1 ml-4 small"},[_c('i',{staticClass:"far fa-edit mr-1"}),_vm._v("\n                        "+_vm._s(_vm.getDateTime(p.lastModifiedDate))+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"badge badge-info ml-4 v-step-5"},[_vm._v("\n                        "+_vm._s(p.numWindows)+" - "+_vm._s(_vm.caption("shared_from"))+" "+_vm._s(p.firstname)+" "+_vm._s(p.lastname)+", "+_vm._s(p.companyName)+"\n                        "),(_vm.getprojreadonly(p.id) == 1)?_c('i',{staticClass:"fas fa-lock ml-3"}):_vm._e(),_vm._v(" "),(_vm.getprojreadonly(p.id) == 0)?_c('i',{staticClass:"fas fa-lock-open ml-3"}):_vm._e()])])])]):_vm._e(),_vm._v(" "),(p.sharedCount > 0)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"row"},[_c('div',[_c('span',{class:p.numWindows > 0 ? 'badge badge-primary v-step-5 ml-4' : 'badge badge-danger ml-4 v-step-5'},[_vm._v(_vm._s(p.numWindows))]),_vm._v(" "),_c('span',{staticClass:"ml-3",staticStyle:{"color":"blue"}},[_c('small',[_vm._v(_vm._s(p.customerName))])]),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_c('strong',[_vm._v(_vm._s(p.projectName))])]),_vm._v(" "),_c('div',{staticClass:"my-1 ml-4 small"},[_c('i',{staticClass:"far fa-plus-square mr-1"}),_vm._v("\n                        "+_vm._s(_vm.getDateTime(p.createdDate))+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"my-1 ml-4 small"},[_c('i',{staticClass:"far fa-edit mr-1"}),_vm._v("\n                        "+_vm._s(_vm.getDateTime(p.lastModifiedDate))+_vm._s(p.lastModifiedUser != p.userId && p.lastModifiedUser != 0 ? ' (' + _vm.getuserinfo(p.lastModifiedUser) + ')' : '')+"\n                        "),(p.lastModifiedUser == p.userId)?_c('i',{staticClass:"far fa-user ml-1 mr-1"}):_vm._e()])])]),_vm._v(" "),_c('div',[_vm._l((_vm.shprojects),function(sh){return [_c('div',{key:sh.projectId + sh.userId,staticClass:"ml-2 mb-1"},[(sh.projectId == p.id)?_c('div',{staticClass:"badge badge-pill badge-warning v-step-5"},[(sh.readonly == 1)?_c('i',{staticClass:"fas fa-lock mr-2"}):_vm._e(),_vm._v(" "),(sh.readonly == 0)?_c('i',{staticClass:"fas fa-lock-open mr-2"}):_vm._e(),_vm._v("\n                          "+_vm._s(_vm.getshareduserinfo(sh.userId, sh.readonly))+"\n                        ")]):_vm._e()])]})],2)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 ml-2 ml-lg-0"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-12 col-xl-6 mb-2"},[(_vm.csvloading == false && _vm.pdfloading == false)?_c('button',{staticClass:"btn btn btn-outline-primary v-step-6",attrs:{"type":"button"},on:{"click":function($event){_vm.projectBOM(p)}}},[_c('i',{staticClass:"far fa-list-alt"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.caption("winlist_BOM")))])]):_vm._e(),_vm._v(" "),((_vm.csvloading == true && p.id != _vm.selProj) || _vm.pdfloading == true)?_c('button',{staticClass:"btn btn btn-outline-primary disabled",attrs:{"type":"button"}},[_c('i',{staticClass:"far fa-list-alt"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.caption("winlist_BOM")))])]):_vm._e(),_vm._v(" "),(_vm.csvloading == true && p.id == _vm.selProj)?_c('button',{staticClass:"btn btn btn-outline-primary disabled",attrs:{"type":"button"}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v(" Please wait...\n                  ")]):_vm._e(),_vm._v(" "),(_vm.pdfloading == false && _vm.csvloading == false)?_c('button',{staticClass:"btn btn btn-outline-success v-step-7",attrs:{"type":"button"},on:{"click":function($event){_vm.projectPDF(p)}}},[_c('i',{staticClass:"far fa-file-pdf fa-lg mr-1"}),_vm._v("PDF\n                  ")]):_vm._e(),_vm._v(" "),((_vm.pdfloading == true && p.id != _vm.pdfproj.id) || _vm.csvloading == true)?_c('button',{staticClass:"btn btn btn-outline-success disabled",attrs:{"type":"button"}},[_c('i',{staticClass:"far fa-file-pdf fa-lg mr-1"}),_vm._v("PDF\n                  ")]):_vm._e(),_vm._v(" "),(_vm.pdfloading == true && p.id == _vm.pdfproj.id)?_c('button',{staticClass:"btn btn btn-outline-success disabled",attrs:{"type":"button"}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n                    "+_vm._s(_vm.pdfcaption)+" is loading...\n                  ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"btn btn mr-4 btn-outline-primary v-step-8",on:{"click":function($event){_vm.projectWindows(p)}}},[_c('i',{staticClass:"fas fa-city"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.caption("projlist_Windows")))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-xl-6"},[(p.sharedCount == null)?_c('span',{staticClass:"btn btn btn-outline-primary v-step-9",on:{"click":function($event){_vm.showSharedUsers(p)}}},[_c('i',{staticClass:"fas fa-share-alt"})]):_vm._e(),_vm._v(" "),(p.sharedCount > 0)?_c('span',{staticClass:"btn btn btn-primary v-step-9",on:{"click":function($event){_vm.showSharedUsers(p)}}},[_c('i',{staticClass:"fas fa-share-alt"})]):_vm._e(),_vm._v(" "),(p.sharedCount == null || p.sharedCount > 0)?_c('span',{staticClass:"btn btn btn-outline-primary v-step-10",on:{"click":function($event){_vm.projectEdit(p.id)}}},[_c('i',{staticClass:"fas fa-pen"}),_vm._v("\n                    "+_vm._s(_vm.caption("Edit"))+"\n                  ")]):_vm._e(),_vm._v(" "),(p.sharedCount == 0)?_c('span',{staticClass:"btn btn btn-outline-primary v-step-10 disabled"},[_c('i',{staticClass:"fas fa-pen"}),_vm._v("\n                    "+_vm._s(_vm.caption("Edit"))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"btn btn btn-outline-primary v-step-11",on:{"click":function($event){_vm.projectCopy(p.id, p.projectName)}}},[_c('i',{staticClass:"far fa-copy"}),_vm._v("\n                    "+_vm._s(_vm.caption("Copy"))+"\n                  ")]),_vm._v(" "),(p.sharedCount == null || p.sharedCount > 0)?_c('span',{staticClass:"btn btn btn-outline-danger v-step-12",on:{"click":function($event){_vm.showConfirmDelete(p)}}},[_c('i',{staticClass:"fas fa-trash-alt"})]):_vm._e(),_vm._v(" "),(p.sharedCount == 0)?_c('span',{staticClass:"btn btn btn-outline-danger v-step-12 disabled"},[_c('i',{staticClass:"fas fa-trash-alt"})]):_vm._e()])])])])])])])})):_vm._e(),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-primary btn-lg back-to-top",attrs:{"id":"back-to-top","href":"#","role":"button"}},[_c('i',{staticClass:"fas fa-chevron-up mr-2"}),_vm._v("Top\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectEdit_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f19d49_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectEdit_vue__ = __webpack_require__(118);
function injectStyle (ssrContext) {
  __webpack_require__(116)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22f19d49"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f19d49_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(117);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("098eb78f", content, true, {});

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:600px){.container-fluid[data-v-22f19d49]{width:75%}}", ""]);

// exports


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{attrs:{"sysco":_vm.sysco}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('h1',{staticClass:"display-4"},[_c('strong',[_vm._v(_vm._s(_vm.caption("projedit_EditProject")))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.projectedit($event)}}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.caption("addproj_CustomerName")))]),_vm._v(" "),_c('input',{directives:[{name:"autofocus",rawName:"v-autofocus"},{name:"model",rawName:"v-model.trim",value:(_vm.form.custName),expression:"form.custName",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.custName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "custName", $event.target.value.trim())},function($event){_vm.$v.form.custName.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.custName.$dirty)?_c('div',[(!_vm.$v.form.custName.required)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.caption("addwin_Required")))]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.caption("addproj_ProjectName")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.projName),expression:"form.projName",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.projName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "projName", $event.target.value.trim())},function($event){_vm.$v.form.projName.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.projName.$dirty)?_c('div',[(!_vm.$v.form.projName.required)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.caption("addwin_Required")))]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.caption("Submit")))]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.caption("Cancel")))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectCreate_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10999623_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectCreate_vue__ = __webpack_require__(122);
function injectStyle (ssrContext) {
  __webpack_require__(120)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10999623"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10999623_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectCreate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(121);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("70b07075", content, true, {});

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:600px){.container-fluid[data-v-10999623]{width:75%}}", ""]);

// exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{attrs:{"sysco":_vm.sysco}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('h1',{staticClass:"display-4"},[_c('strong',[_vm._v(_vm._s(_vm.caption("addproj_CreateProject")))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.projectcreate($event)}}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.caption("addproj_CustomerName")))]),_vm._v(" "),_c('input',{directives:[{name:"autofocus",rawName:"v-autofocus"},{name:"model",rawName:"v-model.trim",value:(_vm.form.custName),expression:"form.custName",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.custName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "custName", $event.target.value.trim())},function($event){_vm.$v.form.custName.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.custName.$dirty)?_c('div',[(!_vm.$v.form.custName.required)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.caption("addwin_Required")))]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.caption("addproj_ProjectName")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.projName),expression:"form.projName",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.projName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "projName", $event.target.value.trim())},function($event){_vm.$v.form.projName.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.projName.$dirty)?_c('div',[(!_vm.$v.form.projName.required)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.caption("addwin_Required")))]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-3",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.caption("Submit")))]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary mb-3",on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.caption("Cancel")))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WindowList_vue__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f99185e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WindowList_vue__ = __webpack_require__(128);
function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f99185e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WindowList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f99185e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WindowList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(125);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("ab7f8578", content, true, {});

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:800px){.container-fluid[data-v-f99185e6]{width:75%}}.back-to-top[data-v-f99185e6]{cursor:pointer;position:fixed;bottom:20px;right:20px;display:none}.centered-and-cropped[data-v-f99185e6]{object-fit:contain}", ""]);

// exports


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type == 1 || _vm.type == 3 || _vm.type == 6 || _vm.type == 7 || _vm.type == 8 || _vm.type == 16 || _vm.type == 30 || _vm.type == 21 || _vm.type == 23 || _vm.type == 26 || _vm.type == 46 || _vm.type == 55 || _vm.type == 50)?_c('svg',{attrs:{"width":_vm.SFb1+42,"height":_vm.SFh+66}},[_c('rect',{attrs:{"x":"23","y":"23","width":_vm.SFb1-4,"height":_vm.SFh,"stroke":"grey","fill":"lightblue","stroke-width":"4"}}),_vm._v(" "),(_vm.dim == true)?[_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":(_vm.SFb1/2)+23,"y":"15","font-size":"20"}},[_vm._v(_vm._s(_vm.Fb1))]),_vm._v(" "),_c('line',{attrs:{"x1":"21","y1":"17","x2":_vm.SFb1+21,"y2":"17","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"21.25","y1":"13","x2":"21.25","y2":"21","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+20.75,"y1":"13","x2":_vm.SFb1+20.75,"y2":"21","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"fill":"blue","x":(_vm.SFb1/2)+23,"y":_vm.SFh+37,"font-size":"14"}},[_vm._v(_vm._s(_vm.W1)+"kg")]),_vm._v(" "),(_vm.type == 30)?_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":(_vm.SFb1/2)+23,"y":_vm.SFh+53,"font-size":"13","font-weight":"bold"}},[_vm._v(_vm._s(_vm.profile))]):_vm._e(),_vm._v(" "),(_vm.type == 21 || _vm.type == 23 || _vm.type == 26)?_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":(_vm.SFb1/2)+23,"y":_vm.SFh+53,"font-size":"13","font-weight":"bold"}},[_vm._v(_vm._s(_vm.caption("addwin_Balcony")))]):_vm._e(),_vm._v(" "),(_vm.dir == 1 && _vm.type != 8)?[_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":_vm.SFb1+27,"y":(_vm.SFh/2)+23,"transform":_vm.rotFh90,"font-size":"20"}},[_vm._v(_vm._s(_vm.Fh))]),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+25,"y1":"21","x2":_vm.SFb1+25,"y2":_vm.SFh+25,"stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+21,"y1":"21","x2":_vm.SFb1+29,"y2":"21","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+21,"y1":_vm.SFh+24.75,"x2":_vm.SFb1+29,"y2":_vm.SFh+24.75,"stroke":"black","stroke-width":".5"}})]:_vm._e(),_vm._v(" "),(_vm.dir == 2 || _vm.type == 8)?[_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":"15","y":(_vm.SFh/2)+23,"transform":_vm.rotFh270,"font-size":"20"}},[_vm._v(_vm._s(_vm.Fh))]),_vm._v(" "),_c('line',{attrs:{"x1":"17","y1":"21","x2":"17","y2":_vm.SFh+25,"stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"13","y1":"21.25","x2":"21","y2":"21.25","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"13","y1":_vm.SFh+24.75,"x2":"21","y2":_vm.SFh+24.75,"stroke":"black","stroke-width":".5"}})]:_vm._e(),_vm._v(" "),(_vm.type != 8 && _vm.type != 50 && _vm.type != 55 && _vm.dir == 1)?[_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":"15","y":(_vm.SFh-_vm.SA/2)+21,"transform":_vm.rotA270,"font-size":"20"}},[_vm._v(_vm._s(_vm.A))]),_vm._v(" "),_c('line',{attrs:{"x1":"17","y1":(_vm.SFh-_vm.SA)+21,"x2":"17","y2":_vm.SFh+25,"stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"13","y1":(_vm.SFh-_vm.SA)+21.25,"x2":"21","y2":(_vm.SFh-_vm.SA)+21.25,"stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"13","y1":_vm.SFh+24.75,"x2":"21","y2":_vm.SFh+24.75,"stroke":"black","stroke-width":".5"}})]:_vm._e(),_vm._v(" "),(_vm.type != 8 && _vm.type != 50 && _vm.type != 55 && _vm.dir == 2)?[_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":_vm.SFb1+27,"y":(_vm.SFh-_vm.SA/2)+25,"transform":_vm.rotA90,"font-size":"20"}},[_vm._v(_vm._s(_vm.A))]),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+25,"y1":(_vm.SFh-_vm.SA)+21,"x2":_vm.SFb1+25,"y2":_vm.SFh+25,"stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+21,"y1":(_vm.SFh-_vm.SA)+21,"x2":_vm.SFb1+29,"y2":(_vm.SFh-_vm.SA)+21,"stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+21,"y1":_vm.SFh+24.75,"x2":_vm.SFb1+29,"y2":_vm.SFh+24.75,"stroke":"black","stroke-width":".5"}})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.dir == 1 && (_vm.type == 1 || _vm.type == 16 || _vm.type == 6 || _vm.type == 3 || _vm.type == 30 || _vm.type == 21 || _vm.type == 23 || _vm.type == 26 || _vm.type == 46))?[_c('line',{attrs:{"x1":_vm.SFb1+17,"y1":"25","x2":"25","y2":(_vm.SFh - _vm.SA)+21,"stroke":"black","stroke-width":".5","stroke-dasharray":_vm.type == 3|| _vm.type == 30 || _vm.type == 23 ? '5,5' : ''}}),_vm._v(" "),_c('line',{attrs:{"x1":"25","y1":(_vm.SFh-_vm.SA)+21,"x2":_vm.SFb1+17,"y2":_vm.SFh+21,"stroke":"black","stroke-width":".5","stroke-dasharray":_vm.type == 3|| _vm.type == 30 || _vm.type == 23 ? '5,5' : ''}})]:_vm._e(),_vm._v(" "),(_vm.dir == 2 && (_vm.type == 1 || _vm.type == 16 || _vm.type == 6 || _vm.type == 3 || _vm.type == 30 || _vm.type == 21 || _vm.type == 23 || _vm.type == 26 || _vm.type == 46))?[_c('line',{attrs:{"x1":"25","y1":"25","x2":_vm.SFb1+17,"y2":(_vm.SFh - _vm.SA)+21,"stroke":"black","stroke-width":".5","stroke-dasharray":_vm.type == 3|| _vm.type == 30 || _vm.type == 23 ? '5,5' : ''}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+17,"y1":(_vm.SFh - _vm.SA) + 21,"x2":"25","y2":_vm.SFh+21,"stroke":"black","stroke-width":".5","stroke-dasharray":_vm.type == 3|| _vm.type == 30 || _vm.type == 23 ? '5,5' : ''}})]:_vm._e(),_vm._v(" "),(_vm.type == 1 || _vm.type == 3 || _vm.type == 7 || _vm.type == 8 || _vm.type == 21 || _vm.type == 23 || _vm.type == 50 || _vm.type == 55)?[_c('line',{attrs:{"x1":"25","y1":_vm.SFh+21,"x2":(_vm.SFb1/2)+21,"y2":"25","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":(_vm.SFb1/2)+21,"y1":"25","x2":_vm.SFb1+17,"y2":_vm.SFh+21,"stroke":"black","stroke-width":".5"}})]:_vm._e(),_vm._v(" "),(_vm.config == 0)?[(_vm.dir == 1 && _vm.type != 8 && _vm.type != 50 && _vm.type != 55 && _vm.handle != '')?[_c('image',{attrs:{"xlink:href":'/src/assets/R_' + _vm.handle + '.png',"x":"21","y":(_vm.SFh-_vm.SA)+21-(_vm.picH/2),"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMinYMid"}})]:_vm._e(),_vm._v(" "),(_vm.dir == 2 && _vm.type != 8 && _vm.type != 50 && _vm.type != 55 && _vm.handle != '')?[_c('image',{attrs:{"xlink:href":'/src/assets/L_' + _vm.handle + '.png',"x":_vm.SFb1+21-(_vm.picW),"y":(_vm.SFh-_vm.SA)+21-(_vm.picH/2),"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMaxYMid"}})]:_vm._e(),_vm._v(" "),(_vm.type == 8 && _vm.type != 50 && _vm.type != 55 && _vm.handle != '')?[_c('image',{attrs:{"xlink:href":'/src/assets/L_' + _vm.handle + '.png',"x":(_vm.SFb1/2)+21-(_vm.picW/2),"y":21,"height":_vm.picH,"width":_vm.picW,"transform":'rotate(270 ' + ((_vm.SFb1/2)+21) + ' ' + (21 + (_vm.picH/2)) + ')',"preserveAspectRatio":"xMaxYMid"}})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.config == 0)?[(_vm.dir == 1 && _vm.hinge == 1)?[_c('image',{attrs:{"xlink:href":'/src/assets/R_VIS.png',"x":_vm.SFb1+21-_vm.picW,"y":_vm.SFh+21-_vm.picH,"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMaxYMid"}})]:_vm._e(),_vm._v(" "),(_vm.dir == 2 && _vm.hinge == 1)?[_c('image',{attrs:{"xlink:href":'/src/assets/L_VIS.png',"x":21,"y":_vm.SFh+21-_vm.picH,"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMinYMid"}})]:_vm._e(),_vm._v(" "),(_vm.dir == 1 && _vm.hinge == 2)?[_c('image',{attrs:{"xlink:href":'/src/assets/R_PRO.png',"x":_vm.SFb1+17-_vm.picW,"y":_vm.SFh+21-_vm.picH,"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMaxYMax"}})]:_vm._e(),_vm._v(" "),(_vm.dir == 2 && _vm.hinge == 2)?[_c('image',{attrs:{"xlink:href":'/src/assets/L_PRO.png',"x":25,"y":_vm.SFh+21-_vm.picH,"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMinYMax"}})]:_vm._e(),_vm._v(" "),(_vm.dir == 1 && _vm.hinge == 5)?[_c('image',{attrs:{"xlink:href":'/src/assets/R_GO.png',"x":_vm.SFb1+20-_vm.picW,"y":_vm.SFh+21-_vm.picH,"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMaxYMax"}})]:_vm._e(),_vm._v(" "),(_vm.dir == 2 && _vm.hinge == 5)?[_c('image',{attrs:{"xlink:href":'/src/assets/L_GO.png',"x":22,"y":_vm.SFh+21-_vm.picH,"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMinYMax"}})]:_vm._e()]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.type == 2 || _vm.type == 4 || _vm.type == 60 || _vm.type == 22 || _vm.type == 24 || _vm.type == 27 || _vm.type == 31)?_c('svg',{attrs:{"width":_vm.SFb1+_vm.SFb2+42,"height":_vm.SFh+66}},[_c('rect',{attrs:{"x":"23","y":"23","width":_vm.SFb1-4,"height":_vm.SFh,"stroke":"grey","fill":"lightblue","stroke-width":"4"}}),_vm._v(" "),_c('rect',{attrs:{"x":23+_vm.SFb1,"y":"23","width":_vm.SFb2-4,"height":_vm.SFh,"stroke":"grey","fill":"lightblue","stroke-width":"4"}}),_vm._v(" "),(_vm.dim == true)?[_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":(_vm.SFb1/2)+23,"y":"15","font-size":"20"}},[_vm._v(_vm._s(_vm.Fb1))]),_vm._v(" "),_c('line',{attrs:{"x1":"21","y1":"17","x2":_vm.SFb1+21,"y2":"17","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"21.25","y1":"13","x2":"21.25","y2":"21","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+20.75,"y1":"13","x2":_vm.SFb1+20.75,"y2":"21","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"fill":"blue","x":(_vm.SFb1/2)+23,"y":_vm.SFh+37,"font-size":"14"}},[_vm._v(_vm._s(_vm.W1)+"kg")]),_vm._v(" "),(_vm.type == 22 || _vm.type == 24 || _vm.type == 27)?_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":((_vm.SFb1 + _vm.SFb2)/2)+23,"y":_vm.SFh+53,"font-size":"13","font-weight":"bold"}},[_vm._v(_vm._s(_vm.caption("addwin_Balcony")))]):_vm._e(),_vm._v(" "),_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":_vm.SFb1+(_vm.SFb2/2)+23,"y":"15","font-size":"20"}},[_vm._v(_vm._s(_vm.Fb2))]),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+21,"y1":"17","x2":_vm.SFb1+_vm.SFb2+21,"y2":"17","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"21.25","y1":"13","x2":"21.25","y2":"21","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+_vm.SFb2+20.75,"y1":"13","x2":_vm.SFb1+_vm.SFb2+20.75,"y2":"21","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"fill":"blue","x":_vm.SFb1+(_vm.SFb2/2)+23,"y":_vm.SFh+37,"font-size":"14"}},[_vm._v(_vm._s(_vm.W2)+"kg")]),_vm._v(" "),(_vm.dir == 1)?[_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":_vm.SFb1+_vm.SFb2+27,"y":(_vm.SFh/2)+23,"transform":_vm.rotSFh90,"font-size":"20"}},[_vm._v(_vm._s(_vm.Fh))]),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+_vm.SFb2+25,"y1":"21","x2":_vm.SFb1+_vm.SFb2+25,"y2":_vm.SFh+25,"stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+_vm.SFb2+21,"y1":"21","x2":_vm.SFb1+_vm.SFb2+29,"y2":"21","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+_vm.SFb2+21,"y1":_vm.SFh+24.75,"x2":_vm.SFb1+_vm.SFb2+29,"y2":_vm.SFh+24.75,"stroke":"black","stroke-width":".5"}})]:_vm._e(),_vm._v(" "),(_vm.dir == 2)?[_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":"15","y":(_vm.SFh/2)+23,"transform":_vm.rotSFh270,"font-size":"20"}},[_vm._v(_vm._s(_vm.Fh))]),_vm._v(" "),_c('line',{attrs:{"x1":"17","y1":"21","x2":"17","y2":_vm.SFh+25,"stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"13","y1":"21.25","x2":"21","y2":"21.25","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"13","y1":_vm.SFh+24.75,"x2":"21","y2":_vm.SFh+24.75,"stroke":"black","stroke-width":".5"}})]:_vm._e(),_vm._v(" "),(_vm.dir == 1)?[_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":"15","y":(_vm.SFh-_vm.SA/2)+21,"transform":_vm.rotSA270,"font-size":"20"}},[_vm._v(_vm._s(_vm.A))]),_vm._v(" "),_c('line',{attrs:{"x1":"17","y1":(_vm.SFh-_vm.SA)+21,"x2":"17","y2":_vm.SFh+25,"stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"13","y1":(_vm.SFh-_vm.SA)+21.25,"x2":"21","y2":(_vm.SFh-_vm.SA)+21.25,"stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"13","y1":_vm.SFh+24.75,"x2":"21","y2":_vm.SFh+24.75,"stroke":"black","stroke-width":".5"}})]:_vm._e(),_vm._v(" "),(_vm.dir == 2)?[_c('text',{staticStyle:{"text-anchor":"middle"},attrs:{"x":_vm.SFb1+_vm.SFb2+27,"y":(_vm.SFh-_vm.SA/2)+25,"transform":_vm.rotSA90,"font-size":"20"}},[_vm._v(_vm._s(_vm.A))]),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+_vm.SFb2+25,"y1":(_vm.SFh-_vm.SA)+21,"x2":_vm.SFb1+_vm.SFb2+25,"y2":_vm.SFh+25,"stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+_vm.SFb2+21,"y1":(_vm.SFh-_vm.SA)+21,"x2":_vm.SFb1+_vm.SFb2+29,"y2":(_vm.SFh-_vm.SA)+21,"stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+_vm.SFb2+21,"y1":_vm.SFh+24.75,"x2":_vm.SFb1+_vm.SFb2+29,"y2":_vm.SFh+24.75,"stroke":"black","stroke-width":".5"}})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.dir == 1 && (_vm.type == 2 || _vm.type == 4 || _vm.type == 60 || _vm.type == 22 || _vm.type == 24 || _vm.type == 27 || _vm.type == 31))?[_c('line',{attrs:{"x1":"25","y1":"25","x2":_vm.SFb1+17,"y2":(_vm.SFh - _vm.SA)+21,"stroke":"black","stroke-width":".5","stroke-dasharray":_vm.type == 31 ? '5,5' : ''}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+17,"y1":(_vm.SFh-_vm.SA)+21,"x2":"25","y2":_vm.SFh+21,"stroke":"black","stroke-width":".5","stroke-dasharray":_vm.type == 31 ? '5,5' : ''}})]:_vm._e(),_vm._v(" "),(_vm.dir == 2 && (_vm.type == 2 || _vm.type == 4 || _vm.type == 60 || _vm.type == 22 || _vm.type == 24 || _vm.type == 27 || _vm.type == 31))?[_c('line',{attrs:{"x1":_vm.SFb1+_vm.SFb2+17,"y1":"25","x2":_vm.SFb1+25,"y2":(_vm.SFh-_vm.SA)+21,"stroke":"black","stroke-width":".5","stroke-dasharray":_vm.type == 31 ? '5,5' : ''}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+25,"y1":(_vm.SFh-_vm.SA)+21,"x2":_vm.SFb1+_vm.SFb2+17,"y2":_vm.SFh+21,"stroke":"black","stroke-width":".5","stroke-dasharray":_vm.type == 31 ? '5,5' : ''}})]:_vm._e(),_vm._v(" "),(_vm.dir == 1 && (_vm.type == 2 || _vm.type == 4 || _vm.type == 60 || _vm.type == 22 || _vm.type == 24 || _vm.type == 27 || _vm.type == 31))?[_c('line',{attrs:{"x1":_vm.SFb1+_vm.SFb2+17,"y1":"25","x2":_vm.SFb1+25,"y2":(_vm.SFh-_vm.SA)+21,"stroke":"black","stroke-width":".5","stroke-dasharray":_vm.type == 4 || _vm.type == 31 ? '5,5' : ''}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+25,"y1":(_vm.SFh-_vm.SA)+21,"x2":_vm.SFb1+_vm.SFb2+17,"y2":_vm.SFh+21,"stroke":"black","stroke-width":".5","stroke-dasharray":_vm.type == 4 || _vm.type == 31 ? '5,5' : ''}})]:_vm._e(),_vm._v(" "),(_vm.dir == 2 && (_vm.type == 2 || _vm.type == 4 || _vm.type == 60 || _vm.type == 22 || _vm.type == 24 || _vm.type == 27 || _vm.type == 31))?[_c('line',{attrs:{"x1":"25","y1":"25","x2":_vm.SFb1+17,"y2":(_vm.SFh - _vm.SA)+21,"stroke":"black","stroke-width":".5","stroke-dasharray":_vm.type == 4 || _vm.type == 31 ? '5,5' : ''}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+17,"y1":(_vm.SFh-_vm.SA)+21,"x2":"25","y2":_vm.SFh+21,"stroke":"black","stroke-width":".5","stroke-dasharray":_vm.type == 4 || _vm.type == 31 ? '5,5' : ''}})]:_vm._e(),_vm._v(" "),(_vm.dir == 1 && (_vm.type == 2 || _vm.type == 4 || _vm.type == 22 || _vm.type == 24))?[_c('line',{attrs:{"x1":_vm.SFb1+25,"y1":_vm.SFh+21,"x2":_vm.SFb1+(_vm.SFb2/2)+21,"y2":"25","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":_vm.SFb1+(_vm.SFb2/2)+21,"y1":"25","x2":_vm.SFb1+_vm.SFb2+17,"y2":_vm.SFh+21,"stroke":"black","stroke-width":".5"}})]:_vm._e(),_vm._v(" "),(_vm.dir == 2 && (_vm.type == 2 || _vm.type == 4 || _vm.type == 22 || _vm.type == 24))?[_c('line',{attrs:{"x1":"25","y1":_vm.SFh+21,"x2":(_vm.SFb1/2)+21,"y2":"25","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":(_vm.SFb1/2)+21,"y1":"25","x2":_vm.SFb1+17,"y2":_vm.SFh+21,"stroke":"black","stroke-width":".5"}})]:_vm._e(),_vm._v(" "),(_vm.config == 0)?[(_vm.dir == 1 && _vm.handle != '' )?[_c('image',{attrs:{"xlink:href":'/src/assets/R_' + _vm.handle + '.png',"x":_vm.SFb1+21,"y":(_vm.SFh-_vm.SA)+21-(_vm.picH/2),"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMinYMid"}})]:_vm._e(),_vm._v(" "),(_vm.dir == 2 && _vm.handle != '' )?[_c('image',{attrs:{"xlink:href":'/src/assets/L_' + _vm.handle + '.png',"x":_vm.SFb1+21-_vm.picW,"y":(_vm.SFh-_vm.SA)+21-(_vm.picH/2),"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMaxYMid"}})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.config == 0)?[(_vm.hinge == 1)?[_c('image',{attrs:{"xlink:href":'/src/assets/R_VIS.png',"x":_vm.SFb1+_vm.SFb2+21-_vm.picW,"y":_vm.SFh+21-_vm.picH,"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMaxYMid"}}),_vm._v(" "),_c('image',{attrs:{"xlink:href":'/src/assets/L_VIS.png',"x":21,"y":_vm.SFh+21-_vm.picH,"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMinYMid"}})]:_vm._e(),_vm._v(" "),(_vm.hinge == 2)?[_c('image',{attrs:{"xlink:href":'/src/assets/R_PRO.png',"x":_vm.SFb1+_vm.SFb2+17-_vm.picW,"y":_vm.SFh+21-_vm.picH,"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMaxYMax"}}),_vm._v(" "),_c('image',{attrs:{"xlink:href":'/src/assets/L_PRO.png',"x":25,"y":_vm.SFh+21-_vm.picH,"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMinYMax"}})]:_vm._e(),_vm._v(" "),(_vm.hinge == 5)?[_c('image',{attrs:{"xlink:href":'/src/assets/R_GO.png',"x":_vm.SFb1+_vm.SFb2+20-_vm.picW,"y":_vm.SFh+21-_vm.picH,"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMaxYMax"}}),_vm._v(" "),_c('image',{attrs:{"xlink:href":'/src/assets/L_GO.png',"x":22,"y":_vm.SFh+21-_vm.picH,"height":_vm.picH,"width":_vm.picW,"preserveAspectRatio":"xMinYMax"}})]:_vm._e()]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var windowsteps = {
  stepswithoutENG: [{
    target: '.v-step-0',
    content: 'Click to go back to the project list.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-1',
    content: 'Click to create a new window',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-2',
    content: 'Enter text here to filter the window list',
    params: {
      placement: 'left'
    }
  }],
  stepswithENG: [{
    target: '.v-step-0',
    content: 'Click to go back to the project list.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-1',
    content: 'Click to create a new window',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-2',
    content: 'Enter text here to filter the window list',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-3',
    content: 'This is the name of the window.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-4',
    content: 'This is the number of identical windows.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-5',
    content: 'Click to edit the window parameters.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-6',
    content: 'Click to make a copy of a window.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-7',
    content: 'Click to delete a window.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-8',
    content: 'Scaled representation of the window with hinges, handle, width, height and weight information.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-9',
    content: 'Set or bulk.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-10',
    content: 'Chrono type.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-11',
    content: 'Hinge type.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-12',
    content: 'Handle type and partnumber.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-13',
    content: 'Click to see the BOM for the window.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-14',
    content: 'Click to generate the .PDF file with mounting instructions. The .PDF file is stored in your Downloads folder.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-15',
    content: 'Click to generate the generic mounting file.PDF for the selected configuration. The .PDF file is stored in your Downloads folder.',
    params: {
      placement: 'bottom'
    }
  }],
  stepswithoutNED: [{
    target: '.v-step-0',
    content: 'Klik om terug te keren naar de lijst van projecten.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-1',
    content: 'Klik om een nieuw raam te maken.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-2',
    content: 'Typ tekst om de ramenlijst te filteren.',
    params: {
      placement: 'left'
    }
  }],
  stepswithNED: [{
    target: '.v-step-0',
    content: 'Klik om terug te keren naar de lijst van projecten.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-1',
    content: 'Klik om een nieuw raam te maken.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-2',
    content: 'Typ tekst om de ramenlijst te filteren.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-3',
    content: 'Dit is de naam van het raam.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-4',
    content: 'Dit is het aantal identieke ramen.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-5',
    content: 'Klik om de raamparameters te wijzigen.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-6',
    content: 'Klik om een kopie te maken van een raam.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-7',
    content: 'Klik om een raam te verwijderen.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-8',
    content: 'Geschaalde afbeelding van een raam met scharnieren, kruk, vleugelbreedte(s), vleugelhoogte en vleugelgewicht(en).',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-9',
    content: 'Set of grootverpakking.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-10',
    content: 'Chronotype.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-11',
    content: 'Scharniertype.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-12',
    content: 'Kruktype en artikelnummer.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-13',
    content: 'Klik om de BOM voor een raam te tonen.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-14',
    content: 'Klik om een .PDF bestand te genereren met montage instructies. Het .PDF bestand wordt in uw Downloads folder bewaard.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-15',
    content: 'Klik om een .PDF bestand te genereren met de generieke montagetekening voor de gekozen configuratie. Het .PDF bestand wordt in uw Downloads folder bewaard.',
    params: {
      placement: 'bottom'
    }
  }],
  stepswithoutCHI: [{
    target: '.v-step-0', // We're using document.querySelector() under the hood
    content: '单击此按钮返回项目列表',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-1',
    content: '单击此按钮创建新的窗型',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-2',
    content: '在此输入文本可筛选项目列表',
    params: {
      placement: 'left'
    }
  }],
  stepswithCHI: [{
    target: '.v-step-0', // We're using document.querySelector() under the hood
    content: '单击此按钮返回项目列表',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-1',
    content: '单击此按钮创建新的窗型',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-2',
    content: '在此输入文本可筛选项目列表',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-3',
    content: '窗型编号',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-4',
    content: '相同窗型的数量',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-5',
    content: '单击此按钮可编辑窗型参数',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-6',
    content: '单击此按钮可复制窗型',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-7',
    content: '单击此按钮可删除窗型',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-8',
    content: '缩放窗口可显示窗型的铰链、执手、宽度、高度和重量信息',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-9',
    content: '套件或散件大包装',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-10',
    content: 'Chrono锁闭类型',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-11',
    content: '铰链类型',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-12',
    content: '执手类型和编号',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-13',
    content: '单击此按钮查看窗型的物料清单',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-14',
    content: '单击此按钮可生成 .PDF安装说明。.PDF文件存储在下载文件夹中',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-15',
    content: '单击此按钮可生成所选配置的 .PDF安装说明。.PDF文件存储在下载文件夹中',
    params: {
      placement: 'bottom'
    }
  }],
  stepswithoutPOR: [{
    target: '.v-step-0',
    content: 'Carregue para voltar à listagem de projetos.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-1',
    content: 'Carregue para criar uma nova janela.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-2',
    content: 'Insira o texto a pesquisar na lista de projetos.',
    params: {
      placement: 'left'
    }
  }],
  stepswithPOR: [{
    target: '.v-step-0',
    content: 'Carregue para voltar à listagem de projetos.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-1',
    content: 'Carregue para criar uma nova janela.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-2',
    content: 'Insira o texto a pesquisar na lista de projetos.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-3',
    content: 'Nome da janela.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-4',
    content: 'Número de janelas com a mesma configuração.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-5',
    content: 'Carregue para editar os parâmetros da janela.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-6',
    content: 'Carregue para criar uma cópia da janela.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-7',
    content: 'Carregue para eliminar a janela.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-8',
    content: 'Representação à escala da janela com dobradiças, puxador, largura, altura e informação de peso.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-9',
    content: 'Em kit ou formato industrial',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-10',
    content: 'Tipologia Chrono.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-11',
    content: 'Tipologia de dobradiça.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-12',
    content: 'Tipologia de puxador e referência.',
    params: {
      placement: 'left'
    }
  }, {
    target: '.v-step-13',
    content: 'Carregue para ver a BOM da janela.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-14',
    content: 'Carregue para gerar um ficheiro .PDF com as instruções de montagem. O ficheiro .PDF será guardado na pasta de Transferências.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-15',
    content: 'Carregue para gerar um ficheiro .PDF com as instruções de montagem gerais do sistema. O ficheiro .PDF será guardado na pasta de Transferências.',
    params: {
      placement: 'bottom'
    }
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (windowsteps);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{attrs:{"sysco":_vm.sysco}}),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"ConfirmDelete","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.caption("delete_warning")))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.wintodelete.name))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.caption("delete_window_sure")))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.windowDelete(_vm.wintodelete.id)}}},[_vm._v(_vm._s(_vm.caption("addwin_Yes")))]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.caption("addwin_No")))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"CopyWindowName","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content centered"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.caption("addwin_EnterWindowName")))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.caption("addwin_WindowName")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.winName),expression:"winName",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.winName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.winName=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.winEmpty)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.caption("addwin_Required")))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('span',[_c('button',{staticClass:"btn btn-small btn-primary",on:{"click":function($event){_vm.winCopySend()}}},[_vm._v(_vm._s(_vm.caption("Submit")))])]),_vm._v(" "),_c('span',[_c('button',{staticClass:"btn btn-small btn-danger",on:{"click":function($event){_vm.wincopyModalHide()}}},[_vm._v(_vm._s(_vm.caption("Cancel")))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"PDFPagesSelection","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content centered"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.caption("pdf_pdfselection")))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{attrs:{"align":"middle"}},[_c('button',{class:_vm.firstpage == '1' ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2',staticStyle:{"width":"400px"},on:{"click":function($event){_vm.setfirstpage()}}},[_vm._v(_vm._s(_vm.caption("pdf_firstpage")))])]),_vm._v(" "),_c('div',{attrs:{"align":"middle"}},[_c('button',{class:_vm.sashpage == '1' ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2',staticStyle:{"width":"400px"},on:{"click":function($event){_vm.setsashpage()}}},[_vm._v(_vm._s(_vm.caption("pdf_sashpage")))])]),_vm._v(" "),_c('div',{attrs:{"align":"middle"}},[_c('button',{class:_vm.framepage == '1' ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2',staticStyle:{"width":"400px"},on:{"click":function($event){_vm.setframepage()}}},[_vm._v(_vm._s(_vm.caption("pdf_framepage")))])]),_vm._v(" "),_c('div',{staticClass:"mt-4",attrs:{"align":"middle"}},[_c('span',[_c('button',{staticClass:"btn btn-small btn-primary",on:{"click":function($event){_vm.pdfpageshide()}}},[_vm._v(_vm._s(_vm.caption("Submit")))])]),_vm._v(" "),_c('span',[_c('button',{staticClass:"btn btn-small btn-danger",on:{"click":function($event){_vm.pdfpagesmodalhide()}}},[_vm._v(_vm._s(_vm.caption("Cancel")))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('span',[_c('button',{staticClass:"btn btn-info btn-sm my-2",attrs:{"type":"button"},on:{"click":_vm.starttour}},[_vm._v(_vm._s(_vm.caption("tour_tour")))])]),_vm._v(" "),_c('div',{staticClass:"lead"},[_vm._v(_vm._s(_vm.proj.customerName))]),_vm._v(" "),_c('div',{staticClass:"lead",staticStyle:{"color":"blue"}},[_c('strong',[_vm._v(_vm._s(_vm.proj.projectName))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"display-4"},[_vm._v(_vm._s(_vm.caption("winlist_Windows")))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"UploadModal","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.caption("upload_status")))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.invalidfile == true)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.caption("upload_invalidfile")))])]):_vm._e(),_vm._v(" "),(_vm.errorlist != null)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.caption("upload_notcreated")))])]):_vm._e(),_vm._v(" "),_c('p'),_vm._v(" "),(_vm.errorlist != null)?_c('div',_vm._l((Object.keys(_vm.errorlist)),function(e){return _c('div',[_c('h3',[_vm._v(_vm._s(e))]),_vm._v(" "),(_vm.errorlist[e].fb1Error != '')?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorlist[e].fb1Error))])]):_vm._e(),_vm._v(" "),(_vm.errorlist[e].fb2Error != '')?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorlist[e].fb2Error))])]):_vm._e(),_vm._v(" "),(_vm.errorlist[e].fhError != '')?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorlist[e].fhError))])]):_vm._e(),_vm._v(" "),(_vm.errorlist[e].aError != '')?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorlist[e].aError))])]):_vm._e(),_vm._v(" "),(_vm.errorlist[e].w1Error != '')?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorlist[e].w1Error))])]):_vm._e(),_vm._v(" "),(_vm.errorlist[e].w2Error != '')?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorlist[e].w2Error))])]):_vm._e(),_vm._v(" "),(_vm.errorlist[e].ventError != '')?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorlist[e].ventError))])]):_vm._e(),_vm._v(" "),(_vm.errorlist[e].magnetError != '')?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorlist[e].magnetError))])]):_vm._e(),_vm._v(" "),(_vm.errorlist[e].snapperError != '')?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorlist[e].snapperError))])]):_vm._e(),_vm._v(" "),(_vm.errorlist[e].hingeError != '')?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorlist[e].hingeError))])]):_vm._e(),_vm._v(" "),(_vm.errorlist[e].chronoError != '')?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorlist[e].chronoError))])]):_vm._e(),_vm._v(" "),(_vm.errorlist[e].handleError != '')?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorlist[e].handleError))])]):_vm._e()])})):_vm._e(),_vm._v(" "),(_vm.errorlist == null && _vm.invalidfile == false)?_c('div',[_vm._v("\n              "+_vm._s(_vm.caption("upload_created"))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.closeModal}},[_vm._v(_vm._s(_vm.caption("upload_close")))])])])])]),_vm._v(" "),(_vm.language == 'Nederlands')?_c('v-tour',{attrs:{"name":"WindowTour","steps":_vm.windows != null ? _vm.stepswithNED : _vm.stepswithoutNED,"callbacks":_vm.myCallbacks,"options":_vm.myOptionsNED}}):(_vm.language == 'Chinese')?_c('v-tour',{attrs:{"name":"WindowTour","steps":_vm.windows != null ? _vm.stepswithCHI : _vm.stepswithoutCHI,"callbacks":_vm.myCallbacks,"options":_vm.myOptionsCHI}}):(_vm.language == 'Portugues')?_c('v-tour',{attrs:{"name":"WindowTour","steps":_vm.windows != null ? _vm.stepswithPOR : _vm.stepswithoutPOR,"callbacks":_vm.myCallbacks,"options":_vm.myOptionsPOR}}):_c('v-tour',{attrs:{"name":"WindowTour","steps":_vm.windows != null ? _vm.stepswithENG : _vm.stepswithoutENG,"callbacks":_vm.myCallbacks,"options":_vm.myOptionsENG}}),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm mb-3 v-step-0",staticStyle:{"font-size":"20px"},attrs:{"type":"button","data-intro":"Hello step one!"},on:{"click":function($event){_vm.showProjectlist()}}},[_c('i',{staticClass:"fas fa-chevron-left mr-2"}),_vm._v(_vm._s(_vm.caption("winlist_Back")))]),_vm._v(" "),(_vm.getprojreadonly(_vm.proj.id) == 0)?_c('button',{staticClass:"btn btn-primary btn-sm mb-3 v-step-1",staticStyle:{"font-size":"20px"},attrs:{"type":"button"},on:{"click":function($event){_vm.windowCreate()}}},[_c('i',{staticClass:"fas fa-plus-square mr-2"}),_vm._v(_vm._s(_vm.caption("winlist_AddWindow")))]):_vm._e(),_vm._v(" "),(_vm.sysco == 2 || _vm.sysco == 7)?_c('span',{staticStyle:{"float":"right"}},[_c('label',{staticClass:"btn btn-secondary mb-3",staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.uploadcaption)),_c('input',{ref:"file",staticClass:"btn btn-secondary mb-3",staticStyle:{"display":"none"},attrs:{"type":"file","id":"file"},on:{"change":function($event){_vm.handleFileUpload()}}})]),_vm._v(" "),(_vm.fileuploading == false)?_c('button',{staticClass:"btn btn-primary mb-3",staticStyle:{"font-size":"20px"},on:{"click":function($event){_vm.submitFile()}}},[_c('i',{staticClass:"fas fa-file-upload"}),_vm._v(" "+_vm._s(_vm.caption("upload_send")))]):_vm._e(),_vm._v(" "),(_vm.fileuploading == true)?_c('button',{staticClass:"btn btn-primary mb-3 disabled",staticStyle:{"font-size":"20px"}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.caption("upload_wait")))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchwin),expression:"searchwin"}],staticClass:"input form-control mb-2 v-step-2",staticStyle:{"font-size":"16px"},attrs:{"type":"text"},domProps:{"value":(_vm.searchwin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchwin=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"dropdown"},[_c('button',{staticClass:"btn btn-secondary btn-sm dropdown-toggle my-2",attrs:{"type":"button","id":"dropdownMenuButton","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n          "+_vm._s(_vm.caption(_vm.sortoptions))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.setSort('byName')}}},[_vm._v(_vm._s(_vm.caption('byName')))]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.setSort('oldnew')}}},[_vm._v(_vm._s(_vm.caption('oldnew')))]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.setSort('newold')}}},[_vm._v(_vm._s(_vm.caption('newold')))])])]),_vm._v(" "),_c('div',{style:(_vm.tour == true ? 'z-index:-1; position:relative;' : '')},_vm._l((_vm.windows),function(w){return _c('div',{key:w.id,staticClass:"card mb-2 border border-dark"},[_c('div',{staticClass:"card-header",style:(w.valid == true ? '' : 'background-color: red;'),attrs:{"id":w.id}},[_c('h2',[_c('span',{staticClass:"v-step-3",style:(w.valid == true ? '' : 'color:white;')},[_vm._v(_vm._s(w.name))]),_vm._v(" "),_c('span',{staticClass:"v-step-4",style:(w.valid == true ? '' : 'color:white;')},[_c('small',[_vm._v("["+_vm._s(w.quantity)+"]")])])]),_vm._v(" "),(_vm.getprojreadonly(w.projectId) == 0)?_c('button',{class:w.valid == true ? 'btn btn-sm btn-outline-primary mr-1 v-step-5' : 'btn btn-sm btn-outline-light mr-1 v-step-5',attrs:{"type":"button"},on:{"click":function($event){_vm.windowEdit(w.id)}}},[_c('i',{staticClass:"fas fa-pen fa-lg mr-1"}),_vm._v(_vm._s(_vm.caption("Edit")))]):_vm._e(),_vm._v(" "),(w.valid == true && _vm.getprojreadonly(w.projectId) == 0)?_c('button',{staticClass:"btn btn-sm btn-outline-primary mr-1 v-step-6",attrs:{"type":"button"},on:{"click":function($event){_vm.windowCopy(w)}}},[_c('i',{staticClass:"far fa-copy fa-lg mr-1"}),_vm._v(_vm._s(_vm.caption("Copy")))]):_vm._e(),_vm._v(" "),(_vm.getprojreadonly(w.projectId) == 0)?_c('button',{class:w.valid == true ? 'btn btn-sm btn-outline-danger mr-5 v-step-7' : 'btn btn-sm btn-outline-light mr-5 v-step-7',attrs:{"type":"button"},on:{"click":function($event){_vm.showConfirmDelete(w)}}},[_c('i',{staticClass:"fas fa-trash-alt"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-body",style:(w.valid == true ? '' : 'background-color: lightgray;')},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[(w.valid == true)?_c('div',{staticClass:"card-img-top my-2 ml-2 v-step-8"},[_c('window-graph',{attrs:{"type":w.windowType,"dir":w.openDir,"hinge":w.hingeType,"handle":_vm.handleBMP(w.handleAN),"Fb1":w.fb1,"Fb2":w.fb2,"Fh":w.fh,"A":w.a,"W1":w.weight1,"W2":w.weight2,"dim":_vm.dimension,"scale":_vm.scale,"profile":w.profile,"config":0}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-8"},[_c('div',{staticClass:"mb-2"},[(w.valid == false)?_c('button',{staticClass:"btn btn-danger"},[_c('h1',[_c('strong',[_vm._v(_vm._s(_vm.caption("upload_errors")))])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('span',{staticClass:"badge my-2 v-step-9",class:w.bulk == 0 ? 'badge-primary' : 'badge-success'},[_vm._v(_vm._s(w.bulk == 0 ? _vm.caption("Set") : _vm.caption("Bulk")))])]),_vm._v(" "),_c('div',{staticClass:"v-step-10"},[_c('h4',[_vm._v(" Chrono "),_c('strong',[_vm._v(_vm._s(_vm.caption(_vm.chrono(w.chrono))))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.setgroove == false ? '[' + _vm.groove(w.groove) + ']' : ''))])])]),_vm._v(" "),(w.chrono == 40)?_c('div',{staticClass:"my-2"},[_c('img',{staticClass:"centered-and-cropped",attrs:{"src":"/src/assets/RC2.jpg","height":"40","width":"50"}})]):_vm._e(),_vm._v(" "),(w.chrono == 50)?_c('div',{staticClass:"my-2"},[_c('img',{staticClass:"centered-and-cropped",attrs:{"src":"/src/assets/SKGxx.jpg","height":"40","width":"50"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"v-step-11"},[_c('h5',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.caption(_vm.hinge(w.hingeType))))])]),_vm._v(" "),((w.windowType != 50 && w.windowType != 55))?_c('div',{staticClass:"v-step-12"},[_c('h5',{staticClass:"text-secondary"},[_vm._v(_vm._s(w.handleAN != 'NONE' ? _vm.caption(_vm.handle(w.handleType)) : '')+" "+_vm._s(w.handleAN != 'NONE' ? _vm.handleAN(w.handleAN) : _vm.caption("addwin_NoHandle")))])]):_vm._e(),_vm._v(" "),(w.valid == true)?_c('button',{staticClass:"btn btn-sm btn-outline-primary v-step-13",attrs:{"type":"button"},on:{"click":function($event){_vm.windowBom(w)}}},[_c('i',{staticClass:"far fa-list-alt fa-lg mr-1"}),_vm._v(_vm._s(_vm.caption("winlist_BOM")))]):_vm._e(),_vm._v(" "),(_vm.loading == false && w.valid == true)?_c('button',{staticClass:"btn btn-sm btn-outline-success v-step-14",attrs:{"type":"button"},on:{"click":function($event){_vm.windowPdf(w)}}},[_c('i',{staticClass:"far fa-file-pdf fa-lg mr-1"}),_vm._v("PDF")]):_vm._e(),_vm._v(" "),(_vm.loading == false && w.valid == true)?_c('button',{staticClass:"btn btn-sm btn-outline-secondary v-step-15",attrs:{"type":"button"},on:{"click":function($event){_vm.genericPdf(w)}}},[_c('i',{staticClass:"far fa-file-pdf fa-lg mr-1"}),_vm._v("GENERIC PDF")]):_vm._e(),_vm._v(" "),(_vm.loading == true && w.id != _vm.selWin)?_c('button',{staticClass:"btn btn-sm btn-outline-success disabled",attrs:{"type":"button"}},[_c('i',{staticClass:"far fa-file-pdf fa-lg mr-1"}),_vm._v("PDF")]):_vm._e(),_vm._v(" "),(_vm.loading == true && w.id == _vm.selWin)?_c('button',{staticClass:"btn btn-sm btn-outline-success disabled",attrs:{"type":"button"}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v(" Please wait...")]):_vm._e()])])])])])}))],1),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-primary btn-lg back-to-top",attrs:{"id":"back-to-top","href":"#","role":"button"}},[_c('i',{staticClass:"fas fa-chevron-up mr-2"}),_vm._v("Top")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WindowEdit_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02538671_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WindowEdit_vue__ = __webpack_require__(133);
function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02538671"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WindowEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02538671_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WindowEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(131);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("a3b45146", content, true, {});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:600px){.container-fluid[data-v-02538671]{width:75%;font-size:14px}}@media (min-width:1200px){.container-fluid[data-v-02538671]{width:75%;font-size:10px}}@media (min-width:2050px){.container-fluid[data-v-02538671]{width:75%;font-size:14px}}.centered-and-cropped[data-v-02538671]{object-fit:contain}", ""]);

// exports


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var windoweditsteps = {
  stepsENG: [{
    target: '.v-step-0',
    content: 'Enter a name or description for the window.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-1',
    content: 'Click to change the opening direction (left/right).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-2',
    content: 'Click to change the packaging (set/bulk).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-3',
    content: 'Click to change the groove (14-18/10-14).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-4',
    content: 'Enter the number of identical windows.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-5',
    content: 'Select the color code.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-6',
    content: 'Select window type.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-7',
    content: 'Select the Chrono hardware type.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-8',
    content: 'Select the hinge type.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-9',
    content: 'Select the handle type.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-10',
    content: 'Click to select an additional handle reinforcement plate (only with fork handles).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-11',
    content: 'Click to select a 90° blocking piece (only with fork handles on side- or bottom-hung windows).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-12',
    content: 'Click to select the required profile (only with open-out windows).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-13',
    content: 'Enter the sash width (in mm).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-14',
    content: 'Enter the second sash width (in mm) (only french casement windows).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-15',
    content: 'Enter the sash height (in mm).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-16',
    content: 'After leaving the sash height field, the handle height is calculated on half of the height. Enter the handle height (in mm) to change it.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-17',
    content: 'Enter the sash weight (in kg).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-18',
    content: 'Enter the second sash weight (in kg) (only french casement windows).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-19',
    content: 'Click to select an optional night vent device.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-20',
    content: 'Click to select an optional magnetic contact.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-21',
    content: 'Click to select an optional window stay.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-22',
    content: 'Click to select an optional snapper.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-23',
    content: 'Select the bolt screw length (only french casement windows).',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-24',
    content: 'Enter the profile depth for the central locking (only french casement windows).',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-25',
    content: 'Click to force a central locking device (only french casement windows)',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-26',
    content: 'Click to select adjustable bolt keeps (only french casement windows).',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-27',
    content: 'Click to send the configuration to the server. If the parameters are valid, the window is saved and the application returns to the window list. In case of validation errors, clues will be visible under the incorrect parameter(s)',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-28',
    content: 'Click to cancel. The parameters are not saved and the application returns to the window list.',
    params: {
      placement: 'bottom'
    }
  }],
  stepsNED: [{
    target: '.v-step-0',
    content: 'Vul een naam of omschrijving in.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-1',
    content: 'Klik om de openingsrichting te wijzigen (links/rechts).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-2',
    content: 'Klik om de verpakking te wijzigen (set/grootverpakking).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-3',
    content: 'Klik om de groef te wijzigen (14-18/10-14).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-4',
    content: 'Vul het aantal identieke ramen in.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-5',
    content: 'Selecteer de kleurcode.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-6',
    content: 'Selecteer het raamtype.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-7',
    content: 'Selecteer het Chrono beslagtype.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-8',
    content: 'Selecteer het scharniertype.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-9',
    content: 'Selecteer het kruktype.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-10',
    content: 'Klik om een bijkomende versterkingsrib te voorzien (enkel bij krukken met vork).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-11',
    content: 'Klik om een 90° blokkeerplaat te voorzien (enkel bij krukken met vork op val- en draairamen).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-12',
    content: 'Klik om een profielreeks te selecteren (enkel bij buitendraaiende ramen).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-13',
    content: 'Vul de vleugelbreedte in (mm).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-14',
    content: 'Vul de vleugelbreedte van de tweede vleugel in (mm) (enkel bij stolpramen).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-15',
    content: 'Vul de vleugelhoogte in (mm).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-16',
    content: 'Bij het verlaten van het veld vleugelhoogte wordt de kruk op de helft van de hoogte geplaatst. Vul indien nodig een andere krukhoogte in (mm).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-17',
    content: 'Vul het vleugelgewicht in (kg).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-18',
    content: 'Vul het vleugelgewicht van de tweede vleugel in (kg) (enkel bij stolpramen).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-19',
    content: 'Klik om een optionele kierstand te voorzien.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-20',
    content: 'Klik om een optioneel magneetcontact te voorzien.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-21',
    content: 'Klik om een optionele raambegrenzer te voorzien.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-22',
    content: 'Klik om een optionele snapper te voorzien.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-23',
    content: 'Selecteer de lengte van de stolpgrendelschroeven (enkel bij stolpramen).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-24',
    content: 'Vul de profieldiepte van de makelaar in (enkel bij stolpramen).',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-25',
    content: 'Klik om een centrale vergrendeling ipv stolpgrendels te voorzien. (enkel bij stolpramen)',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-26',
    content: 'Klik om regelbare sluitstukken te voorzien (enkel bij stolpramen met grendels).',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-27',
    content: 'Klik om de configuratie naar de server te verzenden. Als alle parameters correct zijn wordt het raam opgeslaan en de applicatie keert terug naar de ramenlijst. Validatiefouten worden getoond onder de desbetreffende parameter.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-28',
    content: 'Klik om te annuleren. De parameters worden niet opgeslaan en de applicatie keert terug naar de ramenlijst.',
    params: {
      placement: 'bottom'
    }
  }],
  stepsCHI: [{
    target: '.v-step-0',
    content: '输入窗型编号或描述',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-1',
    content: '\u5355\u51FB\u6B64\u6309\u94AE\u5207\u6362\u5F00\u542F\u65B9\u5411\uFF08\u5DE6/\u53F3\uFF09',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-2',
    content: '单击此按钮切换包装方式（套件/散件大包装）',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-3',
    content: '单击此按钮切换五金槽口形式（14-18槽/10-14槽）',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-4',
    content: '输入窗型数量',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-5',
    content: '选择颜色编号',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-6',
    content: '选择开启类型',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-7',
    content: '选择Chrono锁闭类型',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-8',
    content: '选择铰链类型',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-9',
    content: '选择执手类型',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-10',
    content: '单击选择增加执手加强背板（只适用于拨叉执手）',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-11',
    content: '单击选择90°限位块（只适用于拨叉执手做平开窗或内倒窗）',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-12',
    content: '单击选择适用的型材（只适用于外开窗）',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-13',
    content: '输入窗扇宽度（mm）',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-14',
    content: '输入被动扇宽度（mm）（仅限对开窗）',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-15',
    content: '输入窗扇高度（mm）',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-16',
    content: '输入窗扇高度后，执手高度是默认居中的。可输入执手高度（mm）调整为所需要的实际尺寸',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-17',
    content: '输入窗扇重量（kg）',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-18',
    content: '输入被动扇重量（kg）（仅限对开窗）',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-19',
    content: '单击选择增加夜晚微通风',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-20',
    content: '单击选择增加电磁锁座',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-21',
    content: '单击选择增加限位风撑',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-22',
    content: '单击选择增加碰扣门吸',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-23',
    content: '选择固定插销的螺钉长度（仅限对开窗）',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-24',
    content: '输入假中梃型材的深度用于选择联动插销（仅限对开窗）',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-25',
    content: '单击选择联动插销（仅限对开窗）',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-26',
    content: '单击选择可调插销锁座（仅限对开窗）',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-27',
    content: '单击提交后，配置参数发送到服务器。如果所有参数有效，窗型将被保存，并返回到窗型列表。当配置参数有误时，不正确的参数信息将显示在下方。',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-28',
    content: '单击将取消。窗型参数不保存，并返回到窗型列表',
    params: {
      placement: 'bottom'
    }
  }],
  stepsPOR: [{
    target: '.v-step-0',
    content: 'Insira o nome ou descrição da janela.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-1',
    content: 'Carregue para alterar a orienta\xE7\xE3o de abertura da janela (esquerdo/direito).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-2',
    content: 'Carregue para alterar o formato de embalagem (kit/formato industrial).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-3',
    content: 'Carregue para alterar o canal do perfil (14-18/10-15).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-4',
    content: 'Introduza o numero de janelas idênticas.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-5',
    content: 'Selecione o código da cor.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-6',
    content: 'Selecione o tipo de janela.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-7',
    content: 'Selecione o tipo de Sistema Chrono.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-8',
    content: 'Selecione o tipo de dobradiça.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-9',
    content: 'Selecione o tipo de puxador.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-10',
    content: 'Carregue para selecionar o calço de reforço para o cremone (apenas puxadores de garfo).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-11',
    content: 'Carregue para selecionar a peça de bloqueio a 90º (apenas puxadores de garfo e em sistemas projetantes cremone horizontal e batente).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-12',
    content: 'Carregue para selecionar o tipo de perfil. (apenas para janelas de batente de abertura para o exterior).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-13',
    content: 'Introduza a largura da folha móvel (em mm).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-14',
    content: 'Introduza a largura da segunda folha (em mm) (apenas para janelas de duas folhas).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-15',
    content: 'Introduza a altura da folha móvel (em mm).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-16',
    content: 'Após introduzir a altura da folha móvel, a altura do puxador é calculada por defeito a metade da altura total. Introduza a altura do puxador (em mm) caso pretenda alterar a medida.',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-17',
    content: 'Introduza o peso da folha móvel (em kg).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-18',
    content: 'Introduza o peso da segunda folha (em kg) (apenas para janelas de duas folhas).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-19',
    content: 'Carregue para selecionar a opção de microventilação.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-20',
    content: 'Carregue para selecionar a opção de contacto magnético.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-21',
    content: 'Carregue para selecionar a opção limitador de abertura.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-22',
    content: 'Carregue para selecionar a opção Clip.',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-23',
    content: 'Selecione o comprimento dos parafusos (apenas para janelas de duas folhas).',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-24',
    content: 'Introduza a profundidade do perfil, onde o fecho de segunda folha irá ser usado (apenas para janelas de duas folhas).',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-25',
    content: 'Carregue para utilizar um fecho central de segunda folha (apenas para janelas de duas folhas).',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-26',
    content: 'Carregue para selecionar pontos de fecho ajustáveis (apenas para janelas de duas folhas).',
    params: {
      placement: 'top'
    }
  }, {
    target: '.v-step-27',
    content: 'Carregue para enviar a configuração para o servidor. Se os parametros introduzidos forem válidos, a janela é gravada e a aplicação voltará à listagem de janelas. Caso ocorram erros de validação, surgirão dicas por baixo do(s) campo(s) com erro(s).',
    params: {
      placement: 'bottom'
    }
  }, {
    target: '.v-step-28',
    content: 'Carregue para cancelar. Os parametros não foram gravados e a aplicação voltará à listagem de janelas.',
    params: {
      placement: 'bottom'
    }
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (windoweditsteps);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{attrs:{"sysco":_vm.sysco}}),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"HandlePosition","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.caption("delete_warning")))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.caption("handle_abovecenter")))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.hideModal}},[_vm._v("OK")])])])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('span',[_c('button',{staticClass:"btn btn-info btn-sm my-2",attrs:{"type":"button"},on:{"click":_vm.starttour}},[_vm._v(_vm._s(_vm.caption("tour_tour")))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-sm-12"},[_c('div',{staticClass:"row mt-2",staticStyle:{"text-align":"center"}},[_c('h1',{staticClass:"col-sm-12 display-5"},[_vm._v(_vm._s(_vm.form.windowName))]),_vm._v(" "),_c('div',{staticClass:"col-sm-12",staticStyle:{"text-align":"center"}},[_c('window-graph',{attrs:{"type":_vm.form.windowType,"dir":_vm.form.windowOpenDir,"hinge":_vm.form.windowHinge,"handle":_vm.selectedHandle == null ? '' : _vm.selectedHandle.bmp,"Fb1":_vm.form.windowFb1,"Fb2":_vm.form.windowFb2,"Fh":_vm.form.windowFh,"A":_vm.form.windowA,"W1":_vm.form.windowWeight1,"W2":_vm.form.windowWeight2,"dim":_vm.dimension,"scale":_vm.scale,"profile":_vm.form.profile,"config":1}})],1)]),_vm._v(" "),((_vm.form.windowType != 50 && _vm.form.windowType != 55))?_c('div',{staticClass:"row mt-2",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"col-sm-12",staticStyle:{"text-align":"center"}},[(_vm.selHandle != '')?_c('div',{staticStyle:{"text-align":"center"}},[(_vm.form.windowOpenDir == 1)?_c('img',{staticClass:"centered-and-cropped",attrs:{"src":'/src/assets/R_' + _vm.selHandle + '.PNG',"height":"160 ","width":"200"}}):_vm._e(),_vm._v(" "),(_vm.form.windowOpenDir == 2)?_c('img',{staticClass:"centered-and-cropped",attrs:{"src":'/src/assets/L_' + _vm.selHandle + '.PNG',"height":"160 ","width":"200"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('h2',[_vm._v(_vm._s(_vm.selectedHandle.ext)),((_vm.form.windowType == 31 && _vm.form.windowChrono == 50))?_c('span',[_vm._v(" (x2)")]):_vm._e()])])]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xl-8 col-sm-12"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.checkHandlePosition($event)}}},[(_vm.language == 'Nederlands')?_c('v-tour',{attrs:{"name":"WindowEditTour","steps":_vm.stepsNED,"callbacks":_vm.myCallbacks,"options":_vm.myOptionsNED}}):(_vm.language == 'Chinese')?_c('v-tour',{attrs:{"name":"WindowEditTour","steps":_vm.stepsCHI,"callbacks":_vm.myCallbacks,"options":_vm.myOptionsCHI}}):(_vm.language == 'Portugues')?_c('v-tour',{attrs:{"name":"WindowEditTour","steps":_vm.stepsPOR,"callbacks":_vm.myCallbacks,"options":_vm.myOptionsPOR}}):_c('v-tour',{attrs:{"name":"WindowEditTour","steps":_vm.stepsENG,"callbacks":_vm.myCallbacks,"options":_vm.myOptionsENG}}),_vm._v(" "),_c('div',{staticClass:"form-row",style:(_vm.tour == true ? 'z-index:-1; position:relative;' : '')},[_c('h6',{staticClass:"col-sm-12"},[_vm._v(_vm._s(_vm.caption("addwin_Window")))]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.windowName),expression:"form.windowName",modifiers:{"trim":true}}],staticClass:"input form-control form-control-sm v-step-0",attrs:{"type":"text","placeholder":_vm.caption('addwin_WindowName')},domProps:{"value":(_vm.form.windowName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "windowName", $event.target.value.trim())},function($event){_vm.$v.form.windowName.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.windowName.$dirty)?_c('div',[(!_vm.$v.form.windowName.required)?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.caption("addwin_Required")))])]):_vm._e()]):_vm._e()]),_vm._v(" "),((_vm.form.windowType != 55))?_c('div',{staticClass:"form-group col-sm-2"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-block v-step-1",attrs:{"type":"button"},on:{"click":function($event){_vm.SetDirection()}}},[_c('strong',[_vm._v(_vm._s(_vm.direction))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[(_vm.setpackaging == false)?_c('button',{class:_vm.form.windowBulk == false ? 'btn btn-outline-primary btn-sm btn-block v-step-2' : 'btn btn-danger btn-sm btn-block v-step-2',attrs:{"type":"button"},on:{"click":function($event){_vm.SetPackaging()}}},[_c('strong',[_vm._v(_vm._s(_vm.setOrBulk))])]):_vm._e()]),_vm._v(" "),(_vm.setgroove == false)?_c('div',{staticClass:"form-group col-sm-2"},[_c('button',{class:_vm.setgroove == false ? 'btn btn-outline-secondary btn-sm btn-block v-step-3' : 'btn btn-outline-secondary btn-sm btn-block',attrs:{"type":"button"},on:{"click":function($event){_vm.SetGroove()}}},[_c('strong',[_vm._v(_vm._s(_vm.groove))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-row",style:(_vm.tour == true ? 'z-index:-1; position:relative;' : '')},[_c('div',{staticClass:"form-group col-sm-2"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_Quantity")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.windowQuantity),expression:"form.windowQuantity",modifiers:{"number":true}}],staticClass:"input form-control form-control-sm v-step-4",attrs:{"type":"number","placeholder":"Quantity","min":"1","max":"9999"},domProps:{"value":(_vm.form.windowQuantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "windowQuantity", _vm._n($event.target.value))},function($event){_vm.$v.form.windowQuantity.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.windowQuantity.$dirty)?_c('div',[(!_vm.$v.form.windowQuantity.required)?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.caption("addwin_Required")))])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_Color")))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.windowColor),expression:"form.windowColor"}],staticClass:"form-control form-control-sm v-step-5",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "windowColor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.color),function(c){return _c('option',{key:c.code,domProps:{"value":c.code}},[_vm._v(_vm._s(_vm.caption(c.desc)))])}))])]),_vm._v(" "),_c('div',{staticClass:"form-row",style:(_vm.tour == true ? 'z-index:-1; position:relative;' : '')},[_c('h6',{staticClass:"col-sm-12"},[_vm._v("Chrono")]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_Type")))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.windowType),expression:"form.windowType"}],staticClass:"form-control form-control-sm v-step-6",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "windowType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.setFb2(_vm.form.windowType)}]}},_vm._l((_vm.types),function(t){return _c('option',{key:t.typeId,domProps:{"value":t.typeId}},[_vm._v(_vm._s(_vm.caption(t.typeDesc)))])}))]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-2 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v("Chrono")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.windowChrono),expression:"form.windowChrono"}],staticClass:"form-control form-control-sm v-step-7",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "windowChrono", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.SetChrono()}]}},_vm._l((_vm.chrono),function(c){return _c('option',{key:c.chronoId,domProps:{"value":c.chronoId}},[_vm._v(_vm._s(c.chronoDesc))])})),_vm._v(" "),(_vm.ChronoError != null && _vm.ChronoError !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.ChronoError))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_Hinge")))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.windowHinge),expression:"form.windowHinge"}],staticClass:"form-control form-control-sm mb-2 v-step-8",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "windowHinge", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.changehinge()}]}},_vm._l((_vm.hinge),function(h){return _c('option',{key:h.hingeId,domProps:{"value":h.hingeId}},[_vm._v(_vm._s(_vm.caption(h.hingeDesc)))])})),_vm._v(" "),(_vm.HingeError != null && _vm.HingeError !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.HingeError))])]):_vm._e()])]),_vm._v(" "),((_vm.form.windowType != 55 && _vm.form.windowType != 50))?_c('div',{staticClass:"form-row",style:(_vm.tour == true ? 'z-index:-1; position:relative;' : '')},[([1, 2, 3, 4, 6, 60, 7, 8, 21, 22, 23, 26, 27].includes(_vm.form.windowType))?_c('div',{staticClass:"form-group col-md-2 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v("\n                "+_vm._s(_vm.caption("addwin_HandleFilter"))+"\n              ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.Stype),expression:"Stype"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.Stype=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v(_vm._s(_vm.caption("addwin_All")))]),_vm._v(" "),(_vm.sysco != 2)?_c('option',{attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.caption("addwin_Fork")))]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v(_vm._s(_vm.caption("addwin_ForkS")))]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v(_vm._s(_vm.caption("addwin_Lockcase")))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_Handle")))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.windowHandleAN),expression:"form.windowHandleAN"}],staticClass:"form-control form-control-sm mb-2 v-step-9",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "windowHandleAN", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.$v.form.windowHandleAN.$touch()}]}},_vm._l((_vm.handles),function(h){return _c('option',{key:h.id,domProps:{"value":h.anr}},[_vm._v(_vm._s(h.ext != 'NONE' && h.ext != 'ENVI NO HANDLE' ? h.ext : _vm.caption("addwin_NoHandle")))])})),_vm._v(" "),(_vm.$v.form.windowHandleAN.$dirty)?_c('div',[(!_vm.$v.form.windowHandleAN.required)?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.caption("addwin_Required")))])]):_vm._e(),_vm._v(" "),(_vm.HandleError != null && _vm.HandleError !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.HandleError))])]):_vm._e()]):_vm._e()]),_vm._v(" "),((_vm.selectedHandle != null && _vm.selectedHandle.vrk == 1 && _vm.sethandleplate == false) || _vm.tour == true)?_c('div',{staticClass:"form-group col-md-2 col-sm-6"},[_c('div',{staticClass:"form-text mb-1",staticStyle:{"text-align":"center"}},[_vm._v("\n                "+_vm._s(_vm.caption("addwin_HandleReinforcement"))+"\n              ")]),_vm._v(" "),_c('button',{class:_vm.form.handleReinforcement == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-10' : 'btn btn-primary btn-sm btn-block v-step-10',attrs:{"type":"button"},on:{"click":function($event){_vm.SetHandleReinforcement()}}},[_c('strong',[_vm._v(_vm._s(_vm.handlereinforcement))])])]):_vm._e(),_vm._v(" "),(_vm.form.windowChrono == 40 || _vm.tour == true)?_c('div',{staticClass:"form-group col-md-2 col-sm-6"},[_c('div',{staticClass:"form-text mb-1",staticStyle:{"text-align":"center"}},[_vm._v("\n                "+_vm._s(_vm.caption("addwin_DrillingProtection"))+"\n              ")]),_vm._v(" "),_c('button',{class:_vm.form.drillingProtection == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-11' : 'btn btn-primary btn-sm btn-block v-step-11',attrs:{"type":"button"},on:{"click":function($event){_vm.SetDrillingProtection()}}},[_c('strong',[_vm._v(_vm._s(_vm.drillingprotection))])])]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.form.windowType == 55 || _vm.form.windowType == 50))?_c('div',{staticClass:"form-row",style:(_vm.tour == true ? 'z-index:-1; position:relative;' : '')},[_c('div',{staticClass:"form-group col-md-4 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_Motor")))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.windowMotorAN),expression:"form.windowMotorAN"}],staticClass:"form-control form-control-sm mb-2 v-step-10",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "windowMotorAN", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.motor),function(m){return _c('option',{key:m.anr,domProps:{"value":m.anr}},[_vm._v(_vm._s(m.ext))])}))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-row",style:(_vm.tour == true ? 'z-index:-1; position:relative;' : '')},[(_vm.form.windowType == 30 || _vm.form.windowType == 31 ||  _vm.tour==true)?_c('div',{staticClass:"form-group col-md-3 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_Profile")))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.profile),expression:"form.profile"}],staticClass:"form-control form-control-sm v-step-12",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "profile", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.profiles),function(p){return _c('option',{key:p.id,domProps:{"value":p.anr}},[_vm._v(_vm._s(p.anr))])}))]):_vm._e(),_vm._v(" "),(_vm.form.windowType == 50 || _vm.form.windowType == 55)?_c('div',{staticClass:"form-group col-md-3 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_Profile")))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.profile),expression:"form.profile"}],staticClass:"form-control form-control-sm v-step-12",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "profile", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.invisitopprofiles),function(ip){return _c('option',{key:ip.prf,domProps:{"value":ip.prf}},[_vm._v(_vm._s(ip.prf))])}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-row",style:(_vm.tour == true ? 'z-index:-1; position:relative;' : '')},[_c('div',{staticClass:"col-sm-12"},[_c('h6',[_vm._v(_vm._s(_vm.caption("addwin_Dimensions")))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-2 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_Fb1")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number.lazy",value:(_vm.form.windowFb1),expression:"form.windowFb1",modifiers:{"number":true,"lazy":true}}],staticClass:"input form-control form-control-sm v-step-13",attrs:{"type":"number","min":"1","max":"2400"},domProps:{"value":(_vm.form.windowFb1)},on:{"input":function($event){_vm.$v.form.windowFb1.$touch()},"change":function($event){_vm.$set(_vm.form, "windowFb1", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.windowFb1.$dirty)?_c('div',[(!_vm.$v.form.windowFb1.required)?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.caption("addwin_Required")))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.Fb1Error != null && _vm.Fb1Error !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.Fb1Error))])]):_vm._e()]),_vm._v(" "),((_vm.showFb2 || _vm.tour == true) && (_vm.form.windowType != 55 && _vm.form.windowType != 50))?_c('div',{staticClass:"form-group col-md-2 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_Fb2")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number.lazy",value:(_vm.form.windowFb2),expression:"form.windowFb2",modifiers:{"number":true,"lazy":true}}],staticClass:"input form-control form-control-sm v-step-14",attrs:{"type":"number","min":"0","max":"2400"},domProps:{"value":(_vm.form.windowFb2)},on:{"input":function($event){_vm.$v.form.windowFb2.$touch()},"change":function($event){_vm.$set(_vm.form, "windowFb2", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.windowFb2.$dirty)?_c('div',[(!_vm.$v.form.windowFb2.required)?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.caption("addwin_Required")))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.Fb2Error != null && _vm.Fb2Error !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.Fb2Error))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showFb2 == false  || _vm.form.windowType == 55 || _vm.form.windowType == 50)?_c('div',{staticClass:"form-group col-md-2 col-sm-12"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-2 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_Fh")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number.lazy",value:(_vm.form.windowFh),expression:"form.windowFh",modifiers:{"number":true,"lazy":true}}],staticClass:"input form-control form-control-sm v-step-15",attrs:{"type":"number","min":"1","max":"2800"},domProps:{"value":(_vm.form.windowFh)},on:{"input":function($event){_vm.$v.form.windowFh.$touch()},"blur":[function($event){_vm.setA(_vm.form.windowType)},function($event){_vm.$forceUpdate()}],"change":function($event){_vm.$set(_vm.form, "windowFh", _vm._n($event.target.value))}}}),_vm._v(" "),(_vm.$v.form.windowFh.$dirty)?_c('div',[(!_vm.$v.form.windowFh.required)?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.caption("addwin_Required")))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.FhError != null && _vm.FhError !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.FhError))])]):_vm._e()]),_vm._v(" "),(_vm.form.windowType != 55)?_c('div',{staticClass:"form-group col-md-2 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_A")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.windowA),expression:"form.windowA"}],staticClass:"input form-control form-control-sm v-step-16",attrs:{"min":"1.0","max":"2400.0"},domProps:{"value":(_vm.form.windowA)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "windowA", $event.target.value)}}}),_vm._v(" "),(_vm.AError != null && _vm.AError !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.AError))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-2 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.weightLabel))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.windowWeight1),expression:"form.windowWeight1",modifiers:{"number":true}}],staticClass:"input form-control form-control-sm v-step-17",attrs:{"type":"number","min":"1","max":"200"},domProps:{"value":(_vm.form.windowWeight1)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "windowWeight1", _vm._n($event.target.value))},function($event){_vm.$v.form.windowWeight1.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.windowWeight1.$dirty)?_c('div',[(!_vm.$v.form.windowWeight1.required)?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.caption("addwin_Required")))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.W1Error != null && _vm.W1Error !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.W1Error))])]):_vm._e()]),_vm._v(" "),((_vm.showFb2 || _vm.tour == true) && (_vm.form.windowType != 55 && _vm.form.windowType != 50))?_c('div',{staticClass:"form-group col-md-2 col-sm-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_Weight"))+"2(kg)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.windowWeight2),expression:"form.windowWeight2",modifiers:{"number":true}}],staticClass:"input form-control form-control-sm v-step-18",attrs:{"type":"number","min":"1","max":"200"},domProps:{"value":(_vm.form.windowWeight2)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "windowWeight2", _vm._n($event.target.value))},function($event){_vm.$v.form.windowWeight2.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.windowWeight2.$dirty)?_c('div',[(!_vm.$v.form.windowWeight2.required)?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.caption("addwin_Required")))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.W2Error != null && _vm.W2Error !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.W2Error))])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-row",style:(_vm.tour == true ? 'z-index:-1; position:relative;' : '')},[_c('div',{staticClass:"col-sm-12"},[_c('h6',[_vm._v(_vm._s(_vm.caption("addwin_Options")))])]),_vm._v(" "),((_vm.form.windowType != 55 && _vm.form.windowType != 50))?_c('div',{staticClass:"form-group col-xl-2 col-lg-6"},[_c('div',{staticClass:"form-text mb-1",staticStyle:{"text-align":"center"}},[_vm._v("\n                "+_vm._s(_vm.caption("addwin_Vent"))+"\n              ")]),_vm._v(" "),_c('button',{class:_vm.form.windowK12 == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-19' : 'btn btn-primary btn-sm btn-block v-step-19',attrs:{"type":"button"},on:{"click":function($event){_vm.SetNightvent()}}},[_c('strong',[_vm._v(_vm._s(_vm.nightvent))])]),_vm._v(" "),(_vm.VentError != null && _vm.VentError !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.VentError))])]):_vm._e()]):_vm._e(),_vm._v(" "),(((_vm.setfcmagnet == false) || _vm.tour==true) && (_vm.form.windowType != 55 && _vm.form.windowType != 50))?_c('div',{staticClass:"form-group col-xl-2 col-lg-6"},[_c('div',{staticClass:"form-text mb-1",staticStyle:{"text-align":"center"}},[_vm._v("\n                "+_vm._s(_vm.caption("addwin_Magnet"))+"\n              ")]),_vm._v(" "),_c('button',{class:_vm.form.windowMAC == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-20' : 'btn btn-primary btn-sm btn-block v-step-20',attrs:{"type":"button"},on:{"click":function($event){_vm.SetMagnet()}}},[_c('strong',[_vm._v(_vm._s(_vm.magnet))])]),_vm._v(" "),(_vm.MagnetError != null && _vm.MagnetError !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.MagnetError))])]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.form.windowType != 55 && _vm.form.windowType != 50))?_c('div',{staticClass:"form-group col-xl-2 col-lg-6"},[_c('div',{staticClass:"form-text mb-1",staticStyle:{"text-align":"center"}},[_vm._v("\n                "+_vm._s(_vm.caption("addwin_Stay"))+"\n              ")]),_vm._v(" "),_c('button',{class:_vm.form.windowRAB == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-21' : 'btn btn-primary btn-sm btn-block v-step-21',attrs:{"type":"button"},on:{"click":function($event){_vm.SetStay()}}},[_c('strong',[_vm._v(_vm._s(_vm.stay))])])]):_vm._e(),_vm._v(" "),((_vm.form.windowType != 55 && _vm.form.windowType != 50))?_c('div',{staticClass:"form-group col-xl-2 col-lg-6"},[_c('div',{staticClass:"form-text mb-1",staticStyle:{"text-align":"center"}},[_vm._v("\n                "+_vm._s(_vm.caption("addwin_Snapper"))+"\n              ")]),_vm._v(" "),_c('button',{class:_vm.form.windowSNP == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-22' : 'btn btn-primary btn-sm btn-block v-step-22',attrs:{"type":"button"},on:{"click":function($event){_vm.SetSnapper()}}},[_c('strong',[_vm._v(_vm._s(_vm.snapper))])]),_vm._v(" "),(_vm.SnapperError != null && _vm.SnapperError !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.SnapperError))])]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.form.windowType == 50 || _vm.form.windowType == 55))?_c('div',{staticClass:"form-group col-xl-2 col-lg-6"},[_c('div',{staticClass:"form-text mb-1",staticStyle:{"text-align":"center"}},[_vm._v("\n                "+_vm._s(_vm.caption("addwin_LinkArm"))+"\n              ")]),_vm._v(" "),_c('button',{class:_vm.form.windowXVS == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-23' : 'btn btn-primary btn-sm btn-block v-step-23',attrs:{"type":"button"},on:{"click":function($event){_vm.SetLinkArm()}}},[_c('strong',[_vm._v(_vm._s(_vm.linkarm))])]),_vm._v(" "),(_vm.XVSError != null && _vm.XVSError !='')?_c('div',{staticClass:"alert alert-danger mt-1",staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.XVSError))])]):_vm._e()]):_vm._e()]),_vm._v(" "),((_vm.form.windowType != 55 && _vm.form.windowType != 50))?_c('div',{staticClass:"form-row",style:(_vm.tour == true ? 'z-index:-1; position:relative;' : '')},[((_vm.showFb2 && _vm.setfcscrew == false && !(_vm.form.windowType == 31 && _vm.form.windowChrono == 50)) || _vm.tour==true)?_c('div',{staticClass:"form-group col-xl-2 col-lg-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_ScrewLength")))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.windowScrew),expression:"form.windowScrew"}],staticClass:"form-control form-control-sm v-step-23",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "windowScrew", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.screw),function(s){return _c('option',{key:s,domProps:{"value":s}},[_vm._v(_vm._s(s))])}))]):_vm._e(),_vm._v(" "),((_vm.showFb2 && _vm.setfcprofile == false && !(_vm.form.windowType == 31 && _vm.form.windowChrono == 50)) || _vm.tour==true)?_c('div',{staticClass:"form-group col-xl-2 col-lg-6"},[_c('div',{staticClass:"form-text mb-1"},[_vm._v(_vm._s(_vm.caption("addwin_ProfileDepth")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.windowDepth),expression:"form.windowDepth",modifiers:{"number":true}}],staticClass:"input form-control form-control-sm v-step-24",attrs:{"type":"number","min":"30","max":_vm.form.windowChrono==10 || _vm.form.windowChrono==20 ? 53 : 60},domProps:{"value":(_vm.form.windowDepth)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "windowDepth", _vm._n($event.target.value))},function($event){_vm.$v.form.windowDepth.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.windowDepth.$dirty)?_c('div',[(!_vm.$v.form.windowDepth.required)?_c('small',{staticClass:"form-text text-danger"},[_vm._v(_vm._s(_vm.caption("addwin_Required")))]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.showFb2 && !(_vm.form.windowType == 4 && _vm.form.windowChrono == 10) && _vm.form.windowType != 22 && _vm.form.windowType != 27 && _vm.form.windowType != 31 && (_vm.form.windowChrono == 10 || _vm.form.windowChrono == 20) && _vm.setfccentral == false) || _vm.tour==true)?_c('div',{staticClass:"form-group col-xl-2 col-lg-6"},[_c('div',{staticClass:"form-text mb-1",staticStyle:{"text-align":"center"}},[_vm._v("\n                "+_vm._s(_vm.caption("addwin_FCLockcase"))+"\n              ")]),_vm._v(" "),_c('button',{class:_vm.form.fcLockcase == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-25' : 'btn btn-primary btn-sm btn-block v-step-25',attrs:{"type":"button"},on:{"click":function($event){_vm.SetFCLockcase()}}},[_c('strong',[_vm._v(_vm._s(_vm.fclockcase))])])]):_vm._e(),_vm._v(" "),((_vm.showFb2 && _vm.form.windowType != 22 && _vm.form.windowType != 27 && _vm.form.windowType != 31 && (_vm.form.windowChrono == 10 || _vm.form.windowChrono == 20) && _vm.form.fcLockcase == 0 && _vm.setfcadjkeeps == false) || _vm.tour==true)?_c('div',{staticClass:"form-group col-xl-2 col-lg-6"},[_c('div',{staticClass:"form-text mb-1",staticStyle:{"text-align":"center"}},[_vm._v("\n                "+_vm._s(_vm.caption("addwin_AdjustableFCKeeps"))+"\n              ")]),_vm._v(" "),_c('button',{class:_vm.form.adjustableFCKeeps == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-26' : 'btn btn-primary btn-sm btn-block v-step-26',attrs:{"type":"button"},on:{"click":function($event){_vm.SetAdjustableFCKeeps()}}},[_c('strong',[_vm._v(_vm._s(_vm.adjustablefckeeps))])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('button',{staticClass:"btn btn-sm btn-primary v-step-27",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.caption("Submit")))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-secondary v-step-28",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.caption("Cancel")))])])])],1),_vm._v(" "),_c('div',[(_vm.Error != '')?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('strong',[_vm._v(_vm._s(_vm.Error))])]):_vm._e()])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WindowBom_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c61d4874_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WindowBom_vue__ = __webpack_require__(137);
function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c61d4874"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WindowBom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c61d4874_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WindowBom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(136);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("0c60cd00", content, true, {});

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:600px){.container-fluid[data-v-c61d4874]{width:75%}}", ""]);

// exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{attrs:{"sysco":_vm.sysco}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('h2',{staticClass:"display-4 text-primary"},[_c('strong',[_vm._v(_vm._s(_vm.proj.customerName)+" - "+_vm._s(_vm.proj.projectName))])]),_vm._v(" "),_c('h4',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.caption("addwin_Window"))+": "+_vm._s(_vm.win.name))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-12"},[_c('window-graph',{attrs:{"type":_vm.win.windowType,"dir":_vm.win.openDir,"hinge":_vm.win.hingeType,"handle":_vm.handleAN(_vm.win.handleAN),"Fb1":_vm.win.fb1,"Fb2":_vm.win.fb2,"Fh":_vm.win.fh,"A":_vm.win.a,"W1":_vm.win.weight1,"W2":_vm.win.weight2,"dim":_vm.dimension,"scale":_vm.scale,"profile":_vm.win.profile,"config":0}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-9 col-12"},[_c('div',[_c('span',{staticClass:"badge mb-2 ml-1",class:_vm.win.bulk == 0 ? 'badge-primary' : 'badge-success'},[_vm._v(_vm._s(_vm.win.bulk == 0 ? _vm.caption("Set") : _vm.caption("Bulk")))])]),_vm._v(" "),_c('h4',[_vm._v(" Chrono "+_vm._s(_vm.chrono(_vm.win.chrono)))]),_vm._v(" "),_c('h5',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.caption(_vm.hinge(_vm.win.hingeType))))]),_vm._v(" "),((_vm.win.windowType != 50 && _vm.win.windowType != 55))?_c('h5',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm.win.handleAN != 'NONE' ? _vm.caption(_vm.handle(_vm.win.handleType)) : '')+" "+_vm._s(_vm.win.handleAN != 'NONE' ? _vm.handleAN(_vm.win.handleAN) : _vm.caption("addwin_NoHandle")))]):_vm._e(),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.groove(_vm.win.groove)))])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm mt-3",staticStyle:{"font-size":"20px"},attrs:{"type":"button"},on:{"click":function($event){_vm.showWindowlist()}}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v(" "+_vm._s(_vm.caption("winlist_Back")))]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('h3',[_vm._v(_vm._s(_vm.caption("pdf_BOM")))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('h5',[_c('button',{staticClass:"btn btn-sm btn-secondary ml-3 mr-2",staticStyle:{"font-size":"20px"},attrs:{"type":"button"},on:{"click":function($event){_vm.getCsv()}}},[_vm._m(0)])]),_vm._v(" "),_c('h5',[_c('button',{staticClass:"btn btn-sm btn-secondary",staticStyle:{"font-size":"20px"},attrs:{"type":"button"},on:{"click":function($event){_vm.getXl()}}},[_vm._m(1)])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.bom),function(b){return _c('div',{key:b.gan},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('h5',[_c('div',{staticClass:"badge",class:b.packaging == 'Set' ? 'badge-primary' : 'badge-success'},[_vm._v(_vm._s(b.packaging))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{},[_c('h5',[_vm._v(_vm._s(b.quantity)+" x "),_c('strong',[_vm._v(_vm._s(b.gan))]),(b.color != '')?_c('span',{staticClass:"badge badge-primary ml-3"},[_vm._v(_vm._s(b.color))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('h5',[_vm._v(_vm._s(b.description))])])])])}),_vm._v(" "),_c('hr')],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_c('i',{staticClass:"fas fa-file-download"}),_vm._v(" .CSV")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_c('i',{staticClass:"fas fa-file-download"}),_vm._v(" .XLSX")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserList_vue__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3ea2f6e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserList_vue__ = __webpack_require__(141);
function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3ea2f6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3ea2f6e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(140);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("4ef4bf42", content, true, {});

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:1500px){.container-fluid[data-v-f3ea2f6e]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-f3ea2f6e]{width:60%}}.lnk[data-v-f3ea2f6e]{cursor:pointer}.back-to-top[data-v-f3ea2f6e]{cursor:pointer;position:fixed;bottom:20px;right:20px;display:none}", ""]);

// exports


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row my-3"},[_c('div',{staticClass:"col-lg-1 col-md-12"},[_c('button',{staticClass:"btn btn-outline-primary btn mr-3",staticStyle:{"font-size":"16px"},attrs:{"type":"button"},on:{"click":function($event){_vm.backToProjects()}}},[_c('i',{staticClass:"fas fa-chevron-left mr-2"}),_vm._v("Back")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchuser),expression:"searchuser"}],staticClass:"input form-control",staticStyle:{"font-size":"16px"},attrs:{"type":"text"},domProps:{"value":(_vm.searchuser)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchuser=$event.target.value}}})])]),_vm._v(" "),_c('div',[_c('h1',[_vm._v("Users("+_vm._s(_vm.userlist().length)+")")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.userlist()),function(u){return _c('div',{key:u.userId},[_c('div',{staticClass:"row my-1"},[_c('div',{staticClass:"col-lg-4 col-md-12"},[_c('span',{class:u.role != 3 ? 'badge badge-primary mr-3' : 'badge badge-danger mr-3'},[_vm._v(_vm._s(u.role))]),_c('strong',[_vm._v(_vm._s(u.companyName))]),_vm._v(", "+_vm._s(u.country)+"\r\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-12 small"},[_vm._v("\r\n                    "+_vm._s(u.firstName)+" "+_vm._s(u.lastName)+"\r\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-1 col-md-12"},[_c('span',{class:u.systemCompany == 1 ? 'badge badge-pill badge-primary mr-3' : 'badge badge-pill badge-warning mr-3'},[_vm._v(_vm._s(_vm.sysco(u.systemCompany)))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-1 col-md-12 small"},[_vm._v("\r\n                    "+_vm._s(u.language)+"\r\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-12 small mb-1"},[_vm._v("\r\n                    "+_vm._s(u.email)+"\r\n                ")]),_vm._v(" "),(_vm.role == 1 || _vm.role == 4 || _vm.role == 5 || _vm.role == 6)?_c('div',{staticClass:"col-lg-2 col-md-12 text-lg-right"},[_c('span',{class:u.role != 3 ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-danger',on:{"click":function($event){_vm.EditUser(u.userId)}}},[_vm._v("Edit")])]):_vm._e()]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_vm._m(0)],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-primary btn-lg back-to-top",attrs:{"id":"back-to-top","href":"#","role":"button"}},[_c('i',{staticClass:"fas fa-chevron-up mr-2"}),_vm._v("Top")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cf870b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEdit_vue__ = __webpack_require__(145);
function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cf870b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cf870b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(144);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("72d1d5fc", content, true, {});

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:1500px){.container-fluid[data-v-4cf870b2]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-4cf870b2]{width:60%}}.lnk[data-v-4cf870b2]{cursor:pointer}", ""]);

// exports


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"display-4"},[_c('strong',[_vm._v(_vm._s(_vm.usersettings.companyName)+" - "+_vm._s(_vm.usersettings.firstName)+" "+_vm._s(_vm.usersettings.lastName))])])])]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.useredit($event)}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-3"},[_c('label',{staticClass:"label"},[_vm._v("Company")]),_vm._v(" "),_c('input',{directives:[{name:"autofocus",rawName:"v-autofocus"},{name:"model",rawName:"v-model.trim",value:(_vm.form.userCompanyName),expression:"form.userCompanyName",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.userCompanyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "userCompanyName", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-3"},[_c('label',{staticClass:"label"},[_vm._v("Language")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.userLanguage),expression:"form.userLanguage"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "userLanguage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',[_vm._v("English")]),_vm._v(" "),_c('option',[_vm._v("Nederlands")]),_vm._v(" "),_c('option',[_vm._v("Français")]),_vm._v(" "),_c('option',[_vm._v("Deutsch")]),_vm._v(" "),_c('option',[_vm._v("Chinese")]),_vm._v(" "),_c('option',[_vm._v("Portugues")]),_vm._v(" "),_c('option',[_vm._v("Espanol")]),_vm._v(" "),_c('option',[_vm._v("Czech")]),_vm._v(" "),_c('option',[_vm._v("Polski")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-3"},[_c('label',{staticClass:"label"},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.userCountry),expression:"form.userCountry"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "userCountry", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',[_vm._v("Austria")]),_vm._v(" "),_c('option',[_vm._v("Australia")]),_vm._v(" "),_c('option',[_vm._v("Belgium")]),_vm._v(" "),_c('option',[_vm._v("Canada")]),_vm._v(" "),_c('option',[_vm._v("China")]),_vm._v(" "),_c('option',[_vm._v("Croatia")]),_vm._v(" "),_c('option',[_vm._v("Czechia")]),_vm._v(" "),_c('option',[_vm._v("Denmark")]),_vm._v(" "),_c('option',[_vm._v("Finland")]),_vm._v(" "),_c('option',[_vm._v("France")]),_vm._v(" "),_c('option',[_vm._v("Germany")]),_vm._v(" "),_c('option',[_vm._v("India")]),_vm._v(" "),_c('option',[_vm._v("Iran")]),_vm._v(" "),_c('option',[_vm._v("Ireland")]),_vm._v(" "),_c('option',[_vm._v("Latvia")]),_vm._v(" "),_c('option',[_vm._v("Lithuania")]),_vm._v(" "),_c('option',[_vm._v("Luxembourg")]),_vm._v(" "),_c('option',[_vm._v("Netherlands")]),_vm._v(" "),_c('option',[_vm._v("Norway")]),_vm._v(" "),_c('option',[_vm._v("Poland")]),_vm._v(" "),_c('option',[_vm._v("Portugal")]),_vm._v(" "),_c('option',[_vm._v("Romania")]),_vm._v(" "),_c('option',[_vm._v("Russia")]),_vm._v(" "),_c('option',[_vm._v("Slovakia")]),_vm._v(" "),_c('option',[_vm._v("Spain")]),_vm._v(" "),_c('option',[_vm._v("Sweden")]),_vm._v(" "),_c('option',[_vm._v("Switzerland")]),_vm._v(" "),_c('option',[_vm._v("UK")]),_vm._v(" "),_c('option',[_vm._v("Ukraine")]),_vm._v(" "),_c('option',[_vm._v("USA")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-3"},[_c('label',{staticClass:"label"},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"autofocus",rawName:"v-autofocus"},{name:"model",rawName:"v-model.trim",value:(_vm.form.userFirstName),expression:"form.userFirstName",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.userFirstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "userFirstName", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-3"},[_c('label',{staticClass:"label"},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"autofocus",rawName:"v-autofocus"},{name:"model",rawName:"v-model.trim",value:(_vm.form.userLastName),expression:"form.userLastName",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.userLastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "userLastName", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),(_vm.role == 1)?_c('div',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-3"},[_c('label',{staticClass:"label"},[_vm._v("System company")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.userSystemCompany),expression:"form.userSystemCompany"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "userSystemCompany", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"9"}},[_vm._v("Aliplast")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Reynaers")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("SAPA")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Sobinco")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Titon")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("VBH")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-3"},[_c('label',{staticClass:"label"},[_vm._v("Role")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.userRole),expression:"form.userRole"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "userRole", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Registered User")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Sobinco Administrator")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Sobinco Sales")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Sobinco China")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Reynaers Administrator")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Unregistered User")])])])])]):_vm._e(),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"width":"200px"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.togglePackaging($event)}}},[_vm._v(_vm._s(_vm.packagingCaption))])]),_vm._v(" "),(_vm.form.userSetPackaging)?_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.userPackaging),expression:"form.userPackaging"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "userPackaging", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Set")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Bulk")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"width":"200px"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleGroove($event)}}},[_vm._v(_vm._s(_vm.grooveCaption))])]),_vm._v(" "),(_vm.form.userSetGroove)?_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.userGroove),expression:"form.userGroove"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "userGroove", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"14"}},[_vm._v("14-18")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10-14")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"width":"200px"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleHandleplate($event)}}},[_vm._v(_vm._s(_vm.handleplateCaption))])]),_vm._v(" "),(_vm.form.userSetHandlePlate)?_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.userHandlePlate),expression:"form.userHandlePlate"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "userHandlePlate", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("No")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Yes")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"width":"200px"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleBlock90($event)}}},[_vm._v(_vm._s(_vm.block90Caption))])]),_vm._v(" "),(_vm.form.userSetBlock90)?_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.userBlock90),expression:"form.userBlock90"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "userBlock90", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("No")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Yes")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"width":"200px"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleFCScrew($event)}}},[_vm._v(_vm._s(_vm.fcScrewCaption))])]),_vm._v(" "),(_vm.form.userSetFCScrew)?_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.userFCScrew),expression:"form.userFCScrew"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "userFCScrew", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"6"}},[_vm._v("6 mm")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("12 mm")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16 mm")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"width":"200px"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleFCProfile($event)}}},[_vm._v(_vm._s(_vm.fcProfileCaption))])]),_vm._v(" "),(_vm.form.userSetFCProfile)?_c('div',{staticClass:"col-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.userFCProfile),expression:"form.userFCProfile",modifiers:{"number":true}}],staticClass:"input form-control form-control-sm",attrs:{"type":"number","min":"30","max":"60"},domProps:{"value":(_vm.form.userFCProfile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "userFCProfile", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"width":"200px"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleFCCentral($event)}}},[_vm._v(_vm._s(_vm.fcCentralCaption))])]),_vm._v(" "),(_vm.form.userSetFCCentral)?_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.userFCCentral),expression:"form.userFCCentral"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "userFCCentral", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("No")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Yes")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"width":"200px"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleFCAdjKeeps($event)}}},[_vm._v(_vm._s(_vm.fcAdjKeepsCaption))])]),_vm._v(" "),(_vm.form.userSetFCAdjKeeps)?_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.userFCAdjKeeps),expression:"form.userFCAdjKeeps"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "userFCAdjKeeps", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("No")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Yes")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"width":"200px"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleFCMagnet($event)}}},[_vm._v(_vm._s(_vm.fcMagnetCaption))])]),_vm._v(" "),(_vm.form.userSetFCMagnet)?_c('div',{staticClass:"col-md-2"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-primary mr-1",attrs:{"type":"submit"}},[_vm._v("Verzenden")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.cancel}},[_vm._v("Annuleren")])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row"},[_c('h2',[_vm._v("User data")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row mt-5"},[_c('h2',[_vm._v("User access level")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row mt-5"},[_c('h2',[_vm._v("User preferences")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SharedUserList_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2153d476_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SharedUserList_vue__ = __webpack_require__(149);
function injectStyle (ssrContext) {
  __webpack_require__(147)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2153d476"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SharedUserList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2153d476_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SharedUserList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(148);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("02df7068", content, true, {});

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:1500px){.container-fluid[data-v-2153d476]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-2153d476]{width:60%}}.lnk[data-v-2153d476]{cursor:pointer}", ""]);

// exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"AddUser","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content centered"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.caption("users_adduser")))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.caption("users_useremail")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.userEmail),expression:"userEmail",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.userEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userEmail=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.emailEmpty)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.caption("addwin_Required")))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('span',[_c('button',{staticClass:"btn btn-small btn-primary",on:{"click":function($event){_vm.userSend()}}},[_vm._v(_vm._s(_vm.caption("Submit")))])]),_vm._v(" "),_c('span',[_c('button',{staticClass:"btn btn-small btn-danger",on:{"click":function($event){_vm.userModalHide()}}},[_vm._v(_vm._s(_vm.caption("Cancel")))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"NotFound","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content centered"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.caption("users_notfound")))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.caption("users_notfoundtext")))]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('span',[_c('button',{staticClass:"btn btn-small btn-danger",on:{"click":function($event){_vm.notFoundHide()}}},[_vm._v("OK")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row my-3"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('button',{staticClass:"btn btn-outline-primary btn mr-3",staticStyle:{"font-size":"16px"},attrs:{"type":"button"},on:{"click":function($event){_vm.backToProjects()}}},[_c('i',{staticClass:"fas fa-chevron-left mr-2"}),_vm._v(_vm._s(_vm.caption("winlist_Back")))])])]),_vm._v(" "),_c('div',{staticClass:"h3 mb-4 display-4"},[_vm._v(_vm._s(_vm.caption("users_sharedusers")))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm mb-2 v-step-1",staticStyle:{"font-size":"20px"},attrs:{"type":"button"},on:{"click":function($event){_vm.addUser()}}},[_c('i',{staticClass:"fas fa-plus-square mr-2"}),_vm._v(_vm._s(_vm.caption("users_adduser")))]),_vm._v(" "),_vm._l((_vm.sharedusers),function(users){return _c('div',{key:users.Id,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-subtitle mt-1"},[_c('div',{staticClass:"row my-1"},[_c('div',{staticClass:"col-lg-3 col-md-12"},[_c('strong',[_vm._v(_vm._s(users.firstName)+" "+_vm._s(users.lastName))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-12"},[_vm._v("\r\n                     "+_vm._s(users.companyName)+"\r\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-12"},[_c('a',{attrs:{"href":'mailto:'+users.email}},[_vm._v(_vm._s(users.email))])]),_vm._v(" "),_c('div',{staticClass:" col-lg-3 col-md-12 text-lg-right mx-auto"},[_c('span',{staticClass:"btn btn-sm btn-outline-danger v-step-9",on:{"click":function($event){_vm.deleteuser(users.userId)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])])])])])])})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VersionList_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e4c1ed0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VersionList_vue__ = __webpack_require__(153);
function injectStyle (ssrContext) {
  __webpack_require__(151)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e4c1ed0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VersionList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e4c1ed0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VersionList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(152);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("8eab6406", content, true, {});

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:1500px){.container-fluid[data-v-2e4c1ed0]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-2e4c1ed0]{width:60%}}.lnk[data-v-2e4c1ed0]{cursor:pointer}", ""]);

// exports


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row my-3"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('button',{staticClass:"btn btn-outline-primary btn mr-3",staticStyle:{"font-size":"16px"},attrs:{"type":"button"},on:{"click":function($event){_vm.backToProjects()}}},[_c('i',{staticClass:"fas fa-chevron-left mr-2"}),_vm._v(_vm._s(_vm.caption("winlist_Back")))])])]),_vm._v(" "),_c('div',{staticClass:"h3 mb-4 display-4"},[_vm._v("Updates")]),_vm._v(" "),_vm._l((_vm.getVNList),function(vn){return _c('div',{key:vn},[_c('div',{staticClass:"h4"},[_c('strong',[_vm._v(_vm._s(vn))])]),_vm._v(" "),_vm._l((_vm.versions.filter(function (v){ return v.vn == vn; })),function(version){return _c('div',{key:version.Id},[_c('div',{staticClass:"row my-1"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_vm._v("\r\n                      "+_vm._s(_vm.lang == 'NED' ? version.ned : version.eng)+"\r\n                  ")])])])}),_vm._v(" "),_c('hr')],2)})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b0af080_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__ = __webpack_require__(155);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b0af080_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('h1',{staticClass:"display-4 text-center"},[_vm._v("Please enter your e-mail address")]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("An e-mail with instructions to reset your password will be sent to this e-mail address.")]),_vm._v(" "),_c('div',{staticClass:"container-fluid w-50 mt-5 bg-light"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error !== null),expression:"error !== null"}],staticClass:"btn-danger text-center mb-3"},[_vm._v("\n      "+_vm._s(_vm.error)+"\n    ")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.pwreset($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.email),expression:"form.email",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value.trim())},function($event){_vm.changed()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.email.$dirty)?_c('div',[(!_vm.$v.form.email.required)?_c('div',{staticClass:"text-danger"},[_vm._v("Email is required!")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.email.email)?_c('div',{staticClass:"text-danger"},[_vm._v("Email is not valid!")]):_vm._e()]):_vm._e()]),_vm._v(" "),_vm._m(0)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary mb-3",attrs:{"type":"submit"}},[_vm._v("Send\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordInput_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_783af17f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordInput_vue__ = __webpack_require__(157);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_783af17f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('h1',{staticClass:"display-4 text-center"},[_vm._v("Password reset")]),_vm._v(" "),_c('div',{staticClass:"container-fluid w-50 mt-5 bg-light"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.pwreset($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("New Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.password),expression:"form.password",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"password"},domProps:{"value":(_vm.form.password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value.trim())},function($event){_vm.$v.form.password.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.password.$dirty)?_c('div',[(!_vm.$v.form.password.required)?_c('div',{staticClass:"text-danger"},[_vm._v("Password is required!")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Confirm password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.confirmpassword),expression:"form.confirmpassword",modifiers:{"trim":true}}],staticClass:"input form-control",attrs:{"type":"password"},domProps:{"value":(_vm.form.confirmpassword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "confirmpassword", $event.target.value.trim())},function($event){_vm.$v.form.confirmpassword.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.form.confirmpassword.$dirty)?_c('div',[(!_vm.$v.form.confirmpassword.required)?_c('div',{staticClass:"text-danger"},[_vm._v("Password is required!")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.confirmpassword.sameAsPassword)?_c('div',{staticClass:"text-danger"},[_vm._v("Passwords don't match")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary mb-3",attrs:{"disabled":_vm.loading,"type":"submit"}},[_vm._v("Send\n          "),(_vm.loading)?_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.loading)?_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")]):_vm._e()]),_vm._v(" "),(_vm.errors != null)?_c('div',_vm._l((_vm.errors),function(e){return _c('div',{key:e.code,staticClass:"text-danger"},[_vm._v(_vm._s(e.description))])})):_vm._e()])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CilinderIntro_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_189928f2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CilinderIntro_vue__ = __webpack_require__(161);
function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-189928f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CilinderIntro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_189928f2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CilinderIntro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(160);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("5670a910", content, true, {});

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:1500px){.container-fluid[data-v-189928f2]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-189928f2]{width:60%}}.lnk[data-v-189928f2]{cursor:pointer}.centered-and-cropped[data-v-189928f2]{object-fit:contain}", ""]);

// exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('button',{staticClass:"btn btn-info mb-2",staticStyle:{"width":"500px","height":"400px"},on:{"click":_vm.goto880}},[_c('img',{staticClass:"centered-and-cropped mb-2",attrs:{"src":'/src/assets/880.PNG',"height":"200 ","width":"400"}}),_c('h4',[_vm._v("Nieuwe standaardcilinder(s) bestellen")]),_c('p',[_vm._v("(standaard geleverd met 3 sleutels)")]),_c('h2',[_vm._v("880 reeks")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info mb-2",staticStyle:{"width":"500px","height":"400px"}},[_c('img',{staticClass:"centered-and-cropped mb-2",attrs:{"src":'/src/assets/970.PNG',"height":"200 ","width":"400"}}),_c('h4',[_vm._v("Nieuwe veiligheidcilinder(s) bestellen")]),_c('p',[_vm._v("(standaard geleverd met 3 sleutels)")]),_c('h2',[_vm._v("970 reeks")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info mb-2",staticStyle:{"width":"500px","height":"400px"}},[_c('img',{staticClass:"centered-and-cropped mb-2",attrs:{"src":'/src/assets/960.PNG',"height":"200 ","width":"400"}}),_c('h4',[_vm._v("Nieuwe veiligheidcilinder(s) bestellen")]),_c('p',[_vm._v("(standaard geleverd met 3 sleutels)")]),_c('h2',[_vm._v("960 reeks")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"background-color":"white"}},[_c('div',{staticClass:"display-4"},[_vm._v("Cilinders Online")]),_vm._v(" "),_c('hr')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cilinder880_vue__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f472b930_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cilinder880_vue__ = __webpack_require__(165);
function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f472b930"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cilinder880_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f472b930_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cilinder880_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(164);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("223b40f4", content, true, {});

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:1500px){.container-fluid[data-v-f472b930]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-f472b930]{width:60%}}.lnk[data-v-f472b930]{cursor:pointer}.centered-and-cropped[data-v-f472b930]{object-fit:contain}", ""]);

// exports


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('button',{staticClass:"btn btn-primary mb-2",staticStyle:{"width":"300px","height":"200px"},on:{"click":_vm.config880}},[_c('img',{staticClass:"centered-and-cropped mb-2",attrs:{"src":'/src/assets/880cyl.PNG',"height":"100 ","width":"200"}}),_c('h4',[_vm._v("880-reeks")]),_c('p',[_vm._v("sleutelbediend")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-2",staticStyle:{"width":"300px","height":"200px"}},[_c('img',{staticClass:"centered-and-cropped mb-2",attrs:{"src":'/src/assets/881.PNG',"height":"100 ","width":"200"}}),_c('h4',[_vm._v("881-reeks")]),_c('p',[_vm._v("1 zijde sleutel, 1 zijde knop Type 1")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-2",staticStyle:{"width":"300px","height":"200px"}},[_c('img',{staticClass:"centered-and-cropped mb-2",attrs:{"src":'/src/assets/882.PNG',"height":"100 ","width":"200"}}),_c('h4',[_vm._v("882-reeks")]),_c('p',[_vm._v("1 zijde sleutel, 1 zijde knop Type 2")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-2",staticStyle:{"width":"300px","height":"200px"}},[_c('img',{staticClass:"centered-and-cropped mb-2",attrs:{"src":'/src/assets/883.PNG',"height":"100 ","width":"200"}}),_c('h4',[_vm._v("883-reeks")]),_c('p',[_vm._v("1 zijde sleutel, 1 zijde knop Type 3")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-2",staticStyle:{"width":"300px","height":"200px"}},[_c('img',{staticClass:"centered-and-cropped mb-2",attrs:{"src":'/src/assets/880-10.PNG',"height":"100 ","width":"200"}}),_c('h4',[_vm._v("880-10-reeks")]),_c('p',[_vm._v("halve cilinders")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"background-color":"white"}},[_c('div',{staticClass:"display-4"},[_vm._v("Cilinders Online")]),_vm._v(" "),_c('hr')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Config880_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c4927fb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Config880_vue__ = __webpack_require__(169);
function injectStyle (ssrContext) {
  __webpack_require__(167)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c4927fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Config880_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c4927fb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Config880_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(168);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("3f9c38c8", content, true, {});

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:1500px){.container-fluid[data-v-4c4927fb]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-4c4927fb]{width:60%}}.lnk[data-v-4c4927fb]{cursor:pointer}.centered-and-cropped[data-v-4c4927fb]{object-fit:contain}", ""]);

// exports


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('img',{staticClass:"centered-and-cropped mb-2 col-2",attrs:{"src":"/src/assets/880cyl.PNG"}}),_vm._v(" "),_c('div',{staticClass:"col-4"}),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('h2',[_vm._v("Bestellijst")]),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.reset}},[_vm._v("Reset")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.winkelmand),function(w){return _c('div',{key:w.id,staticClass:"row"},[_c('span',{staticClass:"col-1"},[_c('strong',[_vm._v(_vm._s(w.id))])]),_vm._v(" "),_c('span',{staticClass:"col-4"},[_vm._v(_vm._s(w.artnummer))]),_vm._v(" "),_c('span',{staticClass:"col-2"},[_vm._v(_vm._s(w.aantal))])])}),_vm._v(" "),(_vm.winkelmand.length > 1)?_c('div',{staticClass:"form-group form-check mt-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gs),expression:"gs"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"exampleCheck1"},domProps:{"checked":Array.isArray(_vm.gs)?_vm._i(_vm.gs,null)>-1:(_vm.gs)},on:{"click":_vm.setgs,"change":function($event){var $$a=_vm.gs,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.gs=$$a.concat([$$v]))}else{$$i>-1&&(_vm.gs=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.gs=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleCheck1"}},[_vm._v("Onderling gelijksluitend?")])]):_vm._e()],2)]),_vm._v(" "),_c('h1',{staticClass:"col-4"},[_c('strong',[_vm._v("880-"+_vm._s(_vm.bdim)+"-"+_vm._s(_vm.cdim))])]),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('p',{staticClass:"form-text mb-1 col-1",staticStyle:{"text-align":"center"}},[_vm._v("\n        B\n      ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bdim),expression:"bdim"}],staticClass:"form-control form-control-sm v-step-12 col-1",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.bdim=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.cyl880b),function(b){return _c('option',{key:b},[_vm._v(_vm._s(b))])})),_vm._v(" "),_c('p',{staticClass:"form-text mb-1 col-1",staticStyle:{"text-align":"center"}},[_vm._v("\n        C\n      ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdim),expression:"cdim"}],staticClass:"form-control form-control-sm v-step-12 col-1",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdim=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.cyl880c),function(c){return _c('option',{key:c.c},[_vm._v(_vm._s(c.c))])})),_vm._v(" "),_c('p',{staticClass:"form-text mb-1 col-1",staticStyle:{"text-align":"center"}},[_vm._v("\n        Aantal\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.aantal),expression:"aantal"}],staticClass:"form-control form-control-sm v-step-12 col-1 mr-3",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.aantal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.aantal=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.verzend}},[_vm._v("Verzenden")])])]),_vm._v(" "),_c('svg',{staticClass:"my-5",attrs:{"width":"400","height":200}},[_c('polygon',{staticStyle:{"fill":"none","stroke":"black","stroke-width":"2"},attrs:{"points":"35,35 177,35 177,90 213,90 213,35 365,35 365,120 35,120 35,35"}}),_vm._v(" "),_c('polygon',{staticStyle:{"fill":"grey","stroke":"black","stroke-width":"2"},attrs:{"points":"180,10 210,10 210,87 180,87 180,10"}}),_vm._v(" "),_c('line',{attrs:{"x1":"180","y1":"37","x2":"210","y2":"37","stroke":"black","stroke-width":"2"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"195","cy":"110","r":"5","stroke":"black","stroke-width":"1","fill":"white"}}),_vm._v(" "),_c('line',{attrs:{"x1":"35","y1":"100","x2":"365","y2":"100","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"195","y1":"7","x2":"195","y2":"123","stroke":"black","stroke-width":".25","stroke-dasharray":"8 1 .2 1"}}),_vm._v(" "),_c('line',{attrs:{"x1":"35","y1":"100","x2":"40","y2":"101","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"35","y1":"100","x2":"40","y2":"99","stroke":"black","stroke-width":".5"}}),_vm._v(" "),_c('polygon',{staticStyle:{"fill":"black","stroke":"black","stroke-width":".5"},attrs:{"points":"35,100 40,101 40,99 35,100"}}),_vm._v(" "),_c('polygon',{staticStyle:{"fill":"black","stroke":"black","stroke-width":".5"},attrs:{"points":"365,100 360,101 360,99 365,100"}}),_vm._v(" "),_c('polygon',{staticStyle:{"fill":"black","stroke":"black","stroke-width":".5"},attrs:{"points":"195,100 200,101 200,99 195,100"}}),_vm._v(" "),_c('polygon',{staticStyle:{"fill":"black","stroke":"black","stroke-width":".5"},attrs:{"points":"195,100 190,101 190,99 195,100"}}),_vm._v(" "),_c('text',{staticStyle:{"text-anchor":"middle","fill":"blue","font-weight":"bold"},attrs:{"x":"100","y":"95","font-size":"20"}},[_vm._v("B")]),_vm._v(" "),_c('text',{staticStyle:{"text-anchor":"middle","fill":"blue","font-weight":"bold"},attrs:{"x":"290","y":"95","font-size":"20"}},[_vm._v("C")]),_vm._v(" "),_c('foreignObject',{attrs:{"x":"50","y":"50","width":"110px","height":"40px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bdim),expression:"bdim"}],staticStyle:{"width":"100px"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.bdim=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.cyl880b),function(b){return _c('option',{key:b},[_vm._v(_vm._s(b))])}))]),_vm._v(" "),_c('foreignObject',{attrs:{"x":"245","y":"50","width":"100px","height":"40px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bdim),expression:"bdim"}],staticStyle:{"width":"100px"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.bdim=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.cyl880c),function(c){return _c('option',{key:c.c},[_vm._v(_vm._s(c.c))])}))])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"background-color":"white"}},[_c('div',{staticClass:"display-4"},[_vm._v("Cilinder 880 - sleutelbediend")]),_vm._v(" "),_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('span',{staticClass:"col-1"},[_c('strong')]),_vm._v(" "),_c('span',{staticClass:"col-4"},[_c('strong',[_vm._v("Art.Nummer")])]),_vm._v(" "),_c('span',{staticClass:"col-2"},[_c('strong',[_vm._v("Aantal")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadList_vue__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a26b71b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadList_vue__ = __webpack_require__(173);
function injectStyle (ssrContext) {
  __webpack_require__(171)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a26b71b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a26b71b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(172);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("08382be2", content, true, {});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@media (min-width:1500px){.container-fluid[data-v-5a26b71b]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-5a26b71b]{width:60%}}.lnk[data-v-5a26b71b]{cursor:pointer}.centered-and-cropped[data-v-5a26b71b]{object-fit:contain}", ""]);

// exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.genericdownloadsloaded = true)?_c('div',{staticClass:"container-fluid"},_vm._l((_vm.downloads),function(d){return _c('div',{key:d.Id,staticClass:"card"},[_c('h5',{staticClass:"card-header"},[_vm._v(_vm._s(d.fileName))]),_vm._v(" "),_c('div',{staticClass:"card-body"},_vm._l((d.versions),function(v){return _c('div',{key:v.Id},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(v.displayName))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(v.description))]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":v.link,"target":"_blank"}},[_vm._v("Download")])])}))])})):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"background-color":"white"}},[_c('div',{staticClass:"display-4"},[_vm._v("Downloads")]),_vm._v(" "),_c('hr')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsAndConditions_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7da847bf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditions_vue__ = __webpack_require__(175);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsAndConditions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7da847bf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mb-5"},[_c('ul',{staticClass:"nav nav-pills mb-3  mt-5",attrs:{"id":"pills-tab","role":"tablist"}},[_c('li',{staticClass:"nav-item",attrs:{"role":"presentation"}},[_c('a',{staticClass:"nav-link active",attrs:{"id":"english-tab","data-toggle":"pill","href":"#english","role":"tab","aria-controls":"english","aria-selected":"false"}},[_vm._v("English")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"role":"presentation"}},[_c('a',{staticClass:"nav-link",attrs:{"id":"dutch-tab","data-toggle":"pill","href":"#dutch","role":"tab","aria-controls":"dutch","aria-selected":"true"}},[_vm._v("Nederlands")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content",attrs:{"id":"pills-tabContent"}},[_c('div',{staticClass:"tab-pane fade",attrs:{"id":"dutch","role":"tabpanel","aria-labelledby":"dutch-tab"}},[_c('h1',{staticClass:"mt-5 mb-5"},[_vm._v("Gebruiksvoorwaarden")]),_vm._v(" "),_c('p',{staticClass:"lead mb-5 text-justify"},[_vm._v("\n          Wij danken je voor jouw bezoek aan de website toegankelijk op het adres https://www.chronologiconline.com, hierna de “Website”, eigendom van en beheerd door Sobinco nv, met maatschappelijke zetel te Waregemstraat 5, 9870 Zulte, België, ingeschreven in het KBO onder het nummer 0453.198.846, hierna “Sobinco”.\n          Lees aandachtig deze Gebruiksvoorwaarden. Deze Gebruiksvoorwaarden bepalen de voorwaarden voor het aanmaken van een account en de toegang tot en het gebruik van de Website.\n          Bij het aanmaken van een account zal je gevraagd worden te bevestigen dat je kennis genomen hebt van deze Gebruiksvoorwaarden en dat je de inhoud ervan als bindend aanvaardt. Je bezoek aan de Website, je aanmelding voor een account en elk ander gebruik van de Website, impliceren in ieder geval de kennisname en de aanvaarding van deze Gebruiksvoorwaarden.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("1. OPZET VAN DE WEBSITE")]),_vm._v(" "),_c('p',{staticClass:"text-justify mb-5"},[_vm._v("De Website is een applicatie/online platform (Chrono Logic) voor het berekenen en visualiseren van Chrono beslag voor ramen. De Website geeft een lijst weer met het beslag voor aluminium ramen dat nodig is om het project van de Gebruiker te realiseren. Via de Website wordt meer bepaald een excel bestand (artikellijst) gegenereerd die navolgend kan gebruikt worden om o.a. per e-mail een bestelling te plaatsen bij Sobinco. De Website geeft niet de mogelijkheid om de bestelling zelf te plaatsen.")]),_vm._v(" "),_c('h5',[_vm._v("2. TOEPASSELIJKHEID EN BINDENDE KRACHT")]),_vm._v(" "),_c('p',{staticClass:"text-justify mb-5"},[_vm._v("Deze Gebruiksvoorwaarden zijn van toepassing op elk gebruik van de Website. Je verklaart door je bezoek aan de Website kennis te hebben genomen van deze Gebruiksvoorwaarden en de inhoud ervan als bindend te aanvaarden.")]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("3. DEZE WEBSITE GEBRUIKEN")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("3.1 Het gebruik van de Website en het aanmaken van een account is gratis.")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("3.2 Sobinco behoudt zich het recht voor om de toegang voor bezoekers die de huidige Gebruiksvoorwaarden en Privacy Policy van de Website niet naleven, eenzijdig, onmiddellijk, definitief en zonder voorafgaande verwittiging af te sluiten.")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("4. HET AANMAKEN VAN EEN ACCOUNT")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("4.1. Om de Website te kunnen gebruiken, dien je een account aan te maken door je persoonsgegevens in te vullen op het aanmeldingsformulier ter beschikking op de Website. Het aanmeldingsformulier dient volledig en waarheidsgetrouw ingevuld te worden")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("4.2. Het is niet toegestaan gebruik te maken van andermans identiteit, van proxy's en tijdelijke e-mailadressen. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("4.3 Bij de aanmelding dien je je akkoord te verklaren met de huidige Gebruiksvoorwaarden en de Privacy Policy van de Website. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            4.4. Sobinco behoudt zich het recht voor om je aanmelding al dan niet te aanvaarden. Je aanmelding kan onder meer, maar niet uitsluitend, om volgende redenen geweigerd worden:\n            "),_c('ul',[_c('li',[_vm._v("Je verstrekt niet de gevraagde gegevens voor identificatie of verstrekt onvolledige of onjuiste gegevens;")]),_vm._v(" "),_c('li',[_vm._v("Je tracht je meerdere malen aan te melden door gebruik te maken van verschillende namen;")]),_vm._v(" "),_c('li',[_vm._v("Je maakt gebruik van andermans identiteit;")]),_vm._v(" "),_c('li',[_vm._v("Je komt één of meerdere in deze Gebruiksvoorwaarden gestelde verplichtingen niet na of liet zulks in het verleden na;")]),_vm._v(" "),_c('li',[_vm._v("Sobinco kan redelijkerwijze aannemen dat je een dergelijke verplichting niet zal nakomen;")]),_vm._v(" "),_c('li',[_vm._v("Elke andere reden op grond waarvan wij redelijkerwijze kunnen oordelen dat je aanmelding niet aanvaard kan worden.")])])]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("4.5. Vanaf het ogenblik dat je aanmelding compleet is, ontvang je een bevestigingsemail met alle relevante gegevens voor de toegang tot en het beheer van je account.")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("4.6 De account die noodzakelijk is om toegang te krijgen tot de Website is strikt persoonlijk. Je mag deze niet aan andere personen overdragen, meedelen of verkopen. De account blijft ten allen tijde eigendom van Sobinco.")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("5. ONZE AANSPRAKELIJKHEID")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("5.1. Sobinco besteedt de grootst mogelijke aandacht en zorg aan de inhoud van de Website. Deze inhoud is echter onderhavig aan wijzigingen en wordt je aangeboden zonder expliciete of impliciete garanties omtrent de correctheid ervan. Sobinco is niet aansprakelijk voor schade ingevolge het gebruik van de inhoud van de Website (waaronder de artikellijst), ongeacht of deze correct of incorrect bleek, noch voor schade die wordt veroorzaakt door het gebruiken of verspreiden van deze inhoud, noch voor schade ingevolge onjuiste, onvolledige, dubbelzinnige of gedateerde inhoud of taalfouten op de Website (bijvoorbeeld i.v.m. beslag, technische kenmerken, enz.). Sobinco draagt geen enkele verantwoordelijkheid of aansprakelijkheid met betrekking tot de aangeboden dienst. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            5.2. Sobinco zorgt voor de nodige beveiligingssystemen om de Website, haar informaticasysteem, haar databanken en de gegevens van de gebruikers van de Website te beschermen. Sobinco zorgt onder meer voor regelmatige aanpassingen aan antivirus beveiligingen. Sobinco heeft in dit kader een inspanningsverbintenis en niet een resultaatsverbintenis. Tenzij in geval van kwade trouw of grove nalatigheid, zal Sobinco (en met haar verbonden ondernemingen en personen) niet aansprakelijk zijn voor schade, onderbreking, diefstal, verlies, vernietiging of wijziging van gegevens, gederfde winst, of andere directe of indirecte schade veroorzaakt door een illegale of onrechtmatige toegang of gebruik door derden van de Website of van het informaticasysteem of telecomsysteem van de Website (inclusief m.b.t. gegevens van gebruikers, en inclusief m.b.t. virussen die via de Website zouden verspreid worden).\n            Sobinco stelt alles in werking om een toegang te verlenen tot de Website 24 uur op 24 en 7 dagen op 7. Sobinco garandeert in dit kader geen 100% beschikbaarheid. Gelet op de technische kenmerken van het internet en van de informaticamiddelen, en gelet op de noodzaak om periodieke onderhouds-, update- of upgradewerkzaamheden uit te voeren, kan Sobinco geen ononderbroken toegang en dienstverlening tot de Website garanderen. In geval van normaal aanvaardbare onderbrekingen of storingen van de toegang of de dienstverlening, zal Sobinco alles in het werk stellen om zo snel mogelijk een oplossing voor het probleem te vinden. Dergelijke normaal aanvaardbare onderbrekingen of storingen zijn eigen aan de dienstverlening via internet. Deze kunnen niet beschouwd worden als tekortkomingen en zullen geen aanleiding geven tot schadevergoedingen.\n          ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("5.3. De informatie op de Website kan in geen geval beschouwd worden als advies op vlak van beslag voor aluminium deuren en ramen, of op welk vlak dan ook. Alle informatie op de Website (waaronder de artikellijst) is steeds slechts informatief. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("5.4. De Gebruikers van de Website zijn zelf verantwoordelijk om de Website als een goede huisvader te gebruiken. De gebruikers van de Website zijn ook verantwoordelijk voor de geschiktheid en het onderhoud van hun technisch materiaal zoals, computer, laptop, pc, modem, internettoegang, telefoonlijn, enz.")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("5.5 In ieder geval zal de aansprakelijkheid van Sobinco voor eventuele schade steeds beperkt zijn tot maximaal de factuurwaarde van de bestelling die navolgend eventueel zou worden geplaatst bij Sobinco, meer bepaald het deel van de order waarop de schade en de verantwoordelijkheid van Sobinco betrekking op heeft. De aansprakelijkheid van Sobinco zal ook steeds beperkt zijn tot het bedrag dat Sobinco zelf van haar verzekeraar uitgekeerd krijgt. Sobinco zal in ieder geval nooit aansprakelijk zijn voor indirecte schade, met inbegrip van gevolgschade, incidentele schade, gederfde winst, verlies van inkomsten, gemiste besparingen, gemiste voordelen, verlies van goodwill of reputatie, en schade door bedrijfsstagnatie.")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("6. INTELLECTUELE EIGENDOM")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("Sobinco is de exclusieve eigenaar van de intellectuele eigendomsrechten verbonden aan de Website en de aangeboden dienst (inclusief de namen “Chrono Logic” en “Sobinco”). Als gebruiker van de Website verbind je je ertoe op geen enkele wijze en onder geen enkele vorm dan ook het geheel van elementen waaruit de Website bestaat (of een deel ervan) te kopiëren, te bewerken, te reproduceren, te verspreiden, te vermenigvuldigen, te publiceren, in licentie te geven, uit te baten, over te dragen, door te verkopen of op enige andere wijze te gebruiken. Deze elementen betreffen onder andere de merken, de teksten, de software, de databases, de formulieren, de handelsnamen, de productnamen, de logo’s, de grafische elementen en illustraties, de grafieken, de muziek, de kleurcombinaties, de slogans, de lay-outs en bladschikkingen en elk ander voor bescherming in aanmerking komend element van de Website en van de dienst.")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("7. OVERMACHT")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("7.1. In geval van overmacht is Sobinco niet gehouden haar verplichtingen na te komen. In dat geval kunnen wij ofwel onze verplichtingen opschorten voor de duur van de overmacht, ofwel de gebruiksvoorwaarden definitief ontbinden. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("7.2. Overmacht is elke omstandigheid buiten onze wil en controle die de nakoming van onze verplichtingen geheel of gedeeltelijk verhindert. Hieronder begrijpen wij onder meer, stakingen, brand, bedrijfsstoringen, machinedefecten, informaticadefecten, systeemfouten, energiestoringen, storingen in een (telecommunicatie-)netwerk of verbinding of gebruikte communicatiesystemen en/of het op enig moment niet beschikbaar zijn van toeleveranciers of andere ingeschakelde derden, ... ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("8. ALGEMENE BEPALINGEN")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            8.1. Aanpassingen\n            Indien deze Gebruiksvoorwaarden worden gewijzigd, wordt de nieuwe versie beschikbaar gesteld op de Website en zal deze nieuwe versie van toepassing zijn vanaf uw eerstvolgende bezoek aan de Website. Vanaf dat ogenblik wordt u geacht hiervan kennis te hebben genomen en hiermee akkoord te gaan.\n          ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            8.2. Toepasselijk recht en bevoegdheidsbeding\n            Deze Gebruiksvoorwaarden worden beheerst, geïnterpreteerd en uitgevoerd in overeenstemming met het Belgische recht, dat exclusief van toepassing is bij elk eventueel geschil. De Ondernemingsrechtbank Gent, afdeling Gent is exclusief bevoegd om te oordelen over elk geschil dat zou kunnen voortvloeien uit de interpretatie of de uitvoering van deze Gebruiksvoorwaarden.\n          ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            8.3. Aanvaarding\n            Door de Website te bezoeken en een account aan te maken, aanvaardt u alle bepalingen van deze Gebruiksvoorwaarden.\n          ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            8.4. Contact\n            Voor alle bijkomende inlichtingen of opmerkingen met betrekking tot deze Gebruiksvoorwaarden kan u contact opnemen met Sobinco op het volgend adres: Waregemstraat 5, 9870 Zulte, België, logic@sobinco.com.\n            Elke klacht of betwisting dient aangetekend aan het hierboven vermelde adres te worden verzonden.\n            Elke mededeling van ons aan u gebeurt via de website of per e-mail.\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade show active",attrs:{"id":"english","role":"tabpanel","aria-labelledby":"english-tab"}},[_c('h1',{staticClass:"mt-5 mb-5"},[_vm._v("Terms & Conditons of Use")]),_vm._v(" "),_c('p',{staticClass:"lead text-justify mb-5"},[_vm._v("\n          We would like to thank you for your visit to the website accessible at the address https://www.chronologiconline.com, hereinafter referred to as the “Website”, which is owned and run by Sobinco NV, with its registered office established at Waregemstraat 5, 9870 Zulte, Belgium, listed in the CBE under number 0453.198.846 and hereinafter referred to as “Sobinco”.\n          Please read these Terms and Conditions of Use carefully. These Terms and Conditions of Use lay down the conditions governing the creation of an account and the access to and use of the Website.\n          When you create an account you will be asked to confirm that you have read these Terms and Conditions of Use and that you accept the content thereof as binding. Your visit to the Website, your registration for an account and any other use of the Website in any case imply that you have acquainted yourself with and accepted these Terms and Conditions of Use.\n        ")]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("1. PURPOSE OF THE WEBSITE ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            The Website is an application / online platform (Chrono Logic) for calculating and visualizing Chrono window fittings. The Website displays a list of the fittings for aluminum windows required to realize the project of the User. More specifically, an Excel file (article list) is generated via the Website, which can subsequently be used to place an order with Sobinco e.g. by e-mail. The Website does not give the opportunity to place the order itself.\n          ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("2. APPLICABILITY AND BINDING FORCE ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("These Terms and Conditions of Use apply to any use of the Website. By visiting the Website you declare that you have read these Terms and Conditions of Use and accept the content thereof as binding.")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("3. USING THIS WEBSITE ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("3.1. Use of the Website and the creation of an account are free of charge. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("3.2 Sobinco reserves the right to block access, unilaterally, immediately, permanently and without forewarning, for visitors who fail to observe these Terms and Conditions of Use and the Website’s Privacy Policy. ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("4. CREATING AN ACCOUNT ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("4.1. In order to be able to use the Website, you have to create an account by filling in your personal particulars in the registration form available on the Website. The registration form should be completed fully and truthfully. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("4.2. You are not allowed to use another person’s identity, proxies or temporary e-mail addresses. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("4.3. When you register you must declare that you agree to these Terms and Conditions of Use and the Website’s Privacy Policy. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            4.4. Sobinco reserves the right to accept or reject your registration. Your registration may be rejected for one or more of the following reasons (the list below not being exhaustive):\n            "),_c('ul',[_c('li',[_vm._v("You have failed to provide the requested details for identification purposes, or have provided incomplete or incorrect data;")]),_vm._v(" "),_c('li',[_vm._v("You try to register several times using different names;")]),_vm._v(" "),_c('li',[_vm._v("You are using another person’s identity;")]),_vm._v(" "),_c('li',[_vm._v("You fail to fulfil one or more of the obligations mentioned in these Terms and Conditions of Use or have failed to do so in the past;")]),_vm._v(" "),_c('li',[_vm._v("Sobinco may reasonably assume that you will not fulfil an obligation of this kind;")]),_vm._v(" "),_c('li',[_vm._v("Any other reason on the grounds of which we can reasonably deem it impossible to accept your registration.")])])]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("4.5. As soon as your registration is complete, you will receive a confirmation e-mail containing all the relevant information you need to be able to access and manage your account. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("4.6 The account which is necessary to gain access to the Website is strictly personal. You may not hand over, disclose or sell is to anyone else. The account remains the property of Sobinco at all times.")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("5. OUR LIABILITY ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("5.1. Sobinco devotes the greatest possible care and attention to the Website’s content. However, this content is subject to changes and is presented to you without any explicit or implicit guarantees as to its accuracy or correctness. Sobinco is not liable for loss or damage resulting from use of the Website’s content (including the article list), irrespective of whether this content proved to be correct or incorrect, or for loss or damage caused by the use or dissemination of this content, or for loss or damage stemming from inaccurate, incomplete, ambiguous or outdated content or language errors on the Website (e.g. fittings, technical details, etc.). Sobinco does not bear any responsibility or liability whatsoever with regard to the service offered. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            5.2. Sobinco provides for the necessary security system to protect the Website, its IT system, its databases and the data of the Website’s users. Among other things Sobinco takes care of regular adjustments to antivirus protection. In this context Sobinco has an obligation of best effort and not an obligation of result. Other than in the event of mala fide acts or gross negligence, Sobinco (and companies and persons affiliated to it) shall not be liable for damage, interruption, theft, loss, destruction or alteration of data, loss of profit, or other direct or indirect loss or damage caused by an illegal or unlawful access or use by third parties of the Website or of the Website’s IT system or telecommunication system (including with regard to users’ data and including with regard to viruses possibly spread via the Website).\n            Sobinco makes every effort to provide access to the Website 24 hours a day, seven days a week. In this respect, Sobinco does not guarantee an availability of 100%. Given the technical characteristics of the Internet and IT resources, and given the need to carry out periodic maintenance, updating and upgrading activities, Sobinco is unable to guarantee uninterrupted access to and provision of services on the Website. In the case of normally acceptable interruptions or failures in access or the provision of services, Sobinco shall make very endeavour to find a solution to the problem as quickly as possible. Such normally acceptable interruptions or failures are specific to the provision of services on the Internet. These cannot be considered as shortcomings and shall not give rise to compensation.\n          ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("5.3. The information on the Website may under no circumstances be regarded as advice in the field of fittings for aluminum windows and doors, or in any other field whatsoever. All information provided on the Website (including the article list) is always for information purposes only. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("5.4. The Users of the Website are themselves responsible for using the Website with all due care and diligence. The Users of the Website are also responsible for the suitability and maintenance of their technical equipment, such as their computer, laptop, PC, modem, Internet connection, telephone line, etc.")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("5.5 In any case Sobinco’s liability for any loss or damage shall at all times be limited to a maximum amount of the invoice value of the order that would subsequently be placed with Sobinco, more particularly that part of the order to which the loss/damage and Sobinco’s responsibility relates. Sobinco’s liability shall also always be limited to the amount that Sobinco itself receives from its insurance company by way of a pay-out. Sobinco shall in any case never be liable for indirect loss or damage, including consequential loss, incidental loss, loss of profit, loss of income, savings missed out on, benefits missed out on, loss of goodwill or reputation, and loss incurred on account of business stagnation. ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("6. INTELLECTUAL PROPERTY ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("Sobinco is the exclusive owner of the intellectual property rights attached to the Website and the service offered (also encompassing the names “Chrono Logic” and “Sobinco”). As a user of the Website you undertake to refrain from copying, transcribing, reproducing, disseminating, duplicating, publishing, licensing out, running, transferring, reselling or in any other manner using the totality of the component parts making up the Website (or a part thereof) in any way and in any form whatsoever. These component parts relate inter alia to the brand names, texts, software, databases, forms, trade names, product names, logos, graphic components and illustrations, graphics, music, colour combinations, slogans, layouts and page arrangements and any other component part of the Website and the service that is eligible for protection.")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("7. FORCE MAJEURE ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("7.1. In the event of force majeure Sobinco is not obliged to fulfil its obligations. In this case we may either suspend our obligations for the term of the force majeure or permanently dissolve the terms & conditions of use. ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("7.2. Force majeure is any event or circumstance against our will and beyond our control that wholly or partially prevents the fulfilment of our obligations. We deem this to include, inter alia, strikes, fire, breakdowns, mechanical failures, IT failures, system errors, power failures, failures in a (telecommunications) network or connection or communication systems used and/or failure of availability on the part of suppliers or other third parties whose services have been enlisted, etc. ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("8. GENERAL PROVISIONS")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            8.1. Modifications\n            If these Terms and Conditions of Use are modified, the new version will be made available on the Website and this new version will be applicable from the next time you visit the Website. From that moment onwards you are deemed to have acquainted yourself with these amended conditions and to agree to them.\n          ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            8.2. Applicable law and competence clause\n            These Terms and Conditions of Use are governed, interpreted and implemented in accordance with Belgian law, which is exclusively applicable to any dispute that may arise. The business court Ghent, section Ghent has exclusive jurisdiction to rule on any dispute possibly stemming from the interpretation or implementation of these Terms and Conditions of Use.\n          ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            8.3. Acceptance\n            By visiting the Website and creating an account, you accept all the provisions of these Terms and Conditions of Use.\n          ")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            8.4. Contact\n            For any further information on these Terms and Conditions of Use, or if you would like to make any comments about them, you can contact Sobinco at the following address:\n            Waregemstraat 5, 9870 Zulte, België, logic@sobinco.com.\n            Any complaint or dispute should be sent by registered letter to the address given above.\n            All announcements or notifications from us to you are placed on the Website or sent by e-mail.\n          ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364af8a7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(177);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364af8a7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mb-5"},[_c('ul',{staticClass:"nav nav-pills mb-3 mt-5",attrs:{"id":"pills-tab","role":"tablist"}},[_c('li',{staticClass:"nav-item",attrs:{"role":"presentation"}},[_c('a',{staticClass:"nav-link active",attrs:{"id":"english-tab","data-toggle":"pill","href":"#english","role":"tab","aria-controls":"english","aria-selected":"false"}},[_vm._v("English")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"role":"presentation"}},[_c('a',{staticClass:"nav-link",attrs:{"id":"dutch-tab","data-toggle":"pill","href":"#dutch","role":"tab","aria-controls":"dutch","aria-selected":"true"}},[_vm._v("Nederlands")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content",attrs:{"id":"pills-tabContent"}},[_c('div',{staticClass:"tab-pane fade",attrs:{"id":"dutch","role":"tabpanel","aria-labelledby":"dutch-tab"}},[_c('h1',{staticClass:"mt-5 mb-5"},[_vm._v("Privacybeleid")]),_vm._v(" "),_c('p',{staticClass:"lead text-justify mb-5"},[_vm._v("\n          Wij hechten veel belang aan de veiligheid en vertrouwelijkheid van de persoonsgegevens die wij verwerken. Bovendien willen we heel duidelijk en transparant zijn over wat er gebeurt als we uw persoonsgegevens verzamelen en gebruiken. Vandaar dit privacybeleid.\n        ")]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("1. WANNEER WORDEN UW PERSOONSGEGEVENS VERZAMELD EN GEBRUIKT?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            Wij verzamelen en gebruiken uw persoonsgegevens wanneer u:\n            "),_c('ul',[_c('li',[_vm._v("onze website of sociale media gebruikt of met ons communiceert via email, telefoon, fax of een ander digitaal communicatiekanaal;")]),_vm._v(" "),_c('li',[_vm._v("zich inschrijft voor onze nieuwsbrief;")]),_vm._v(" "),_c('li',[_vm._v("met ons een (gebruiks)overeenkomst sluit en in dat kader met ons communiceert als onze klant (zoals de aanmaak van een account op Chrono Logic);")])])])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("2. WAT ALS DIT PRIVACYBELEID NIET AL UW VRAGEN BEANTWOORDT?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            De wetgeving betreffende gegevensbescherming (in het bijzonder de GDPR/AVG) verplicht ons om u heel wat informatie te verstrekken, dus vragen we u even om uw aandacht. Mocht u nog vragen hebben over de verwerking van uw persoonsgegevens, aarzel dan niet om contact op te nemen met ons via e-mail: "),_c('a',{attrs:{"href":"mailto:privacy@sobinco.com"}},[_vm._v("privacy@sobinco.com")]),_vm._v(".\n          ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("3. WIE IS \"WIJ\"?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            \"Wij\" verwijst in dit privacybeleid naar Sobinco:"),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Sobinco NV")]),_c('br'),_vm._v("\n            Waregemstraat 5,"),_c('br'),_vm._v("\n            9870 Zulte"),_c('br'),_vm._v("\n            België"),_c('br'),_vm._v("\n            Ondernemingsnummer: 0453.198.846"),_c('br'),_vm._v("\n            Tel.: +32 (0)9 388 88 81"),_c('br'),_c('br'),_vm._v("\n            Sobinco is verantwoordelijk voor het verwerken van uw persoonsgegevens op de wijze uitgelegd in dit privacybeleid.\n          ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("4. WELKE PERSOONSGEGEVENS VERWERKEN WIJ EN WAAROM?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            Wanneer u gebruik maakt van onze website, sociale media of met ons communiceert via telefoon, e-mail, fax of ander digitaal communicatiekanaal, zullen wij uw persoonsgegevens verzamelen en gebruiken om:\n            "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("de communicatie tussen u en ons mogelijk te maken, waarbij we ons beroepen op ons legitiem belang om te kunnen reageren op verzoeken, vragen of opmerkingen of om proactief contact met u op te nemen voor vragen van welke aard dan ook (bijv. wanneer u reageert op een blog, gebruik maakt van ons contactformulier of contact met ons opneemt via sociale media, telefoon, e-mail of fax);")]),_vm._v(" "),_c('li',[_vm._v("de inhoud van en de algemene ervaring op de website en social media pagina's te verbeteren, waarvoor we ons beroepen op ons legitiem belang om onze bezoekers een interessante online ervaring te kunnen bieden;")]),_vm._v(" "),_c('li',[_vm._v("malware, illegale inhoud en gedrag en andere vormen van misbruik op te sporen en te voorkomen, waarvoor we ons beroepen op ons legitiem belang om onze online aanwezigheid veilig te houden.")])]),_vm._v(" "),_c('br'),_vm._v("\n            Om de bovengenoemde doelen te bereiken, verwerken wij de volgende persoonsgegevens:\n            "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("de basisidentiteitsgegevens die u ons verstrekt, zoals naam, e-mailadres, postadres, telefoonnummer, het bedrijf waarvoor u werkt, uw functie;")]),_vm._v(" "),_c('li',[_vm._v("de inhoud van uw communicatie en de technische details van de communicatie zelf (met wie u van ons correspondeert, datum en tijd, enz.);")]),_vm._v(" "),_c('li',[_vm._v("technische informatie in verband met het apparaat dat u gebruikt, zoals uw IP-adres, browsertype, geografische locatie en besturingssysteem;")]),_vm._v(" "),_c('li',[_vm._v("informatie over uw surfgedrag, zoals hoe lang u surft, op welke links u klikt, welke pagina's u bezoekt en hoe vaak u een pagina bezoekt.")]),_vm._v(" "),_c('li',[_vm._v("alle andere persoonsgegevens die u ons verstrekt.")])]),_vm._v(" "),_c('br'),_vm._v("\n            Wanneer u zich inschrijft voor onze online nieuwsbrief, zullen wij uw persoonsgegevens verzamelen en gebruiken om u onze nieuwsbrief of andere elektronische communicatie te kunnen toesturen. Wij zullen u altijd om uw expliciete toestemming vragen alvorens we u onze nieuwsbrief toesturen, tenzij u een bestaande klant bent die wij op de hoogte willen houden van onze diensten. U heeft steeds de mogelijkheid om u af te melden voor onze nieuwsbrief. Om u onze nieuwsbrief toe te sturen, verwerken wij alleen uw basisidentiteitsgegevens, d.w.z. uw naam en e-mailadres.\n            "),_c('br'),_c('br'),_vm._v("\n            Wanneer wij het genoegen hebben om een overeenkomst met u aan te gaan, zoals als klant, zullen wij uw persoonsgegevens verzamelen en gebruiken om:\n            "),_c('br'),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("onze contractuele verplichtingen na te komen. Wanneer u als individu onze klant bent, vertrouwen wij op de noodzaak van de verwerking van uw persoonsgegevens voor de totstandkoming en uitvoering van de overeenkomst die wij met u hebben. Als u echter namens een bedrijf of een andere rechtspersoon optreedt, vertrouwen wij op ons legitiem belang om met klanten en leveranciers te kunnen contracteren;")]),_vm._v(" "),_c('li',[_vm._v("onze normale bedrijfsadministratie (bijv. facturering en relatiebeheer), waarvoor we vertrouwen op onze legitieme belangen om onze activiteiten op een verantwoorde en professionele manier te beheren;   ")]),_vm._v(" "),_c('li',[_vm._v("ons te verdedigen in gerechtelijke procedures, wanneer het in ons legitiem belang is om uw persoonsgegevens in deze procedures te gebruiken.")])]),_vm._v(" "),_c('br'),_vm._v("\n            De persoonsgegevens die wij voor deze doeleinden verwerken, hebben altijd betrekking op uw basisidentiteitsgegevens zoals voornaam en familienaam, e-mailadres, postadres, telefoonnummer, het bedrijf waarvoor u werkt en uw functie. Wij kunnen ook andere persoonsgegevens verwerken die u ons verstrekt, afhankelijk van onze contractuele relatie met u.\n            "),_c('br'),_c('br'),_vm._v("\n            Wij zijn van mening dat de bovengenoemde doeleinden voor de verwerking van uw persoonsgegevens binnen ieders redelijke verwachtingen liggen. Voor alle persoonsgegevens die wij in de bovengenoemde omstandigheden hebben verzameld, willen wij echter duidelijk maken dat wij ook uw persoonsgegevens zullen verwerken:\n            "),_c('br'),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("om wettelijke verplichtingen na te komen of, voor zover het ons toegestaan is, te voldoen aan elk redelijk verzoek van bevoegde politiediensten, gerechtelijke autoriteiten, overheidsinstellingen of -organen, met inbegrip van bevoegde gegevensbeschermingsautoriteiten;")]),_vm._v(" "),_c('li',[_vm._v("om een derde te informeren in het kader van een mogelijke fusie met, overname van/door of splitsing door die derde, zelfs indien die derde buiten de EU is gevestigd, in welk geval wij ons beroepen op ons legitiem belang om zakelijke transacties te kunnen aangaan.")])]),_vm._v(" "),_c('br'),_vm._v("\n            Wij willen benadrukken dat voor ons vertrouwelijkheid van het grootste belang zijn. Dit betekent dat wij uw persoonsgegevens alleen zullen verwerken wanneer dit is toegestaan, gelet op deze vertrouwelijkheidsverplichtingen.\n          ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("5. MET WIE DELEN WIJ UW PERSOONSGEGEVENS?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            In principe delen wij uw persoonsgegevens met niemand anders dan de mensen die voor Sobinco werken, evenals met de leveranciers die ons helpen bij de verwerking van uw persoonsgegevens. Iedereen die toegang heeft tot uw persoonsgegevens zal altijd gebonden zijn door strikte wettelijke of contractuele verplichtingen om uw persoonsgegevens veilig en vertrouwelijk te bewaren. Dit betekent dat alleen de volgende ontvangers uw persoonsgegevens ontvangen:\n            "),_c('br'),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("u;")]),_vm._v(" "),_c('li',[_vm._v("uw werkgever of zakenpartners, maar alleen wanneer dit nodig is voor de hierboven vermelde doeleinden (bijvoorbeeld wanneer uw werkgever onze klant is);")]),_vm._v(" "),_c('li',[_vm._v("de medewerkers en leveranciers van Sobinco;")]),_vm._v(" "),_c('li',[_vm._v("overheids- of gerechtelijke autoriteiten voor zover wij verplicht zijn om hen uw persoonsgegevens toe te zenden (bijv. belastingdienst, politie of gerechtelijke autoriteiten).")])]),_vm._v(" "),_c('br'),_vm._v("\n            Uw persoonsgegevens worden door ons niet buiten de Europese Economische Ruimte verzonden (de Europese Economische Ruimte bestaat uit de EU, Liechtenstein, Noorwegen en IJsland). Wij zullen uw persoonsgegevens alleen buiten de EER doorgeven wanneer u of uw werkgever, als klant, vestigingen buiten de EER heeft waarmee wij moeten communiceren. Als er een overdracht zou plaatsvinden, zullen wij voldoende waarborgen nemen om uw persoonsgegevens bij overdracht te beschermen (bijvoorbeeld door het afsluiten van een overeenkomst op basis van modelcontractbepalingen zoals opgesteld door de Europese Commissie).\n          ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("6. HOE LANG BEWAREN WIJ UW PERSOONSGEGEVENS?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            Uw persoonsgegevens worden slechts zolang verwerkt als nodig is om de hierboven beschreven doeleinden te bereiken of, wanneer wij u om uw toestemming hebben gevraagd, tot het moment dat u uw toestemming intrekt. In dit artikel voorzien wij u van de informatie die u nodig heeft om te beoordelen hoe lang wij uw persoonsgegevens identificeerbaar houden."),_c('br'),_c('br'),_vm._v("\n            Als algemene regel geldt dat wij uw persoonsgegevens zullen de-identificeren wanneer deze niet langer nodig zijn voor de hierboven beschreven doeleinden of wanneer de bewaartermijn, zoals in dit artikel wordt uitgelegd, is verstreken. Wij kunnen uw persoonsgegevens echter niet verwijderen als er een wettelijke of reglementaire verplichting of een gerechtelijk of administratief bevel bestaat dat Sobinco verhindert deze te verwijderen."),_c('br'),_c('br'),_vm._v("\n            Alle persoonsgegevens die wij via onze interacties met u verzamelen via de website, sociale media, telefoon, fax, e-mail en andere digitale communicatiekanalen zullen wij zo lang bewaren als nodig is om met u te communiceren, maar ook om een historisch archief van onze communicatie te kunnen bijhouden. Dit stelt ons in staat om terug te keren naar eerdere communicatie als u bij ons terugkomt met nieuwe vragen, verzoeken, opmerkingen of andere input."),_c('br'),_c('br'),_vm._v("\n            Alle persoonsgegevens die wij verzamelen om u onze nieuwsbrief toe te sturen, zullen wij bewaren zolang u ingeschreven blijft op onze mailinglijst of zolang u onze klant blijft."),_c('br'),_c('br'),_vm._v("\n            Alle persoonsgegevens die wij verzamelen in het kader van een contractuele relatie met u of de organisatie die u vertegenwoordigt, bewaren wij voor de duur van de contractuele relatie en ten minste tot 7 jaar daarna."),_c('br')])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("7. WAT DOEN WIJ OM UW PERSOONSGEGEVENS VEILIG TE BEWAREN?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("Zoals eerder uitgelegd, is de veiligheid en vertrouwelijkheid van alle gegevens die wij verwerken zeer belangrijk voor ons. Daarom hebben we maatregelen genomen om ervoor te zorgen dat alle verwerkte persoonsgegevens veilig worden bewaard. Deze stappen omvatten onder meer de beperking van de verwerking tot de persoonsgegevens die nodig zijn voor het bereiken van de doeleinden die wij u hebben meegedeeld. We hebben ook technische en organisatorische maatregelen genomen om onze infrastructuur, systemen, toepassingen, gebouw en processen te beveiligen. Al uw persoonsgegevens worden bewaard en verwerkt in een beveiligde databank die gehost wordt door Microsoft Azure.")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("8. WELKE RECHTEN HEEFT U MET BETREKKING TOT UW PERSOONSGEGEVENS?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            Wanneer wij uw persoonsgegevens verzamelen en gebruiken, geniet u een aantal rechten die u op de hieronder beschreven wijze kunt uitoefenen. Houd er rekening mee dat wanneer u een recht wilt uitoefenen, wij u om een identiteitsbewijs zullen vragen. Wij doen dit om te voorkomen dat wij een inbreuk in verband met persoonsgegevens tegenkomen, bijvoorbeeld omdat een onbevoegd persoon zich voordoet als u en een recht in uw naam uitoefent."),_c('br'),_c('br'),_vm._v("\n            U hebt het recht op toegang tot uw persoonsgegevens, wat betekent dat u ons kunt vragen om u informatie te verstrekken over de persoonsgegevens die wij over u hebben. U kunt zelfs een kopie van uw persoonsgegevens opvragen. Houd er echter rekening mee dat u moet aangeven voor welke verwerkingsactiviteiten u toegang wenst te hebben tot uw persoonsgegevens."),_c('br'),_c('br'),_vm._v("\n            Indien u herhaaldelijk hetzelfde verzoek indient en daarbij duidelijk overlast veroorzaakt, kunnen wij deze opeenvolgende verzoeken weigeren of u een administratieve vergoeding in rekening brengen om de kosten te dekken. Wij kunnen u ook het recht op toegang tot uw persoonsgegevens weigeren of slechts gedeeltelijk verlenen, indien een dergelijke toegang de rechten en vrijheden van anderen, waaronder die van Sobinco, onevenredig zou kunnen schaden."),_c('br'),_c('br'),_vm._v("\n            U hebt het recht om te vragen dat wij uw persoonsgegevens corrigeren als u kunt aantonen dat de persoonsgegevens die wij over u verwerken onjuist, onvolledig of verouderd zijn. Geef aan in welke context wij uw persoonsgegevens gebruiken (bijvoorbeeld om u nieuwsbrieven te sturen of om te reageren op een verzoek), zodat wij uw verzoek snel en accuraat kunnen beoordelen."),_c('br'),_c('br'),_vm._v("\n            Als wij uw toestemming vragen om uw persoonsgegevens te verzamelen en te gebruiken, bijvoorbeeld om u nieuwsbrieven te sturen, hebt u het recht om deze eerder gegeven toestemming in te trekken."),_c('br'),_c('br'),_vm._v("\n            U kunt ons verzoeken om uw persoonsgegevens te verwijderen als deze persoonsgegevens niet langer nodig zijn voor de doeleinden waarvoor wij ze hebben verzameld, als het verzamelen ervan onwettig was of als u met succes gebruik hebt gemaakt van uw recht om uw toestemming in te trekken of uw recht om bezwaar te maken tegen de verwerking van uw persoonsgegevens. Wanneer een van deze omstandigheden van toepassing is, zullen wij uw persoonsgegevens onmiddellijk verwijderen, tenzij wettelijke verplichtingen of administratieve of gerechtelijke bevelen ons verbieden om uw persoonsgegevens te verwijderen."),_c('br'),_c('br'),_vm._v("\n            U kunt ons vragen om de verwerking van uw persoonsgegevens te beperken:\n            "),_c('ul',[_c('li',[_vm._v("gedurende de tijd dat wij uw verzoek om correctie van uw persoonsgegevens beoordelen;")]),_vm._v(" "),_c('li',[_vm._v("gedurende de tijd dat wij uw bezwaar tegen de verwerking van uw persoonsgegevens beoordelen;")]),_vm._v(" "),_c('li',[_vm._v("wanneer een dergelijke verwerking onwettig was, maar u geeft de voorkeur aan een beperking boven wissen;")]),_vm._v(" "),_c('li',[_vm._v("wanneer wij uw persoonsgegevens niet langer nodig hebben, maar u hebt ze nodig voor de vaststelling, uitoefening van of verdediging tegen een rechtsvordering.")])]),_vm._v(" "),_c('br'),_vm._v("\n            Wanneer wij uw persoonsgegevens verwerken op basis van onze eigen belangen, d.w.z. u heeft ons geen toestemming gegeven en wij hebben ze niet nodig voor de uitvoering of uitvoering van een overeenkomst, noch om te voldoen aan wettelijke verplichtingen, hebt u het recht om u te verzetten tegen onze verwerking van uw persoonsgegevens. Wanneer ons belang betrekking heeft op direct marketing, zullen wij u uw verzoek onmiddellijk inwilligen. Voor andere belangen, bijvoorbeeld onze veiligheidsbelangen, vragen wij u om uw specifieke omstandigheden te beschrijven die aanleiding geven tot een verzoek. Dan moeten we uw omstandigheden afwegen tegen onze belangen. Als deze afweging ertoe leidt dat uw omstandigheden zwaarder wegen dan onze belangen, zullen wij de verwerking van uw persoonsgegevens staken."),_c('br'),_c('br'),_vm._v("\n            Wanneer wij uw persoonsgegevens hebben verzameld op basis van uw toestemming of omdat ze nodig waren voor de uitvoering of de uitvoering van een overeenkomst met u, hebt u het recht om een kopie van ons te verkrijgen in een gestructureerd, veel gebruikt en machine-leesbaar formaat. Dit recht geldt echter alleen voor persoonsgegevens die u ons heeft verstrekt."),_c('br'),_c('br'),_vm._v("\n            Als u een van deze rechten wilt uitoefenen, vragen wij u ons een e-mail te sturen. U kunt ons bereiken op privacy@sobinco.com."),_c('br'),_c('br'),_vm._v("\n            U kunt er zeker van zijn dat wij een e-mail van u, waarmee u aangeeft een recht uit te willen oefenen, niet zullen interpreteren als uw toestemming voor de verwerking van uw persoonsgegevens die verder gaat dan wat nodig is voor de behandeling van uw verzoek."),_c('br'),_c('br'),_vm._v("\n            In een verzoek moet duidelijk worden aangegeven en gespecificeerd welk recht u wenst uit te oefenen. Geef altijd aan in welke context wij uw persoonsgegevens hebben verkregen, zodat wij uw aanvraag snel en zorgvuldig kunnen behandelen. Uw aanvraag moet ook gedateerd en ondertekend zijn en vergezeld gaan van een digitaal gescande kopie van uw geldige identiteitskaart die uw identiteit bewijst."),_c('br'),_c('br'),_vm._v("\n            Wij zullen u onmiddellijk op de hoogte brengen van de ontvangst van dit verzoek. Indien de aanvraag gegrond blijkt te zijn, zullen wij u daarvan zo spoedig mogelijk en uiterlijk dertig (30) dagen na ontvangst van de aanvraag op de hoogte stellen."),_c('br'),_c('br'),_vm._v("\n            Indien u een klacht heeft over de verwerking van uw persoonsgegevens door Sobinco, kunt u altijd contact met ons opnemen via bovenvermeld e-mailadres. Als u niet tevreden bent met ons antwoord, kunt u een klacht indienen bij de bevoegde gegevensbeschermingsautoriteit, d.w.z. de Belgische gegevensbeschermingsautoriteit ("),_c('a',{attrs:{"href":"https://www.gegevensbeschermingsautoriteit.be/","target":"_blank"}},[_vm._v("https://www.gegevensbeschermingsautoriteit.be/")]),_vm._v(")."),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade show active",attrs:{"id":"english","role":"tabpanel","aria-labelledby":"english-tab"}},[_c('h1',{staticClass:"mt-5 mb-5"},[_vm._v("Privacy policy")]),_vm._v(" "),_c('p',{staticClass:"lead text-justify mb-5"},[_vm._v("\n          The safety and confidentiality of the personal data we process, are a key concern for us. Moreover, we wish to be very clear and transparent about what happens when we collect and use your personal data. Hence this privacy policy.\n        ")]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("1. WHEN ARE YOUR PERSONAL DATA COLLECTED AND USED?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            We collect and use your personal data whenever you:"),_c('br'),_c('br'),_vm._v(" "),_c('ul',[_c('li',[_vm._v("use our website or social media or communicate with us via e-mail, phone, fax (yes, these still exist) or any other digital communication channel;")]),_vm._v(" "),_c('li',[_vm._v("register for our newsletter;")]),_vm._v(" "),_c('li',[_vm._v("enter into a (user)agreement and communicate with us as our client (e.g. registration of an account on Chrono Logic);")])])])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("2. WHAT IF THIS PRIVACY POLICY DOES NOT ANSWER ALL OF YOUR QUESTIONS?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            The data protection laws (in particular the GDPR) oblige us to provide you with quite a lot of information, so please bear with us. Should you have further questions regarding the processing of your personal data, do not hesitate to contact us via e-mail: "),_c('a',{attrs:{"href":"mailto:privacy@sobinco.com"}},[_vm._v("privacy@sobinco.com")]),_vm._v(".\n          ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("3. WHO IS \"WE\"?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            Whenever you see a reference to “we” in this privacy policy, it actually refers to Sobinco:\n            "),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Sobinco NV")]),_c('br'),_vm._v("\n            Waregemstraat 5"),_c('br'),_vm._v("\n            9870 Zulte"),_c('br'),_vm._v("\n            Belgium"),_c('br'),_vm._v("\n            Company number 0453.198.846"),_c('br'),_vm._v("\n            Tel.: +32 (0)9 388 88 81"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n            Sobinco is responsible for collecting and using your personal data as explained in this privacy policy.\n          ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("4. WHAT PERSONAL DATA DO WE PROCESS AND WHY?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            When you use our website, social media or communicate with us via phone, e-mail, fax or other digital communication channel, we will collect and use your personal data to:\n            "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("allow for the communication between you and us, for which we rely on our legitimate interest to be able to respond to requests, questions or remarks or to contact you proactively for inquiries of whatever kind (e.g. when you respond to a blog, use our contact form or contact us via social media, phone, e-mail or fax);")]),_vm._v(" "),_c('li',[_vm._v("improve the website’s and social media pages’ content and the overall experience, for which we rely on our own legitimate interest to offer our visitors an interesting online space;")]),_vm._v(" "),_c('li',[_vm._v("detect and prevent malware, illegal content and behavior and other types of misuse, for which we rely on our legitimate interest to keep our online presence safe.")])]),_vm._v("\n            To achieve the above-mentioned purposes, we process the following personal data:\n            "),_c('br'),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("the basic identity information you provide us with, such as name, e-mail address, postal address, telephone number, the company you work for, your function;")]),_vm._v(" "),_c('li',[_vm._v("the content of your communication and the technical details of the communication itself (with whom you correspond at our end, date and time, etc.); ")]),_vm._v(" "),_c('li',[_vm._v("technical information associated with the device you use, such as your IP address, browser type, geographical location and operating system;")]),_vm._v(" "),_c('li',[_vm._v("information concerning your browsing behavior, such as how long you visit, what links you click on, what pages you visit and how many times you visit a page.")]),_vm._v(" "),_c('li',[_vm._v("any other personal data you choose to provide to us.")])]),_vm._v("\n            When you register for our online newsletter, we will collect and use your personal data to be able to send you our newsletter or other electronic communications. We will always ask for your explicit consent before sending you our newsletter, unless you are an existing client who we wish to keep informed of our services. You will always have the opportunity to unsubscribe from our newsletter. To send you our newsletter, we only process your basic identity information, i.e. your name and e-mail address.\n            "),_c('br'),_c('br'),_vm._v("\n            When we have the pleasure of being able to enter into an agreement with you, as a client, we will collect and use your personal data to:\n            "),_c('br'),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("be able to execute and perform our end of the contract. When you as an individual are our client, we rely on the necessity of processing your personal data for executing and performing the agreement we have with you. However, if you act on behalf of a company or other legal entity, we rely on our legitimate interest to be able to contract with clients when processing your personal data;")]),_vm._v(" "),_c('li',[_vm._v("do our normal business administration (e.g. invoicing and relationship management), for which we rely on our legitimate interest to manage our business responsibly and professionally;")]),_vm._v(" "),_c('li',[_vm._v("defend ourselves in legal proceedings, when it is in our legitimate interest to use your personal data in these proceedings.")])]),_vm._v("\n            The personal data we process for these purposes will always involve your basic identity information such as first- and family name, e-mail address, postal address, telephone number, the company you work for and your function. We may also process other personal data you provide us with, dependent on our contractual relationship with you.\n            "),_c('br'),_c('br'),_vm._v("\n            We believe that the above-mentioned purposes for processing your personal data are within anyone’s reasonable expectations. However, for all of the personal data we have collected in the aforementioned circumstances, we wish to make it clear that we will also process your personal data to:\n            "),_c('br'),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("comply with legal obligations or to comply, insofar we are legally allowed, with any reasonable request from competent law enforcement agents or representatives, judicial authorities, governmental agencies or bodies, including competent data protection authorities;")]),_vm._v(" "),_c('li',[_vm._v("inform a third party in the context of a possible merger with, acquisition from/by or demerger by that third party, even if that third party is located outside the EU, in which case we rely on our legitimate interest to engage in corporate transactions.")])]),_vm._v("\n            We would like to stress that for us confidentiality is of paramount importance. This means that we will only process your personal data when such is allowed given these confidentiality obligations.\n          ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("5. WITH WHOM DO WE SHARE YOUR PERSONAL DATA?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            In principle we will not share your personal data with anyone but the people working for Sobinco, as well as our suppliers who help us process your personal data. Anyone who has access to your personal data will always be bound by strict legal or contractual obligations to keep your personal data safe and confidential. "),_c('br'),_vm._v("\n            This means that only the following recipients will receive your personal data:\n            "),_c('br'),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("you;")]),_vm._v(" "),_c('li',[_vm._v("your employer or business partners, but only when required given the purposes mentioned above (e.g. when your employer is our client);")]),_vm._v(" "),_c('li',[_vm._v("Sobinco’s staff and suppliers;")]),_vm._v(" "),_c('li',[_vm._v("governmental or judicial authorities insofar we are required to send them your personal data (e.g. tax authority, police or law enforcement).")])]),_vm._v("\n            Your personal data are not sent outside the European Economic Area by us (the European Economic Area consists of the EU, Liechtenstein, Norway and Iceland). We will only transfer your personal data outside the EEA when you or your employer, as client, has establishments outside the EEA with which we are required to interact. If a transfer would take place, we will take adequate safeguards to protect your personal when transferred (e.g. by putting in place standard contractual clauses as drafted by the European Commission).\n          ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("6. HOW LONG DO WE KEEP YOUR PERSONAL DATA?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            Your personal data are only processed for as long as needed to achieve the purposes which are described above or, when we asked for your consent, up until such time where you withdraw your consent. In this article we provide you with the information you need to assess how long we will keep your personal data identifiable. As a general rule, we will de-identify your personal data when they are no longer necessary for the purposes outlined above or when the retention period as explained in this article has expired. However, we cannot de-identify your personal data if there is a legal or regulatory obligation or a judicial or administrative order that prevents Sobinco from de-identifying them."),_c('br'),_c('br'),_vm._v("\n            All personal data we collect through our interactions with you via the website, social media, phone, fax, e-mail and other digital communication channels we keep for as long as required to communicate with you, but also to keep an historical archive of our communications. This allows us to revert back to earlier communications if you return to us with new questions, request, remarks or other input."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n            All personal data we collect to send you our newsletter we will keep for as long as you remain subscribed to our mailing list or for as long as you remain our client."),_c('br'),_c('br'),_vm._v("\n            All personal data we collect in the context of a contractual relationship with you or the organization you represent, we will keep for the duration of the contractual relationship and at least until 7 years thereafter.\n          ")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("7. WHAT DO WE DO TO KEEP YOUR PERSONAL DATA SAFE?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("As explained earlier, the security and confidentiality of all data we process is very important to us. Hence, we have taken steps to ensure that all personal data processed are kept safe. These steps include processing only the personal data required for achieving the purposes we have communicated to you. We have also taken technical and organizational measures to secure our infrastructure, systems, applications, premises and processes. All your personal data will be registered and processed in a secure database hosted on Microsoft Azure.")])]),_vm._v(" "),_c('article',{staticClass:"text-justify mb-5"},[_c('h5',[_vm._v("8. WHICH RIGHTS DO YOU HAVE WITH REGARD TO YOUR PERSONAL DATA?")]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n            When we collect and use your personal data, you enjoy a number of rights which you can exercise in the manner described below. Please be aware that whenever you wish to exercise a right, we will ask you for a proof of identity. We do this to avoid that we have a data breach on our hands, e.g. because an unauthorized person pretends to be you and exercises a right in your name.\n            You have the right to access your personal data, which means that you can ask us to provide you information regarding the personal data we have about you. You can even ask for a copy of your personal data. However, note that you must specify for which processing activities you would like to have access to your personal data. If you make the same request repeatedly, clearly causing us nuisance, we are allowed to refuse granting you these subsequent requests or charge an administrative fee covering the expenses. We can also refuse granting you a right to access your personal data, or only grant it partially, if such access would risk disproportional detriment to the rights and freedoms of others, including Sobinco’s. "),_c('br'),_c('br'),_vm._v("\n            You have the right to ask that we correct your personal data if you can show that the personal data we process about you are incorrect, incomplete or outdated. Please specify the context in which we use your personal data (e.g. to send you newsletters or to respond to a request), so that we may assess your request swiftly and accurately."),_c('br'),_c('br'),_vm._v("\n            If we asked for your consent to collect and use your personal data, e.g. to send you newsletters, you have the right to withdraw that earlier given consent."),_c('br'),_c('br'),_vm._v("\n            You can ask that we delete your personal data, if these personal data are no longer needed for the purposes for which we collected them in the first place, if our collection of them was illegitimate or if you have successfully exercised your right to withdraw your consent or your right to object to the processing of your personal data. When one of these circumstances applies, we will immediately delete your personal data unless the law, regulatory obligations or administrative or judicial orders prohibit us to delete your personal data."),_c('br'),_c('br'),_vm._v("\n            You can ask that we restrict the processing of your personal data:\n            "),_c('br'),_c('br'),_vm._v(" "),_c('ul',[_c('li',[_vm._v("during the time we are assessing your request for correction of your personal data;")]),_vm._v(" "),_c('li',[_vm._v("we no longer need your personal data, but you require them for the establishment, exercise or defence of a legal claim.")]),_vm._v(" "),_c('li',[_vm._v("when such processing was unlawful but you prefer restriction to erasure;")]),_vm._v(" "),_c('li',[_vm._v("during the time we are assessing your objection to the processing of your personal data;")])]),_vm._v(" "),_c('br'),_vm._v("\n            When we process your personal data on the basis of our own interests, i.e. you have not given us your consent and we do not need them for the execution or performance of an agreement nor to comply with legal obligations, you have the right to oppose our processing of your personal data. When our interest relates to direct marketing, we will grant you your request immediately. For other interests, e.g. our security interests, we will ask you to describe your specific circumstances giving rise to request. We then need to balance your circumstances against our interests. If this balancing exercise results in your circumstances outweighing our interests, we will cease processing your personal data.\n            When we have collected your personal data on the basis of your consent or because they were necessary for the execution or the performance of an agreement with you, you have the right to obtain a copy from us in a structured, commonly used and machine-readable format. However, this right only applies to personal data you have provided to us.\n            If you would like to exercise any of these rights, we ask that you send us an e-mail. You can reach us at privacy@sobinco.com.\n            "),_c('br'),_c('br'),_vm._v("\n            Rest assured that we will not interpret an e-mail from you requesting to exercise a right as your consent with any processing of your personal data beyond what is required for handling your request.\n            "),_c('br'),_c('br'),_vm._v("\n            A request should clearly state and specify which right you wish to exercise. Always indicate the context in which we have obtained your personal data so that we may handle your request swiftly and diligently. Your request should also be dated and signed, and accompanied by a digitally scanned copy of your valid identity card proving your identity.\n            "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n            We will promptly inform you of having received this request. If the request proves valid, we will notify you as soon as reasonably possible and at the latest thirty (30) days after having received the request.\n            "),_c('br'),_c('br'),_vm._v("\n            If you have any complaint regarding the processing of your personal data by Sobinco, you may always contact us via the e-mail address mentioned in the first paragraph of this clause. If you remain unsatisfied with our response, you may file a complaint with the competent data protection authority, i.e. the Belgian data protection authority ("),_c('a',{attrs:{"href":"https://www.dataprotectionauthority.be/"}},[_vm._v("https://www.dataprotectionauthority.be/")]),_vm._v(").\n          ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vuelidate = Vuelidate;
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _params.withParams;
  }
});
exports.default = exports.validationMixin = void 0;

var _vval = __webpack_require__(179);

var _params = __webpack_require__(21);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var NIL = function NIL() {
  return null;
};

var buildFromKeys = function buildFromKeys(keys, fn, keyFn) {
  return keys.reduce(function (build, key) {
    build[keyFn ? keyFn(key) : key] = fn(key);
    return build;
  }, {});
};

function isFunction(val) {
  return typeof val === 'function';
}

function isObject(val) {
  return val !== null && (_typeof(val) === 'object' || isFunction(val));
}

function isPromise(object) {
  return isObject(object) && isFunction(object.then);
}

var getPath = function getPath(ctx, obj, path, fallback) {
  if (typeof path === 'function') {
    return path.call(ctx, obj, fallback);
  }

  path = Array.isArray(path) ? path : path.split('.');

  for (var i = 0; i < path.length; i++) {
    if (obj && _typeof(obj) === 'object') {
      obj = obj[path[i]];
    } else {
      return fallback;
    }
  }

  return typeof obj === 'undefined' ? fallback : obj;
};

var __isVuelidateAsyncVm = '__isVuelidateAsyncVm';

function makePendingAsyncVm(Vue, promise) {
  var asyncVm = new Vue({
    data: {
      p: true,
      v: false
    }
  });
  promise.then(function (value) {
    asyncVm.p = false;
    asyncVm.v = value;
  }, function (error) {
    asyncVm.p = false;
    asyncVm.v = false;
    throw error;
  });
  asyncVm[__isVuelidateAsyncVm] = true;
  return asyncVm;
}

var validationGetters = {
  $invalid: function $invalid() {
    var _this = this;

    var proxy = this.proxy;
    return this.nestedKeys.some(function (nested) {
      return _this.refProxy(nested).$invalid;
    }) || this.ruleKeys.some(function (rule) {
      return !proxy[rule];
    });
  },
  $dirty: function $dirty() {
    var _this2 = this;

    if (this.dirty) {
      return true;
    }

    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.every(function (key) {
      return _this2.refProxy(key).$dirty;
    });
  },
  $anyDirty: function $anyDirty() {
    var _this3 = this;

    if (this.dirty) {
      return true;
    }

    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.some(function (key) {
      return _this3.refProxy(key).$anyDirty;
    });
  },
  $error: function $error() {
    return this.$dirty && !this.$pending && this.$invalid;
  },
  $anyError: function $anyError() {
    return this.$anyDirty && !this.$pending && this.$invalid;
  },
  $pending: function $pending() {
    var _this4 = this;

    return this.ruleKeys.some(function (key) {
      return _this4.getRef(key).$pending;
    }) || this.nestedKeys.some(function (key) {
      return _this4.refProxy(key).$pending;
    });
  },
  $params: function $params() {
    var _this5 = this;

    var vals = this.validations;
    return _objectSpread({}, buildFromKeys(this.nestedKeys, function (key) {
      return vals[key] && vals[key].$params || null;
    }), buildFromKeys(this.ruleKeys, function (key) {
      return _this5.getRef(key).$params;
    }));
  }
};

function setDirtyRecursive(newState) {
  this.dirty = newState;
  var proxy = this.proxy;
  var method = newState ? '$touch' : '$reset';
  this.nestedKeys.forEach(function (key) {
    proxy[key][method]();
  });
}

var validationMethods = {
  $touch: function $touch() {
    setDirtyRecursive.call(this, true);
  },
  $reset: function $reset() {
    setDirtyRecursive.call(this, false);
  },
  $flattenParams: function $flattenParams() {
    var proxy = this.proxy;
    var params = [];

    for (var key in this.$params) {
      if (this.isNested(key)) {
        var childParams = proxy[key].$flattenParams();

        for (var j = 0; j < childParams.length; j++) {
          childParams[j].path.unshift(key);
        }

        params = params.concat(childParams);
      } else {
        params.push({
          path: [],
          name: key,
          params: this.$params[key]
        });
      }
    }

    return params;
  }
};
var getterNames = Object.keys(validationGetters);
var methodNames = Object.keys(validationMethods);
var _cachedComponent = null;

var getComponent = function getComponent(Vue) {
  if (_cachedComponent) {
    return _cachedComponent;
  }

  var VBase = Vue.extend({
    computed: {
      refs: function refs() {
        var oldVval = this._vval;
        this._vval = this.children;
        (0, _vval.patchChildren)(oldVval, this._vval);
        var refs = {};

        this._vval.forEach(function (c) {
          refs[c.key] = c.vm;
        });

        return refs;
      }
    },
    beforeCreate: function beforeCreate() {
      this._vval = null;
    },
    beforeDestroy: function beforeDestroy() {
      if (this._vval) {
        (0, _vval.patchChildren)(this._vval);
        this._vval = null;
      }
    },
    methods: {
      getModel: function getModel() {
        return this.lazyModel ? this.lazyModel(this.prop) : this.model;
      },
      getModelKey: function getModelKey(key) {
        var model = this.getModel();

        if (model) {
          return model[key];
        }
      },
      hasIter: function hasIter() {
        return false;
      }
    }
  });
  var ValidationRule = VBase.extend({
    data: function data() {
      return {
        rule: null,
        lazyModel: null,
        model: null,
        lazyParentModel: null,
        rootModel: null
      };
    },
    methods: {
      runRule: function runRule(parent) {
        var model = this.getModel();
        (0, _params.pushParams)();
        var rawOutput = this.rule.call(this.rootModel, model, parent);
        var output = isPromise(rawOutput) ? makePendingAsyncVm(Vue, rawOutput) : rawOutput;
        var rawParams = (0, _params.popParams)();
        var params = rawParams && rawParams.$sub ? rawParams.$sub.length > 1 ? rawParams : rawParams.$sub[0] : null;
        return {
          output: output,
          params: params
        };
      }
    },
    computed: {
      run: function run() {
        var _this6 = this;

        var parent = this.lazyParentModel();

        var isArrayDependant = Array.isArray(parent) && parent.__ob__;

        if (isArrayDependant) {
          var arrayDep = parent.__ob__.dep;
          arrayDep.depend();
          var target = arrayDep.constructor.target;

          if (!this._indirectWatcher) {
            var Watcher = target.constructor;
            this._indirectWatcher = new Watcher(this, function () {
              return _this6.runRule(parent);
            }, null, {
              lazy: true
            });
          }

          var model = this.getModel();

          if (!this._indirectWatcher.dirty && this._lastModel === model) {
            this._indirectWatcher.depend();

            return target.value;
          }

          this._lastModel = model;

          this._indirectWatcher.evaluate();

          this._indirectWatcher.depend();
        } else if (this._indirectWatcher) {
          this._indirectWatcher.teardown();

          this._indirectWatcher = null;
        }

        return this._indirectWatcher ? this._indirectWatcher.value : this.runRule(parent);
      },
      $params: function $params() {
        return this.run.params;
      },
      proxy: function proxy() {
        var output = this.run.output;

        if (output[__isVuelidateAsyncVm]) {
          return !!output.v;
        }

        return !!output;
      },
      $pending: function $pending() {
        var output = this.run.output;

        if (output[__isVuelidateAsyncVm]) {
          return output.p;
        }

        return false;
      }
    },
    destroyed: function destroyed() {
      if (this._indirectWatcher) {
        this._indirectWatcher.teardown();

        this._indirectWatcher = null;
      }
    }
  });
  var Validation = VBase.extend({
    data: function data() {
      return {
        dirty: false,
        validations: null,
        lazyModel: null,
        model: null,
        prop: null,
        lazyParentModel: null,
        rootModel: null
      };
    },
    methods: _objectSpread({}, validationMethods, {
      refProxy: function refProxy(key) {
        return this.getRef(key).proxy;
      },
      getRef: function getRef(key) {
        return this.refs[key];
      },
      isNested: function isNested(key) {
        return typeof this.validations[key] !== 'function';
      }
    }),
    computed: _objectSpread({}, validationGetters, {
      nestedKeys: function nestedKeys() {
        return this.keys.filter(this.isNested);
      },
      ruleKeys: function ruleKeys() {
        var _this7 = this;

        return this.keys.filter(function (k) {
          return !_this7.isNested(k);
        });
      },
      keys: function keys() {
        return Object.keys(this.validations).filter(function (k) {
          return k !== '$params';
        });
      },
      proxy: function proxy() {
        var _this8 = this;

        var keyDefs = buildFromKeys(this.keys, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this8.refProxy(key);
            }
          };
        });
        var getterDefs = buildFromKeys(getterNames, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this8[key];
            }
          };
        });
        var methodDefs = buildFromKeys(methodNames, function (key) {
          return {
            enumerable: false,
            configurable: true,
            get: function get() {
              return _this8[key];
            }
          };
        });
        var iterDefs = this.hasIter() ? {
          $iter: {
            enumerable: true,
            value: Object.defineProperties({}, _objectSpread({}, keyDefs))
          }
        } : {};
        return Object.defineProperties({}, _objectSpread({}, keyDefs, iterDefs, {
          $model: {
            enumerable: true,
            get: function get() {
              var parent = _this8.lazyParentModel();

              if (parent != null) {
                return parent[_this8.prop];
              } else {
                return null;
              }
            },
            set: function set(value) {
              var parent = _this8.lazyParentModel();

              if (parent != null) {
                parent[_this8.prop] = value;

                _this8.$touch();
              }
            }
          }
        }, getterDefs, methodDefs));
      },
      children: function children() {
        var _this9 = this;

        return _toConsumableArray(this.nestedKeys.map(function (key) {
          return renderNested(_this9, key);
        })).concat(_toConsumableArray(this.ruleKeys.map(function (key) {
          return renderRule(_this9, key);
        }))).filter(Boolean);
      }
    })
  });
  var GroupValidation = Validation.extend({
    methods: {
      isNested: function isNested(key) {
        return typeof this.validations[key]() !== 'undefined';
      },
      getRef: function getRef(key) {
        var vm = this;
        return {
          get proxy() {
            return vm.validations[key]() || false;
          }

        };
      }
    }
  });
  var EachValidation = Validation.extend({
    computed: {
      keys: function keys() {
        var model = this.getModel();

        if (isObject(model)) {
          return Object.keys(model);
        } else {
          return [];
        }
      },
      tracker: function tracker() {
        var _this10 = this;

        var trackBy = this.validations.$trackBy;
        return trackBy ? function (key) {
          return "".concat(getPath(_this10.rootModel, _this10.getModelKey(key), trackBy));
        } : function (x) {
          return "".concat(x);
        };
      },
      getModelLazy: function getModelLazy() {
        var _this11 = this;

        return function () {
          return _this11.getModel();
        };
      },
      children: function children() {
        var _this12 = this;

        var def = this.validations;
        var model = this.getModel();

        var validations = _objectSpread({}, def);

        delete validations['$trackBy'];
        var usedTracks = {};
        return this.keys.map(function (key) {
          var track = _this12.tracker(key);

          if (usedTracks.hasOwnProperty(track)) {
            return null;
          }

          usedTracks[track] = true;
          return (0, _vval.h)(Validation, track, {
            validations: validations,
            prop: key,
            lazyParentModel: _this12.getModelLazy,
            model: model[key],
            rootModel: _this12.rootModel
          });
        }).filter(Boolean);
      }
    },
    methods: {
      isNested: function isNested() {
        return true;
      },
      getRef: function getRef(key) {
        return this.refs[this.tracker(key)];
      },
      hasIter: function hasIter() {
        return true;
      }
    }
  });

  var renderNested = function renderNested(vm, key) {
    if (key === '$each') {
      return (0, _vval.h)(EachValidation, key, {
        validations: vm.validations[key],
        lazyParentModel: vm.lazyParentModel,
        prop: key,
        lazyModel: vm.getModel,
        rootModel: vm.rootModel
      });
    }

    var validations = vm.validations[key];

    if (Array.isArray(validations)) {
      var root = vm.rootModel;
      var refVals = buildFromKeys(validations, function (path) {
        return function () {
          return getPath(root, root.$v, path);
        };
      }, function (v) {
        return Array.isArray(v) ? v.join('.') : v;
      });
      return (0, _vval.h)(GroupValidation, key, {
        validations: refVals,
        lazyParentModel: NIL,
        prop: key,
        lazyModel: NIL,
        rootModel: root
      });
    }

    return (0, _vval.h)(Validation, key, {
      validations: validations,
      lazyParentModel: vm.getModel,
      prop: key,
      lazyModel: vm.getModelKey,
      rootModel: vm.rootModel
    });
  };

  var renderRule = function renderRule(vm, key) {
    return (0, _vval.h)(ValidationRule, key, {
      rule: vm.validations[key],
      lazyParentModel: vm.lazyParentModel,
      lazyModel: vm.getModel,
      rootModel: vm.rootModel
    });
  };

  _cachedComponent = {
    VBase: VBase,
    Validation: Validation
  };
  return _cachedComponent;
};

var _cachedVue = null;

function getVue(rootVm) {
  if (_cachedVue) return _cachedVue;
  var Vue = rootVm.constructor;

  while (Vue.super) {
    Vue = Vue.super;
  }

  _cachedVue = Vue;
  return Vue;
}

var validateModel = function validateModel(model, validations) {
  var Vue = getVue(model);

  var _getComponent = getComponent(Vue),
      Validation = _getComponent.Validation,
      VBase = _getComponent.VBase;

  var root = new VBase({
    computed: {
      children: function children() {
        var vals = typeof validations === 'function' ? validations.call(model) : validations;
        return [(0, _vval.h)(Validation, '$v', {
          validations: vals,
          lazyParentModel: NIL,
          prop: '$v',
          model: model,
          rootModel: model
        })];
      }
    }
  });
  return root;
};

var validationMixin = {
  data: function data() {
    var vals = this.$options.validations;

    if (vals) {
      this._vuelidate = validateModel(this, vals);
    }

    return {};
  },
  beforeCreate: function beforeCreate() {
    var options = this.$options;
    var vals = options.validations;
    if (!vals) return;
    if (!options.computed) options.computed = {};
    if (options.computed.$v) return;

    options.computed.$v = function () {
      return this._vuelidate ? this._vuelidate.refs.$v.proxy : null;
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this._vuelidate) {
      this._vuelidate.$destroy();

      this._vuelidate = null;
    }
  }
};
exports.validationMixin = validationMixin;

function Vuelidate(Vue) {
  Vue.mixin(validationMixin);
}

var _default = Vuelidate;
exports.default = _default;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patchChildren = patchChildren;
exports.h = h;

function isUndef(v) {
  return v === null || v === undefined;
}

function isDef(v) {
  return v !== null && v !== undefined;
}

function sameVval(oldVval, vval) {
  return vval.tag === oldVval.tag && vval.key === oldVval.key;
}

function createVm(vval) {
  var Vm = vval.tag;
  vval.vm = new Vm({
    data: vval.args
  });
}

function updateVval(vval) {
  var keys = Object.keys(vval.args);

  for (var i = 0; i < keys.length; i++) {
    keys.forEach(function (k) {
      vval.vm[k] = vval.args[k];
    });
  }
}

function createKeyToOldIdx(children, beginIdx, endIdx) {
  var i, key;
  var map = {};

  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) map[key] = i;
  }

  return map;
}

function updateChildren(oldCh, newCh) {
  var oldStartIdx = 0;
  var newStartIdx = 0;
  var oldEndIdx = oldCh.length - 1;
  var oldStartVval = oldCh[0];
  var oldEndVval = oldCh[oldEndIdx];
  var newEndIdx = newCh.length - 1;
  var newStartVval = newCh[0];
  var newEndVval = newCh[newEndIdx];
  var oldKeyToIdx, idxInOld, elmToMove;

  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (isUndef(oldStartVval)) {
      oldStartVval = oldCh[++oldStartIdx];
    } else if (isUndef(oldEndVval)) {
      oldEndVval = oldCh[--oldEndIdx];
    } else if (sameVval(oldStartVval, newStartVval)) {
      patchVval(oldStartVval, newStartVval);
      oldStartVval = oldCh[++oldStartIdx];
      newStartVval = newCh[++newStartIdx];
    } else if (sameVval(oldEndVval, newEndVval)) {
      patchVval(oldEndVval, newEndVval);
      oldEndVval = oldCh[--oldEndIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldStartVval, newEndVval)) {
      patchVval(oldStartVval, newEndVval);
      oldStartVval = oldCh[++oldStartIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldEndVval, newStartVval)) {
      patchVval(oldEndVval, newStartVval);
      oldEndVval = oldCh[--oldEndIdx];
      newStartVval = newCh[++newStartIdx];
    } else {
      if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
      idxInOld = isDef(newStartVval.key) ? oldKeyToIdx[newStartVval.key] : null;

      if (isUndef(idxInOld)) {
        createVm(newStartVval);
        newStartVval = newCh[++newStartIdx];
      } else {
        elmToMove = oldCh[idxInOld];

        if (sameVval(elmToMove, newStartVval)) {
          patchVval(elmToMove, newStartVval);
          oldCh[idxInOld] = undefined;
          newStartVval = newCh[++newStartIdx];
        } else {
          createVm(newStartVval);
          newStartVval = newCh[++newStartIdx];
        }
      }
    }
  }

  if (oldStartIdx > oldEndIdx) {
    addVvals(newCh, newStartIdx, newEndIdx);
  } else if (newStartIdx > newEndIdx) {
    removeVvals(oldCh, oldStartIdx, oldEndIdx);
  }
}

function addVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    createVm(vvals[startIdx]);
  }
}

function removeVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    var ch = vvals[startIdx];

    if (isDef(ch)) {
      ch.vm.$destroy();
      ch.vm = null;
    }
  }
}

function patchVval(oldVval, vval) {
  if (oldVval === vval) {
    return;
  }

  vval.vm = oldVval.vm;
  updateVval(vval);
}

function patchChildren(oldCh, ch) {
  if (isDef(oldCh) && isDef(ch)) {
    if (oldCh !== ch) updateChildren(oldCh, ch);
  } else if (isDef(ch)) {
    addVvals(ch, 0, ch.length - 1);
  } else if (isDef(oldCh)) {
    removeVvals(oldCh, 0, oldCh.length - 1);
  }
}

function h(tag, key, args) {
  return {
    tag: tag,
    key: key,
    args: args
  };
}

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(17);




__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(undefined, function (error) {
  var originalRequest = error.config;
  if (error.response.status === 401 && !originalRequest._retry && __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.refresh_token) {
    originalRequest._retry = true;

    var payload = {
      refresh_token: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.refresh_token
    };

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAddress + 'token/refresh', payload).then(function (response) {
      var auth = response.data;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common["Authorization"] = "Bearer " + auth.access_token;
      originalRequest.headers["Authorization"] = "Bearer " + auth.access_token;
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit("loginSuccess", auth);
      return __WEBPACK_IMPORTED_MODULE_0_axios___default()(originalRequest);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit("logout");
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/"
      });
      delete __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common["Authorization"];
      return Promise.reject(error);
    });
  }

  return Promise.reject(error);
});

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("vue-autofocus-directive",[],t):"object"==typeof exports?exports["vue-autofocus-directive"]=t():e["vue-autofocus-directive"]=t()}(window,function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var r=t[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(o,r,function(t){return e[t]}.bind(null,r));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=0)}([function(e,t,n){"use strict";n.r(t);t.default={inserted:function(e){e.focus()}}}])});

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(183);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("1bb891f9", content, true, {});

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "/*!\n * Bootstrap v4.0.0 (https://getbootstrap.com)\n * Copyright 2011-2018 The Bootstrap Authors\n * Copyright 2011-2018 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */:root{--blue:#007bff;--indigo:#6610f2;--purple:#6f42c1;--pink:#e83e8c;--red:#dc3545;--orange:#fd7e14;--yellow:#ffc107;--green:#28a745;--teal:#20c997;--cyan:#17a2b8;--white:#fff;--gray:#6c757d;--gray-dark:#343a40;--primary:#007bff;--secondary:#6c757d;--success:#28a745;--info:#17a2b8;--warning:#ffc107;--danger:#dc3545;--light:#f8f9fa;--dark:#343a40;--breakpoint-xs:0;--breakpoint-sm:576px;--breakpoint-md:768px;--breakpoint-lg:992px;--breakpoint-xl:1200px;--font-family-sans-serif:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";--font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}*,:after,:before{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:transparent}@-ms-viewport{width:device-width}article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}[tabindex=\"-1\"]:focus{outline:0!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}p{margin-top:0;margin-bottom:1rem}abbr[data-original-title],abbr[title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0}address{font-style:normal;line-height:inherit}address,dl,ol,ul{margin-bottom:1rem}dl,ol,ul{margin-top:0}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}dfn{font-style:italic}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#007bff;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects}a:hover{color:#0056b3;text-decoration:underline}a:not([href]):not([tabindex]),a:not([href]):not([tabindex]):focus,a:not([href]):not([tabindex]):hover{color:inherit;text-decoration:none}a:not([href]):not([tabindex]):focus{outline:0}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg:not(:root){overflow:hidden}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th{text-align:inherit}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=date],input[type=datetime-local],input[type=month],input[type=time]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.2;color:inherit}.h1,h1{font-size:2.5rem}.h2,h2{font-size:2rem}.h3,h3{font-size:1.75rem}.h4,h4{font-size:1.5rem}.h5,h5{font-size:1.25rem}.h6,h6{font-size:1rem}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:6rem}.display-1,.display-2{font-weight:300;line-height:1.2}.display-2{font-size:5.5rem}.display-3{font-size:4.5rem}.display-3,.display-4{font-weight:300;line-height:1.2}.display-4{font-size:3.5rem}hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:90%;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote-footer{display:block;font-size:80%;color:#6c757d}.blockquote-footer:before{content:\"\\2014   \\A0\"}.img-fluid,.img-thumbnail{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#6c757d}code,kbd,pre,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}code{font-size:87.5%;color:#e83e8c;word-break:break-word}a>code{color:inherit}kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container{max-width:540px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:960px}}@media (min-width:1200px){.container{max-width:1140px}}.container-fluid{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-auto,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-auto,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-auto,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-auto{position:relative;width:100%;min-height:1px;padding-right:15px;padding-left:15px}.col{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-1,.col-auto{-webkit-box-flex:0}.col-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-2,.col-3{-webkit-box-flex:0}.col-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-4,.col-5{-webkit-box-flex:0}.col-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-6,.col-7{-webkit-box-flex:0}.col-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-8,.col-9{-webkit-box-flex:0}.col-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-10,.col-11{-webkit-box-flex:0}.col-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-12{-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-first{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.order-last{-webkit-box-ordinal-group:14;-ms-flex-order:13;order:13}.order-0{-webkit-box-ordinal-group:1;-ms-flex-order:0;order:0}.order-1{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.order-2{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.order-3{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.order-4{-webkit-box-ordinal-group:5;-ms-flex-order:4;order:4}.order-5{-webkit-box-ordinal-group:6;-ms-flex-order:5;order:5}.order-6{-webkit-box-ordinal-group:7;-ms-flex-order:6;order:6}.order-7{-webkit-box-ordinal-group:8;-ms-flex-order:7;order:7}.order-8{-webkit-box-ordinal-group:9;-ms-flex-order:8;order:8}.order-9{-webkit-box-ordinal-group:10;-ms-flex-order:9;order:9}.order-10{-webkit-box-ordinal-group:11;-ms-flex-order:10;order:10}.order-11{-webkit-box-ordinal-group:12;-ms-flex-order:11;order:11}.order-12{-webkit-box-ordinal-group:13;-ms-flex-order:12;order:12}.offset-1{margin-left:8.333333%}.offset-2{margin-left:16.666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.333333%}.offset-5{margin-left:41.666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.333333%}.offset-8{margin-left:66.666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.333333%}.offset-11{margin-left:91.666667%}@media (min-width:576px){.col-sm{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-sm-auto{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-sm-1{-webkit-box-flex:0;-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-sm-2{-webkit-box-flex:0;-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-sm-3{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-sm-4{-webkit-box-flex:0;-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-sm-5{-webkit-box-flex:0;-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-sm-6{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-sm-7{-webkit-box-flex:0;-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-sm-8{-webkit-box-flex:0;-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-sm-9{-webkit-box-flex:0;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-sm-10{-webkit-box-flex:0;-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-sm-11{-webkit-box-flex:0;-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-sm-12{-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-sm-first{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.order-sm-last{-webkit-box-ordinal-group:14;-ms-flex-order:13;order:13}.order-sm-0{-webkit-box-ordinal-group:1;-ms-flex-order:0;order:0}.order-sm-1{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.order-sm-2{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.order-sm-3{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.order-sm-4{-webkit-box-ordinal-group:5;-ms-flex-order:4;order:4}.order-sm-5{-webkit-box-ordinal-group:6;-ms-flex-order:5;order:5}.order-sm-6{-webkit-box-ordinal-group:7;-ms-flex-order:6;order:6}.order-sm-7{-webkit-box-ordinal-group:8;-ms-flex-order:7;order:7}.order-sm-8{-webkit-box-ordinal-group:9;-ms-flex-order:8;order:8}.order-sm-9{-webkit-box-ordinal-group:10;-ms-flex-order:9;order:9}.order-sm-10{-webkit-box-ordinal-group:11;-ms-flex-order:10;order:10}.order-sm-11{-webkit-box-ordinal-group:12;-ms-flex-order:11;order:11}.order-sm-12{-webkit-box-ordinal-group:13;-ms-flex-order:12;order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.333333%}.offset-sm-2{margin-left:16.666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.333333%}.offset-sm-5{margin-left:41.666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.333333%}.offset-sm-8{margin-left:66.666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.333333%}.offset-sm-11{margin-left:91.666667%}}@media (min-width:768px){.col-md{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-md-auto{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-md-1{-webkit-box-flex:0;-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-md-2{-webkit-box-flex:0;-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-3{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-md-4{-webkit-box-flex:0;-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-md-5{-webkit-box-flex:0;-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-md-6{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-md-7{-webkit-box-flex:0;-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-md-8{-webkit-box-flex:0;-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-md-9{-webkit-box-flex:0;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-md-10{-webkit-box-flex:0;-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-md-11{-webkit-box-flex:0;-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-md-12{-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-md-first{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.order-md-last{-webkit-box-ordinal-group:14;-ms-flex-order:13;order:13}.order-md-0{-webkit-box-ordinal-group:1;-ms-flex-order:0;order:0}.order-md-1{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.order-md-2{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.order-md-3{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.order-md-4{-webkit-box-ordinal-group:5;-ms-flex-order:4;order:4}.order-md-5{-webkit-box-ordinal-group:6;-ms-flex-order:5;order:5}.order-md-6{-webkit-box-ordinal-group:7;-ms-flex-order:6;order:6}.order-md-7{-webkit-box-ordinal-group:8;-ms-flex-order:7;order:7}.order-md-8{-webkit-box-ordinal-group:9;-ms-flex-order:8;order:8}.order-md-9{-webkit-box-ordinal-group:10;-ms-flex-order:9;order:9}.order-md-10{-webkit-box-ordinal-group:11;-ms-flex-order:10;order:10}.order-md-11{-webkit-box-ordinal-group:12;-ms-flex-order:11;order:11}.order-md-12{-webkit-box-ordinal-group:13;-ms-flex-order:12;order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.333333%}.offset-md-2{margin-left:16.666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.333333%}.offset-md-5{margin-left:41.666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.333333%}.offset-md-8{margin-left:66.666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.333333%}.offset-md-11{margin-left:91.666667%}}@media (min-width:992px){.col-lg{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-lg-auto{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-lg-1{-webkit-box-flex:0;-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-lg-2{-webkit-box-flex:0;-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-lg-3{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-lg-4{-webkit-box-flex:0;-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-lg-5{-webkit-box-flex:0;-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-lg-6{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-lg-7{-webkit-box-flex:0;-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-lg-8{-webkit-box-flex:0;-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-lg-9{-webkit-box-flex:0;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-lg-10{-webkit-box-flex:0;-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-lg-11{-webkit-box-flex:0;-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-lg-12{-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-lg-first{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.order-lg-last{-webkit-box-ordinal-group:14;-ms-flex-order:13;order:13}.order-lg-0{-webkit-box-ordinal-group:1;-ms-flex-order:0;order:0}.order-lg-1{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.order-lg-2{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.order-lg-3{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.order-lg-4{-webkit-box-ordinal-group:5;-ms-flex-order:4;order:4}.order-lg-5{-webkit-box-ordinal-group:6;-ms-flex-order:5;order:5}.order-lg-6{-webkit-box-ordinal-group:7;-ms-flex-order:6;order:6}.order-lg-7{-webkit-box-ordinal-group:8;-ms-flex-order:7;order:7}.order-lg-8{-webkit-box-ordinal-group:9;-ms-flex-order:8;order:8}.order-lg-9{-webkit-box-ordinal-group:10;-ms-flex-order:9;order:9}.order-lg-10{-webkit-box-ordinal-group:11;-ms-flex-order:10;order:10}.order-lg-11{-webkit-box-ordinal-group:12;-ms-flex-order:11;order:11}.order-lg-12{-webkit-box-ordinal-group:13;-ms-flex-order:12;order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.333333%}.offset-lg-2{margin-left:16.666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.333333%}.offset-lg-5{margin-left:41.666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.333333%}.offset-lg-8{margin-left:66.666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.333333%}.offset-lg-11{margin-left:91.666667%}}@media (min-width:1200px){.col-xl{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-xl-auto{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-xl-1{-webkit-box-flex:0;-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-xl-2{-webkit-box-flex:0;-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-xl-3{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-xl-4{-webkit-box-flex:0;-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-xl-5{-webkit-box-flex:0;-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-xl-6{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-xl-7{-webkit-box-flex:0;-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-xl-8{-webkit-box-flex:0;-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-xl-9{-webkit-box-flex:0;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-xl-10{-webkit-box-flex:0;-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-xl-11{-webkit-box-flex:0;-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-xl-12{-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-xl-first{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.order-xl-last{-webkit-box-ordinal-group:14;-ms-flex-order:13;order:13}.order-xl-0{-webkit-box-ordinal-group:1;-ms-flex-order:0;order:0}.order-xl-1{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.order-xl-2{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.order-xl-3{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.order-xl-4{-webkit-box-ordinal-group:5;-ms-flex-order:4;order:4}.order-xl-5{-webkit-box-ordinal-group:6;-ms-flex-order:5;order:5}.order-xl-6{-webkit-box-ordinal-group:7;-ms-flex-order:6;order:6}.order-xl-7{-webkit-box-ordinal-group:8;-ms-flex-order:7;order:7}.order-xl-8{-webkit-box-ordinal-group:9;-ms-flex-order:8;order:8}.order-xl-9{-webkit-box-ordinal-group:10;-ms-flex-order:9;order:9}.order-xl-10{-webkit-box-ordinal-group:11;-ms-flex-order:10;order:10}.order-xl-11{-webkit-box-ordinal-group:12;-ms-flex-order:11;order:11}.order-xl-12{-webkit-box-ordinal-group:13;-ms-flex-order:12;order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.333333%}.offset-xl-2{margin-left:16.666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.333333%}.offset-xl-5{margin-left:41.666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.333333%}.offset-xl-8{margin-left:66.666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.333333%}.offset-xl-11{margin-left:91.666667%}}.table{width:100%;max-width:100%;margin-bottom:1rem;background-color:transparent}.table td,.table th{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table .table{background-color:#fff}.table-sm td,.table-sm th{padding:.3rem}.table-bordered,.table-bordered td,.table-bordered th{border:1px solid #dee2e6}.table-bordered thead td,.table-bordered thead th{border-bottom-width:2px}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-hover tbody tr:hover{background-color:rgba(0,0,0,.075)}.table-primary,.table-primary>td,.table-primary>th{background-color:#b8daff}.table-hover .table-primary:hover,.table-hover .table-primary:hover>td,.table-hover .table-primary:hover>th{background-color:#9fcdff}.table-secondary,.table-secondary>td,.table-secondary>th{background-color:#d6d8db}.table-hover .table-secondary:hover,.table-hover .table-secondary:hover>td,.table-hover .table-secondary:hover>th{background-color:#c8cbcf}.table-success,.table-success>td,.table-success>th{background-color:#c3e6cb}.table-hover .table-success:hover,.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#b1dfbb}.table-info,.table-info>td,.table-info>th{background-color:#bee5eb}.table-hover .table-info:hover,.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#abdde5}.table-warning,.table-warning>td,.table-warning>th{background-color:#ffeeba}.table-hover .table-warning:hover,.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#ffe8a1}.table-danger,.table-danger>td,.table-danger>th{background-color:#f5c6cb}.table-hover .table-danger:hover,.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#f1b0b7}.table-light,.table-light>td,.table-light>th{background-color:#fdfdfe}.table-hover .table-light:hover,.table-hover .table-light:hover>td,.table-hover .table-light:hover>th{background-color:#ececf6}.table-dark,.table-dark>td,.table-dark>th{background-color:#c6c8ca}.table-hover .table-dark:hover,.table-hover .table-dark:hover>td,.table-hover .table-dark:hover>th{background-color:#b9bbbe}.table-active,.table-active>td,.table-active>th,.table-hover .table-active:hover,.table-hover .table-active:hover>td,.table-hover .table-active:hover>th{background-color:rgba(0,0,0,.075)}.table .thead-dark th{color:#fff;background-color:#212529;border-color:#32383e}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#212529}.table-dark td,.table-dark th,.table-dark thead th{border-color:#32383e}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:hsla(0,0%,100%,.05)}.table-dark.table-hover tbody tr:hover{background-color:hsla(0,0%,100%,.075)}@media (max-width:575.98px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-sm>.table-bordered{border:0}}@media (max-width:767.98px){.table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-md>.table-bordered{border:0}}@media (max-width:991.98px){.table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-lg>.table-bordered{border:0}}@media (max-width:1199.98px){.table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-xl>.table-bordered{border:0}}.table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive>.table-bordered{border:0}.form-control{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.form-control::-webkit-input-placeholder{color:#6c757d;opacity:1}.form-control::-moz-placeholder{color:#6c757d;opacity:1}.form-control:-ms-input-placeholder,.form-control::-ms-input-placeholder{color:#6c757d;opacity:1}.form-control::placeholder{color:#6c757d;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#e9ecef;opacity:1}select.form-control:not([size]):not([multiple]){height:calc(2.25rem + 2px)}select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file,.form-control-range{display:block;width:100%}.col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.form-control-plaintext{display:block;width:100%;padding-top:.375rem;padding-bottom:.375rem;margin-bottom:0;line-height:1.5;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm,.input-group-lg>.form-control-plaintext.form-control,.input-group-lg>.input-group-append>.form-control-plaintext.btn,.input-group-lg>.input-group-append>.form-control-plaintext.input-group-text,.input-group-lg>.input-group-prepend>.form-control-plaintext.btn,.input-group-lg>.input-group-prepend>.form-control-plaintext.input-group-text,.input-group-sm>.form-control-plaintext.form-control,.input-group-sm>.input-group-append>.form-control-plaintext.btn,.input-group-sm>.input-group-append>.form-control-plaintext.input-group-text,.input-group-sm>.input-group-prepend>.form-control-plaintext.btn,.input-group-sm>.input-group-prepend>.form-control-plaintext.input-group-text{padding-right:0;padding-left:0}.form-control-sm,.input-group-sm>.form-control,.input-group-sm>.input-group-append>.btn,.input-group-sm>.input-group-append>.input-group-text,.input-group-sm>.input-group-prepend>.btn,.input-group-sm>.input-group-prepend>.input-group-text{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.input-group-sm>.input-group-append>select.btn:not([size]):not([multiple]),.input-group-sm>.input-group-append>select.input-group-text:not([size]):not([multiple]),.input-group-sm>.input-group-prepend>select.btn:not([size]):not([multiple]),.input-group-sm>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),.input-group-sm>select.form-control:not([size]):not([multiple]),select.form-control-sm:not([size]):not([multiple]){height:calc(1.8125rem + 2px)}.form-control-lg,.input-group-lg>.form-control,.input-group-lg>.input-group-append>.btn,.input-group-lg>.input-group-append>.input-group-text,.input-group-lg>.input-group-prepend>.btn,.input-group-lg>.input-group-prepend>.input-group-text{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.input-group-lg>.input-group-append>select.btn:not([size]):not([multiple]),.input-group-lg>.input-group-append>select.input-group-text:not([size]):not([multiple]),.input-group-lg>.input-group-prepend>select.btn:not([size]):not([multiple]),.input-group-lg>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),.input-group-lg>select.form-control:not([size]):not([multiple]),select.form-control-lg:not([size]):not([multiple]){height:calc(2.875rem + 2px)}.form-group{margin-bottom:1rem}.form-text{display:block;margin-top:.25rem}.form-row{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row>.col,.form-row>[class*=col-]{padding-right:5px;padding-left:5px}.form-check{position:relative;display:block;padding-left:1.25rem}.form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.form-check-input:disabled~.form-check-label{color:#6c757d}.form-check-label{margin-bottom:0}.form-check-inline{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:0;margin-right:.75rem}.form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.valid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.5rem;margin-top:.1rem;font-size:.875rem;line-height:1;color:#fff;background-color:rgba(40,167,69,.8);border-radius:.2rem}.custom-select.is-valid,.form-control.is-valid,.was-validated .custom-select:valid,.was-validated .form-control:valid{border-color:#28a745}.custom-select.is-valid:focus,.form-control.is-valid:focus,.was-validated .custom-select:valid:focus,.was-validated .form-control:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.custom-select.is-valid~.valid-feedback,.custom-select.is-valid~.valid-tooltip,.form-control.is-valid~.valid-feedback,.form-control.is-valid~.valid-tooltip,.was-validated .custom-select:valid~.valid-feedback,.was-validated .custom-select:valid~.valid-tooltip,.was-validated .form-control:valid~.valid-feedback,.was-validated .form-control:valid~.valid-tooltip{display:block}.form-check-input.is-valid~.form-check-label,.was-validated .form-check-input:valid~.form-check-label{color:#28a745}.form-check-input.is-valid~.valid-feedback,.form-check-input.is-valid~.valid-tooltip,.was-validated .form-check-input:valid~.valid-feedback,.was-validated .form-check-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid~.custom-control-label,.was-validated .custom-control-input:valid~.custom-control-label{color:#28a745}.custom-control-input.is-valid~.custom-control-label:before,.was-validated .custom-control-input:valid~.custom-control-label:before{background-color:#71dd8a}.custom-control-input.is-valid~.valid-feedback,.custom-control-input.is-valid~.valid-tooltip,.was-validated .custom-control-input:valid~.valid-feedback,.was-validated .custom-control-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid:checked~.custom-control-label:before,.was-validated .custom-control-input:valid:checked~.custom-control-label:before{background-color:#34ce57}.custom-control-input.is-valid:focus~.custom-control-label:before,.was-validated .custom-control-input:valid:focus~.custom-control-label:before{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(40,167,69,.25)}.custom-file-input.is-valid~.custom-file-label,.was-validated .custom-file-input:valid~.custom-file-label{border-color:#28a745}.custom-file-input.is-valid~.custom-file-label:before,.was-validated .custom-file-input:valid~.custom-file-label:before{border-color:inherit}.custom-file-input.is-valid~.valid-feedback,.custom-file-input.is-valid~.valid-tooltip,.was-validated .custom-file-input:valid~.valid-feedback,.was-validated .custom-file-input:valid~.valid-tooltip{display:block}.custom-file-input.is-valid:focus~.custom-file-label,.was-validated .custom-file-input:valid:focus~.custom-file-label{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.invalid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.5rem;margin-top:.1rem;font-size:.875rem;line-height:1;color:#fff;background-color:rgba(220,53,69,.8);border-radius:.2rem}.custom-select.is-invalid,.form-control.is-invalid,.was-validated .custom-select:invalid,.was-validated .form-control:invalid{border-color:#dc3545}.custom-select.is-invalid:focus,.form-control.is-invalid:focus,.was-validated .custom-select:invalid:focus,.was-validated .form-control:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.custom-select.is-invalid~.invalid-feedback,.custom-select.is-invalid~.invalid-tooltip,.form-control.is-invalid~.invalid-feedback,.form-control.is-invalid~.invalid-tooltip,.was-validated .custom-select:invalid~.invalid-feedback,.was-validated .custom-select:invalid~.invalid-tooltip,.was-validated .form-control:invalid~.invalid-feedback,.was-validated .form-control:invalid~.invalid-tooltip{display:block}.form-check-input.is-invalid~.form-check-label,.was-validated .form-check-input:invalid~.form-check-label{color:#dc3545}.form-check-input.is-invalid~.invalid-feedback,.form-check-input.is-invalid~.invalid-tooltip,.was-validated .form-check-input:invalid~.invalid-feedback,.was-validated .form-check-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid~.custom-control-label,.was-validated .custom-control-input:invalid~.custom-control-label{color:#dc3545}.custom-control-input.is-invalid~.custom-control-label:before,.was-validated .custom-control-input:invalid~.custom-control-label:before{background-color:#efa2a9}.custom-control-input.is-invalid~.invalid-feedback,.custom-control-input.is-invalid~.invalid-tooltip,.was-validated .custom-control-input:invalid~.invalid-feedback,.was-validated .custom-control-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid:checked~.custom-control-label:before,.was-validated .custom-control-input:invalid:checked~.custom-control-label:before{background-color:#e4606d}.custom-control-input.is-invalid:focus~.custom-control-label:before,.was-validated .custom-control-input:invalid:focus~.custom-control-label:before{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(220,53,69,.25)}.custom-file-input.is-invalid~.custom-file-label,.was-validated .custom-file-input:invalid~.custom-file-label{border-color:#dc3545}.custom-file-input.is-invalid~.custom-file-label:before,.was-validated .custom-file-input:invalid~.custom-file-label:before{border-color:inherit}.custom-file-input.is-invalid~.invalid-feedback,.custom-file-input.is-invalid~.invalid-tooltip,.was-validated .custom-file-input:invalid~.invalid-feedback,.was-validated .custom-file-input:invalid~.invalid-tooltip{display:block}.custom-file-input.is-invalid:focus~.custom-file-label,.was-validated .custom-file-input:invalid:focus~.custom-file-label{box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-inline{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.form-inline .form-check{width:100%}@media (min-width:576px){.form-inline label{-ms-flex-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.form-inline .form-group,.form-inline label{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;align-items:center;margin-bottom:0}.form-inline .form-group{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-plaintext{display:inline-block}.form-inline .input-group{width:auto}.form-inline .form-check{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-left:0}.form-inline .form-check-input{position:relative;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline .custom-control{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.form-inline .custom-control-label{margin-bottom:0}}.btn{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.btn:focus,.btn:hover{text-decoration:none}.btn.focus,.btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn.disabled,.btn:disabled{opacity:.65}.btn:not(:disabled):not(.disabled){cursor:pointer}.btn:not(:disabled):not(.disabled).active,.btn:not(:disabled):not(.disabled):active{background-image:none}a.btn.disabled,fieldset:disabled a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}.btn-primary.focus,.btn-primary:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-primary.disabled,.btn-primary:disabled{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:not(:disabled):not(.disabled).active,.btn-primary:not(:disabled):not(.disabled):active,.show>.btn-primary.dropdown-toggle{color:#fff;background-color:#0062cc;border-color:#005cbf}.btn-primary:not(:disabled):not(.disabled).active:focus,.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-secondary{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary:hover{color:#fff;background-color:#5a6268;border-color:#545b62}.btn-secondary.focus,.btn-secondary:focus{box-shadow:0 0 0 .2rem hsla(208,7%,46%,.5)}.btn-secondary.disabled,.btn-secondary:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary:not(:disabled):not(.disabled).active,.btn-secondary:not(:disabled):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{color:#fff;background-color:#545b62;border-color:#4e555b}.btn-secondary:not(:disabled):not(.disabled).active:focus,.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(208,7%,46%,.5)}.btn-success{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:hover{color:#fff;background-color:#218838;border-color:#1e7e34}.btn-success.focus,.btn-success:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-success.disabled,.btn-success:disabled{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:not(:disabled):not(.disabled).active,.btn-success:not(:disabled):not(.disabled):active,.show>.btn-success.dropdown-toggle{color:#fff;background-color:#1e7e34;border-color:#1c7430}.btn-success:not(:disabled):not(.disabled).active:focus,.btn-success:not(:disabled):not(.disabled):active:focus,.show>.btn-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-info{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:hover{color:#fff;background-color:#138496;border-color:#117a8b}.btn-info.focus,.btn-info:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-info.disabled,.btn-info:disabled{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:not(:disabled):not(.disabled).active,.btn-info:not(:disabled):not(.disabled):active,.show>.btn-info.dropdown-toggle{color:#fff;background-color:#117a8b;border-color:#10707f}.btn-info:not(:disabled):not(.disabled).active:focus,.btn-info:not(:disabled):not(.disabled):active:focus,.show>.btn-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-warning{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:hover{color:#212529;background-color:#e0a800;border-color:#d39e00}.btn-warning.focus,.btn-warning:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-warning.disabled,.btn-warning:disabled{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:not(:disabled):not(.disabled).active,.btn-warning:not(:disabled):not(.disabled):active,.show>.btn-warning.dropdown-toggle{color:#212529;background-color:#d39e00;border-color:#c69500}.btn-warning:not(:disabled):not(.disabled).active:focus,.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:hover{color:#fff;background-color:#c82333;border-color:#bd2130}.btn-danger.focus,.btn-danger:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-danger.disabled,.btn-danger:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:not(:disabled):not(.disabled).active,.btn-danger:not(:disabled):not(.disabled):active,.show>.btn-danger.dropdown-toggle{color:#fff;background-color:#bd2130;border-color:#b21f2d}.btn-danger:not(:disabled):not(.disabled).active:focus,.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-light{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:hover{color:#212529;background-color:#e2e6ea;border-color:#dae0e5}.btn-light.focus,.btn-light:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-light.disabled,.btn-light:disabled{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:not(:disabled):not(.disabled).active,.btn-light:not(:disabled):not(.disabled):active,.show>.btn-light.dropdown-toggle{color:#212529;background-color:#dae0e5;border-color:#d3d9df}.btn-light:not(:disabled):not(.disabled).active:focus,.btn-light:not(:disabled):not(.disabled):active:focus,.show>.btn-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark.focus,.btn-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-dark.disabled,.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:not(:disabled):not(.disabled).active,.btn-dark:not(:disabled):not(.disabled):active,.show>.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark:not(:disabled):not(.disabled).active:focus,.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-primary{color:#007bff;background-color:transparent;background-image:none;border-color:#007bff}.btn-outline-primary:hover{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary.focus,.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-primary.disabled,.btn-outline-primary:disabled{color:#007bff;background-color:transparent}.btn-outline-primary:not(:disabled):not(.disabled).active,.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-secondary{color:#6c757d;background-color:transparent;background-image:none;border-color:#6c757d}.btn-outline-secondary:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary.focus,.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem hsla(208,7%,46%,.5)}.btn-outline-secondary.disabled,.btn-outline-secondary:disabled{color:#6c757d;background-color:transparent}.btn-outline-secondary:not(:disabled):not(.disabled).active,.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(208,7%,46%,.5)}.btn-outline-success{color:#28a745;background-color:transparent;background-image:none;border-color:#28a745}.btn-outline-success:hover{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success.focus,.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-success.disabled,.btn-outline-success:disabled{color:#28a745;background-color:transparent}.btn-outline-success:not(:disabled):not(.disabled).active,.btn-outline-success:not(:disabled):not(.disabled):active,.show>.btn-outline-success.dropdown-toggle{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success:not(:disabled):not(.disabled).active:focus,.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-info{color:#17a2b8;background-color:transparent;background-image:none;border-color:#17a2b8}.btn-outline-info:hover{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info.focus,.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-info.disabled,.btn-outline-info:disabled{color:#17a2b8;background-color:transparent}.btn-outline-info:not(:disabled):not(.disabled).active,.btn-outline-info:not(:disabled):not(.disabled):active,.show>.btn-outline-info.dropdown-toggle{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info:not(:disabled):not(.disabled).active:focus,.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-warning{color:#ffc107;background-color:transparent;background-image:none;border-color:#ffc107}.btn-outline-warning:hover{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning.focus,.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-warning.disabled,.btn-outline-warning:disabled{color:#ffc107;background-color:transparent}.btn-outline-warning:not(:disabled):not(.disabled).active,.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-danger{color:#dc3545;background-color:transparent;background-image:none;border-color:#dc3545}.btn-outline-danger:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger.focus,.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-danger.disabled,.btn-outline-danger:disabled{color:#dc3545;background-color:transparent}.btn-outline-danger:not(:disabled):not(.disabled).active,.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-light{color:#f8f9fa;background-color:transparent;background-image:none;border-color:#f8f9fa}.btn-outline-light:hover{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light.focus,.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-light.disabled,.btn-outline-light:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-light:not(:disabled):not(.disabled).active,.btn-outline-light:not(:disabled):not(.disabled):active,.show>.btn-outline-light.dropdown-toggle{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:not(:disabled):not(.disabled).active:focus,.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark.focus,.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-dark.disabled,.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.btn-outline-dark:not(:disabled):not(.disabled).active,.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-link{font-weight:400;color:#007bff;background-color:transparent}.btn-link:hover{color:#0056b3;background-color:transparent}.btn-link.focus,.btn-link:focus,.btn-link:hover{text-decoration:underline;border-color:transparent}.btn-link.focus,.btn-link:focus{box-shadow:none}.btn-link.disabled,.btn-link:disabled{color:#6c757d}.btn-group-lg>.btn,.btn-lg{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.show{opacity:1}.collapse{display:none}.collapse.show{display:block}tr.collapse.show{display:table-row}tbody.collapse.show{display:table-row-group}.collapsing{height:0;overflow:hidden;transition:height .35s ease}.collapsing,.dropdown,.dropup{position:relative}.dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty:after{margin-left:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropup .dropdown-menu{margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty:after{margin-left:0}.dropright .dropdown-menu{margin-top:0;margin-left:.125rem}.dropright .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright .dropdown-toggle:empty:after{margin-left:0}.dropright .dropdown-toggle:after{vertical-align:0}.dropleft .dropdown-menu{margin-top:0;margin-right:.125rem}.dropleft .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropleft .dropdown-toggle:before{display:inline-block;width:0;height:0;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft .dropdown-toggle:empty:after{margin-left:0}.dropleft .dropdown-toggle:before{vertical-align:0}.dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#16181b;text-decoration:none;background-color:#f8f9fa}.dropdown-item.active,.dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled,.dropdown-item:disabled{color:#6c757d;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.btn-group,.btn-group-vertical{position:relative;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:1}.btn-group-vertical .btn+.btn,.btn-group-vertical .btn+.btn-group,.btn-group-vertical .btn-group+.btn,.btn-group-vertical .btn-group+.btn-group,.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split:after{margin-left:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.btn-group-vertical .btn,.btn-group-vertical .btn-group{width:100%}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle>.btn,.btn-group-toggle>.btn-group>.btn{margin-bottom:0}.btn-group-toggle>.btn-group>.btn input[type=checkbox],.btn-group-toggle>.btn-group>.btn input[type=radio],.btn-group-toggle>.btn input[type=checkbox],.btn-group-toggle>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;width:100%}.input-group>.custom-file,.input-group>.custom-select,.input-group>.form-control{position:relative;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;width:1%;margin-bottom:0}.input-group>.custom-file:focus,.input-group>.custom-select:focus,.input-group>.form-control:focus{z-index:3}.input-group>.custom-file+.custom-file,.input-group>.custom-file+.custom-select,.input-group>.custom-file+.form-control,.input-group>.custom-select+.custom-file,.input-group>.custom-select+.custom-select,.input-group>.custom-select+.form-control,.input-group>.form-control+.custom-file,.input-group>.form-control+.custom-select,.input-group>.form-control+.form-control{margin-left:-1px}.input-group>.custom-select:not(:last-child),.input-group>.form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-select:not(:first-child),.input-group>.form-control:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group>.custom-file{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.input-group>.custom-file:not(:last-child) .custom-file-label,.input-group>.custom-file:not(:last-child) .custom-file-label:before{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-file:not(:first-child) .custom-file-label,.input-group>.custom-file:not(:first-child) .custom-file-label:before{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-append,.input-group-prepend{display:-webkit-box;display:-ms-flexbox;display:flex}.input-group-append .btn,.input-group-prepend .btn{position:relative;z-index:2}.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.btn,.input-group-append .input-group-text+.input-group-text,.input-group-prepend .btn+.btn,.input-group-prepend .btn+.input-group-text,.input-group-prepend .input-group-text+.btn,.input-group-prepend .input-group-text+.input-group-text{margin-left:-1px}.input-group-prepend{margin-right:-1px}.input-group-append{margin-left:-1px}.input-group-text{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text input[type=checkbox],.input-group-text input[type=radio]{margin-top:0}.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),.input-group>.input-group-append:not(:last-child)>.btn,.input-group>.input-group-append:not(:last-child)>.input-group-text,.input-group>.input-group-prepend>.btn,.input-group>.input-group-prepend>.input-group-text{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.btn,.input-group>.input-group-append>.input-group-text,.input-group>.input-group-prepend:first-child>.btn:not(:first-child),.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),.input-group>.input-group-prepend:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.input-group-text{border-top-left-radius:0;border-bottom-left-radius:0}.custom-control{position:relative;display:block;min-height:1.5rem;padding-left:1.5rem}.custom-control-inline{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-right:1rem}.custom-control-input{position:absolute;z-index:-1;opacity:0}.custom-control-input:checked~.custom-control-label:before{color:#fff;background-color:#007bff}.custom-control-input:focus~.custom-control-label:before{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:active~.custom-control-label:before{color:#fff;background-color:#b3d7ff}.custom-control-input:disabled~.custom-control-label{color:#6c757d}.custom-control-input:disabled~.custom-control-label:before{background-color:#e9ecef}.custom-control-label{margin-bottom:0}.custom-control-label:before{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#dee2e6}.custom-control-label:after,.custom-control-label:before{position:absolute;top:.25rem;left:0;display:block;width:1rem;height:1rem;content:\"\"}.custom-control-label:after{background-repeat:no-repeat;background-position:50%;background-size:50% 50%}.custom-checkbox .custom-control-label:before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label:before{background-color:#007bff}.custom-checkbox .custom-control-input:checked~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label:before{background-color:#007bff}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\")}.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label:before{background-color:rgba(0,123,255,.5)}.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label:before{background-color:rgba(0,123,255,.5)}.custom-radio .custom-control-label:before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label:before{background-color:#007bff}.custom-radio .custom-control-input:checked~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.custom-radio .custom-control-input:disabled:checked~.custom-control-label:before{background-color:rgba(0,123,255,.5)}.custom-select{display:inline-block;width:100%;height:calc(2.25rem + 2px);padding:.375rem 1.75rem .375rem .75rem;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right .75rem center;background-size:8px 10px;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;box-shadow:inset 0 1px 2px rgba(0,0,0,.075),0 0 5px rgba(128,189,255,.5)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#6c757d;background-color:#e9ecef}.custom-select::-ms-expand{opacity:0}.custom-select-sm{height:calc(1.8125rem + 2px);font-size:75%}.custom-select-lg,.custom-select-sm{padding-top:.375rem;padding-bottom:.375rem}.custom-select-lg{height:calc(2.875rem + 2px);font-size:125%}.custom-file{display:inline-block;margin-bottom:0}.custom-file,.custom-file-input{position:relative;width:100%;height:calc(2.25rem + 2px)}.custom-file-input{z-index:2;margin:0;opacity:0}.custom-file-input:focus~.custom-file-control{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input:focus~.custom-file-control:before{border-color:#80bdff}.custom-file-input:lang(en)~.custom-file-label:after{content:\"Browse\"}.custom-file-label{left:0;z-index:1;height:calc(2.25rem + 2px);background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.custom-file-label,.custom-file-label:after{position:absolute;top:0;right:0;padding:.375rem .75rem;line-height:1.5;color:#495057}.custom-file-label:after{bottom:0;z-index:3;display:block;height:calc((2.25rem + 2px) - 1px * 2);content:\"Browse\";background-color:#e9ecef;border-left:1px solid #ced4da;border-radius:0 .25rem .25rem 0}.nav{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:.5rem 1rem}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#6c757d}.nav-tabs{border-bottom:1px solid #dee2e6}.nav-tabs .nav-item{margin-bottom:-1px}.nav-tabs .nav-link{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link{border-radius:.25rem}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.nav-fill .nav-item{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;text-align:center}.nav-justified .nav-item{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:center}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;padding:.5rem 1rem}.navbar,.navbar>.container,.navbar>.container-fluid{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-nav{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu{position:static;float:none}.navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse{-ms-flex-preferred-size:100%;flex-basis:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-toggler:not(:disabled):not(.disabled){cursor:pointer}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:no-repeat 50%;background-size:100% 100%}@media (max-width:575.98px){.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-sm,.navbar-expand-sm .navbar-nav{-webkit-box-orient:horizontal;-webkit-box-direction:normal}.navbar-expand-sm .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-sm .navbar-collapse{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}.navbar-expand-sm .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:767.98px){.navbar-expand-md>.container,.navbar-expand-md>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-md,.navbar-expand-md .navbar-nav{-webkit-box-orient:horizontal;-webkit-box-direction:normal}.navbar-expand-md .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md>.container,.navbar-expand-md>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-md .navbar-collapse{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}.navbar-expand-md .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:991.98px){.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-lg,.navbar-expand-lg .navbar-nav{-webkit-box-orient:horizontal;-webkit-box-direction:normal}.navbar-expand-lg .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-lg .navbar-collapse{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}.navbar-expand-lg .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:1199.98px){.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-xl,.navbar-expand-xl .navbar-nav{-webkit-box-orient:horizontal;-webkit-box-direction:normal}.navbar-expand-xl .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-xl .navbar-collapse{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}.navbar-expand-xl .dropup .dropdown-menu{top:auto;bottom:100%}}.navbar-expand{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand>.container,.navbar-expand>.container-fluid{padding-right:0;padding-left:0}.navbar-expand .navbar-nav{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand>.container,.navbar-expand>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand .navbar-collapse{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-expand .dropup .dropdown-menu{top:auto;bottom:100%}.navbar-light .navbar-brand,.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.show,.navbar-light .navbar-nav .show>.nav-link{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text{color:rgba(0,0,0,.5)}.navbar-light .navbar-text a,.navbar-light .navbar-text a:focus,.navbar-light .navbar-text a:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand,.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:hsla(0,0%,100%,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .show>.nav-link{color:#fff}.navbar-dark .navbar-toggler{color:hsla(0,0%,100%,.5);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text{color:hsla(0,0%,100%,.5)}.navbar-dark .navbar-text a,.navbar-dark .navbar-text a:focus,.navbar-dark .navbar-text a:hover{color:#fff}.card{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr{margin-right:0;margin-left:0}.card>.list-group:first-child .list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-body{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;padding:1.25rem}.card-title{margin-bottom:.75rem}.card-subtitle{margin-top:-.375rem}.card-subtitle,.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:1.25rem}.card-header{padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-header+.list-group .list-group-item:first-child{border-top:0}.card-footer{padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs{margin-bottom:-.75rem;border-bottom:0}.card-header-pills,.card-header-tabs{margin-right:-.625rem;margin-left:-.625rem}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.card-img{width:100%;border-radius:calc(.25rem - 1px)}.card-img-top{width:100%;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom{width:100%;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-deck{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.card-deck .card{margin-bottom:15px}@media (min-width:576px){.card-deck{-webkit-box-orient:horizontal;-ms-flex-flow:row wrap;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck,.card-deck .card{-webkit-box-direction:normal}.card-deck .card{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 0 0%;flex:1 0 0%;-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.card-group>.card{margin-bottom:15px}@media (min-width:576px){.card-group{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.card-group>.card{-webkit-box-flex:1;-ms-flex:1 0 0%;flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:first-child .card-header,.card-group>.card:first-child .card-img-top{border-top-right-radius:0}.card-group>.card:first-child .card-footer,.card-group>.card:first-child .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:last-child .card-header,.card-group>.card:last-child .card-img-top{border-top-left-radius:0}.card-group>.card:last-child .card-footer,.card-group>.card:last-child .card-img-bottom{border-bottom-left-radius:0}.card-group>.card:only-child{border-radius:.25rem}.card-group>.card:only-child .card-header,.card-group>.card:only-child .card-img-top{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.card-group>.card:only-child .card-footer,.card-group>.card:only-child .card-img-bottom{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-group>.card:not(:first-child):not(:last-child):not(:only-child),.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-footer,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-header,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-top{border-radius:0}}.card-columns .card{margin-bottom:.75rem}@media (min-width:576px){.card-columns{-webkit-column-count:3;-moz-column-count:3;column-count:3;-webkit-column-gap:1.25rem;-moz-column-gap:1.25rem;column-gap:1.25rem}.card-columns .card{display:inline-block;width:100%}}.breadcrumb{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.breadcrumb-item+.breadcrumb-item:before{display:inline-block;padding-right:.5rem;padding-left:.5rem;color:#6c757d;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover:before{text-decoration:underline;text-decoration:none}.breadcrumb-item.active{color:#6c757d}.pagination{display:-webkit-box;display:-ms-flexbox;display:flex;padding-left:0;list-style:none;border-radius:.25rem}.page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link:hover{color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link:focus{z-index:2;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.page-link:not(:disabled):not(.disabled){cursor:pointer}.page-item:first-child .page-link{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.page-item.active .page-link{z-index:1;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.pagination-lg .page-item:first-child .page-link{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.pagination-sm .page-item:first-child .page-link{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary{color:#fff;background-color:#007bff}.badge-primary[href]:focus,.badge-primary[href]:hover{color:#fff;text-decoration:none;background-color:#0062cc}.badge-secondary{color:#fff;background-color:#6c757d}.badge-secondary[href]:focus,.badge-secondary[href]:hover{color:#fff;text-decoration:none;background-color:#545b62}.badge-success{color:#fff;background-color:#28a745}.badge-success[href]:focus,.badge-success[href]:hover{color:#fff;text-decoration:none;background-color:#1e7e34}.badge-info{color:#fff;background-color:#17a2b8}.badge-info[href]:focus,.badge-info[href]:hover{color:#fff;text-decoration:none;background-color:#117a8b}.badge-warning{color:#212529;background-color:#ffc107}.badge-warning[href]:focus,.badge-warning[href]:hover{color:#212529;text-decoration:none;background-color:#d39e00}.badge-danger{color:#fff;background-color:#dc3545}.badge-danger[href]:focus,.badge-danger[href]:hover{color:#fff;text-decoration:none;background-color:#bd2130}.badge-light{color:#212529;background-color:#f8f9fa}.badge-light[href]:focus,.badge-light[href]:hover{color:#212529;text-decoration:none;background-color:#dae0e5}.badge-dark{color:#fff;background-color:#343a40}.badge-dark[href]:focus,.badge-dark[href]:hover{color:#fff;text-decoration:none;background-color:#1d2124}.jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width:576px){.jumbotron{padding:4rem 2rem}}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:4rem}.alert-dismissible .close{position:absolute;top:0;right:0;padding:.75rem 1.25rem;color:inherit}.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert-primary hr{border-top-color:#9fcdff}.alert-primary .alert-link{color:#002752}.alert-secondary{color:#383d41;background-color:#e2e3e5;border-color:#d6d8db}.alert-secondary hr{border-top-color:#c8cbcf}.alert-secondary .alert-link{color:#202326}.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success hr{border-top-color:#b1dfbb}.alert-success .alert-link{color:#0b2e13}.alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info hr{border-top-color:#abdde5}.alert-info .alert-link{color:#062c33}.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning hr{border-top-color:#ffe8a1}.alert-warning .alert-link{color:#533f03}.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger hr{border-top-color:#f1b0b7}.alert-danger .alert-link{color:#491217}.alert-light{color:#818182;background-color:#fefefe;border-color:#fdfdfe}.alert-light hr{border-top-color:#ececf6}.alert-light .alert-link{color:#686868}.alert-dark{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark hr{border-top-color:#b9bbbe}.alert-dark .alert-link{color:#040505}@-webkit-keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}.progress{height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress,.progress-bar{display:-webkit-box;display:-ms-flexbox;display:flex}.progress-bar{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;text-align:center;background-color:#007bff;transition:width .6s ease}.progress-bar-striped{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated{-webkit-animation:progress-bar-stripes 1s linear infinite;animation:progress-bar-stripes 1s linear infinite}.media{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.media-body{-webkit-box-flex:1;-ms-flex:1;flex:1}.list-group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0}.list-group-item-action{width:100%;color:#495057;text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action:active{color:#212529;background-color:#e9ecef}.list-group-item{position:relative;display:block;padding:.75rem 1.25rem;margin-bottom:-1px;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.list-group-item:focus,.list-group-item:hover{z-index:1;text-decoration:none}.list-group-item.disabled,.list-group-item:disabled{color:#6c757d;background-color:#fff}.list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-flush .list-group-item{border-right:0;border-left:0;border-radius:0}.list-group-flush:first-child .list-group-item:first-child{border-top:0}.list-group-flush:last-child .list-group-item:last-child{border-bottom:0}.list-group-item-primary{color:#004085;background-color:#b8daff}.list-group-item-primary.list-group-item-action:focus,.list-group-item-primary.list-group-item-action:hover{color:#004085;background-color:#9fcdff}.list-group-item-primary.list-group-item-action.active{color:#fff;background-color:#004085;border-color:#004085}.list-group-item-secondary{color:#383d41;background-color:#d6d8db}.list-group-item-secondary.list-group-item-action:focus,.list-group-item-secondary.list-group-item-action:hover{color:#383d41;background-color:#c8cbcf}.list-group-item-secondary.list-group-item-action.active{color:#fff;background-color:#383d41;border-color:#383d41}.list-group-item-success{color:#155724;background-color:#c3e6cb}.list-group-item-success.list-group-item-action:focus,.list-group-item-success.list-group-item-action:hover{color:#155724;background-color:#b1dfbb}.list-group-item-success.list-group-item-action.active{color:#fff;background-color:#155724;border-color:#155724}.list-group-item-info{color:#0c5460;background-color:#bee5eb}.list-group-item-info.list-group-item-action:focus,.list-group-item-info.list-group-item-action:hover{color:#0c5460;background-color:#abdde5}.list-group-item-info.list-group-item-action.active{color:#fff;background-color:#0c5460;border-color:#0c5460}.list-group-item-warning{color:#856404;background-color:#ffeeba}.list-group-item-warning.list-group-item-action:focus,.list-group-item-warning.list-group-item-action:hover{color:#856404;background-color:#ffe8a1}.list-group-item-warning.list-group-item-action.active{color:#fff;background-color:#856404;border-color:#856404}.list-group-item-danger{color:#721c24;background-color:#f5c6cb}.list-group-item-danger.list-group-item-action:focus,.list-group-item-danger.list-group-item-action:hover{color:#721c24;background-color:#f1b0b7}.list-group-item-danger.list-group-item-action.active{color:#fff;background-color:#721c24;border-color:#721c24}.list-group-item-light{color:#818182;background-color:#fdfdfe}.list-group-item-light.list-group-item-action:focus,.list-group-item-light.list-group-item-action:hover{color:#818182;background-color:#ececf6}.list-group-item-light.list-group-item-action.active{color:#fff;background-color:#818182;border-color:#818182}.list-group-item-dark{color:#1b1e21;background-color:#c6c8ca}.list-group-item-dark.list-group-item-action:focus,.list-group-item-dark.list-group-item-action:hover{color:#1b1e21;background-color:#b9bbbe}.list-group-item-dark.list-group-item-action.active{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close:focus,.close:hover{color:#000;text-decoration:none;opacity:.75}.close:not(:disabled):not(.disabled){cursor:pointer}button.close{padding:0;background-color:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;outline:0}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog{transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;-webkit-transform:translateY(-25%);transform:translateY(-25%)}.modal.show .modal-dialog{-webkit-transform:translate(0);transform:translate(0)}.modal-dialog-centered{-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:calc(100% - 1rem)}.modal-content,.modal-dialog-centered{display:-webkit-box;display:-ms-flexbox;display:flex}.modal-content{position:relative;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:.5}.modal-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:1rem;border-bottom:1px solid #e9ecef;border-top-left-radius:.3rem;border-top-right-radius:.3rem}.modal-header .close{padding:1rem;margin:-1rem -1rem -1rem auto}.modal-title{margin-bottom:0;line-height:1.5}.modal-body{position:relative;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;padding:1rem}.modal-footer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:1rem;border-top:1px solid #e9ecef}.modal-footer>:not(:first-child){margin-left:.25rem}.modal-footer>:not(:last-child){margin-right:.25rem}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg{max-width:800px}}.tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show{opacity:.9}.tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .arrow:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[x-placement^=top],.bs-tooltip-top{padding:.4rem 0}.bs-tooltip-auto[x-placement^=top] .arrow,.bs-tooltip-top .arrow{bottom:0}.bs-tooltip-auto[x-placement^=top] .arrow:before,.bs-tooltip-top .arrow:before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[x-placement^=right],.bs-tooltip-right{padding:0 .4rem}.bs-tooltip-auto[x-placement^=right] .arrow,.bs-tooltip-right .arrow{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=right] .arrow:before,.bs-tooltip-right .arrow:before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[x-placement^=bottom],.bs-tooltip-bottom{padding:.4rem 0}.bs-tooltip-auto[x-placement^=bottom] .arrow,.bs-tooltip-bottom .arrow{top:0}.bs-tooltip-auto[x-placement^=bottom] .arrow:before,.bs-tooltip-bottom .arrow:before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[x-placement^=left],.bs-tooltip-left{padding:0 .4rem}.bs-tooltip-auto[x-placement^=left] .arrow,.bs-tooltip-left .arrow{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=left] .arrow:before,.bs-tooltip-left .arrow:before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover{top:0;left:0;z-index:1060;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover,.popover .arrow{position:absolute;display:block}.popover .arrow{width:1rem;height:.5rem;margin:0 .3rem}.popover .arrow:after,.popover .arrow:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[x-placement^=top],.bs-popover-top{margin-bottom:.5rem}.bs-popover-auto[x-placement^=top] .arrow,.bs-popover-top .arrow{bottom:calc((.5rem + 1px) * -1)}.bs-popover-auto[x-placement^=top] .arrow:after,.bs-popover-auto[x-placement^=top] .arrow:before,.bs-popover-top .arrow:after,.bs-popover-top .arrow:before{border-width:.5rem .5rem 0}.bs-popover-auto[x-placement^=top] .arrow:before,.bs-popover-top .arrow:before{bottom:0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=top] .arrow:after,.bs-popover-top .arrow:after{bottom:1px;border-top-color:#fff}.bs-popover-auto[x-placement^=right],.bs-popover-right{margin-left:.5rem}.bs-popover-auto[x-placement^=right] .arrow,.bs-popover-right .arrow{left:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=right] .arrow:after,.bs-popover-auto[x-placement^=right] .arrow:before,.bs-popover-right .arrow:after,.bs-popover-right .arrow:before{border-width:.5rem .5rem .5rem 0}.bs-popover-auto[x-placement^=right] .arrow:before,.bs-popover-right .arrow:before{left:0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=right] .arrow:after,.bs-popover-right .arrow:after{left:1px;border-right-color:#fff}.bs-popover-auto[x-placement^=bottom],.bs-popover-bottom{margin-top:.5rem}.bs-popover-auto[x-placement^=bottom] .arrow,.bs-popover-bottom .arrow{top:calc((.5rem + 1px) * -1)}.bs-popover-auto[x-placement^=bottom] .arrow:after,.bs-popover-auto[x-placement^=bottom] .arrow:before,.bs-popover-bottom .arrow:after,.bs-popover-bottom .arrow:before{border-width:0 .5rem .5rem}.bs-popover-auto[x-placement^=bottom] .arrow:before,.bs-popover-bottom .arrow:before{top:0;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=bottom] .arrow:after,.bs-popover-bottom .arrow:after{top:1px;border-bottom-color:#fff}.bs-popover-auto[x-placement^=bottom] .popover-header:before,.bs-popover-bottom .popover-header:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bs-popover-auto[x-placement^=left],.bs-popover-left{margin-right:.5rem}.bs-popover-auto[x-placement^=left] .arrow,.bs-popover-left .arrow{right:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=left] .arrow:after,.bs-popover-auto[x-placement^=left] .arrow:before,.bs-popover-left .arrow:after,.bs-popover-left .arrow:before{border-width:.5rem 0 .5rem .5rem}.bs-popover-auto[x-placement^=left] .arrow:before,.bs-popover-left .arrow:before{right:0;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=left] .arrow:after,.bs-popover-left .arrow:after{right:1px;border-left-color:#fff}.popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;color:inherit;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header:empty{display:none}.popover-body{padding:.5rem .75rem;color:#212529}.carousel{position:relative}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-item{position:relative;display:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;transition:-webkit-transform .6s ease;transition:transform .6s ease;transition:transform .6s ease,-webkit-transform .6s ease;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.carousel-item-next,.carousel-item-prev{position:absolute;top:0}.carousel-item-next.carousel-item-left,.carousel-item-prev.carousel-item-right{-webkit-transform:translateX(0);transform:translateX(0)}@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)){.carousel-item-next.carousel-item-left,.carousel-item-prev.carousel-item-right{-webkit-transform:translateZ(0);transform:translateZ(0)}}.active.carousel-item-right,.carousel-item-next{-webkit-transform:translateX(100%);transform:translateX(100%)}@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)){.active.carousel-item-right,.carousel-item-next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.active.carousel-item-left,.carousel-item-prev{-webkit-transform:translateX(-100%);transform:translateX(-100%)}@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)){.active.carousel-item-left,.carousel-item-prev{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:20px;height:20px;background:transparent no-repeat 50%;background-size:100% 100%}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\")}.carousel-indicators{position:absolute;right:0;bottom:10px;left:0;z-index:15;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators li{position:relative;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;background-color:hsla(0,0%,100%,.5)}.carousel-indicators li:before{top:-10px}.carousel-indicators li:after,.carousel-indicators li:before{position:absolute;left:0;display:inline-block;width:100%;height:10px;content:\"\"}.carousel-indicators li:after{bottom:-10px}.carousel-indicators .active{background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.bg-primary{background-color:#007bff!important}a.bg-primary:focus,a.bg-primary:hover,button.bg-primary:focus,button.bg-primary:hover{background-color:#0062cc!important}.bg-secondary{background-color:#6c757d!important}a.bg-secondary:focus,a.bg-secondary:hover,button.bg-secondary:focus,button.bg-secondary:hover{background-color:#545b62!important}.bg-success{background-color:#28a745!important}a.bg-success:focus,a.bg-success:hover,button.bg-success:focus,button.bg-success:hover{background-color:#1e7e34!important}.bg-info{background-color:#17a2b8!important}a.bg-info:focus,a.bg-info:hover,button.bg-info:focus,button.bg-info:hover{background-color:#117a8b!important}.bg-warning{background-color:#ffc107!important}a.bg-warning:focus,a.bg-warning:hover,button.bg-warning:focus,button.bg-warning:hover{background-color:#d39e00!important}.bg-danger{background-color:#dc3545!important}a.bg-danger:focus,a.bg-danger:hover,button.bg-danger:focus,button.bg-danger:hover{background-color:#bd2130!important}.bg-light{background-color:#f8f9fa!important}a.bg-light:focus,a.bg-light:hover,button.bg-light:focus,button.bg-light:hover{background-color:#dae0e5!important}.bg-dark{background-color:#343a40!important}a.bg-dark:focus,a.bg-dark:hover,button.bg-dark:focus,button.bg-dark:hover{background-color:#1d2124!important}.bg-white{background-color:#fff!important}.bg-transparent{background-color:transparent!important}.border{border:1px solid #dee2e6!important}.border-top{border-top:1px solid #dee2e6!important}.border-right{border-right:1px solid #dee2e6!important}.border-bottom{border-bottom:1px solid #dee2e6!important}.border-left{border-left:1px solid #dee2e6!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary{border-color:#007bff!important}.border-secondary{border-color:#6c757d!important}.border-success{border-color:#28a745!important}.border-info{border-color:#17a2b8!important}.border-warning{border-color:#ffc107!important}.border-danger{border-color:#dc3545!important}.border-light{border-color:#f8f9fa!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded{border-radius:.25rem!important}.rounded-top{border-top-left-radius:.25rem!important}.rounded-right,.rounded-top{border-top-right-radius:.25rem!important}.rounded-bottom,.rounded-right{border-bottom-right-radius:.25rem!important}.rounded-bottom,.rounded-left{border-bottom-left-radius:.25rem!important}.rounded-left{border-top-left-radius:.25rem!important}.rounded-circle{border-radius:50%!important}.rounded-0{border-radius:0!important}.clearfix:after{display:block;clear:both;content:\"\"}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.d-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.d-sm-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.d-md-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.d-lg-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.d-xl-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media print{.d-print-none{display:none!important}.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.d-print-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}.embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive:before{display:block;content:\"\"}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9:before{padding-top:42.857143%}.embed-responsive-16by9:before{padding-top:56.25%}.embed-responsive-4by3:before{padding-top:75%}.embed-responsive-1by1:before{padding-top:100%}.flex-row{-webkit-box-orient:horizontal!important;-ms-flex-direction:row!important;flex-direction:row!important}.flex-column,.flex-row{-webkit-box-direction:normal!important}.flex-column{-webkit-box-orient:vertical!important;-ms-flex-direction:column!important;flex-direction:column!important}.flex-row-reverse{-webkit-box-orient:horizontal!important;-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-column-reverse,.flex-row-reverse{-webkit-box-direction:reverse!important}.flex-column-reverse{-webkit-box-orient:vertical!important;-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-start{-webkit-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-end{-webkit-box-pack:end!important;-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-center{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.justify-content-between{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-start{-webkit-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important}.align-items-end{-webkit-box-align:end!important;-ms-flex-align:end!important;align-items:flex-end!important}.align-items-center{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}.align-items-baseline{-webkit-box-align:baseline!important;-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-stretch{-webkit-box-align:stretch!important;-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}@media (min-width:576px){.flex-sm-row{-webkit-box-orient:horizontal!important;-ms-flex-direction:row!important;flex-direction:row!important}.flex-sm-column,.flex-sm-row{-webkit-box-direction:normal!important}.flex-sm-column{-webkit-box-orient:vertical!important;-ms-flex-direction:column!important;flex-direction:column!important}.flex-sm-row-reverse{-webkit-box-orient:horizontal!important;-webkit-box-direction:reverse!important;-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-sm-column-reverse{-webkit-box-orient:vertical!important;-webkit-box-direction:reverse!important;-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-sm-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-sm-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-sm-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-sm-start{-webkit-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-sm-end{-webkit-box-pack:end!important;-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-sm-center{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.justify-content-sm-between{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-sm-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-sm-start{-webkit-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important}.align-items-sm-end{-webkit-box-align:end!important;-ms-flex-align:end!important;align-items:flex-end!important}.align-items-sm-center{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}.align-items-sm-baseline{-webkit-box-align:baseline!important;-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-sm-stretch{-webkit-box-align:stretch!important;-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-sm-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-sm-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-sm-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-sm-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-sm-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-sm-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-sm-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-sm-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-sm-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-sm-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-sm-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-sm-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:768px){.flex-md-row{-webkit-box-orient:horizontal!important;-ms-flex-direction:row!important;flex-direction:row!important}.flex-md-column,.flex-md-row{-webkit-box-direction:normal!important}.flex-md-column{-webkit-box-orient:vertical!important;-ms-flex-direction:column!important;flex-direction:column!important}.flex-md-row-reverse{-webkit-box-orient:horizontal!important;-webkit-box-direction:reverse!important;-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-md-column-reverse{-webkit-box-orient:vertical!important;-webkit-box-direction:reverse!important;-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-md-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-md-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-md-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-md-start{-webkit-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-md-end{-webkit-box-pack:end!important;-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-md-center{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.justify-content-md-between{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-md-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-md-start{-webkit-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important}.align-items-md-end{-webkit-box-align:end!important;-ms-flex-align:end!important;align-items:flex-end!important}.align-items-md-center{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}.align-items-md-baseline{-webkit-box-align:baseline!important;-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-md-stretch{-webkit-box-align:stretch!important;-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-md-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-md-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-md-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-md-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-md-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-md-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-md-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-md-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-md-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-md-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-md-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-md-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:992px){.flex-lg-row{-webkit-box-orient:horizontal!important;-ms-flex-direction:row!important;flex-direction:row!important}.flex-lg-column,.flex-lg-row{-webkit-box-direction:normal!important}.flex-lg-column{-webkit-box-orient:vertical!important;-ms-flex-direction:column!important;flex-direction:column!important}.flex-lg-row-reverse{-webkit-box-orient:horizontal!important;-webkit-box-direction:reverse!important;-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-lg-column-reverse{-webkit-box-orient:vertical!important;-webkit-box-direction:reverse!important;-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-lg-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-lg-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-lg-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-lg-start{-webkit-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-lg-end{-webkit-box-pack:end!important;-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-lg-center{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.justify-content-lg-between{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-lg-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-lg-start{-webkit-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important}.align-items-lg-end{-webkit-box-align:end!important;-ms-flex-align:end!important;align-items:flex-end!important}.align-items-lg-center{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}.align-items-lg-baseline{-webkit-box-align:baseline!important;-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-lg-stretch{-webkit-box-align:stretch!important;-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-lg-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-lg-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-lg-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-lg-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-lg-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-lg-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-lg-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-lg-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-lg-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-lg-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-lg-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-lg-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:1200px){.flex-xl-row{-webkit-box-orient:horizontal!important;-ms-flex-direction:row!important;flex-direction:row!important}.flex-xl-column,.flex-xl-row{-webkit-box-direction:normal!important}.flex-xl-column{-webkit-box-orient:vertical!important;-ms-flex-direction:column!important;flex-direction:column!important}.flex-xl-row-reverse{-webkit-box-orient:horizontal!important;-webkit-box-direction:reverse!important;-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-xl-column-reverse{-webkit-box-orient:vertical!important;-webkit-box-direction:reverse!important;-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-xl-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-xl-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-xl-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-xl-start{-webkit-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-xl-end{-webkit-box-pack:end!important;-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-xl-center{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.justify-content-xl-between{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-xl-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-xl-start{-webkit-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important}.align-items-xl-end{-webkit-box-align:end!important;-ms-flex-align:end!important;align-items:flex-end!important}.align-items-xl-center{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}.align-items-xl-baseline{-webkit-box-align:baseline!important;-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-xl-stretch{-webkit-box-align:stretch!important;-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-xl-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-xl-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-xl-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-xl-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-xl-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-xl-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-xl-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-xl-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-xl-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-xl-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-xl-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-xl-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}@media (min-width:576px){.float-sm-left{float:left!important}.float-sm-right{float:right!important}.float-sm-none{float:none!important}}@media (min-width:768px){.float-md-left{float:left!important}.float-md-right{float:right!important}.float-md-none{float:none!important}}@media (min-width:992px){.float-lg-left{float:left!important}.float-lg-right{float:right!important}.float-lg-none{float:none!important}}@media (min-width:1200px){.float-xl-left{float:left!important}.float-xl-right{float:right!important}.float-xl-none{float:none!important}}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.fixed-top{top:0}.fixed-bottom,.fixed-top{position:fixed;right:0;left:0;z-index:1030}.fixed-bottom{bottom:0}@supports ((position:-webkit-sticky) or (position:sticky)){.sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;-webkit-clip-path:inset(50%);clip-path:inset(50%);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal;-webkit-clip-path:none;clip-path:none}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.mw-100{max-width:100%!important}.mh-100{max-height:100%!important}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:.25rem!important}.mt-1,.my-1{margin-top:.25rem!important}.mr-1,.mx-1{margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:.25rem!important}.m-2{margin:.5rem!important}.mt-2,.my-2{margin-top:.5rem!important}.mr-2,.mx-2{margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:.5rem!important}.m-3{margin:1rem!important}.mt-3,.my-3{margin-top:1rem!important}.mr-3,.mx-3{margin-right:1rem!important}.mb-3,.my-3{margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:1rem!important}.m-4{margin:1.5rem!important}.mt-4,.my-4{margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:1.5rem!important}.m-5{margin:3rem!important}.mt-5,.my-5{margin-top:3rem!important}.mr-5,.mx-5{margin-right:3rem!important}.mb-5,.my-5{margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.p-5{padding:3rem!important}.pt-5,.py-5{padding-top:3rem!important}.pr-5,.px-5{padding-right:3rem!important}.pb-5,.py-5{padding-bottom:3rem!important}.pl-5,.px-5{padding-left:3rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.text-justify{text-align:justify!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media (min-width:576px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-light{font-weight:300!important}.font-weight-normal{font-weight:400!important}.font-weight-bold{font-weight:700!important}.font-italic{font-style:italic!important}.text-white{color:#fff!important}.text-primary{color:#007bff!important}a.text-primary:focus,a.text-primary:hover{color:#0062cc!important}.text-secondary{color:#6c757d!important}a.text-secondary:focus,a.text-secondary:hover{color:#545b62!important}.text-success{color:#28a745!important}a.text-success:focus,a.text-success:hover{color:#1e7e34!important}.text-info{color:#17a2b8!important}a.text-info:focus,a.text-info:hover{color:#117a8b!important}.text-warning{color:#ffc107!important}a.text-warning:focus,a.text-warning:hover{color:#d39e00!important}.text-danger{color:#dc3545!important}a.text-danger:focus,a.text-danger:hover{color:#bd2130!important}.text-light{color:#f8f9fa!important}a.text-light:focus,a.text-light:hover{color:#dae0e5!important}.text-dark{color:#343a40!important}a.text-dark:focus,a.text-dark:hover{color:#1d2124!important}.text-muted{color:#6c757d!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media print{*,:after,:before{text-shadow:none!important;box-shadow:none!important}a:not(.btn){text-decoration:underline}abbr[title]:after{content:\" (\" attr(title) \")\"}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}@page{size:a3}.container,body{min-width:992px!important}.navbar{display:none}.badge{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}", ""]);

// exports


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js